import { Locale } from './i18n';

export const translations = {
  de: {
    nav: {
      home: 'Startseite',
      services: 'Dienstleistungen',
      products: 'Produkte',
      about: 'Über uns',
      leitbild: 'Leitbild',
      team: 'Team',
      partners: 'Partner & Ökosystem',
      anfahrt: 'Anfahrt',
      chameleonStory: 'Chamäleon Story',
      successStories: 'Success Stories',
      sustainability: 'Nachhaltigkeit',
      sustainabilityDescription: 'Nachhaltige Automatisierung für eine bessere Zukunft',
      careers: 'Karriere',
      careersDescription: 'Werden Sie Teil unseres innovativen Teams',
      vocationalTraining: 'Berufsbildung',
      vocationalTrainingDescription: 'Starten Sie Ihre Karriere mit einer erstklassigen Ausbildung',
      news: 'News',
      contact: 'Kontakt',
      overview: 'Übersicht'
    },
    routes: {
      services: 'dienstleistungen',
      products: 'produkte',
      about: 'ueber-uns',
      sustainability: 'nachhaltigkeit',
      careers: 'karriere',
      news: 'news',
      contact: 'kontakt',
      jobOpenings: 'offene-stellen',
      vocationalTraining: 'berufsbildung',
      schaltschrankbau: 'schaltschrankbau',
      engineering: 'engineering',
      softwareengineering: 'softwareengineering',
      leitbild: 'leitbild',
      team: 'management',
      partners: 'partner-oekosystem',
      anfahrt: 'anfahrt',
      chameleonStory: 'chamaeleon-story',
      successStories: 'erfolgsgeschichten',
      hardwareentwickler: 'hardwareentwickler',
      projektleiter: 'projektleiter',
      automatiker: 'automatiker',
      athex: 'athex',
      panelscout: 'panelscout',
      documents: 'dokumente',
      ausstellung: 'ausstellung'
    },
    footer: {
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      howToGetHere: 'Anfahrt',
      documents: 'Dokumente',
      quickLinks: 'Quick Links',
      company: 'Unternehmen',
      headquarters: 'Hauptsitz',
      isoCertified: 'ISO 14001 zertifiziert',
      copyright: '© 2026 W. Althaus AG. Alle Rechte vorbehalten.',
      quality: 'Leading in Automation seit 1968'
    },
    home: {
      hero: {
        weAre: 'Wir sind...',
        title: 'Produktivität durch integrierte Workflows & automatisierte Produktion',
        subtitle: 'Seit über 40 Jahren steigern wir die Produktivität durch integrierte Arbeitsabläufe und vollautomatisierte Produktion - Tag für Tag.',
        tagline: 'Unsere Automatisierung für ihren Wettbewerbsvorteil',
        ctaContact: 'Kontakt aufnehmen',
        ctaServices: 'Leistungen ansehen',
        stats: {
          experience: 'Jahre Erfahrung',
          projects: 'Projekte', 
          employees: 'Mitarbeitende arbeiten an Ihrer Automatisierung',
          swissFamily: 'Schweizer Familienunternehmen'
        }
      },
      services: {
        title: 'Schaltschränke für alle Anforderungen',
        subtitle: 'Als Technologieführer der Branche bieten wir ein umfangreiches Leistungsportfolio. Die Kombination aus hochwertigen Komponenten und umfassender Expertise erlaubt es uns, neben leistungsstarken Seriensteuerungen massgeschneiderte Lösungen anzubieten. Dabei erhalten Sie von der Planung über die Umsetzung bis hin zur Montage alles aus einer Hand.',
        viewAll: 'Alle Leistungen ansehen',
        learnMore: 'Mehr erfahren'
      },
      partners: {
        title: 'Unsere Partner',
        subtitle: 'Wir pflegen eine von Kontinuität, Vertrauen und Kompetenz geprägte Partnerschaft mit anderen führenden Unternehmen'
      }
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Ihre Automatisierung. Unser Know-how.',
      schaltschrankbau: {
        title: 'Schaltschrankbau',
        description: 'Als grösstes und führendes Schweizer Unternehmen im Schaltschrankbau verschaffen wir Ihnen mit unserer KI-gestützten, vollautomatisierten Produktion neue Wettbewerbsvorteile',
        badge: 'Schaltschrankbau 4.0',
        heroTitle: 'Professioneller Schaltschrankbau',
        heroSubtitle: 'Unsere Automatisierung mit Schaltschrankbau 4.0 für Ihren Wettbewerbsvorteil. Von Prototypen bis zur Serienfertigung - vollautomatisierte Prozesse für höchste Qualität.',
        servicesTitle: 'Unser Leistungsspektrum',
        servicesSubtitle: 'Vollautomatisierte Produktion mit optimaler Fertigungstiefe bei voller Flexibilität bezüglich Kundenanforderungen.',
        capabilitiesTitle: 'Unser Leistungsangebot',
        capabilitiesSubtitle: 'Im Auftrag ihrer Kunden baut und konfektioniert die W. Althaus AG Schaltschränke und Baugruppen für diverse Märkte von Prototypen bis zur Serien- und Variantenfertigung.',
        automationTitle: 'Vollautomatisierte Produktion',
        automationDescription: 'Der hohe Automatisierungsgrad generiert uns eine hohe, gleichbleibende Qualität zu wettbewerbsfähigen Bedingungen.',
        automationGrade: 'Automatisierungsgrad',
        ctaTitle: 'Bereit für Ihren Schaltschrankbau?',
        ctaSubtitle: 'Lassen Sie uns gemeinsam Ihre Automatisierungslösung realisieren. Kontaktieren Sie uns für eine unverbindliche Beratung.',
        ctaButtonPrimary: 'Projekt anfragen',
        ctaButtonSecondary: 'Case Study lesen',
        features: {
          ecad: {
            title: 'E-CAD Engineering',
            description: 'Professionelle Planung mit ePlan P8, ePlan Pro Panel und E3.series für präzise Schaltpläne'
          },
          production: {
            title: 'Vollautomatisierte Produktion',
            description: 'Schaltschrankbau 4.0 mit höchstem Automatisierungsgrad für gleichbleibende Qualität'
          },
          compliance: {
            title: 'Normkonformität',
            description: 'Einhaltung aller relevanten Normen und Standards für maximale Betriebssicherheit'
          },
          terminals: {
            title: 'Klemmenleisten-Produktion',
            description: 'Automatische Fertigung von Klemmenleisten mit Phoenix Contact-Steckern'
          },
          assembly: {
            title: 'Baugruppenmontage',
            description: 'Fachgerechte Montage und Integration aller Komponenten nach höchsten Standards'
          },
          testing: {
            title: 'Prüf- & Testverfahren',
            description: 'Umfassende Qualitätsprüfungen und Funktionstests vor Auslieferung'
          }
        },
        benefits: {
          competitive: {
            title: 'Wettbewerbsvorteile',
            description: 'Durch Schaltschrankbau 4.0 generieren wir Ihnen messbare Wettbewerbsvorteile'
          },
          quality: {
            title: 'Hohe Qualität',
            description: 'Vollautomatisierte Prozesse garantieren gleichbleibend hohe Qualität'
          },
          flexibility: {
            title: 'Flexibilität',
            description: 'Von Prototypen bis zur Serienfertigung - wir passen uns Ihren Anforderungen an'
          },
          efficiency: {
            title: 'Kosteneffizienz',
            description: 'Automatisierungsgrad sorgt für wettbewerbsfähige Preise bei höchster Qualität'
          }
        },
        capabilities: [
          'E-CAD: ePlan P8, ePlan Pro Panel, E3.series',
          'Schaltschrankbau von Prototypen bis Serienfertigung',
          'Klemmenleisten-Produktion (Phoenix Contact)',
          'Baugruppenmontage und Integration',
          'Prüf- und Testverfahren',
          'Vollautomatisierte Verdrahtung',
          'Blechbearbeitung und Gehäusebau',
          'Qualitätskontrolle nach ISO-Standards'
        ],
        // NEW: Page-specific translations
        hero: {
          tagline: 'automatisiert. präzise. Althaus.',
          intro: 'Mit dem Schaltschrankbau 4.0 verbinden wir ECAD-Digital Twin, modularisierte Prozesse und hochautomatisierte Fertigung in der Schweiz. Für konkurrenzfähige Kosten, konstant hohe Qualität und seriennahe Fertigung ab\u00A0Stückzahl\u00A01.'
        },
        cards: {
          whatYouGet: {
            title: 'Was Sie bei Althaus erhalten',
            description: 'Wir bauen und konfektionieren Schaltschränke und Baugruppen für unterschiedliche Branchen, vom Prototyp bis zur Serie. Vollautomatisierte Prozessketten, standardisierte Module und ein durchgängiger ECAD-Datenfluss sichern Tempo, Qualität und Planbarkeit über den gesamten Produktlebenszyklus.'
          },
          scope: {
            title: 'Leistungsumfang - Kompetenzen & Tools',
            description: 'Vom ersten Klick im ECAD bis zur Inbetriebnahme. Wir realisieren Schaltschranklösungen schnell, skalierbar und normgerecht. Digitaler Zwilling (ePlan P8/Pro Panel, E3), standardisierte Plattform-Baukästen und abgestimmtes SCM sichern Tempo, Qualität und Kosten – 100 % in der Schweiz gefertigt. Mit On-Site-Montage und UL/CSA-Prüfung.'
          },
          howWeWork: {
            title: 'So arbeiten wir',
            description: 'Vom ersten Gespräch bis zur Montage vor Ort definieren wir Ziele, Normen, Stückzahlen und Budget. Auf dieser Basis erstellen wir einen digitalen Zwilling. Design for Assembly, Standardisierung und UL/CSA-Check sichern eine effiziente Umsetzung. Automatisierte Fertigung, Tests, Dokumentation und Rückverfolgbarkeit gewährleisten Qualität bis zur Auslieferung und darüber hinaus.'
          }
        },
        processSteps: {
          requirement: { title: 'Anforderung & Beratung', description: 'Detaillierte Anforderungsanalyse und kompetente Beratung für Ihr Projekt.' },
          engineering: { title: 'Engineering', description: 'Professionelle Planung und technische Ausarbeitung nach höchsten Standards.' },
          material: { title: 'Material & Vorbereitung', description: 'Sorgfältige Materialauswahl und optimale Vorbereitung aller Komponenten.' },
          automated: { title: 'Automatisierte Bearbeitung', description: 'Präzise automatisierte Fertigung mit modernster Technologie.' },
          assembly: { title: 'Montage & Verdrahtung', description: 'Fachgerechte Montage und strukturierte Verdrahtung nach Industriestandards.' },
          testing: { title: 'Prüfung & Abnahme', description: 'Umfassende Qualitätsprüfung und dokumentierte Abnahme aller Systeme.' },
          commissioning: { title: 'Inbetriebnahme', description: 'Professionelle Inbetriebnahme und Optimierung vor Ort beim Kunden.' },
          service: { title: 'Service & Lifecycle', description: 'Langfristige Betreuung und Wartung über den gesamten Lebenszyklus.' }
        },
        servicesGrid: {
          ecad: { name: 'E-CAD: ePlan p8, ePlan Pro Panel, E3', description: 'Professionelle Elektroplanung mit modernsten CAD-Tools' },
          layout: { name: 'Schaltschrankkonzept: Konstruktion, Layout', description: 'Durchdachte Konzeption und optimierte Layouts' },
          standardization: { name: 'Standardisierung, Modularisierung', description: 'Effiziente Prozesse durch standardisierte Module' },
          procurement: { name: 'Beschaffungs- und Logistikkonzepte', description: 'Optimierte Materialflüsse und Logistik' },
          materialOptimization: { name: 'Optimierung der Materialwirtschaft', description: 'Effiziente Materialplanung und -verwaltung' },
          production: { name: 'Prototypenbau, Einzel- & Serienfertigung', description: 'Flexible Fertigung für alle Anforderungen' },
          onSite: { name: 'Montagen vor Ort beim Kunden', description: 'Professionelle Installation und Inbetriebnahme direkt bei Ihnen vor Ort' },
          ulCsa: { name: 'UL / CSA Zertifizierung', description: 'Internationale Zertifizierung für den nordamerikanischen Markt' }
        },
        valueProposition: {
          title: 'Ihr Mehrwert durch unsere Automatisierung',
          cost: { title: 'Konkurrenzfähige Kosten', description: 'Effiziente Prozesse und standardisierte Abläufe für optimale Wirtschaftlichkeit.' },
          quality: { title: 'Konstant hohe Qualität', description: 'Strenge Qualitätskontrollen und zertifizierte Prozesse garantieren Zuverlässigkeit.' },
          changes: { title: 'Änderungen spät möglich', description: 'Flexible Anpassungen bis zur letzten Minute dank modularer Bauweise.' },
          speed: { title: 'Kurze Durchlaufzeiten', description: 'Automatisierte Fertigung und optimierte Logistik für schnelle Lieferung.' }
        },
        sectionHeaders: {
          servicesOffering: 'Unser Leistungsangebot umfasst'
        }
      },
      kabelkonfektion: {
        title: 'Kabelkonfektion',
        description: 'Ein für den Einsatzort passend konstruierter Kabelbaum kann, dank exakter Längen, unverwechselbarer Beschriftung, kontaktsicherer Kabelenden und anschlussgerechter Fertigung schnell und fehlerfrei verbaut werden.'
      },
      klemmensteg: {
        title: 'Klemmenstegproduktion',
        description: 'Um den Projektablauf zu optimieren, haben wir die gesamte Fertigung von Klemmenstegen und Montageschienen vollständig automatisiert.'
      },
      softwareengineering: {
        title: 'Software-Engineering',
        description: 'Komplette Softwarelösungen von der Projektplanung bis zur Inbetriebnahme. Benutzerfreundliche Visualisierungen und maßgeschneiderte Datenbankanwendungen.'
      },
      engineering: {
        title: 'Hardware-Engineering',
        description: 'Professionelle Hardware- und Steuerungskonzepte für Ihre Anlagen und Maschinen. Mit umfassendem System Know-how und langjähriger Erfahrung in der Automatisierung.'
      },
      elektromontage: {
        title: 'Elektromontage',
        description: 'Professionelle Elektromontage und Installation elektrischer Anlagen nach höchsten Sicherheitsstandards für Ihre Automatisierungslösungen.'
      }
    },
    company: {
      tagline: 'Mit Hauptsitz in Aarwangen ist die W. Althaus AG seit über 50 Jahren der Full-Service-Spezialist für industrielle Automation.',
      founded: 'Gegründet 1980',
      familyOwned: 'Inhabergeführt',
      employees: '50+ Mitarbeiter',
      hours: 'Öffnungszeiten',
      hoursDetail: 'Montag bis Donnerstag\n07.30 - 12.00 Uhr /\n13.00 - 16.00 Uhr\n\nFreitag\n07.30 - 12.00 Uhr /\n13.00 - 15.00 Uhr',
      contactTitle: 'KONTAKT',
      headquarters: 'Hauptsitz\nW. Althaus AG\nIndustrielle Automation\nJurastrasse 12\nCH-4912 Aarwangen\nSwitzerland',
      production: 'Produktion\nW. Althaus AG\nIndustrielle Automation\nIndustriering 2\nCH-4912 Aarwangen\nSwitzerland',
      phone1: '+41 62 919 82 10',
      phone2: '+41 62 919 82 29',
      email: ''
    },
    about: {
      title: 'Über uns',
      subtitle: 'Die W. Althaus AG in Aarwangen ist seit über 50 Jahren der Schweizer Full-Service-Spezialist für industrielle Automation',
      story: {
        title: 'Unsere Geschichte',
        description: 'Wir sind ein Schweizer Familienunternehmen, das 1968 in Aarwangen im Kanton Bern gegründet wurde. Heute arbeiten an zwei Standorten über 160 Mitarbeiterinnen und Mitarbeiter, und die W. Althaus AG gilt als wichtiger und richtungsweisender Arbeitgeber in der Region.'
      },
      expertise: {
        title: 'Unsere Kernkompetenz',
        description: 'Entwicklung und Produktion von einfachsten elektrischen Steuerungen bis hin zu komplexen Automatisierungslösungen. Als Full-Service-Unternehmen bieten wir Konzeptberatung, Hard- und Software-Engineering, Schaltschrankbau, Klemmensteg-Produktion, Baugruppenmontage, Montagesupport, Inbetriebnahme und Training. - Alles aus einer Hand.'
      },
      stats: {
        experience: "50+",
        experienceLabel: "Jahre Erfahrung",
        employees: "160+",
        employeesLabel: "Mitarbeitende",
        locations: "2",
        locationsLabel: "Standorte"
      },
      team: {
        title: 'Unser Team',
        subtitle: 'Unsere Ansprechpartner sind gerne für Sie da',
        description: 'Wir sind ein dynamisches und hochmotiviertes Team, das sich mit ausgezeichneten Qualifikationen für Kunden aus der ganzen Welt engagiert. Als Familienunternehmen setzen wir dabei auf langfristiges Denken und stehen für Vertrauen, Kontinuität und Kompetenz. Unsere Ansprechpartner sind gerne für Sie da.',
        leadership: 'Geschäftsleitung',
        hrVocationalTraining: 'HR/Berufsbildung',
        members: {
          walterAlthaus: {
            name: 'Walter Althaus',
            position: 'Geschäftsinhaber',
            phone: '+41 62 919 82 12'
          },
          marcoSchneider: {
            name: 'Marco Schneider', 
            position: 'Geschäftsführer / CEO',
            phone: '+41 62 919 82 26'
          },
          manfredBoegli: {
            name: 'Manfred Bögli',
            position: 'Leiter Finanzen / HR', 
            phone: '+41 62 919 82 33'
          },
          michaelKuenzi: {
            name: 'Michael Künzi',
            position: 'Leiter Produktion',
            phone: '+41 62 919 82 18'
          },
          thiloBiss: {
            name: 'Thilo Biss',
            position: 'Leiter Entwicklung',
            phone: '+41 62 919 82 37'
          },
          retoFritsche: {
            name: 'Reto Fritsche', 
            position: 'Leiter Vertrieb',
            phone: '+41 62 919 82 39'
          },
          stefanBrudermann: {
            name: 'Stefan Brudermann',
            position: 'Leiter Material Management',
            phone: '+41 62 531 83 94'
          },
          kathrinWalter: {
            name: 'Kathrin Walter',
            position: 'HR-Verantwortliche',
            phone: ''
          },
          rolandRebecchi: {
            name: 'Roland Rebecchi',
            position: 'Leiter Berufsbildung', 
            phone: '+41 62 919 82 19'
          }
        }
      }
    },
    careers: {
      title: 'Karriere',
      subtitle: 'Werden Sie Teil unseres Teams - Gestalten Sie mit uns die Zukunft der industriellen Automation',
      teamSpirit: {
        title: 'Unser Teamgeist',
        description: 'Wir sind ein junges, dynamisches und hochmotiviertes Team. Unsere ausgezeichneten Qualifikationen setzen wir mit Engagement für unsere Kunden aus der ganzen Welt ein. Wir pflegen ein offenes und vertrauensvolles Miteinander und leben eine hohe Identifikation mit unserem Unternehmen.'
      },
      employer: {
        title: 'Arbeitgeber für die Region',
        description: 'Wir pflegen mit unseren Mitarbeitenden wie mit unseren Lieferanten, Partnern und Kunden eine von Kontinuität geprägte Partnerschaft. Die W. Althaus AG ist dadurch ein wichtiger und sicherer Arbeitgeber in der Region.'
      },
      benefits: {
        title: 'Was macht es besonders, für uns zu arbeiten?',
        items: [
          'Familiäres Arbeitsklima',
          'Ausgewogene Work-Life-Balance',
          'Flexible Arbeitszeiten',
          'Top ausgestattete Arbeitsplätze',
          'Spannende und abwechslungsreiche Arbeitsinhalte',
          'Positive Unternehmensentwicklung'
        ]
      },
      education: {
        title: 'Aus- und Weiterbildung',
        subtitle: 'Wir bilden Profis aus',
        description: 'Über hundert qualifizierte Mitarbeitende aus den Bereichen Engineering, CAE, Produktion und Logistik belegen die hohe und breit gestützte Fachkompetenz der W. Althaus AG. Die konsequente Aus- und Weiterbildung unserer Mitarbeitenden ist Teil unserer Unternehmensphilosophie.',
        apprenticeships: {
          title: 'Lehrberufe',
          automatiker: {
            title: 'Automatiker/-in EFZ',
            description: 'Automatiker/innen arbeiten in Bereichen wie Steuerungsbau, Energieverteilung, Verfahrenstechnik, Elektromaschinenbau oder Industrieautomation. Sie entwickeln oder konstruieren Lösungen für Steuerungs- und Automatisierungsaufgaben.'
          },
          automatikmonteur: {
            title: 'Automatikmonteur/-in EFZ',
            description: 'Automatikmonteure/-innen montieren, warten und reparieren elektronische Anlagen und Geräte oder betreuen entsprechende Produktionsvorgänge.'
          }
        }
      },
      openings: {
        title: 'Offene Stellen',
        noOpenings: 'Aktuell sind keine Stellen ausgeschrieben',
        spontaneous: {
          title: 'Initiativbewerbung',
          description: 'Ihre Wunschstelle ist nicht verfügbar? Wir freuen uns über Ihre Initiativbewerbung. Falls Ihre Bewerbung einem gesuchten Profil entspricht, melden wir uns gerne bei Ihnen.'
        },
        apply: 'Jetzt bewerben',
        backToListings: 'Zurück zu den Stellenausschreibungen',
        viewDetails: 'Details ansehen',
        jobs: {
          hardwareentwickler: {
            title: "Hardwareentwickler (m/w/d)",
            department: "Engineering",
            type: "Festanstellung",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "September oder nach Vereinbarung",
            applicationUrl: "https://odm.ostendis.com/ojp/#!/cvdropper/bb9db840f04d469e9cc3d22a297358d8/DE?src=qjvrssywz65ofdiiqtiqfzwz42lspjzqug6r386umf3ekedccpopbbvwm225p0n7",
            description: "Digitalisierung, Automation oder Robotik - alle reden darüber. Bei uns stecken Sie mittendrin! Denn wir arbeiten mit modernsten Tools und Technologien.",
            longDescription: "Als Hardwareentwickler bei der W. Althaus AG sind Sie Teil eines innovativen Teams, das sich auf die Entwicklung modernster Automatisierungslösungen spezialisiert hat. Sie arbeiten an spannenden Projekten in den Bereichen Digitalisierung, Automation und Robotik und tragen entscheidend zur technologischen Weiterentwicklung unseres Unternehmens bei.",
            requirements: [
              "Techniker TS oder Ingenieurstudium (HF/FH) Elektrotechnik/Automation",
              "Erfahrung mit EPLAN P8, idealerweise auch Pro Panel",
              "Fundierte IT-Kenntnisse im Microsoft-365-Umfeld",
              "Englischkenntnisse",
              "Selbständige, strukturierte und lösungsorientierte Arbeitsweise",
              "Teamfähigkeit und Kommunikationsstärke",
              "Interesse an innovativen Technologien"
            ],
            responsibilities: [
              "Selbständige Konzeption, Entwicklung und Realisierung von Automatisierungslösungen/Steuerungshardware",
              "Technische Ausarbeitung von Angeboten in enger Zusammenarbeit mit dem Vertrieb",
              "Planung und Weiterentwicklung von Steuerungshardware - standardisiert, dokumentiert und normenkonform",
              "Schemaerstellung mit EPLAN P8 auf Basis von Kundenvorgaben",
              "Begleitung der Projekte bis zur Inbetriebnahme inkl. technischem Support",
              "Zusammenarbeit mit interdisziplinären Teams",
              "Qualitätssicherung und Dokumentation"
            ],
            benefits: [
              "Spannende und vielseitige Tätigkeit in einem dynamischen Team",
              "Fortschrittliche Anstellungsbedingungen",
              "Hervorragende Sozialleistungen",
              "Moderner Arbeitsplatz mit neuester Technik",
              "Flexible Arbeitszeiten",
              "Weiterbildungsmöglichkeiten",
              "Betriebliche Altersvorsorge",
              "Firmenparkplatz"
            ],
            labels: {
              location: "Standort",
              workload: "Pensum", 
              type: "Anstellung",
              startDate: "Start",
              requirements: "Anforderungen",
              responsibilities: "Aufgaben",
              benefits: "Unser Angebot",
              featuredPosition: "Top Position"
            }
          },
          projektleiter: {
            title: "Projektleiter Automation (m/w/d)",
            department: "Projektmanagement",
            type: "Festanstellung",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "Nach Vereinbarung",
            applicationUrl: "https://ostendis.com/apply/5023-projektleiter-automation-m-w-d",
            description: "Übernehmen Sie die Führung komplexer Automatisierungsprojekte und gestalten Sie die Zukunft der industriellen Automation mit.",
            longDescription: "Als Projektleiter Automation bei der W. Althaus AG übernehmen Sie die Verantwortung für komplexe Automatisierungsprojekte von der Konzeption bis zur erfolgreichen Inbetriebnahme. Sie koordinieren interdisziplinäre Teams und sorgen für die termingerechte und budgetconforme Umsetzung unserer innovativen Lösungen.",
            requirements: [
              "Abgeschlossene technische Ausbildung (HF/FH) in Elektrotechnik, Automation oder ähnlich",
              "Mehrjährige Erfahrung im Projektmanagement, idealerweise in der Automatisierung",
              "Fundierte Kenntnisse in Projektmanagement-Methoden (PMI, PRINCE2 von Vorteil)",
              "Erfahrung mit MS Project oder ähnlichen Tools",
              "Ausgezeichnete Kommunikations- und Führungsfähigkeiten",
              "Deutsch und Englisch fließend",
              "Reisebereitschaft (ca. 20%)"
            ],
            responsibilities: [
              "Leitung und Koordination von Automatisierungsprojekten von A-Z",
              "Projektplanung, Budgetierung und Ressourcenmanagement",
              "Führung interdisziplinärer Projektteams",
              "Kundenbetreuung und Stakeholder-Management",
              "Risikomanagement und Qualitätssicherung",
              "Terminüberwachung und Projektcontrolling",
              "Dokumentation und Berichtswesen",
              "Kontinuierliche Prozessverbesserung"
            ],
            benefits: [
              "Verantwortungsvolle Position mit Gestaltungsspielraum",
              "Abwechslungsreiche Projekte mit modernster Technologie",
              "Attraktive Anstellungsbedingungen",
              "Umfassende Sozialleistungen",
              "Flexible Arbeitsmodelle",
              "Weiterbildungsmöglichkeiten und Zertifizierungen",
              "Modernes Arbeitsumfeld",
              "Firmenwagen oder ÖV-Abo"
            ],
            labels: {
              location: "Standort",
              workload: "Pensum",
              type: "Anstellung", 
              startDate: "Start",
              requirements: "Anforderungen",
              responsibilities: "Aufgaben",
              benefits: "Unser Angebot",
              featuredPosition: "Top Position"
            }
          },
          automatiker: {
            title: "Automatiker EFZ (m/w/d)",
            department: "Produktion",
            type: "Festanstellung",
            workload: "100%",
            location: "Aarwangen",
            startDate: "Nach Vereinbarung",
            applicationUrl: "https://ostendis.com/apply/5025-automatiker-m-w-d",
            description: "Werden Sie Teil unseres Produktionsteams und arbeiten Sie an der Realisierung modernster Automatisierungslösungen.",
            longDescription: "Als Automatiker EFZ bei der W. Althaus AG sind Sie für die fachgerechte Montage, Verdrahtung und Inbetriebnahme von Automatisierungsanlagen verantwortlich. Sie arbeiten sowohl in unserer modernen Produktionsstätte als auch direkt beim Kunden vor Ort.",
            requirements: [
              "Abgeschlossene Berufslehre als Automatiker EFZ oder gleichwertige Ausbildung",
              "Mehrjährige Berufserfahrung in der Automatisierungstechnik",
              "Erfahrung mit SPS-Programmierung (Siemens, Beckhoff, etc.)",
              "Kenntnisse in Schaltschrankbau und Verdrahlungstechnik",
              "Präzise und selbständige Arbeitsweise",
              "Teamfähigkeit und Zuverlässigkeit",
              "Reisebereitschaft für Montagen beim Kunden"
            ],
            responsibilities: [
              "Montage und Verdrahtung von Schaltschränken und Automatisierungskomponenten",
              "Inbetriebnahme von Steuerungsanlagen beim Kunden",
              "SPS-Programmierung und Parametrierung",
              "Durchführung von Funktions- und Sicherheitsprüfungen",
              "Fehlerdiagnose und Reparaturen",
              "Dokumentation der durchgeführten Arbeiten",
              "Kundenschulungen und technischer Support",
              "Einhaltung der Sicherheitsvorschriften"
            ],
            benefits: [
              "Abwechslungsreiche Tätigkeit in der Produktion und beim Kunden",
              "Arbeit mit modernster Automatisierungstechnik",
              "Attraktive Entlöhnung nach Qualifikation",
              "Umfassende Sozialleistungen",
              "Flexible Arbeitszeiten nach Absprache",
              "Weiterbildungsmöglichkeiten",
              "Spesenvergütung bei Aussenmontagen",
              "Firmenwagen für Kundeneinsätze"
            ],
            labels: {
              location: "Standort",
              workload: "Pensum",
              type: "Anstellung",
              startDate: "Start", 
              requirements: "Anforderungen",
              responsibilities: "Aufgaben",
              benefits: "Unser Angebot",
              featuredPosition: "Top Position"
            }
          }
        }
      }
    },
    vocationalTraining: {
      title: "Berufsbildung bei W. Althaus AG",
      subtitle: "Investieren Sie in Ihre Zukunft mit einer hochwertigen Ausbildung in der Automatisierungstechnik. Unsere Lernenden profitieren von modernster Technologie, erfahrenen Mentoren und vielfältigen Karrieremöglichkeiten.",
      badge: "Ausbildungsplätze verfügbar",
      programs: {
        title: "Unsere Ausbildungsprogramme",
        description: "Wir bieten praxisnahe Ausbildungen in zukunftsorientierten Berufen der Automatisierungs- und Elektrotechnik.",
        highlights: "Ausbildungsschwerpunkte",
        automatiker: {
          title: "Automatiker/in EFZ",
          description: "Als Automatiker/in entwickeln, installieren und warten Sie automatisierte Anlagen und Systeme. Sie arbeiten mit modernster Technologie und lernen alle Aspekte der industriellen Automatisierung kennen.",
          highlights: [
            "Programmierung von SPS-Steuerungen",
            "Installation von Automatisierungsanlagen",
            "Inbetriebnahme komplexer Systeme",
            "Fehlerdiagnose und Wartung",
            "Projektarbeit im Team"
          ]
        },
        automatikmonteur: {
          title: "Automatikmonteur/in EFZ",
          description: "Als Automatikmonteur/in montieren Sie elektrische und pneumatische Komponenten, verdrahten Schaltschränke und nehmen automatisierte Anlagen in Betrieb.",
          highlights: [
            "Schaltschrankbau und Verdrahtung",
            "Montage von Komponenten",
            "Inbetriebnahme von Anlagen",
            "Qualitätskontrolle",
            "Kundenbetreuung vor Ort"
          ]
        }
      },
      benefits: {
        title: "Warum eine Ausbildung bei uns?",
        description: "Bei W. Althaus AG erhalten Sie nicht nur eine erstklassige fachliche Ausbildung, sondern werden auch persönlich gefördert und unterstützt.",
        mentorship: {
          title: "Erfahrene Mentoren",
          description: "Unsere erfahrenen Fachkräfte begleiten Sie während der gesamten Ausbildung und stehen Ihnen mit Rat und Tat zur Seite."
        },
        practical: {
          title: "Praxisnahe Ausbildung", 
          description: "Arbeiten Sie von Anfang an an echten Projekten mit modernster Technologie und sammeln Sie wertvolle Berufserfahrung."
        },
        career: {
          title: "Karrieremöglichkeiten",
          description: "Nach der Ausbildung bieten wir Ihnen attraktive Übernahmemöglichkeiten und vielfältige Weiterbildungschancen."
        },
        culture: {
          title: "Familiäres Arbeitsklima",
          description: "Profitieren Sie von unserem offenen, unterstützenden Arbeitsklima und werden Sie Teil unseres Teams."
        }
      },
      timeline: {
        title: "Ihr Ausbildungsweg",
        description: "Von den Grundlagen bis zum Fachexperten - so entwickeln Sie sich während Ihrer Ausbildung bei uns.",
        year1: {
          title: "Grundlagen & Orientierung",
          description: "Erlernen Sie die Grundlagen der Elektrotechnik, Mechanik und ersten Programmiersprachen. Orientierung im Betrieb und kennenlernen der verschiedenen Abteilungen."
        },
        year2: {
          title: "Praxis & Vertiefung", 
          description: "Erste praktische Arbeiten an Anlagen, Vertiefung der SPS-Programmierung und Teilnahme an kleineren Projekten."
        },
        year3: {
          title: "Spezialisierung & Projekte",
          description: "Spezialisierung auf Ihren gewählten Bereich, Mitarbeit in Kundenprojekten und Übernahme von Verantwortung."
        },
        year4: {
          title: "Expertenrolle & Abschluss",
          description: "Selbstständiges Arbeiten, Betreuung jüngerer Lernender und Vorbereitung auf das Qualifikationsverfahren."
        }
      },
      cta: {
        title: "Starten Sie Ihre Karriere bei uns!",
        description: "Bewerben Sie sich jetzt für einen Ausbildungsplatz bei W. Althaus AG und legen Sie den Grundstein für eine erfolgreiche Zukunft in der Automatisierungstechnik.",
        apply: "Jetzt bewerben",
        contact: "Kontakt aufnehmen"
      }
    },
    news: {
      title: 'News',
      subtitle: 'Aktuelle Neuigkeiten aus dem Unternehmen',
      readMore: 'Weiterlesen',
      watchVideo: 'Video ansehen',
      backToOverview: 'Zurück zur Übersicht',
      noNews: 'Derzeit sind keine Neuigkeiten verfügbar.',
      filter: {
        all: 'Alle',
        company: 'Unternehmen',
        training: 'Berufsbildung',
        events: 'Events'
      }
    },
    jobDetailLabels: {
      jobDescription: 'Stellenbeschreibung',
      responsibilities: 'Ihre Aufgaben',
      requirements: 'Anforderungen',
      benefits: 'Das bieten wir Ihnen',
      applyNow: 'Jetzt bewerben!',
      convinceUs: 'Überzeugen Sie uns mit Ihrer Bewerbung',
      applyOnline: 'Online bewerben',
      questionsContact: 'Haben Sie Fragen? Kontaktieren Sie uns gerne telefonisch oder per E-Mail.',
      aboutUs: 'Über uns',
      companyDescription: 'Die W. Althaus AG ist ein führendes Unternehmen im Bereich Industrieautomation mit über 25 Jahren Erfahrung. Wir entwickeln innovative Lösungen für die Zukunft der Produktion.',
      employees: '50+ Mitarbeitende',
      international: 'International tätig',
      isoCertified: 'ISO 14001 zertifiziert',
      backToListings: 'Zurück zu den Stellenausschreibungen',
      featuredPosition: 'Featured Position',
      urgentlyNeeded: 'Dringend gesucht!',
      location: 'Standort',
      workload: 'Pensum',
      employment: 'Anstellung',
      startDate: 'Start'
    },
    caseStudyLabels: {
      backToOverview: 'Zurück zur Übersicht',
      challengePrefix: 'Vorher:',
      challenge: 'Die Herausforderung',
      solutionPrefix: 'Jetzt:',
      solution: 'Die Lösung mit W. Althaus AG',
      positiveOutcomes: 'Positive Outcomes',
      servicesInProject: 'Leistungen im Projekt',
      conclusion: 'Fazit',
      yourProject: 'Ihr Projekt mit',
      realizeTogether: 'Lassen Sie uns gemeinsam Ihre Automatisierungslösung realisieren',
      requestProject: 'Projekt anfragen',
      moreSuccessStories: 'Weitere Success Stories',
      learnMore: 'Mehr erfahren',
      about: 'Über',
      content: 'Inhalt',
      customerSince: 'Kunde seit',
      builtCabinets: 'Gebaute Schaltschränke',
      automationDegree: 'Automatisierungsgrad',
      onTimeDelivery: 'Termintreue',
      negativeConsequences: 'Negative Konsequenzen',
      challengeWithout: 'Die Herausforderung ohne W. Althaus AG',
      solutionWith: 'Die Lösung mit der W. Althaus AG',
      projectFits: 'Ihr Projekt passt',
      scalableCabinetBuild: 'Skalierbarer Schaltschrankbau für Ihre Serie.'
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Nehmen Sie Kontakt mit uns auf. Wir freuen uns auf Ihre Anfrage.',
      headquarters: 'Hauptsitz',
      production: 'Produktionsstandort',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      hours: 'Öffnungszeiten',
      directPhone: 'Direktwahl Produktion',
      directions: 'Anfahrt',
      directionsText: 'Direkt an der Autobahn A1, Ausfahrt Aarwangen. Parkplätze für Besucher direkt am Gebäude verfügbar.',
      hoursText: 'Mo-Fr: 07:00 - 17:00 Uhr\nSa: Nach Vereinbarung',
      form: {
        title: 'Anfrage senden',
        subtitle: 'Wir melden uns so schnell wie möglich – in der Regel innerhalb eines Arbeitstages.',
        sections: {
          concern: 'Ihr Anliegen',
          personal: 'Persönliche Angaben',
          message: 'Ihre Nachricht',
          privacy: 'Datenschutz'
        },
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          company: 'Firma',
          email: 'E-Mail',
          phone: 'Telefon',
          contactMethod: 'Bevorzugte Kontaktart',
          category: 'Was ist Ihr Anliegen?',
          categoryHint: 'Bitte wählen Sie die passende Kategorie aus:',
          subject: 'Betreff',
          requestTo: 'Anfrage An',
          services: 'Anliegen / interessierte Dienstleistung',
          message: 'Bitte beschreiben Sie Ihre Anfrage',
          files: 'Dateien hochladen',
          privacy: 'Datenschutz-Einwilligung'
        },
        placeholders: {
          firstName: 'z. B. Max',
          lastName: 'z. B. Muster',
          company: 'z. B. Muster AG',
          email: 'z. B. max.muster@beispiel.ch',
          phone: 'z. B. +41 79 123 45 67',
          message: 'Bitte beschreiben Sie Ihre Anfrage.',
          subject: 'Geben Sie einen Betreff der Nachricht an',
          requestTo: 'z. B. Herr Muster',
          preferredTime: 'Bevorzugte Uhrzeit'
        },
        options: {
          contactMethod: {
            email: 'E-Mail',
            phone: 'Telefon'
          },
          categories: {
            serviceInquiry: 'Anfrage zu unseren Dienstleistungen',
            productIntro: 'Produkt oder Dienstleistung vorstellen',
            general: 'Allgemeine Anfrage',
            support: 'Support zu einem bestehenden Auftrag'
          },
          services: {
            controlCabinet: 'Schaltschrankbau',
            hardwareEngineering: 'Hardware Engineering',
            softwareEngineering: 'Software Engineering',
            cableAssembly: 'Litzenkonfektion',
            terminalProduction: 'Klemmenstegproduktion',
            consulting: 'Beratung',
            other: 'Sonstiges'
          },
          preferredTime: {
            morning: 'Vormittag',
            afternoon: 'Nachmittag',
            flexible: 'flexibel'
          }
        },
        validation: {
          firstNameRequired: 'Bitte Vorname angeben.',
          lastNameRequired: 'Bitte Nachname angeben.',
          companyRequired: 'Bitte Firma angeben.',
          contactRequired: 'Bitte E-Mail oder Telefon angeben (mind. eines ist erforderlich).',
          emailInvalid: 'Bitte eine gültige E-Mail-Adresse eingeben.',
          phoneInvalid: 'Bitte eine gültige Telefonnummer eingeben (z. B. +41 79 123 45 67).',
          contactMethodRequired: 'Bitte Kontaktart wählen.',
          categoryRequired: 'Bitte wählen Sie ein Anliegen aus.',
          messageRequired: 'Bitte beschreiben Sie Ihre Anfrage.',
          phoneRequiredWhenSelected: 'Bitte geben Sie Ihre Telefonnummer ein, wenn Sie telefonisch kontaktiert werden möchten.',
          emailRequiredWhenSelected: 'Bitte geben Sie Ihre E-Mail-Adresse ein, wenn Sie per E-Mail kontaktiert werden möchten.',
          servicesRequired: 'Bitte mindestens eine Dienstleistung auswählen.',
          privacyRequired: 'Bitte der Datenverarbeitung zustimmen.'
        },
        buttons: {
          submit: 'Anfrage senden',
          submitting: 'Wird gesendet...',
          newRequest: 'Neue Anfrage senden',
          callAlternative: 'Oder rufe uns an: +41 62 919 82 10'
        },
        error: {
          title: 'Fehler',
          message: 'Beim Senden der Anfrage ist ein Fehler aufgetreten.'
        },
        success: {
          title: 'Anfrage erfolgreich übermittelt',
          message: 'Ihre Anfrage wurde erfolgreich übermittelt. Wir melden uns zeitnah bei Ihnen.',
          newsTitle: 'Neuigkeiten aus unserem Unternehmen',
        },
        privacy: {
          text: 'Ich stimme der Verarbeitung meiner Angaben gemäss',
          link: 'Datenschutzerklärung',
          linkText: 'zu.'
        },
        fileUpload: {
          accepted: 'PDF, PNG/JPG, ZIP • Max. 15 MB • Mehrfachupload erlaubt',
          dropzone: 'Dateien hier ablegen oder klicken zum Auswählen'
        }
      }
    },
    anfahrt: {
      title: 'Anfahrt',
      subtitle: 'Besuchen Sie uns in Aarwangen - Direkt an der Autobahn A1 gelegen',
      hero: {
        title: 'Willkommen bei W. Althaus AG',
        subtitle: 'Finden Sie einfach zu uns nach Aarwangen. Unser Hauptsitz und Werk 2 sind verkehrsgünstig direkt an der Autobahn A1 gelegen.'
      },
      headquarters: {
        title: 'Hauptsitz',
        name: 'W. Althaus AG',
        street: 'Jurastrasse 12',
        city: '4912 Aarwangen',
        country: 'Schweiz'
      },
      werk2: {
        title: 'Werk 2 - Produktion',
        name: 'W. Althaus AG - Werk 2',
        street: 'Industriering',
        city: '4912 Aarwangen',
        country: 'Schweiz'
      },
      contact: {
        phone: '+41 62 919 82 82',
        email: '',
        website: 'www.althaus.swiss'
      },
      directions: {
        title: 'Anfahrt mit dem Auto',
        highway: 'Autobahn A1',
        exit: 'Ausfahrt Aarwangen',
        description: 'Nehmen Sie die Ausfahrt Aarwangen und folgen Sie der Beschilderung Richtung Industriegebiet. Beide Standorte befinden sich im Industriegebiet Aarwangen.'
      },
      parking: {
        title: 'Parkplätze',
        description: 'Kostenlose Besucherparkplätze stehen an beiden Standorten zur Verfügung.'
      },
      publicTransport: {
        title: 'Öffentliche Verkehrsmittel',
        train: 'Bahnhof Aarwangen (10 Minuten zu Fuss)',
        bus: 'Bushaltestelle Aarwangen Dorf (5 Minuten zu Fuss)'
      },
      hours: {
        title: 'Öffnungszeiten',
        weekdays: 'Montag - Freitag: 07:00 - 17:00 Uhr',
        saturday: 'Samstag: Nach Vereinbarung',
        sunday: 'Sonntag: Geschlossen'
      }
    },
    products: {
      title: 'Produkte',
      subtitle: 'Entdecken Sie unser Portfolio an hochwertigen Automatisierungslösungen und Produkten für die Industrie.'
    },
    cookieConsent: {
      bannerTitle: 'Privatsphäre-Einstellungen',
      bannerText: 'Diese Website nutzt Technologien von Drittanbietern, um Dienste anzubieten, stetig zu verbessern und Inhalte entsprechend Ihren Interessen anzuzeigen.',
      privacyPolicy: 'Datenschutzerklärung',
      imprint: 'Impressum',
      settings: 'Einstellungen',
      acceptAll: 'Alles akzeptieren',
      saveSettings: 'Einstellungen speichern',
      cookieSettings: 'Cookie-Einstellungen',
      modalTitle: 'Privatsphäre-Einstellungen',
      modalDescription: 'Mit diesem Tool können Sie Ihre Zustimmung zur Erfassung und Verarbeitung personenbezogener Daten durch Technologien von Drittanbietern verwalten.',
      tabCategories: 'Kategorien',
      tabServices: 'Services',
      categories: {
        essential: { name: 'Essenziell', description: 'Diese Technologien sind erforderlich, um die wesentlichen Funktionen unseres Dienstleistungsangebots zu aktivieren.' },
        functional: { name: 'Funktionell', description: 'Diese Technologien ermöglichen es uns, das Nutzungsverhalten zu analysieren, um die Leistungsfähigkeit unserer Website zu messen und zu verbessern.' },
        marketing: { name: 'Marketing', description: 'Diese Technologien werden von Werbetreibenden verwendet, um Anzeigen zu schalten, die für Ihre Interessen relevant sind.' }
      },
      services: {
        consentManager: { name: 'Consent Manager', description: 'Speichert Ihre Datenschutz-Präferenzen sicher in Ihrem Browser.' },
        cloudflare: { name: 'Cloudflare', description: 'Content Delivery Network zur sicheren und schnellen Auslieferung der Website.' },
        googleFonts: { name: 'Google Fonts', description: 'Lädt Webschriften für eine konsistente Darstellung der Website.' },
        googleMaps: { name: 'Google Maps', description: 'Zeigt interaktive Karten zur Anfahrt und für Standortinformationen an.' },
        ostendis: { name: 'Ostendis', description: 'Stellt aktuelle Stelleninserate auf der Karriereseite bereit.' },
        googleAnalytics: { name: 'Google Analytics', description: 'Analysiert anonymisiert die Nutzung der Website zur Verbesserung des Angebots.' },
        googleTagManager: { name: 'Google Tag Manager', description: 'Verwaltet Marketing- und Analyse-Tags der Website.' },
        googleAds: { name: 'Google Ads', description: 'Wird verwendet, um relevante Werbung auszuspielen und Konversionen zu messen.' }
      },
      alwaysActive: 'Immer aktiv',
      poweredBy: 'Bereitgestellt von W. Althaus AG'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      products: 'Products',
      about: 'About Us',
      leitbild: 'Mission Statement',
      team: 'Management',
      partners: 'Partners & Ecosystem',
      anfahrt: 'Directions',
      chameleonStory: 'Chameleon Story',
      successStories: 'Success Stories',
      sustainability: 'Sustainability',
      sustainabilityDescription: 'Sustainable automation for a better future',
      careers: 'Careers',
      careersDescription: 'Join our innovative team',
      vocationalTraining: 'Vocational Training',
      vocationalTrainingDescription: 'Start your career with first-class training',
      news: 'News',
      contact: 'Contact',
      overview: 'Overview'
    },
    routes: {
      services: 'services',
      products: 'products',
      about: 'about',
      sustainability: 'sustainability',
      careers: 'careers',
      news: 'news',
      contact: 'contact',
      jobOpenings: 'job-openings',
      vocationalTraining: 'vocational-training',
      schaltschrankbau: 'control-cabinet-construction',
      engineering: 'engineering',
      softwareengineering: 'software-engineering',
      leitbild: 'mission-statement',
      team: 'management',
      partners: 'partners-ecosystem',
      anfahrt: 'directions',
      chameleonStory: 'chameleon-story',
      successStories: 'success-stories',
      hardwareentwickler: 'hardware-developer',
      projektleiter: 'project-manager',
      automatiker: 'automation-technician',
      athex: 'athex',
      panelscout: 'panelscout',
      documents: 'documents',
      ausstellung: 'exhibition'
    },
    footer: {
      imprint: 'Imprint',
      privacy: 'Privacy',
      howToGetHere: 'How to get here',
      documents: 'Documents',
      quickLinks: 'Quick Links',
      company: 'Company',
      headquarters: 'Headquarters',
      isoCertified: 'ISO 14001 certified',
      copyright: '© 2026 W. Althaus AG. All rights reserved.',
      quality: 'Leading in Automation since 1968'
    },
    home: {
      hero: {
        weAre: 'We are...',
        title: 'Productivity through integrated workflows & automated production',
        subtitle: 'For over 40 years, we have been increasing productivity through integrated workflows and fully automated production - every single day.',
        tagline: 'Our automation for your competitive advantage',
        ctaContact: 'Get in touch',
        ctaServices: 'View services',
        stats: {
          experience: 'Years Experience',
          projects: 'Projects',
          employees: 'Employees working on your dreams',
          swissFamily: 'Swiss Family Business'
        }
      },
      services: {
        title: 'Our Services',
        subtitle: 'Complete solutions for industrial automation',
        viewAll: 'View all services',
        learnMore: 'Learn more'
      },
      partners: {
        title: 'Our Partners',
        subtitle: 'Trust in proven technologies from leading manufacturers'
      }
    },
    services: {
      title: 'Services',
      subtitle: 'Your automation. Our expertise.',
      schaltschrankbau: {
        title: 'Control Cabinet Construction',
        description: 'As the largest and leading Swiss company in control cabinet construction, we provide you with new competitive advantages through our AI-supported, fully automated production',
        badge: 'Control Cabinet Construction 4.0',
        heroTitle: 'Professional Control Cabinet Construction',
        heroSubtitle: 'Our automation with control cabinet construction 4.0 for your competitive advantage. From prototypes to series production - fully automated processes for highest quality.',
        servicesTitle: 'Our Service Range',
        servicesSubtitle: 'Fully automated production with optimal manufacturing depth while maintaining full flexibility regarding customer requirements.',
        capabilitiesTitle: 'Our Service Offering',
        capabilitiesSubtitle: 'On behalf of their customers, W. Althaus AG builds and assembles control cabinets and assemblies for various markets from prototypes to series and variant production.',
        automationTitle: 'Fully Automated Production',
        automationDescription: 'The high degree of automation generates consistently high quality at competitive conditions.',
        automationGrade: 'Automation Degree',
        ctaTitle: 'Ready for Your Control Cabinet Construction?',
        ctaSubtitle: 'Let us realize your automation solution together. Contact us for a non-binding consultation.',
        ctaButtonPrimary: 'Request Project',
        ctaButtonSecondary: 'View References',
        features: {
          ecad: {
            title: 'E-CAD Engineering',
            description: 'Professional planning with ePlan P8, ePlan Pro Panel and E3.series for precise circuit diagrams'
          },
          production: {
            title: 'Fully Automated Production',
            description: 'Control cabinet construction 4.0 with highest degree of automation for consistent quality'
          },
          compliance: {
            title: 'Standards Compliance',
            description: 'Compliance with all relevant norms and standards for maximum operational safety'
          },
          terminals: {
            title: 'Terminal Strip Production',
            description: 'Automatic production of terminal strips with Phoenix Contact connectors'
          },
          assembly: {
            title: 'Assembly Mounting',
            description: 'Professional mounting and integration of all components according to highest standards'
          },
          testing: {
            title: 'Testing & Verification Procedures',
            description: 'Comprehensive quality inspections and functional tests before delivery'
          }
        },
        benefits: {
          competitive: {
            title: 'Competitive Advantages',
            description: 'Through control cabinet construction 4.0 we generate measurable competitive advantages for you'
          },
          quality: {
            title: 'High Quality',
            description: 'Fully automated processes guarantee consistently high quality'
          },
          flexibility: {
            title: 'Flexibility',
            description: 'From prototypes to series production - we adapt to your requirements'
          },
          efficiency: {
            title: 'Cost Efficiency',
            description: 'Automation degree ensures competitive prices with highest quality'
          }
        },
        capabilities: [
          'E-CAD: ePlan P8, ePlan Pro Panel, E3.series',
          'Control cabinet construction from prototypes to series production',
          'Terminal strip production (Phoenix Contact)',
          'Assembly mounting and integration',
          'Testing and verification procedures',
          'Fully automated wiring',
          'Sheet metal processing and housing construction',
          'Quality control according to ISO standards'
        ],
        // NEW: Page-specific translations
        hero: {
          tagline: 'automated. precise. Althaus.',
          intro: 'With Control Cabinet Construction 4.0, we combine ECAD Digital Twin, modularized processes and highly automated production in Switzerland – for competitive costs, consistently high quality and series-level production starting from unit 1.'
        },
        cards: {
          whatYouGet: {
            title: 'What You Get at Althaus',
            description: 'We build and assemble control cabinets and assemblies for various industries – from prototypes to series production. Fully automated process chains, standardized modules and a continuous ECAD data flow ensure speed, quality and planability throughout the entire product lifecycle.'
          },
          scope: {
            title: 'Service Scope - Competencies & Tools',
            description: 'From the first click in ECAD to commissioning. We implement control cabinet solutions quickly, scalably and in compliance with standards. Digital Twin (ePlan P8/Pro Panel, E3), standardized platform kits and coordinated SCM ensure speed, quality and costs – 100% manufactured in Switzerland. With on-site installation and UL/CSA testing.'
          },
          howWeWork: {
            title: 'How We Work',
            description: 'From the first conversation to on-site installation. Goals, standards, quantity scenarios and budget clarified. Digital Twin (ePlan/E3, 3D Panel) with automatable wiring concept. Design for Assembly, standardization, UL/CSA check. Automated production: series-level quality from unit 1, changes until shortly before shipping, tests, documentation, traceability and support.'
          }
        },
        processSteps: {
          requirement: { title: 'Requirements & Consulting', description: 'Detailed requirements analysis and expert consulting for your project.' },
          engineering: { title: 'Engineering', description: 'Professional planning and technical elaboration to the highest standards.' },
          material: { title: 'Material & Preparation', description: 'Careful material selection and optimal preparation of all components.' },
          automated: { title: 'Automated Processing', description: 'Precise automated manufacturing with state-of-the-art technology.' },
          assembly: { title: 'Assembly & Wiring', description: 'Professional assembly and structured wiring according to industry standards.' },
          testing: { title: 'Testing & Acceptance', description: 'Comprehensive quality testing and documented acceptance of all systems.' },
          commissioning: { title: 'Commissioning', description: 'Professional commissioning and optimization at the customer site.' },
          service: { title: 'Service & Lifecycle', description: 'Long-term support and maintenance throughout the entire lifecycle.' }
        },
        servicesGrid: {
          ecad: { name: 'E-CAD: ePlan p8, ePlan Pro Panel, E3', description: 'Professional electrical planning with state-of-the-art CAD tools' },
          layout: { name: 'Cabinet Concept: Design, Layout', description: 'Well-thought-out conception and optimized layouts' },
          standardization: { name: 'Standardization, Modularization', description: 'Efficient processes through standardized modules' },
          procurement: { name: 'Procurement and Logistics Concepts', description: 'Optimized material flows and logistics' },
          materialOptimization: { name: 'Material Management Optimization', description: 'Efficient material planning and management' },
          production: { name: 'Prototyping, Single & Series Production', description: 'Flexible manufacturing for all requirements' },
          onSite: { name: 'On-Site Assembly at Customer', description: 'Professional installation and commissioning directly at your site' },
          ulCsa: { name: 'UL / CSA Certification', description: 'International certification for the North American market' }
        },
        valueProposition: {
          title: 'Your Added Value from Our Automation',
          cost: { title: 'Competitive Costs', description: 'Efficient processes and standardized workflows for optimal cost-effectiveness.' },
          quality: { title: 'Consistently High Quality', description: 'Strict quality controls and certified processes guarantee reliability.' },
          changes: { title: 'Late Changes Possible', description: 'Flexible adjustments until the last minute thanks to modular design.' },
          speed: { title: 'Short Lead Times', description: 'Automated manufacturing and optimized logistics for fast delivery.' }
        },
        sectionHeaders: {
          servicesOffering: 'Our Service Offering Includes'
        }
      },
      kabelkonfektion: {
        title: 'Cable Assembly',
        description: 'Professional cable assembly according to the highest quality standards'
      },
      klemmensteg: {
        title: 'Terminal Block Production',
        description: 'Precise terminal block production for your automation solutions'
      },
      softwareengineering: {
        title: 'Software Engineering',
        description: 'Complete software solutions from project planning to commissioning. User-friendly visualizations and customized database applications.'
      },
      engineering: {
        title: 'Hardware Engineering',
        description: 'We work together with you to develop a hardware and control concept for your specific system or machine. With our extensive system know-how and diverse experience in automation for the plant and machine building industry, you are always one step ahead with us.'
      }
    },
    company: {
      tagline: 'Based in Aarwangen, W. Althaus AG has been the full-service specialist for industrial automation for more than 50 years.',
      founded: 'Founded 1968',
      familyOwned: 'Owner-managed',
      employees: '50+ employees',
      hours: 'Opening Hours',
      hoursDetail: 'Monday to Thursday\n07.30 - 12.00 /\n13.00 - 16.00\n\nFriday\n07.30 - 12.00 /\n13.00 - 15.00',
      contactTitle: 'CONTACT',
      headquarters: 'Headquarters\nW. Althaus AG\nIndustrial Automation\nJurastrasse 12\nCH-4912 Aarwangen\nSwitzerland',
      production: 'Production\nW. Althaus AG\nIndustrial Automation\nIndustriering 2\nCH-4912 Aarwangen\nSwitzerland',
      phone1: '+41 62 919 82 10',
      phone2: '+41 62 919 82 29',
      email: ''
    },
    about: {
      title: 'About Us',
      subtitle: 'W. Althaus AG in Aarwangen has been Switzerland\'s full-service specialist for industrial automation for over 50 years',
      story: {
        title: 'Our Story',
        description: 'We are a Swiss family business that was founded in 1968 in Aarwangen in the canton of Bern. Today, over 160 employees work at two locations, and W. Althaus AG is considered an important and pioneering employer in the region.'
      },
      expertise: {
        title: 'Our Core Competency',
        description: 'Development and production of the simplest electrical controls to complex automation solutions. As a full-service company, we offer concept consulting, hardware software engineering, control cabinet construction, terminal block production, assembly group assembly, assembly support, commissioning and training.'
      },
      stats: {
        experience: "50+",
        experienceLabel: "Years Experience",
        employees: "160+",
        employeesLabel: "Employees",
        locations: "2",
        locationsLabel: "Locations"
      },
      team: {
        title: 'Our Team',
        subtitle: 'Our contact persons are happy to be there for you',
        description: 'We are a dynamic and highly motivated team, committed with excellent qualifications to customers from all over the world. As a family business, we focus on long-term thinking and stand for trust, continuity and competence. Our contact persons are happy to assist you.',
        leadership: 'Management',
        hrVocationalTraining: 'HR/Vocational Training',
        members: {
          walterAlthaus: {
            name: 'Walter Althaus',
            position: 'Owner',
            phone: '+41 62 919 82 12'
          },
          marcoSchneider: {
            name: 'Marco Schneider', 
            position: 'Managing Director / CEO',
            phone: '+41 62 919 82 26'
          },
          manfredBoegli: {
            name: 'Manfred Bögli',
            position: 'Head of Finance / HR', 
            phone: '+41 62 919 82 33'
          },
          michaelKuenzi: {
            name: 'Michael Künzi',
            position: 'Head of Production',
            phone: '+41 62 919 82 18'
          },
          thiloBiss: {
            name: 'Thilo Biss',
            position: 'Head of Development',
            phone: '+41 62 919 82 37'
          },
          retoFritsche: {
            name: 'Reto Fritsche', 
            position: 'Head of Sales',
            phone: '+41 62 919 82 39'
          },
          stefanBrudermann: {
            name: 'Stefan Brudermann',
            position: 'Head of Material Management',
            phone: '+41 62 531 83 94'
          },
          kathrinWalter: {
            name: 'Kathrin Walter',
            position: 'HR Manager',
            phone: ''
          },
          rolandRebecchi: {
            name: 'Roland Rebecchi',
            position: 'Head of Vocational Training', 
            phone: '+41 62 919 82 19'
          }
        }
      }
    },
    careers: {
      title: 'Careers',
      subtitle: 'Join our team - Shape the future of industrial automation with us',
      teamSpirit: {
        title: 'Our Team Spirit',
        description: 'We are a young, dynamic and highly motivated team. We use our excellent qualifications with dedication for our customers from all over the world. We maintain an open and trusting relationship with each other and live a high identification with our company.'
      },
      employer: {
        title: 'Employer for the Region',
        description: 'We maintain a partnership characterized by continuity with our employees as well as with our suppliers, partners and customers. W. Althaus AG is thus an important and secure employer in the region.'
      },
      benefits: {
        title: 'What makes it special to work for us?',
        items: [
          'Family work atmosphere',
          'Balanced work-life balance',
          'Flexible working hours',
          'Top-equipped workplaces',
          'Exciting and varied work content',
          'Positive company development'
        ]
      },
      education: {
        title: 'Training and Development',
        subtitle: 'We make professionals',
        description: 'Over one hundred qualified employees from the fields of engineering, CAE, production and logistics demonstrate the high and broadly based technical competence of W. Althaus AG. The consistent training and development of our employees is part of our corporate philosophy.',
        apprenticeships: {
          title: 'Apprenticeships',
          automatiker: {
            title: 'Automation Technician',
            description: 'Automation technicians work in areas such as control construction, energy distribution, process engineering, electrical machine construction or industrial automation. They develop or design solutions for control and automation tasks.'
          },
          automatikmonteur: {
            title: 'Automation Assembly Technician',
            description: 'Automation assembly technicians assemble, maintain and repair electronic systems and devices or supervise corresponding production processes.'
          }
        }
      },
      openings: {
        title: 'Open Positions',
        noOpenings: 'No positions are currently advertised',
        spontaneous: {
          title: 'Spontaneous Application',
          description: 'Your desired position is not available? We welcome your spontaneous application. If your application matches a profile we are looking for, we will gladly contact you.'
        },
        apply: 'Apply Now',
        backToListings: 'Back to Job Listings',
        viewDetails: 'View Details',
        jobs: {
          hardwareentwickler: {
            title: "Hardware Developer (m/f/d)",
            department: "Engineering",
            type: "Permanent Position",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "September or by arrangement",
            applicationUrl: "https://ostendis.com/apply/5024-hardwareentwickler-m-w-d",
            description: "Digitalization, automation or robotics - everyone talks about it. With us, you're right in the middle of it! We work with the most modern tools and technologies.",
            longDescription: "As a Hardware Developer at W. Althaus AG, you are part of an innovative team specializing in the development of state-of-the-art automation solutions. You work on exciting projects in digitalization, automation and robotics and contribute significantly to the technological advancement of our company.",
            requirements: [
              "Technical degree or engineering studies (HF/FH) in electrical engineering/automation",
              "Experience with EPLAN P8, ideally also Pro Panel",
              "Sound IT knowledge in the Microsoft 365 environment",
              "English language skills",
              "Independent, structured and solution-oriented working style",
              "Team player with strong communication skills",
              "Interest in innovative technologies"
            ],
            responsibilities: [
              "Independent conception, development and implementation of automation solutions/control hardware",
              "Technical preparation of offers in close cooperation with sales",
              "Planning and further development of control hardware - standardized, documented and compliant with standards",
              "Schema creation with EPLAN P8 based on customer specifications",
              "Project support until commissioning including technical support",
              "Collaboration with interdisciplinary teams",
              "Quality assurance and documentation"
            ],
            benefits: [
              "Exciting and versatile activity in a dynamic team",
              "Progressive employment conditions",
              "Excellent social benefits",
              "Modern workplace with latest technology",
              "Flexible working hours",
              "Training opportunities",
              "Company pension scheme",
              "Company parking"
            ],
            labels: {
              location: "Location",
              workload: "Workload",
              type: "Employment",
              startDate: "Start",
              requirements: "Requirements",
              responsibilities: "Responsibilities",
              benefits: "Our Offer",
              featuredPosition: "Featured Position"
            }
          },
          projektleiter: {
            title: "Automation Project Manager (m/f/d)",
            department: "Project Management",
            type: "Permanent Position", 
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "By arrangement",
            applicationUrl: "https://ostendis.com/apply/5023-projektleiter-automation-m-w-d",
            description: "Take the lead in complex automation projects and help shape the future of industrial automation.",
            longDescription: "As an Automation Project Manager at W. Althaus AG, you take responsibility for complex automation projects from conception to successful commissioning. You coordinate interdisciplinary teams and ensure timely and budget-compliant implementation of our innovative solutions.",
            requirements: [
              "Completed technical education (HF/FH) in electrical engineering, automation or similar",
              "Several years of experience in project management, ideally in automation",
              "Sound knowledge of project management methods (PMI, PRINCE2 advantageous)",
              "Experience with MS Project or similar tools",
              "Excellent communication and leadership skills", 
              "Fluent German and English",
              "Willingness to travel (approx. 20%)"
            ],
            responsibilities: [
              "Management and coordination of automation projects from A-Z",
              "Project planning, budgeting and resource management",
              "Leadership of interdisciplinary project teams",
              "Customer support and stakeholder management",
              "Risk management and quality assurance",
              "Schedule monitoring and project controlling",
              "Documentation and reporting",
              "Continuous process improvement"
            ],
            benefits: [
              "Responsible position with creative freedom",
              "Diverse projects with state-of-the-art technology",
              "Attractive employment conditions",
              "Comprehensive social benefits",
              "Flexible working models",
              "Training opportunities and certifications",
              "Modern work environment",
              "Company car or public transport subscription"
            ],
            labels: {
              location: "Location",
              workload: "Workload",
              type: "Employment",
              startDate: "Start",
              requirements: "Requirements", 
              responsibilities: "Responsibilities",
              benefits: "Our Offer",
              featuredPosition: "Featured Position"
            }
          },
          automatiker: {
            title: "Automation Technician EFZ (m/f/d)",
            department: "Production",
            type: "Permanent Position",
            workload: "100%",
            location: "Aarwangen",
            startDate: "By arrangement",
            applicationUrl: "https://ostendis.com/apply/5025-automatiker-m-w-d",
            description: "Become part of our production team and work on implementing state-of-the-art automation solutions.",
            longDescription: "As an Automation Technician EFZ at W. Althaus AG, you are responsible for the professional assembly, wiring and commissioning of automation systems. You work both in our modern production facility and directly at the customer's site.",
            requirements: [
              "Completed apprenticeship as Automation Technician EFZ or equivalent training",
              "Several years of professional experience in automation technology",
              "Experience with PLC programming (Siemens, Beckhoff, etc.)",
              "Knowledge in control cabinet construction and wiring technology",
              "Precise and independent working style",
              "Team player and reliability",
              "Willingness to travel for customer installations"
            ],
            responsibilities: [
              "Assembly and wiring of control cabinets and automation components",
              "Commissioning of control systems at customer sites",
              "PLC programming and parameterization", 
              "Performing functional and safety tests",
              "Error diagnosis and repairs",
              "Documentation of performed work",
              "Customer training and technical support",
              "Compliance with safety regulations"
            ],
            benefits: [
              "Varied activity in production and at customer sites",
              "Work with state-of-the-art automation technology",
              "Attractive remuneration according to qualification",
              "Comprehensive social benefits",
              "Flexible working hours by arrangement",
              "Training opportunities",
              "Expense reimbursement for external installations",
              "Company car for customer assignments"
            ],
            labels: {
              location: "Location",
              workload: "Workload", 
              type: "Employment",
              startDate: "Start",
              requirements: "Requirements",
              responsibilities: "Responsibilities",
              benefits: "Our Offer",
              featuredPosition: "Featured Position"
            }
          }
        }
      }
    },
    vocationalTraining: {
      title: "Vocational Training at W. Althaus AG",
      subtitle: "Invest in your future with high-quality training in automation technology. Our apprentices benefit from state-of-the-art technology, experienced mentors and diverse career opportunities.",
      badge: "Training positions available",
      programs: {
        title: "Our Training Programs",
        description: "We offer practical training in future-oriented professions in automation and electrical engineering.",
        highlights: "Training Focus Areas",
        automatiker: {
          title: "Automation Technician EFZ",
          description: "As an automation technician, you develop, install and maintain automated systems. You work with state-of-the-art technology and learn all aspects of industrial automation.",
          highlights: [
            "Programming PLC controls",
            "Installation of automation systems",
            "Commissioning complex systems",
            "Error diagnosis and maintenance",
            "Project work in teams"
          ]
        },
        automatikmonteur: {
          title: "Automation Assembly Technician EFZ",
          description: "As an automation assembly technician, you assemble electrical and pneumatic components, wire control cabinets and commission automated systems.",
          highlights: [
            "Control cabinet construction and wiring",
            "Component assembly",
            "System commissioning",
            "Quality control",
            "On-site customer support"
          ]
        }
      },
      benefits: {
        title: "Why train with us?",
        description: "At W. Althaus AG, you not only receive first-class technical training, but are also personally encouraged and supported.",
        mentorship: {
          title: "Experienced Mentors",
          description: "Our experienced professionals accompany you throughout your training and are always available with advice and support."
        },
        practical: {
          title: "Practical Training", 
          description: "Work on real projects with state-of-the-art technology from the beginning and gain valuable professional experience."
        },
        career: {
          title: "Career Opportunities",
          description: "After training, we offer you attractive takeover opportunities and diverse continuing education opportunities."
        },
        culture: {
          title: "Family Work Environment",
          description: "Benefit from our open, supportive work environment and become part of our team."
        }
      },
      timeline: {
        title: "Your Training Path",
        description: "From basics to expert - this is how you develop during your training with us.",
        year1: {
          title: "Basics & Orientation",
          description: "Learn the basics of electrical engineering, mechanics and first programming languages. Orientation in the company and getting to know the various departments."
        },
        year2: {
          title: "Practice & Deepening", 
          description: "First practical work on systems, deepening PLC programming and participation in smaller projects."
        },
        year3: {
          title: "Specialization & Projects",
          description: "Specialization in your chosen area, collaboration in customer projects and taking on responsibility."
        },
        year4: {
          title: "Expert Role & Completion",
          description: "Independent work, mentoring younger apprentices and preparation for the qualification procedure."
        }
      },
      cta: {
        title: "Start your career with us!",
        description: "Apply now for a training position at W. Althaus AG and lay the foundation for a successful future in automation technology.",
        apply: "Apply now",
        contact: "Get in touch"
      }
    },
    news: {
      title: 'News',
      subtitle: 'Latest news from the company',
      readMore: 'Read More',
      watchVideo: 'Watch Video',
      backToOverview: 'Back to Overview',
      noNews: 'Currently no news available.',
      filter: {
        all: 'All',
        company: 'Company',
        training: 'Training',
        events: 'Events'
      }
    },
    jobDetailLabels: {
      jobDescription: 'Job Description',
      responsibilities: 'Your Tasks',
      requirements: 'Requirements',
      benefits: 'What We Offer',
      applyNow: 'Apply Now!',
      convinceUs: 'Convince us with your application',
      applyOnline: 'Apply Online',
      questionsContact: 'Do you have questions? Feel free to contact us by phone or email.',
      aboutUs: 'About Us',
      companyDescription: 'W. Althaus AG is a leading company in the field of industrial automation with over 25 years of experience. We develop innovative solutions for the future of production.',
      employees: '50+ Employees',
      international: 'Internationally active',
      isoCertified: 'ISO 14001 certified',
      backToListings: 'Back to Job Listings',
      featuredPosition: 'Featured Position',
      urgentlyNeeded: 'Urgently needed!',
      location: 'Location',
      workload: 'Workload',
      employment: 'Employment',
      startDate: 'Start'
    },
    caseStudyLabels: {
      backToOverview: 'Back to Overview',
      challengePrefix: 'Before:',
      challenge: 'The Challenge',
      solutionPrefix: 'Now:',
      solution: 'The Solution with W. Althaus AG',
      positiveOutcomes: 'Positive Outcomes',
      servicesInProject: 'Services in the Project',
      conclusion: 'Conclusion',
      yourProject: 'Your Project with',
      realizeTogether: 'Let us realize your automation solution together',
      requestProject: 'Request Project',
      moreSuccessStories: 'More Success Stories',
      learnMore: 'Learn more',
      about: 'About',
      content: 'Content',
      customerSince: 'Customer since',
      builtCabinets: 'Cabinets built',
      automationDegree: 'Automation degree',
      onTimeDelivery: 'On-time delivery',
      negativeConsequences: 'Negative Consequences',
      challengeWithout: 'The Challenge without W. Althaus AG',
      solutionWith: 'The Solution with W. Althaus AG',
      projectFits: 'Your Project Fits',
      scalableCabinetBuild: 'Scalable control cabinet construction for your series.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us. We look forward to your inquiry.',
      headquarters: 'Headquarters',
      production: 'Production Site',
      address: 'Address',
      phone: 'Phone',
      email: 'E-Mail',
      hours: 'Opening Hours',
      directPhone: 'Production Direct Line',
      directions: 'Directions',
      directionsText: 'Directly on highway A1, exit Aarwangen. Visitor parking available directly at the building.',
      hoursText: 'Mon-Fri: 07:00 - 17:00\nSat: By appointment',
      form: {
        title: 'Send Inquiry',
        subtitle: 'We will get back to you as soon as possible – usually within one business day.',
        sections: {
          concern: 'Your Concern',
          personal: 'Personal Details',
          message: 'Your Message',
          privacy: 'Privacy'
        },
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          company: 'Company',
          email: 'E-Mail',
          phone: 'Phone',
          contactMethod: 'Preferred Contact Method',
          category: 'What is your concern?',
          categoryHint: 'Please select the appropriate category:',
          subject: 'Subject',
          requestTo: 'Request To',
          services: 'Inquiry / Interested Services',
          message: 'Please describe your inquiry',
          files: 'Upload Files',
          privacy: 'Privacy Consent'
        },
        placeholders: {
          firstName: 'e.g. John',
          lastName: 'e.g. Doe',
          company: 'e.g. Example Ltd',
          email: 'e.g. john.doe@example.com',
          phone: 'e.g. +41 79 123 45 67',
          message: 'Please describe your inquiry.',
          subject: 'Enter a subject for your message',
          requestTo: 'e.g. Mr. Smith',
          preferredTime: 'Preferred Time'
        },
        options: {
          contactMethod: {
            email: 'E-Mail',
            phone: 'Phone'
          },
          categories: {
            serviceInquiry: 'Inquiry about our services',
            productIntro: 'Present a product or service',
            general: 'General inquiry',
            support: 'Support for an existing order'
          },
          services: {
            controlCabinet: 'Control Cabinet Construction',
            hardwareEngineering: 'Hardware Engineering',
            softwareEngineering: 'Software Engineering',
            cableAssembly: 'Cable Assembly',
            terminalProduction: 'Terminal Block Production',
            consulting: 'Consulting',
            other: 'Other'
          },
          preferredTime: {
            morning: 'Morning',
            afternoon: 'Afternoon',
            flexible: 'Flexible'
          }
        },
        validation: {
          firstNameRequired: 'Please enter first name.',
          lastNameRequired: 'Please enter last name.',
          companyRequired: 'Please enter company name.',
          contactRequired: 'Please provide email or phone (at least one is required).',
          emailInvalid: 'Please enter a valid email address.',
          phoneInvalid: 'Please enter a valid phone number (e.g. +41 79 123 45 67).',
          contactMethodRequired: 'Please select contact method.',
          categoryRequired: 'Please select a concern.',
          messageRequired: 'Please describe your inquiry.',
          phoneRequiredWhenSelected: 'Please enter your phone number if you would like to be contacted by phone.',
          emailRequiredWhenSelected: 'Please enter your email address if you would like to be contacted by email.',
          servicesRequired: 'Please select at least one service.',
          privacyRequired: 'Please agree to data processing.'
        },
        buttons: {
          submit: 'Send Inquiry',
          submitting: 'Sending...',
          newRequest: 'Send new inquiry',
          callAlternative: 'Or call us: +41 62 919 82 10'
        },
        error: {
          title: 'Error',
          message: 'An error occurred while sending your inquiry.'
        },
        success: {
          title: 'Request successfully submitted',
          message: 'Your request has been successfully submitted. We will get back to you shortly.',
          newsTitle: 'News from our company',
        },
        privacy: {
          text: 'I agree to the processing of my data according to the',
          link: 'Privacy Policy',
          linkText: '.'
        },
        fileUpload: {
          accepted: 'PDF, PNG/JPG, ZIP • Max. 15 MB • Multiple uploads allowed',
          dropzone: 'Drop files here or click to select'
        }
      }
    },
    anfahrt: {
      title: 'Directions',
      subtitle: 'Visit us in Aarwangen - Conveniently located directly on highway A1',
      hero: {
        title: 'Welcome to W. Althaus AG',
        subtitle: 'Find your way to us in Aarwangen easily. Our headquarters and Plant 2 are conveniently located directly on highway A1.'
      },
      headquarters: {
        title: 'Headquarters',
        name: 'W. Althaus AG',
        street: 'Jurastrasse 12',
        city: '4912 Aarwangen',
        country: 'Switzerland'
      },
      werk2: {
        title: 'Plant 2 - Production',
        name: 'W. Althaus AG - Plant 2',
        street: 'Industriering',
        city: '4912 Aarwangen',
        country: 'Switzerland'
      },
      contact: {
        phone: '+41 62 919 82 82',
        email: '',
        website: 'www.althaus.swiss'
      },
      directions: {
        title: 'Directions by Car',
        highway: 'Highway A1',
        exit: 'Exit Aarwangen',
        description: 'Take the Aarwangen exit and follow the signs towards the industrial area. Both locations are situated in the Aarwangen industrial area.'
      },
      parking: {
        title: 'Parking',
        description: 'Free visitor parking is available at both locations.'
      },
      publicTransport: {
        title: 'Public Transportation',
        train: 'Aarwangen Train Station (10 minutes walk)',
        bus: 'Aarwangen Dorf Bus Stop (5 minutes walk)'
      },
      hours: {
        title: 'Opening Hours',
        weekdays: 'Monday - Friday: 07:00 - 17:00',
        saturday: 'Saturday: By appointment',
        sunday: 'Sunday: Closed'
      }
    },
    products: {
      title: 'Products',
      subtitle: 'Discover our portfolio of high-quality automation solutions and products for industry.'
    },
    cookieConsent: {
      bannerTitle: 'Privacy Settings',
      bannerText: 'This website uses third-party technologies to provide services, continuously improve them, and display content tailored to your interests.',
      privacyPolicy: 'Privacy Policy',
      imprint: 'Imprint',
      settings: 'Settings',
      acceptAll: 'Accept all',
      saveSettings: 'Save settings',
      cookieSettings: 'Cookie settings',
      modalTitle: 'Privacy Settings',
      modalDescription: 'With this tool you can manage your consent to the collection and processing of personal data by third-party technologies.',
      tabCategories: 'Categories',
      tabServices: 'Services',
      categories: {
        essential: { name: 'Essential', description: 'These technologies are required to enable the core functionality of our services.' },
        functional: { name: 'Functional', description: 'These technologies allow us to analyse usage in order to measure and improve the performance of our website.' },
        marketing: { name: 'Marketing', description: 'These technologies are used by advertisers to display ads that are relevant to your interests.' }
      },
      services: {
        consentManager: { name: 'Consent Manager', description: 'Securely stores your privacy preferences in your browser.' },
        cloudflare: { name: 'Cloudflare', description: 'Content delivery network for secure and fast website delivery.' },
        googleFonts: { name: 'Google Fonts', description: 'Loads web fonts for consistent rendering of the website.' },
        googleMaps: { name: 'Google Maps', description: 'Displays interactive maps for directions and location information.' },
        ostendis: { name: 'Ostendis', description: 'Provides current job postings on the careers page.' },
        googleAnalytics: { name: 'Google Analytics', description: 'Analyses website usage anonymously to improve our offering.' },
        googleTagManager: { name: 'Google Tag Manager', description: 'Manages marketing and analytics tags on the website.' },
        googleAds: { name: 'Google Ads', description: 'Used to deliver relevant advertising and measure conversions.' }
      },
      alwaysActive: 'Always active',
      poweredBy: 'Provided by W. Althaus AG'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      products: 'Produits',
      about: 'À propos',
      leitbild: 'Mission',
      team: 'Management',
      partners: 'Partenaires & Écosystème',
      anfahrt: 'Accès',
      chameleonStory: 'Histoire du Caméléon',
      successStories: 'Success Stories',
      aboutDescription: 'Découvrez notre entreprise et notre expertise',
      sustainability: 'Durabilité',
      sustainabilityDescription: 'Automatisation durable pour un avenir meilleur',
      careers: 'Carrières',
      careersDescription: 'Rejoignez notre équipe innovante',
      vocationalTraining: 'Formation professionnelle',
      vocationalTrainingDescription: 'Commencez votre carrière avec une formation de première classe',
      news: 'Actualités',
      contact: 'Contact',
      overview: 'Aperçu'
    },
    routes: {
      services: 'services',
      products: 'produits',
      about: 'a-propos',
      sustainability: 'durabilite',
      careers: 'carrieres',
      news: 'actualites',
      contact: 'contact',
      jobOpenings: 'offres-emploi',
      vocationalTraining: 'formation-professionnelle',
      schaltschrankbau: 'construction-armoires',
      engineering: 'ingenierie',
      softwareengineering: 'ingenierie-logicielle',
      leitbild: 'mission',
      team: 'management',
      partners: 'partenaires-ecosysteme',
      anfahrt: 'acces',
      chameleonStory: 'histoire-cameleon',
      successStories: 'success-stories',
      hardwareentwickler: 'developpeur-hardware',
      projektleiter: 'chef-projet',
      automatiker: 'technicien-automatisation',
      athex: 'athex',
      panelscout: 'panelscout',
      documents: 'documents',
      ausstellung: 'exposition'
    },
    footer: {
      imprint: 'Mentions légales',
      privacy: 'Protection des données',
      howToGetHere: 'Accès',
      documents: 'Documents',
      quickLinks: 'Liens rapides',
      company: 'Entreprise',
      headquarters: 'Siège social',
      isoCertified: 'Certifié ISO 14001',
      copyright: '© 2026 W. Althaus AG. Tous droits réservés.',
      quality: 'Leading in Automation depuis 1968'
    },
    home: {
      hero: {
        weAre: 'Nous sommes...',
        title: 'Productivité grâce aux flux de travail intégrés et à la production automatisée',
        subtitle: 'Depuis plus de 40 ans, nous augmentons la productivité grâce à des flux de travail intégrés et à une production entièrement automatisée - chaque jour.',
        tagline: 'Notre automatisation pour votre avantage concurrentiel',
        ctaContact: 'Nous contacter',
        ctaServices: 'Voir les services',
        stats: {
          experience: 'Années d\'expérience',
          projects: 'Projets',
          employees: 'Employés travaillent sur vos rêves',
          swissFamily: 'Entreprise familiale suisse'
        }
      },
      services: {
        title: 'Nos Services',
        subtitle: 'Solutions complètes pour l\'automation industrielle',
        viewAll: 'Voir tous les services',
        learnMore: 'En savoir plus'
      },
      partners: {
        title: 'Nos Partenaires',
        subtitle: 'Faites confiance aux technologies éprouvées des fabricants leaders'
      }
    },
    services: {
      title: 'Services',
      subtitle: 'Votre automatisation. Notre expertise.',
      schaltschrankbau: {
        title: 'Construction d\'armoires électriques',
        description: 'En tant que plus grande et principale entreprise suisse de construction d\'armoires électriques, nous vous procurons de nouveaux avantages concurrentiels grâce à notre production entièrement automatisée assistée par IA',
        badge: 'Construction d\'armoires électriques 4.0',
        heroTitle: 'Construction d\'armoires électriques professionnelle',
        heroSubtitle: 'Notre automatisation avec construction d\'armoires électriques 4.0 pour votre avantage concurrentiel. Du prototype à la production en série - processus entièrement automatisés pour la plus haute qualité.',
        servicesTitle: 'Notre gamme de services',
        servicesSubtitle: 'Production entièrement automatisée avec profondeur de fabrication optimale tout en maintenant une flexibilité totale concernant les exigences clients.',
        capabilitiesTitle: 'Notre offre de services',
        capabilitiesSubtitle: 'Pour le compte de leurs clients, W. Althaus AG construit et assemble des armoires électriques et des assemblages pour divers marchés, du prototype à la production en série et aux variantes.',
        automationTitle: 'Production entièrement automatisée',
        automationDescription: 'Le haut degré d\'automatisation nous génère une qualité élevée et constante à des conditions compétitives.',
        automationGrade: 'Degré d\'automatisation',
        ctaTitle: 'Prêt pour votre construction d\'armoires électriques?',
        ctaSubtitle: 'Réalisons ensemble votre solution d\'automatisation. Contactez-nous pour un conseil sans engagement.',
        ctaButtonPrimary: 'Demander un projet',
        ctaButtonSecondary: 'Voir les références',
        features: {
          ecad: {
            title: 'Ingénierie E-CAD',
            description: 'Planification professionnelle avec ePlan P8, ePlan Pro Panel et E3.series pour des schémas précis'
          },
          production: {
            title: 'Production entièrement automatisée',
            description: 'Construction d\'armoires électriques 4.0 avec le plus haut degré d\'automatisation pour une qualité constante'
          },
          compliance: {
            title: 'Conformité aux normes',
            description: 'Respect de toutes les normes et standards pertinents pour une sécurité opérationnelle maximale'
          },
          terminals: {
            title: 'Production de borniers',
            description: 'Fabrication automatique de borniers avec connecteurs Phoenix Contact'
          },
          assembly: {
            title: 'Montage d\'assemblages',
            description: 'Montage professionnel et intégration de tous les composants selon les plus hauts standards'
          },
          testing: {
            title: 'Procédures de test et vérification',
            description: 'Contrôles qualité complets et tests fonctionnels avant livraison'
          }
        },
        benefits: {
          competitive: {
            title: 'Avantages concurrentiels',
            description: 'Grâce à la construction d\'armoires électriques 4.0, nous vous générons des avantages concurrentiels mesurables'
          },
          quality: {
            title: 'Haute qualité',
            description: 'Les processus entièrement automatisés garantissent une qualité constamment élevée'
          },
          flexibility: {
            title: 'Flexibilité',
            description: 'Du prototype à la production en série - nous nous adaptons à vos exigences'
          },
          efficiency: {
            title: 'Efficacité des coûts',
            description: 'Le degré d\'automatisation assure des prix compétitifs avec la plus haute qualité'
          }
        },
        capabilities: [
          'E-CAD: ePlan P8, ePlan Pro Panel, E3.series',
          'Construction d\'armoires électriques du prototype à la production en série',
          'Production de borniers (Phoenix Contact)',
          'Montage d\'assemblages et intégration',
          'Procédures de test et vérification',
          'Câblage entièrement automatisé',
          'Traitement de tôlerie et construction de boîtiers',
          'Contrôle qualité selon les normes ISO'
        ],
        // NEW: Page-specific translations
        hero: {
          tagline: 'automatisé. précis. Althaus.',
          intro: 'Avec la construction d\'armoires électriques 4.0, nous combinons ECAD Digital Twin, processus modularisés et production hautement automatisée en Suisse – pour des coûts compétitifs, une qualité constamment élevée et une production en série dès l\'unité 1.'
        },
        cards: {
          whatYouGet: {
            title: 'Ce que vous obtenez chez Althaus',
            description: 'Nous construisons et assemblons des armoires électriques et des ensembles pour différentes industries – du prototype à la production en série. Des chaînes de processus entièrement automatisées, des modules standardisés et un flux de données ECAD continu garantissent rapidité, qualité et planifiabilité tout au long du cycle de vie du produit.'
          },
          scope: {
            title: 'Étendue des services - Compétences & Outils',
            description: 'Du premier clic dans ECAD à la mise en service. Nous réalisons des solutions d\'armoires électriques rapidement, de manière évolutive et conforme aux normes. Digital Twin (ePlan P8/Pro Panel, E3), kits de plateforme standardisés et SCM coordonné garantissent rapidité, qualité et coûts – 100% fabriqué en Suisse. Avec montage sur site et test UL/CSA.'
          },
          howWeWork: {
            title: 'Comment nous travaillons',
            description: 'De la première conversation au montage sur site. Objectifs, normes, scénarios de quantité et budget clarifiés. Digital Twin (ePlan/E3, Panneau 3D) avec concept de câblage automatisable. Design for Assembly, standardisation, vérification UL/CSA. Production automatisée: qualité série dès l\'unité 1, modifications jusqu\'à peu avant l\'expédition, tests, documentation, traçabilité et support.'
          }
        },
        processSteps: {
          requirement: { title: 'Exigences & Conseil', description: 'Analyse détaillée des exigences et conseil expert pour votre projet.' },
          engineering: { title: 'Ingénierie', description: 'Planification professionnelle et élaboration technique selon les plus hauts standards.' },
          material: { title: 'Matériel & Préparation', description: 'Sélection soigneuse des matériaux et préparation optimale de tous les composants.' },
          automated: { title: 'Traitement Automatisé', description: 'Fabrication automatisée précise avec technologie de pointe.' },
          assembly: { title: 'Montage & Câblage', description: 'Montage professionnel et câblage structuré selon les normes industrielles.' },
          testing: { title: 'Test & Réception', description: 'Tests de qualité complets et réception documentée de tous les systèmes.' },
          commissioning: { title: 'Mise en Service', description: 'Mise en service professionnelle et optimisation sur site client.' },
          service: { title: 'Service & Cycle de Vie', description: 'Support et maintenance à long terme tout au long du cycle de vie.' }
        },
        servicesGrid: {
          ecad: { name: 'E-CAD: ePlan p8, ePlan Pro Panel, E3', description: 'Planification électrique professionnelle avec outils CAO de pointe' },
          layout: { name: 'Concept d\'armoire: Conception, Layout', description: 'Conception réfléchie et layouts optimisés' },
          standardization: { name: 'Standardisation, Modularisation', description: 'Processus efficaces grâce à des modules standardisés' },
          procurement: { name: 'Concepts d\'Approvisionnement et Logistique', description: 'Flux de matériaux optimisés et logistique' },
          materialOptimization: { name: 'Optimisation de la Gestion des Matériaux', description: 'Planification et gestion efficaces des matériaux' },
          production: { name: 'Prototypage, Production Unitaire & Série', description: 'Fabrication flexible pour toutes les exigences' },
          onSite: { name: 'Montage sur Site Client', description: 'Installation et mise en service professionnelles directement chez vous' },
          ulCsa: { name: 'Certification UL / CSA', description: 'Certification internationale pour le marché nord-américain' }
        },
        valueProposition: {
          title: 'Votre Valeur Ajoutée de Notre Automatisation',
          cost: { title: 'Coûts Compétitifs', description: 'Processus efficaces et flux de travail standardisés pour une rentabilité optimale.' },
          quality: { title: 'Qualité Constamment Élevée', description: 'Contrôles qualité stricts et processus certifiés garantissent la fiabilité.' },
          changes: { title: 'Modifications Tardives Possibles', description: 'Ajustements flexibles jusqu\'à la dernière minute grâce à la conception modulaire.' },
          speed: { title: 'Délais Courts', description: 'Fabrication automatisée et logistique optimisée pour une livraison rapide.' }
        },
        sectionHeaders: {
          servicesOffering: 'Notre Offre de Services Comprend'
        }
      },
      kabelkonfektion: {
        title: 'Confection de câbles',
        description: 'Confection de câbles professionnelle selon les plus hauts standards de qualité'
      },
      klemmensteg: {
        title: 'Production de borniers',
        description: 'Production précise de borniers pour vos solutions d\'automatisation'
      },
      softwareengineering: {
        title: 'Ingénierie logicielle',
        description: 'Solutions logicielles complètes de la planification du projet à la mise en service. Visualisations conviviales et applications de base de données personnalisées.'
      },
      engineering: {
        title: 'Ingénierie matérielle et logicielle',
        description: 'Ingénierie qui tient ses promesses. Matériel et logiciel – tout d\'une seule source. Nous numérisons vos idées – jusqu\'à ce que votre automatisation fonctionne de manière productive.'
      }
    },
    careers: {
      title: 'Carrières',
      subtitle: 'Rejoignez notre équipe - Façonnez avec nous l\'avenir de l\'automatisation industrielle',
      teamSpirit: {
        title: 'Notre Esprit d\'Équipe',
        description: 'Nous sommes une équipe jeune, dynamique et hautement motivée. Nous mettons nos excellentes qualifications au service de nos clients du monde entier avec engagement. Nous entretenons des relations ouvertes et confiantes les uns avec les autres et vivons une forte identification avec notre entreprise.'
      },
      employer: {
        title: 'Employeur pour la Région',
        description: 'Nous entretenons un partenariat caractérisé par la continuité avec nos employés ainsi qu\'avec nos fournisseurs, partenaires et clients. W. Althaus AG est ainsi un employeur important et sûr dans la région.'
      },
      benefits: {
        title: 'Qu\'est-ce qui rend spécial le fait de travailler pour nous?',
        items: [
          'Atmosphère de travail familiale',
          'Équilibre travail-vie équilibré',
          'Horaires de travail flexibles',
          'Postes de travail équipés de première qualité',
          'Contenu de travail passionnant et varié',
          'Développement positif de l\'entreprise'
        ]
      },
      education: {
        title: 'Formation et Développement',
        subtitle: 'Nous formons des professionnels',
        description: 'Plus de cent employés qualifiés des domaines de l\'ingénierie, CAE, production et logistique témoignent de la compétence technique élevée et largement soutenue de W. Althaus AG. La formation et le développement continus de nos employés font partie de notre philosophie d\'entreprise.',
        apprenticeships: {
          title: 'Apprentissages',
          automatiker: {
            title: 'Technicien en Automatisation',
            description: 'Les techniciens en automatisation travaillent dans des domaines tels que la construction de commandes, la distribution d\'énergie, l\'ingénierie des procédés, la construction de machines électriques ou l\'automatisation industrielle.'
          },
          automatikmonteur: {
            title: 'Monteur en Automatisation',
            description: 'Les monteurs en automatisation assemblent, entretiennent et réparent des systèmes et équipements électroniques ou supervisent les processus de production correspondants.'
          }
        }
      },
      openings: {
        title: 'Postes Ouverts',
        noOpenings: 'Aucun poste n\'est actuellement annoncé',
        spontaneous: {
          title: 'Candidature Spontanée',
          description: 'Votre poste souhaité n\'est pas disponible? Nous nous réjouissons de recevoir votre candidature spontanée. Si votre candidature correspond à un profil que nous recherchons, nous vous contactons volontiers.'
        },
        apply: 'Postuler Maintenant',
        backToListings: 'Retour aux offres d\'emploi',
        viewDetails: 'Voir les détails',
        jobs: {
          hardwareentwickler: {
            title: "Développeur Hardware (h/f/d)",
            department: "Ingénierie",
            type: "Poste permanent",
            workload: "80-100%",
            location: "Aarwangen", 
            startDate: "Septembre ou selon accord",
            applicationUrl: "https://ostendis.com/apply/5024-hardwareentwickler-m-w-d",
            description: "Digitalisation, automatisation ou robotique - tout le monde en parle. Chez nous, vous êtes au cœur de l'action ! Car nous travaillons avec les outils et technologies les plus modernes.",
            longDescription: "En tant que développeur hardware chez W. Althaus AG, vous faites partie d'une équipe innovante spécialisée dans le développement de solutions d'automatisation de pointe. Vous travaillez sur des projets passionnants dans les domaines de la digitalisation, de l'automatisation et de la robotique et contribuez de manière décisive au développement technologique de notre entreprise.",
            requirements: [
              "Formation technique TS ou études d'ingénieur (HF/FH) électrotechnique/automatisation",
              "Expérience avec EPLAN P8, idéalement aussi Pro Panel",
              "Connaissances IT approfondies dans l'environnement Microsoft 365",
              "Connaissances en anglais",
              "Méthode de travail indépendante, structurée et axée sur les solutions",
              "Esprit d'équipe et force de communication",
              "Intérêt pour les technologies innovantes"
            ],
            responsibilities: [
              "Conception, développement et réalisation autonomes de solutions d'automatisation/hardware de contrôle",
              "Élaboration technique d'offres en étroite collaboration avec les ventes",
              "Planification et développement du hardware de contrôle - standardisé, documenté et conforme aux normes",
              "Création de schémas avec EPLAN P8 sur la base des spécifications clients",
              "Accompagnement des projets jusqu'à la mise en service y compris support technique",
              "Collaboration avec des équipes interdisciplinaires",
              "Assurance qualité et documentation"
            ],
            benefits: [
              "Activité passionnante et variée dans une équipe dynamique",
              "Conditions d'emploi progressistes",
              "Excellentes prestations sociales",
              "Poste de travail moderne avec la technologie la plus récente",
              "Horaires de travail flexibles",
              "Possibilités de formation continue",
              "Prévoyance professionnelle d'entreprise",
              "Parking d'entreprise"
            ],
            labels: {
              location: "Lieu",
              workload: "Taux d'occupation",
              type: "Emploi",
              startDate: "Début",
              requirements: "Exigences",
              responsibilities: "Tâches",
              benefits: "Notre offre",
              featuredPosition: "Poste vedette"
            }
          },
          projektleiter: {
            title: "Chef de Projet Automatisation (h/f/d)",
            department: "Gestion de Projet",
            type: "Poste permanent",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "Selon accord",
            applicationUrl: "https://ostendis.com/apply/5023-projektleiter-automation-m-w-d",
            description: "Prenez la direction de projets d'automatisation complexes et participez à façonner l'avenir de l'automatisation industrielle.",
            longDescription: "En tant que chef de projet automatisation chez W. Althaus AG, vous assumez la responsabilité de projets d'automatisation complexes de la conception à la mise en service réussie. Vous coordonnez des équipes interdisciplinaires et assurez la mise en œuvre dans les délais et le budget de nos solutions innovantes.",
            requirements: [
              "Formation technique achevée (HF/FH) en électrotechnique, automatisation ou similaire",
              "Plusieurs années d'expérience en gestion de projet, idéalement dans l'automatisation",
              "Connaissances approfondies des méthodes de gestion de projet (PMI, PRINCE2 avantageux)",
              "Expérience avec MS Project ou outils similaires",
              "Excellentes capacités de communication et de leadership",
              "Allemand et anglais couramment",
              "Disponibilité pour voyager (env. 20%)"
            ],
            responsibilities: [
              "Direction et coordination de projets d'automatisation de A à Z",
              "Planification de projet, budgétisation et gestion des ressources",
              "Direction d'équipes de projet interdisciplinaires",
              "Support client et gestion des parties prenantes",
              "Gestion des risques et assurance qualité",
              "Surveillance des délais et contrôle de projet",
              "Documentation et rapports",
              "Amélioration continue des processus"
            ],
            benefits: [
              "Poste à responsabilités avec marge de manœuvre créative",
              "Projets variés avec technologie de pointe",
              "Conditions d'emploi attractives",
              "Prestations sociales complètes",
              "Modèles de travail flexibles",
              "Possibilités de formation et certifications",
              "Environnement de travail moderne",
              "Voiture d'entreprise ou abonnement transports publics"
            ],
            labels: {
              location: "Lieu",
              workload: "Taux d'occupation",
              type: "Emploi", 
              startDate: "Début",
              requirements: "Exigences",
              responsibilities: "Tâches",
              benefits: "Notre offre",
              featuredPosition: "Poste vedette"
            }
          },
          automatiker: {
            title: "Automaticien CFC (h/f/d)",
            department: "Production",
            type: "Poste permanent",
            workload: "100%",
            location: "Aarwangen",
            startDate: "Selon accord",
            applicationUrl: "https://ostendis.com/apply/5025-automatiker-m-w-d",
            description: "Rejoignez notre équipe de production et travaillez sur la réalisation de solutions d'automatisation de pointe.",
            longDescription: "En tant qu'automaticien CFC chez W. Althaus AG, vous êtes responsable du montage, du câblage et de la mise en service professionnels des installations d'automatisation. Vous travaillez à la fois dans notre site de production moderne et directement chez le client.",
            requirements: [
              "Apprentissage achevé comme automaticien CFC ou formation équivalente",
              "Plusieurs années d'expérience professionnelle en technologie d'automatisation",
              "Expérience avec la programmation API (Siemens, Beckhoff, etc.)",
              "Connaissances en construction d'armoires et technique de câblage",
              "Méthode de travail précise et indépendante",
              "Esprit d'équipe et fiabilité",
              "Disponibilité pour voyager pour montages chez le client"
            ],
            responsibilities: [
              "Montage et câblage d'armoires et de composants d'automatisation",
              "Mise en service d'installations de contrôle chez le client",
              "Programmation API et paramétrage",
              "Réalisation de tests fonctionnels et de sécurité",
              "Diagnostic d'erreurs et réparations",
              "Documentation des travaux effectués",
              "Formation client et support technique",
              "Respect des consignes de sécurité"
            ],
            benefits: [
              "Activité variée en production et chez le client",
              "Travail avec technologie d'automatisation de pointe",
              "Rémunération attractive selon qualification",
              "Prestations sociales complètes",
              "Horaires de travail flexibles selon accord",
              "Possibilités de formation continue",
              "Remboursement des frais pour montages externes",
              "Voiture d'entreprise pour missions client"
            ],
            labels: {
              location: "Lieu",
              workload: "Taux d'occupation",
              type: "Emploi",
              startDate: "Début",
              requirements: "Exigences", 
              responsibilities: "Tâches",
              benefits: "Notre offre",
              featuredPosition: "Poste vedette"
            }
          }
        }
      }
    },
    vocationalTraining: {
      title: "Formation professionnelle chez W. Althaus AG",
      subtitle: "Investissez dans votre avenir avec une formation de haute qualité en technologie d'automatisation. Nos apprentis bénéficient d'une technologie de pointe, de mentors expérimentés et d'opportunités de carrière diverses.",
      badge: "Postes de formation disponibles",
      programs: {
        title: "Nos programmes de formation",
        description: "Nous offrons des formations pratiques dans des professions d'avenir de l'automatisation et de l'électrotechnique.",
        highlights: "Domaines de formation",
        automatiker: {
          title: "Automaticien/ne CFC",
          description: "En tant qu'automaticien/ne, vous développez, installez et maintenez des systèmes automatisés. Vous travaillez avec la technologie la plus moderne et apprenez tous les aspects de l'automatisation industrielle.",
          highlights: [
            "Programmation de commandes API",
            "Installation de systèmes d'automatisation",
            "Mise en service de systèmes complexes",
            "Diagnostic d'erreurs et maintenance",
            "Travail de projet en équipe"
          ]
        },
        automatikmonteur: {
          title: "Monteur/euse en automatisation CFC",
          description: "En tant que monteur/euse en automatisation, vous assemblez des composants électriques et pneumatiques, câblez des armoires de commande et mettez en service des systèmes automatisés.",
          highlights: [
            "Construction d'armoires et câblage",
            "Assemblage de composants",
            "Mise en service de systèmes",
            "Contrôle qualité",
            "Support client sur site"
          ]
        }
      },
      benefits: {
        title: "Pourquoi se former chez nous?",
        description: "Chez W. Althaus AG, vous recevez non seulement une formation technique de première classe, mais vous êtes également encouragé et soutenu personnellement.",
        mentorship: {
          title: "Mentors expérimentés",
          description: "Nos professionnels expérimentés vous accompagnent tout au long de votre formation et sont toujours disponibles pour vous conseiller et vous soutenir."
        },
        practical: {
          title: "Formation pratique", 
          description: "Travaillez sur de vrais projets avec une technologie de pointe dès le début et acquérez une expérience professionnelle précieuse."
        },
        career: {
          title: "Opportunités de carrière",
          description: "Après la formation, nous vous offrons des opportunités de reprise attrayantes et diverses possibilités de formation continue."
        },
        culture: {
          title: "Environnement de travail familial",
          description: "Bénéficiez de notre environnement de travail ouvert et favorable et devenez partie intégrante de notre équipe."
        }
      },
      timeline: {
        title: "Votre parcours de formation",
        description: "Des bases à l'expert - c'est ainsi que vous vous développez pendant votre formation chez nous.",
        year1: {
          title: "Bases & Orientation",
          description: "Apprenez les bases de l'électrotechnique, de la mécanique et des premiers langages de programmation. Orientation dans l'entreprise et découverte des différents départements."
        },
        year2: {
          title: "Pratique & Approfondissement", 
          description: "Premiers travaux pratiques sur les installations, approfondissement de la programmation API et participation à de petits projets."
        },
        year3: {
          title: "Spécialisation & Projets",
          description: "Spécialisation dans votre domaine choisi, collaboration dans les projets clients et prise de responsabilités."
        },
        year4: {
          title: "Rôle d'expert & Achèvement",
          description: "Travail indépendant, encadrement des jeunes apprentis et préparation de la procédure de qualification."
        }
      },
      cta: {
        title: "Commencez votre carrière chez nous!",
        description: "Postulez maintenant pour un poste de formation chez W. Althaus AG et posez les bases d'un avenir réussi dans la technologie d'automatisation.",
        apply: "Postuler maintenant",
        contact: "Prendre contact"
      }
    },
    company: {
      tagline: 'Basée à Aarwangen, W. Althaus AG est depuis plus de 50 ans le spécialiste du service complet pour l\'automatisation industrielle.',
      founded: 'Fondée en 1968',
      familyOwned: 'Gestion familiale',
      employees: '50+ employés',
      hours: 'Heures d\'ouverture',
      hoursDetail: 'Lundi au jeudi\n07.30 - 12.00 /\n13.00 - 16.00\n\nVendredi\n07.30 - 12.00 /\n13.00 - 15.00',
      contactTitle: 'CONTACT',
      headquarters: 'Siège social\nW. Althaus AG\nAutomatisation industrielle\nJurastrasse 12\nCH-4912 Aarwangen\nSuisse',
      production: 'Production\nW. Althaus AG\nAutomatisation industrielle\nIndustriering 2\nCH-4912 Aarwangen\nSuisse',
      phone1: '+41 62 919 82 10',
      phone2: '+41 62 919 82 29',
      email: ''
    },
    about: {
      title: 'À propos de nous',
      subtitle: 'W. Althaus AG à Aarwangen est depuis plus de 50 ans le spécialiste suisse du service complet pour l\'automatisation industrielle',
      story: {
        title: 'Notre Histoire',
        description: 'Nous sommes une entreprise familiale suisse qui a été fondée en 1968 à Aarwangen dans le canton de Berne. Aujourd\'hui, plus de 100 employés travaillent sur deux sites, et W. Althaus AG est considérée comme un employeur important et pionnier dans la région.'
      },
      expertise: {
        title: 'Notre Compétence Principale',
        description: 'Développement et production des commandes électriques les plus simples aux solutions d\'automatisation complexes. En tant qu\'entreprise de service complet, nous offrons conseil conceptuel, ingénierie matérielle et logicielle, construction d\'armoires de commande, production de borniers, assemblage de groupes, support d\'assemblage, mise en service et formation.'
      },
      stats: {
        experience: "50+",
        experienceLabel: "Années d\'Expérience",
        employees: "100+", 
        employeesLabel: "Employés",
        locations: "2",
        locationsLabel: "Sites"
      },
      team: {
        title: 'Notre Équipe',
        subtitle: 'Nos interlocuteurs sont heureux d\'être là pour vous',
        description: 'Nous sommes une équipe dynamique et hautement motivée, engagée avec d\'excellentes qualifications pour des clients du monde entier. En tant qu\'entreprise familiale, nous misons sur une réflexion à long terme et représentons la confiance, la continuité et la compétence. Nos interlocuteurs sont à votre disposition.',
        leadership: 'Direction',
        hrVocationalTraining: 'RH/Formation professionnelle',
        members: {
          walterAlthaus: {
            name: 'Walter Althaus',
            position: 'Propriétaire',
            phone: '+41 62 919 82 12'
          },
          marcoSchneider: {
            name: 'Marco Schneider', 
            position: 'Directeur Général / CEO',
            phone: '+41 62 919 82 26'
          },
          manfredBoegli: {
            name: 'Manfred Bögli',
            position: 'Responsable Finances / RH', 
            phone: '+41 62 919 82 33'
          },
          michaelKuenzi: {
            name: 'Michael Künzi',
            position: 'Chef de Production',
            phone: '+41 62 919 82 18'
          },
          thiloBiss: {
            name: 'Thilo Biss',
            position: 'Chef de Développement',
            phone: '+41 62 919 82 37'
          },
          retoFritsche: {
            name: 'Reto Fritsche', 
            position: 'Chef des Ventes',
            phone: '+41 62 919 82 39'
          },
          stefanBrudermann: {
            name: 'Stefan Brudermann',
            position: 'Chef de Gestion des Matériaux',
            phone: '+41 62 531 83 94'
          },
          kathrinWalter: {
            name: 'Kathrin Walter',
            position: 'Responsable RH',
            phone: ''
          },
          rolandRebecchi: {
            name: 'Roland Rebecchi',
            position: 'Chef de Formation Professionnelle', 
            phone: '+41 62 919 82 19'
          }
        }
      }
    },
    news: {
      title: 'Actualités',
      subtitle: 'Dernières nouvelles de l\'entreprise',
      readMore: 'Lire la suite',
      watchVideo: 'Voir la vidéo',
      backToOverview: 'Retour à l\'aperçu',
      noNews: 'Aucune actualité actuellement disponible.',
      filter: {
        all: 'Toutes',
        company: 'Entreprise',
        training: 'Formation',
        events: 'Événements'
      }
    },
    jobDetailLabels: {
      jobDescription: 'Description du poste',
      responsibilities: 'Vos tâches',
      requirements: 'Exigences',
      benefits: 'Ce que nous offrons',
      applyNow: 'Postuler maintenant !',
      convinceUs: 'Convainquez-nous avec votre candidature',
      applyOnline: 'Postuler en ligne',
      questionsContact: 'Vous avez des questions ? N\'hésitez pas à nous contacter par téléphone ou par e-mail.',
      aboutUs: 'À propos de nous',
      companyDescription: 'W. Althaus AG est une entreprise leader dans le domaine de l\'automatisation industrielle avec plus de 25 ans d\'expérience. Nous développons des solutions innovantes pour l\'avenir de la production.',
      employees: '50+ Collaborateurs',
      international: 'Actif à l\'international',
      isoCertified: 'Certifié ISO 14001',
      backToListings: 'Retour aux offres d\'emploi',
      featuredPosition: 'Position vedette',
      urgentlyNeeded: 'Recherche urgente !',
      location: 'Lieu',
      workload: 'Taux d\'occupation',
      employment: 'Emploi',
      startDate: 'Début'
    },
    caseStudyLabels: {
      backToOverview: 'Retour à l\'aperçu',
      challengePrefix: 'Avant :',
      challenge: 'Le défi',
      solutionPrefix: 'Maintenant :',
      solution: 'La solution avec W. Althaus AG',
      positiveOutcomes: 'Résultats positifs',
      servicesInProject: 'Prestations du projet',
      conclusion: 'Conclusion',
      yourProject: 'Votre projet avec',
      realizeTogether: 'Réalisons ensemble votre solution d\'automatisation',
      requestProject: 'Demander un projet',
      moreSuccessStories: 'Plus de Success Stories',
      learnMore: 'En savoir plus',
      about: 'À propos de',
      content: 'Contenu',
      customerSince: 'Client depuis',
      builtCabinets: 'Armoires construites',
      automationDegree: 'Degré d\'automatisation',
      onTimeDelivery: 'Respect des délais',
      negativeConsequences: 'Conséquences négatives',
      challengeWithout: 'Le défi sans W. Althaus AG',
      solutionWith: 'La solution avec W. Althaus AG',
      projectFits: 'Votre projet correspond',
      scalableCabinetBuild: 'Construction d\'armoires de commande évolutive pour votre série.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Contactez-nous. Nous attendons votre demande avec impatience.',
      headquarters: 'Siège social',
      production: 'Site de production',
      address: 'Adresse',
      phone: 'Téléphone',
      email: 'E-Mail',
      hours: 'Heures d\'ouverture',
      directPhone: 'Ligne directe production',
      directions: 'Accès',
      directionsText: 'Directement sur l\'autoroute A1, sortie Aarwangen. Parking visiteurs disponible directement au bâtiment.',
      hoursText: 'Lun-Ven: 07:00 - 17:00\nSam: Sur rendez-vous',
      form: {
        title: 'Envoyer une demande',
        subtitle: 'Nous vous répondrons dans les plus brefs délais – généralement dans un délai d\'une journée ouvrable.',
        sections: {
          concern: 'Votre demande',
          personal: 'Informations personnelles',
          message: 'Votre message',
          privacy: 'Protection des données'
        },
        fields: {
          firstName: 'Prénom',
          lastName: 'Nom',
          company: 'Entreprise',
          email: 'E-Mail',
          phone: 'Téléphone',
          contactMethod: 'Méthode de contact préférée',
          category: 'Quel est votre besoin ?',
          categoryHint: 'Veuillez sélectionner la catégorie appropriée :',
          subject: 'Objet',
          requestTo: 'Demande à',
          services: 'Demande / Services intéressés',
          message: 'Veuillez décrire votre demande',
          files: 'Télécharger des fichiers',
          privacy: 'Consentement à la confidentialité'
        },
        placeholders: {
          firstName: 'p. ex. Pierre',
          lastName: 'p. ex. Dupont',
          company: 'p. ex. Exemple SA',
          email: 'p. ex. pierre.dupont@exemple.fr',
          phone: 'p. ex. +41 79 123 45 67',
          message: 'Veuillez décrire votre demande.',
          subject: 'Indiquez l\'objet de votre message',
          requestTo: 'p. ex. M. Dupont',
          preferredTime: 'Heure préférée'
        },
        options: {
          contactMethod: {
            email: 'E-Mail',
            phone: 'Téléphone'
          },
          categories: {
            serviceInquiry: 'Demande concernant nos services',
            productIntro: 'Présenter un produit ou service',
            general: 'Demande générale',
            support: 'Support pour une commande existante'
          },
          services: {
            controlCabinet: 'Construction d\'armoires électriques',
            hardwareEngineering: 'Ingénierie matérielle',
            softwareEngineering: 'Ingénierie logicielle',
            cableAssembly: 'Confection de câbles',
            terminalProduction: 'Production de borniers',
            consulting: 'Conseil',
            other: 'Autre'
          },
          preferredTime: {
            morning: 'Matin',
            afternoon: 'Après-midi',
            flexible: 'Flexible'
          }
        },
        validation: {
          firstNameRequired: 'Veuillez saisir le prénom.',
          lastNameRequired: 'Veuillez saisir le nom.',
          companyRequired: 'Veuillez saisir le nom de l\'entreprise.',
          contactRequired: 'Veuillez fournir un email ou un téléphone (au moins un est requis).',
          emailInvalid: 'Veuillez saisir une adresse email valide.',
          phoneInvalid: 'Veuillez saisir un numéro de téléphone valide (p. ex. +41 79 123 45 67).',
          contactMethodRequired: 'Veuillez sélectionner une méthode de contact.',
          categoryRequired: 'Veuillez sélectionner un type de demande.',
          messageRequired: 'Veuillez décrire votre demande.',
          phoneRequiredWhenSelected: 'Veuillez saisir votre numéro de téléphone si vous souhaitez être contacté par téléphone.',
          emailRequiredWhenSelected: 'Veuillez saisir votre adresse e-mail si vous souhaitez être contacté par e-mail.',
          servicesRequired: 'Veuillez sélectionner au moins un service.',
          privacyRequired: 'Veuillez accepter le traitement des données.'
        },
        buttons: {
          submit: 'Envoyer la demande',
          submitting: 'Envoi en cours...',
          newRequest: 'Envoyer une nouvelle demande',
          callAlternative: 'Ou appelez-nous: +41 62 919 82 10'
        },
        error: {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'envoi de votre demande.'
        },
        success: {
          title: 'Demande envoyée avec succès',
          message: 'Votre demande a été transmise avec succès. Nous vous répondrons dans les meilleurs délais.',
          newsTitle: 'Actualités de notre entreprise',
        },
        privacy: {
          text: 'J\'accepte le traitement de mes données selon la',
          link: 'Politique de confidentialité',
          linkText: '.'
        },
        fileUpload: {
          accepted: 'PDF, PNG/JPG, ZIP • Max. 15 MB • Téléchargements multiples autorisés',
          dropzone: 'Déposez les fichiers ici ou cliquez pour sélectionner'
        }
      }
    },
    anfahrt: {
      title: 'Accès',
      subtitle: 'Visitez-nous à Aarwangen - Situé directement sur l\'autoroute A1',
      hero: {
        title: 'Bienvenue chez W. Althaus AG',
        subtitle: 'Trouvez facilement votre chemin vers nous à Aarwangen. Notre siège social et l\'Usine 2 sont idéalement situés directement sur l\'autoroute A1.'
      },
      headquarters: {
        title: 'Siège social',
        name: 'W. Althaus AG',
        street: 'Jurastrasse 12',
        city: '4912 Aarwangen',
        country: 'Suisse'
      },
      werk2: {
        title: 'Usine 2 - Production',
        name: 'W. Althaus AG - Usine 2',
        street: 'Industriering',
        city: '4912 Aarwangen',
        country: 'Suisse'
      },
      contact: {
        phone: '+41 62 919 82 82',
        email: '',
        website: 'www.althaus.swiss'
      },
      directions: {
        title: 'Accès en voiture',
        highway: 'Autoroute A1',
        exit: 'Sortie Aarwangen',
        description: 'Prenez la sortie Aarwangen et suivez les panneaux direction zone industrielle. Les deux sites se trouvent dans la zone industrielle d\'Aarwangen.'
      },
      parking: {
        title: 'Parking',
        description: 'Parking gratuit pour les visiteurs disponible sur les deux sites.'
      },
      publicTransport: {
        title: 'Transports publics',
        train: 'Gare d\'Aarwangen (10 minutes à pied)',
        bus: 'Arrêt de bus Aarwangen Dorf (5 minutes à pied)'
      },
      hours: {
        title: 'Heures d\'ouverture',
        weekdays: 'Lundi - Vendredi: 07:00 - 17:00',
        saturday: 'Samedi: Sur rendez-vous',
        sunday: 'Dimanche: Fermé'
      }
    },
    products: {
      title: 'Produits',
      subtitle: 'Découvrez notre portefeuille de solutions d\'automatisation et de produits de haute qualité pour l\'industrie.'
    },
    cookieConsent: {
      bannerTitle: 'Paramètres de confidentialité',
      bannerText: 'Ce site utilise des technologies tierces pour proposer des services, les améliorer continuellement et afficher des contenus adaptés à vos centres d\'intérêt.',
      privacyPolicy: 'Politique de confidentialité',
      imprint: 'Mentions légales',
      settings: 'Paramètres',
      acceptAll: 'Tout accepter',
      saveSettings: 'Enregistrer les paramètres',
      cookieSettings: 'Paramètres des cookies',
      modalTitle: 'Paramètres de confidentialité',
      modalDescription: 'Cet outil vous permet de gérer votre consentement à la collecte et au traitement de données personnelles par des technologies tierces.',
      tabCategories: 'Catégories',
      tabServices: 'Services',
      categories: {
        essential: { name: 'Essentiel', description: 'Ces technologies sont nécessaires pour activer les fonctions essentielles de notre offre de services.' },
        functional: { name: 'Fonctionnel', description: 'Ces technologies nous permettent d\'analyser l\'utilisation afin de mesurer et d\'améliorer les performances de notre site.' },
        marketing: { name: 'Marketing', description: 'Ces technologies sont utilisées par les annonceurs pour diffuser des publicités pertinentes pour vos intérêts.' }
      },
      services: {
        consentManager: { name: 'Consent Manager', description: 'Enregistre vos préférences de confidentialité de manière sécurisée dans votre navigateur.' },
        cloudflare: { name: 'Cloudflare', description: 'Réseau de diffusion de contenu pour une livraison sécurisée et rapide du site.' },
        googleFonts: { name: 'Google Fonts', description: 'Charge les polices Web pour un affichage cohérent du site.' },
        googleMaps: { name: 'Google Maps', description: 'Affiche des cartes interactives pour l\'itinéraire et les informations de localisation.' },
        ostendis: { name: 'Ostendis', description: 'Fournit les offres d\'emploi actuelles sur la page Carrière.' },
        googleAnalytics: { name: 'Google Analytics', description: 'Analyse de manière anonyme l\'utilisation du site afin d\'améliorer notre offre.' },
        googleTagManager: { name: 'Google Tag Manager', description: 'Gère les balises marketing et d\'analyse du site.' },
        googleAds: { name: 'Google Ads', description: 'Utilisé pour diffuser des publicités pertinentes et mesurer les conversions.' }
      },
      alwaysActive: 'Toujours actif',
      poweredBy: 'Fourni par W. Althaus AG'
    }
  },
  it: {
    nav: {
      home: 'Home',
      services: 'Servizi',
      products: 'Prodotti',
      about: 'Chi siamo',
      leitbild: 'Missione',
      team: 'Management',
      partners: 'Partner & Ecosistema',
      anfahrt: 'Come arrivare',
      chameleonStory: 'Storia del Camaleonte',
      successStories: 'Success Stories',
      aboutDescription: 'Scopri la nostra azienda e la nostra competenza',
      sustainability: 'Sostenibilità',
      sustainabilityDescription: 'Automazione sostenibile per un futuro migliore',
      careers: 'Carriere',
      careersDescription: 'Unisciti al nostro team innovativo',
      vocationalTraining: 'Formazione professionale',
      vocationalTrainingDescription: 'Inizia la tua carriera con una formazione di prima classe',
      news: 'Notizie',
      contact: 'Contatto',
      overview: 'Panoramica'
    },
    routes: {
      services: 'servizi',
      products: 'prodotti',
      about: 'chi-siamo',
      sustainability: 'sostenibilita',
      careers: 'carriere',
      news: 'notizie',
      contact: 'contatto',
      jobOpenings: 'offerte-lavoro',
      vocationalTraining: 'formazione-professionale',
      schaltschrankbau: 'costruzione-quadri',
      engineering: 'ingegneria',
      softwareengineering: 'ingegneria-software',
      leitbild: 'missione',
      team: 'management',
      partners: 'partner-ecosistema',
      anfahrt: 'come-arrivare',
      chameleonStory: 'storia-camaleonte',
      successStories: 'success-stories',
      hardwareentwickler: 'sviluppatore-hardware',
      projektleiter: 'capo-progetto',
      automatiker: 'tecnico-automazione',
      athex: 'athex',
      panelscout: 'panelscout',
      documents: 'documenti',
      ausstellung: 'esposizione'
    },
    footer: {
      imprint: 'Colofone',
      privacy: 'Privacy',
      howToGetHere: 'Come arrivare',
      documents: 'Documenti',
      quickLinks: 'Link rapidi',
      company: 'Azienda',
      headquarters: 'Sede centrale',
      isoCertified: 'Certificato ISO 14001',
      copyright: '© 2026 W. Althaus AG. Tutti i diritti riservati.',
      quality: 'Leading in Automation dal 1968'
    },
    home: {
      hero: {
        weAre: 'Noi siamo...',
        title: 'Produttività attraverso flussi di lavoro integrati e produzione automatizzata',
        subtitle: 'Da oltre 40 anni aumentiamo la produttività attraverso flussi di lavoro integrati e produzione completamente automatizzata - ogni singolo giorno.',
        tagline: 'La nostra automazione per il vostro vantaggio competitivo',
        ctaContact: 'Contattaci',
        ctaServices: 'Vedi servizi',
        stats: {
          experience: 'Anni di esperienza',
          projects: 'Progetti',
          employees: 'Dipendenti lavorano sui vostri sogni',
          swissFamily: 'Azienda familiare svizzera'
        }
      },
      services: {
        title: 'I nostri servizi',
        subtitle: 'Soluzioni complete per l\'automazione industriale',
        viewAll: 'Vedi tutti i servizi',
        learnMore: 'Scopri di più'
      },
      partners: {
        title: 'I nostri partner',
        subtitle: 'Affidatevi a tecnologie collaudate dei produttori leader'
      }
    },
    services: {
      title: 'Servizi',
      subtitle: 'La vostra automazione. La nostra competenza.',
      schaltschrankbau: {
        title: 'Costruzione quadri elettrici',
        description: 'Come più grande e principale azienda svizzera nella costruzione di quadri elettrici, vi procuriamo nuovi vantaggi competitivi attraverso la nostra produzione completamente automatizzata assistita da IA',
        badge: 'Costruzione quadri elettrici 4.0',
        heroTitle: 'Costruzione quadri elettrici professionale',
        heroSubtitle: 'La nostra automazione con costruzione quadri elettrici 4.0 per il vostro vantaggio competitivo. Dai prototipi alla produzione in serie - processi completamente automatizzati per la massima qualità.',
        servicesTitle: 'La nostra gamma di servizi',
        servicesSubtitle: 'Produzione completamente automatizzata con profondità di produzione ottimale mantenendo piena flessibilità riguardo ai requisiti del cliente.',
        capabilitiesTitle: 'La nostra offerta di servizi',
        capabilitiesSubtitle: 'Per conto dei loro clienti, W. Althaus AG costruisce e assembla quadri elettrici e assiemi per vari mercati dai prototipi alla produzione in serie e varianti.',
        automationTitle: 'Produzione completamente automatizzata',
        automationDescription: 'L\'alto grado di automazione ci genera un\'alta qualità costante a condizioni competitive.',
        automationGrade: 'Grado di automazione',
        ctaTitle: 'Pronti per la vostra costruzione quadri elettrici?',
        ctaSubtitle: 'Realizziamo insieme la vostra soluzione di automazione. Contattateci per una consulenza senza impegno.',
        ctaButtonPrimary: 'Richiedere progetto',
        ctaButtonSecondary: 'Vedere referenze',
        features: {
          ecad: {
            title: 'Ingegneria E-CAD',
            description: 'Pianificazione professionale con ePlan P8, ePlan Pro Panel e E3.series per schemi precisi'
          },
          production: {
            title: 'Produzione completamente automatizzata',
            description: 'Costruzione quadri elettrici 4.0 con il massimo grado di automazione per qualità costante'
          },
          compliance: {
            title: 'Conformità alle norme',
            description: 'Rispetto di tutte le norme e standard pertinenti per la massima sicurezza operativa'
          },
          terminals: {
            title: 'Produzione morsettiere',
            description: 'Produzione automatica di morsettiere con connettori Phoenix Contact'
          },
          assembly: {
            title: 'Montaggio assiemi',
            description: 'Montaggio professionale e integrazione di tutti i componenti secondo i più alti standard'
          },
          testing: {
            title: 'Procedure di test e verifica',
            description: 'Controlli qualità completi e test funzionali prima della consegna'
          }
        },
        benefits: {
          competitive: {
            title: 'Vantaggi competitivi',
            description: 'Attraverso la costruzione quadri elettrici 4.0 vi generiamo vantaggi competitivi misurabili'
          },
          quality: {
            title: 'Alta qualità',
            description: 'I processi completamente automatizzati garantiscono qualità costantemente alta'
          },
          flexibility: {
            title: 'Flessibilità',
            description: 'Dai prototipi alla produzione in serie - ci adattiamo alle vostre esigenze'
          },
          efficiency: {
            title: 'Efficienza dei costi',
            description: 'Il grado di automazione assicura prezzi competitivi con la massima qualità'
          }
        },
        capabilities: [
          'E-CAD: ePlan P8, ePlan Pro Panel, E3.series',
          'Costruzione quadri elettrici dai prototipi alla produzione in serie',
          'Produzione morsettiere (Phoenix Contact)',
          'Montaggio assiemi e integrazione',
          'Procedure di test e verifica',
          'Cablaggio completamente automatizzato',
          'Lavorazione lamiera e costruzione involucri',
          'Controllo qualità secondo standard ISO'
        ],
        // NEW: Page-specific translations
        hero: {
          tagline: 'automatizzato. preciso. Althaus.',
          intro: 'Con la costruzione quadri elettrici 4.0, combiniamo ECAD Digital Twin, processi modularizzati e produzione altamente automatizzata in Svizzera – per costi competitivi, qualità costantemente elevata e produzione in serie a partire dall\'unità 1.'
        },
        cards: {
          whatYouGet: {
            title: 'Cosa Ottenete da Althaus',
            description: 'Costruiamo e assembliamo quadri elettrici e assiemi per diverse industrie – dal prototipo alla produzione in serie. Catene di processo completamente automatizzate, moduli standardizzati e un flusso dati ECAD continuo garantiscono velocità, qualità e pianificabilità durante l\'intero ciclo di vita del prodotto.'
          },
          scope: {
            title: 'Ambito dei Servizi - Competenze & Strumenti',
            description: 'Dal primo clic in ECAD alla messa in servizio. Realizziamo soluzioni per quadri elettrici in modo rapido, scalabile e conforme alle norme. Digital Twin (ePlan P8/Pro Panel, E3), kit di piattaforma standardizzati e SCM coordinato garantiscono velocità, qualità e costi – 100% prodotto in Svizzera. Con montaggio in loco e test UL/CSA.'
          },
          howWeWork: {
            title: 'Come Lavoriamo',
            description: 'Dalla prima conversazione al montaggio in loco. Obiettivi, norme, scenari di quantità e budget chiariti. Digital Twin (ePlan/E3, Pannello 3D) con concetto di cablaggio automatizzabile. Design for Assembly, standardizzazione, verifica UL/CSA. Produzione automatizzata: qualità di serie dall\'unità 1, modifiche fino a poco prima della spedizione, test, documentazione, tracciabilità e supporto.'
          }
        },
        processSteps: {
          requirement: { title: 'Requisiti & Consulenza', description: 'Analisi dettagliata dei requisiti e consulenza esperta per il vostro progetto.' },
          engineering: { title: 'Ingegneria', description: 'Pianificazione professionale ed elaborazione tecnica secondo i più alti standard.' },
          material: { title: 'Materiale & Preparazione', description: 'Selezione accurata dei materiali e preparazione ottimale di tutti i componenti.' },
          automated: { title: 'Lavorazione Automatizzata', description: 'Produzione automatizzata precisa con tecnologia all\'avanguardia.' },
          assembly: { title: 'Montaggio & Cablaggio', description: 'Montaggio professionale e cablaggio strutturato secondo gli standard industriali.' },
          testing: { title: 'Test & Accettazione', description: 'Test di qualità completi e accettazione documentata di tutti i sistemi.' },
          commissioning: { title: 'Messa in Servizio', description: 'Messa in servizio professionale e ottimizzazione presso il cliente.' },
          service: { title: 'Servizio & Ciclo di Vita', description: 'Supporto e manutenzione a lungo termine per l\'intero ciclo di vita.' }
        },
        servicesGrid: {
          ecad: { name: 'E-CAD: ePlan p8, ePlan Pro Panel, E3', description: 'Pianificazione elettrica professionale con strumenti CAD all\'avanguardia' },
          layout: { name: 'Concetto Quadro: Progettazione, Layout', description: 'Concezione ben pensata e layout ottimizzati' },
          standardization: { name: 'Standardizzazione, Modularizzazione', description: 'Processi efficienti attraverso moduli standardizzati' },
          procurement: { name: 'Concetti di Approvvigionamento e Logistica', description: 'Flussi di materiale ottimizzati e logistica' },
          materialOptimization: { name: 'Ottimizzazione della Gestione Materiali', description: 'Pianificazione e gestione efficiente dei materiali' },
          production: { name: 'Prototipazione, Produzione Singola & Serie', description: 'Produzione flessibile per tutte le esigenze' },
          onSite: { name: 'Montaggio in Loco dal Cliente', description: 'Installazione e messa in servizio professionale direttamente presso di voi' },
          ulCsa: { name: 'Certificazione UL / CSA', description: 'Certificazione internazionale per il mercato nordamericano' }
        },
        valueProposition: {
          title: 'Il Vostro Valore Aggiunto dalla Nostra Automazione',
          cost: { title: 'Costi Competitivi', description: 'Processi efficienti e flussi di lavoro standardizzati per un\'ottimale convenienza economica.' },
          quality: { title: 'Qualità Costantemente Elevata', description: 'Controlli qualità rigorosi e processi certificati garantiscono affidabilità.' },
          changes: { title: 'Modifiche Tardive Possibili', description: 'Regolazioni flessibili fino all\'ultimo momento grazie al design modulare.' },
          speed: { title: 'Tempi di Consegna Brevi', description: 'Produzione automatizzata e logistica ottimizzata per consegne rapide.' }
        },
        sectionHeaders: {
          servicesOffering: 'La Nostra Offerta di Servizi Include'
        }
      },
      kabelkonfektion: {
        title: 'Confezione cavi',
        description: 'Confezione cavi professionale secondo i più alti standard di qualità'
      },
      klemmensteg: {
        title: 'Produzione morsettiere',
        description: 'Produzione precisa di morsettiere per le vostre soluzioni di automazione'
      },
      softwareengineering: {
        title: 'Ingegneria del software',
        description: 'Soluzioni software complete dalla pianificazione del progetto alla messa in servizio. Visualizzazioni intuitive e applicazioni di database personalizzate.'
      },
      engineering: {
        title: 'Ingegneria hardware e software',
        description: 'Ingegneria che mantiene ciò che promette. Hardware e software – tutto da un\'unica fonte. Digitalizziamo le vostre idee – fino a quando la vostra automazione funziona produttivamente.'
      }
    },
    company: {
      tagline: 'Con sede ad Aarwangen, W. Althaus AG è da oltre 50 anni lo specialista a servizio completo per l\'automazione industriale.',
      founded: 'Fondata nel 1968',
      familyOwned: 'A conduzione familiare',
      employees: '50+ dipendenti',
      hours: 'Orari di apertura',
      hoursDetail: 'Lunedì al giovedì\n07.30 - 12.00 /\n13.00 - 16.00\n\nVenerdì\n07.30 - 12.00 /\n13.00 - 15.00',
      contactTitle: 'CONTATTO',
      headquarters: 'Sede principale\nW. Althaus AG\nAutomazione industriale\nJurastrasse 12\nCH-4912 Aarwangen\nSvizzera',
      production: 'Produzione\nW. Althaus AG\nAutomazione industriale\nIndustriering 2\nCH-4912 Aarwangen\nSvizzera',
      phone1: '+41 62 919 82 10',
      phone2: '+41 62 919 82 29',
      email: ''
    },
    about: {
      title: 'Chi siamo',
      subtitle: 'W. Althaus AG ad Aarwangen è da oltre 50 anni lo specialista svizzero a servizio completo per l\'automazione industriale',
      story: {
        title: 'La Nostra Storia',
        description: 'Siamo un\'azienda familiare svizzera fondata nel 1968 ad Aarwangen nel cantone di Berna. Oggi, oltre 100 dipendenti lavorano in due sedi, e W. Althaus AG è considerata un datore di lavoro importante e pioniere nella regione.'
      },
      expertise: {
        title: 'La Nostra Competenza Principale',
        description: 'Sviluppo e produzione dai controlli elettrici più semplici alle soluzioni di automazione complesse. Come azienda a servizio completo, offriamo consulenza concettuale, ingegneria hardware e software, costruzione quadri di comando, produzione morsettiere, assemblaggio gruppi, supporto assemblaggio, messa in servizio e formazione.'
      },
      stats: {
        experience: "50+",
        experienceLabel: "Anni di Esperienza",
        employees: "100+", 
        employeesLabel: "Dipendenti",
        locations: "2",
        locationsLabel: "Sedi"
      },
      team: {
        title: 'Il Nostro Team',
        subtitle: 'I nostri interlocutori sono felici di essere lì per voi',
        description: 'Siamo un team dinamico e altamente motivato, impegnato con eccellenti qualifiche per clienti di tutto il mondo. Come azienda familiare, puntiamo sul pensiero a lungo termine e rappresentiamo fiducia, continuità e competenza. I nostri interlocutori sono a vostra disposizione.',
        leadership: 'Direzione',
        hrVocationalTraining: 'HR/Formazione professionale',
        members: {
          walterAlthaus: {
            name: 'Walter Althaus',
            position: 'Proprietario',
            phone: '+41 62 919 82 12'
          },
          marcoSchneider: {
            name: 'Marco Schneider', 
            position: 'Direttore Generale / CEO',
            phone: '+41 62 919 82 26'
          },
          manfredBoegli: {
            name: 'Manfred Bögli',
            position: 'Responsabile Finanze / HR', 
            phone: '+41 62 919 82 33'
          },
          michaelKuenzi: {
            name: 'Michael Künzi',
            position: 'Capo Produzione',
            phone: '+41 62 919 82 18'
          },
          thiloBiss: {
            name: 'Thilo Biss',
            position: 'Capo Sviluppo',
            phone: '+41 62 919 82 37'
          },
          retoFritsche: {
            name: 'Reto Fritsche', 
            position: 'Capo Vendite',
            phone: '+41 62 919 82 39'
          },
          stefanBrudermann: {
            name: 'Stefan Brudermann',
            position: 'Capo Gestione Materiali',
            phone: '+41 62 531 83 94'
          },
          kathrinWalter: {
            name: 'Kathrin Walter',
            position: 'Responsabile HR',
            phone: ''
          },
          rolandRebecchi: {
            name: 'Roland Rebecchi',
            position: 'Capo Formazione Professionale', 
            phone: '+41 62 919 82 19'
          }
        }
      }
    },
    careers: {
      title: 'Carriere',
      subtitle: 'Unisciti al nostro team - Forma con noi il futuro dell\'automazione industriale',
      teamSpirit: {
        title: 'Il Nostro Spirito di Squadra',
        description: 'Siamo un team giovane, dinamico e altamente motivato. Mettiamo le nostre eccellenti qualifiche al servizio dei nostri clienti di tutto il mondo con dedizione. Manteniamo rapporti aperti e di fiducia tra di noi e viviamo una forte identificazione con la nostra azienda.'
      },
      employer: {
        title: 'Datore di Lavoro per la Regione',
        description: 'Manteniamo una partnership caratterizzata dalla continuità con i nostri dipendenti così come con i nostri fornitori, partner e clienti. W. Althaus AG è così un datore di lavoro importante e sicuro nella regione.'
      },
      benefits: {
        title: 'Cosa rende speciale lavorare per noi?',
        items: [
          'Atmosfera di lavoro familiare',
          'Equilibrio lavoro-vita bilanciato',
          'Orari di lavoro flessibili',
          'Postazioni di lavoro attrezzate al top',
          'Contenuti di lavoro entusiasmanti e vari',
          'Sviluppo aziendale positivo'
        ]
      },
      education: {
        title: 'Formazione e Sviluppo',
        subtitle: 'Formiamo professionisti',
        description: 'Oltre cento dipendenti qualificati dai settori ingegneria, CAE, produzione e logistica dimostrano l\'elevata competenza tecnica ampiamente supportata di W. Althaus AG. La formazione e lo sviluppo continui dei nostri dipendenti fanno parte della nostra filosofia aziendale.',
        apprenticeships: {
          title: 'Apprendistati',
          automatiker: {
            title: 'Tecnico dell\'Automazione',
            description: 'I tecnici dell\'automazione lavorano in aree come costruzione di controlli, distribuzione energetica, ingegneria di processo, costruzione di macchine elettriche o automazione industriale.'
          },
          automatikmonteur: {
            title: 'Montatore di Automazione',
            description: 'I montatori di automazione assemblano, mantengono e riparano sistemi e dispositivi elettronici o supervisionano i corrispondenti processi di produzione.'
          }
        }
      },
      openings: {
        title: 'Posizioni Aperte',
        noOpenings: 'Attualmente non ci sono posizioni annunciate',
        spontaneous: {
          title: 'Candidatura Spontanea',
          description: 'La vostra posizione desiderata non è disponibile? Accogliamo volentieri la vostra candidatura spontanea. Se la vostra candidatura corrisponde a un profilo che stiamo cercando, vi contatteremo volentieri.'
        },
        apply: 'Candidati Ora',
        backToListings: 'Torna agli annunci di lavoro',
        viewDetails: 'Vedi dettagli',
        jobs: {
          hardwareentwickler: {
            title: "Sviluppatore Hardware (m/f/d)",
            department: "Ingegneria",
            type: "Posizione permanente",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "Settembre o secondo accordo",
            applicationUrl: "https://ostendis.com/apply/5024-hardwareentwickler-m-w-d",
            description: "Digitalizzazione, automazione o robotica - tutti ne parlano. Da noi sei proprio nel mezzo! Perché lavoriamo con gli strumenti e le tecnologie più moderni.",
            longDescription: "Come sviluppatore hardware presso W. Althaus AG, fai parte di un team innovativo specializzato nello sviluppo di soluzioni di automazione all'avanguardia. Lavori su progetti entusiasmanti nei settori della digitalizzazione, automazione e robotica e contribuisci in modo decisivo allo sviluppo tecnologico della nostra azienda.",
            requirements: [
              "Formazione tecnica TS o studi di ingegneria (HF/FH) elettrotecnica/automazione",
              "Esperienza con EPLAN P8, idealmente anche Pro Panel",
              "Solide conoscenze IT nell'ambiente Microsoft 365",
              "Conoscenze di inglese",
              "Metodo di lavoro indipendente, strutturato e orientato alle soluzioni",
              "Spirito di squadra e forza comunicativa",
              "Interesse per tecnologie innovative"
            ],
            responsibilities: [
              "Concezione, sviluppo e realizzazione autonomi di soluzioni di automazione/hardware di controllo",
              "Elaborazione tecnica di offerte in stretta collaborazione con le vendite",
              "Pianificazione e sviluppo dell'hardware di controllo - standardizzato, documentato e conforme alle norme",
              "Creazione di schemi con EPLAN P8 basata su specifiche del cliente",
              "Accompagnamento dei progetti fino alla messa in servizio incluso supporto tecnico",
              "Collaborazione con team interdisciplinari",
              "Assicurazione qualità e documentazione"
            ],
            benefits: [
              "Attività entusiasmante e versatile in un team dinamico",
              "Condizioni di impiego progressive",
              "Eccellenti prestazioni sociali",
              "Posto di lavoro moderno con tecnologia più recente",
              "Orari di lavoro flessibili",
              "Opportunità di formazione continua",
              "Previdenza aziendale",
              "Parcheggio aziendale"
            ],
            labels: {
              location: "Ubicazione",
              workload: "Carico di lavoro",
              type: "Impiego",
              startDate: "Inizio",
              requirements: "Requisiti",
              responsibilities: "Compiti",
              benefits: "La nostra offerta",
              featuredPosition: "Posizione in evidenza"
            }
          },
          projektleiter: {
            title: "Capo Progetto Automazione (m/f/d)",
            department: "Gestione Progetti",
            type: "Posizione permanente",
            workload: "80-100%",
            location: "Aarwangen",
            startDate: "Secondo accordo",
            applicationUrl: "https://ostendis.com/apply/5023-projektleiter-automation-m-w-d",
            description: "Prendi la guida di progetti di automazione complessi e contribuisci a plasmare il futuro dell'automazione industriale.",
            longDescription: "Come capo progetto automazione presso W. Althaus AG, assumi la responsabilità di progetti di automazione complessi dalla concezione alla messa in servizio di successo. Coordini team interdisciplinari e assicuri l'implementazione puntuale e conforme al budget delle nostre soluzioni innovative.",
            requirements: [
              "Formazione tecnica completata (HF/FH) in elettrotecnica, automazione o simile",
              "Diversi anni di esperienza nella gestione progetti, idealmente nell'automazione",
              "Solide conoscenze dei metodi di gestione progetti (PMI, PRINCE2 vantaggiosi)",
              "Esperienza con MS Project o strumenti simili",
              "Eccellenti capacità di comunicazione e leadership",
              "Tedesco e inglese fluenti",
              "Disponibilità a viaggiare (ca. 20%)"
            ],
            responsibilities: [
              "Gestione e coordinamento di progetti di automazione dalla A alla Z",
              "Pianificazione progetti, budgeting e gestione risorse",
              "Leadership di team di progetto interdisciplinari",
              "Assistenza clienti e gestione stakeholder",
              "Gestione rischi e assicurazione qualità",
              "Monitoraggio tempistiche e controlling progetti",
              "Documentazione e reportistica",
              "Miglioramento continuo dei processi"
            ],
            benefits: [
              "Posizione di responsabilità con margine creativo",
              "Progetti diversificati con tecnologia all'avanguardia",
              "Condizioni di impiego attrattive",
              "Prestazioni sociali complete",
              "Modelli di lavoro flessibili",
              "Opportunità di formazione e certificazioni",
              "Ambiente di lavoro moderno",
              "Auto aziendale o abbonamento trasporti pubblici"
            ],
            labels: {
              location: "Ubicazione",
              workload: "Carico di lavoro",
              type: "Impiego",
              startDate: "Inizio",
              requirements: "Requisiti",
              responsibilities: "Compiti",
              benefits: "La nostra offerta",
              featuredPosition: "Posizione in evidenza"
            }
          },
          automatiker: {
            title: "Tecnico Automazione AFC (m/f/d)",
            department: "Produzione",
            type: "Posizione permanente",
            workload: "100%",
            location: "Aarwangen",
            startDate: "Secondo accordo",
            applicationUrl: "https://ostendis.com/apply/5025-automatiker-m-w-d",
            description: "Entra a far parte del nostro team di produzione e lavora sulla realizzazione di soluzioni di automazione all'avanguardia.",
            longDescription: "Come tecnico automazione AFC presso W. Althaus AG, sei responsabile del montaggio, cablaggio e messa in servizio professionale di impianti di automazione. Lavori sia nel nostro moderno stabilimento produttivo che direttamente presso il cliente.",
            requirements: [
              "Apprendistato completato come tecnico automazione AFC o formazione equivalente",
              "Diversi anni di esperienza professionale nella tecnologia di automazione",
              "Esperienza con programmazione PLC (Siemens, Beckhoff, ecc.)",
              "Conoscenze nella costruzione quadri e tecniche di cablaggio",
              "Metodo di lavoro preciso e indipendente",
              "Spirito di squadra e affidabilità",
              "Disponibilità a viaggiare per montaggi presso clienti"
            ],
            responsibilities: [
              "Montaggio e cablaggio di quadri elettrici e componenti di automazione",
              "Messa in servizio di impianti di controllo presso clienti",
              "Programmazione PLC e parametrizzazione",
              "Esecuzione di test funzionali e di sicurezza",
              "Diagnosi errori e riparazioni",
              "Documentazione dei lavori eseguiti",
              "Formazione clienti e supporto tecnico",
              "Rispetto delle norme di sicurezza"
            ],
            benefits: [
              "Attività varia in produzione e presso clienti",
              "Lavoro con tecnologia di automazione all'avanguardia",
              "Remunerazione attrattiva secondo qualifica",
              "Prestazioni sociali complete",
              "Orari di lavoro flessibili secondo accordo",
              "Opportunità di formazione continua",
              "Rimborso spese per montaggi esterni",
              "Auto aziendale per missioni clienti"
            ],
            labels: {
              location: "Ubicazione",
              workload: "Carico di lavoro",
              type: "Impiego",
              startDate: "Inizio",
              requirements: "Requisiti",
              responsibilities: "Compiti",
              benefits: "La nostra offerta",
              featuredPosition: "Posizione in evidenza"
            }
          }
        }
      }
    },
    vocationalTraining: {
      title: "Formazione professionale presso W. Althaus AG",
      subtitle: "Investi nel tuo futuro con una formazione di alta qualità nella tecnologia di automazione. I nostri apprendisti beneficiano di tecnologia all'avanguardia, mentori esperti e diverse opportunità di carriera.",
      badge: "Posizioni di formazione disponibili",
      programs: {
        title: "I nostri programmi di formazione",
        description: "Offriamo formazioni pratiche in professioni orientate al futuro dell'automazione e dell'elettrotecnica.",
        highlights: "Aree di formazione",
        automatiker: {
          title: "Tecnico dell'automazione AFC",
          description: "Come tecnico dell'automazione, sviluppi, installi e mantieni sistemi automatizzati. Lavori con tecnologia all'avanguardia e impari tutti gli aspetti dell'automazione industriale.",
          highlights: [
            "Programmazione controlli PLC",
            "Installazione sistemi di automazione",
            "Messa in servizio sistemi complessi",
            "Diagnosi errori e manutenzione",
            "Lavoro di progetto in team"
          ]
        },
        automatikmonteur: {
          title: "Montatore automazione AFC",
          description: "Come montatore di automazione, assembli componenti elettrici e pneumatici, cabli quadri di controllo e metti in servizio sistemi automatizzati.",
          highlights: [
            "Costruzione quadri e cablaggio",
            "Assemblaggio componenti",
            "Messa in servizio sistemi",
            "Controllo qualità",
            "Supporto clienti in loco"
          ]
        }
      },
      benefits: {
        title: "Perché formarsi con noi?",
        description: "Presso W. Althaus AG, non ricevi solo una formazione tecnica di prima classe, ma vieni anche incoraggiato e supportato personalmente.",
        mentorship: {
          title: "Mentori esperti",
          description: "I nostri professionisti esperti ti accompagnano durante tutta la formazione e sono sempre disponibili per consigli e supporto."
        },
        practical: {
          title: "Formazione pratica", 
          description: "Lavora su progetti reali con tecnologia all'avanguardia fin dall'inizio e acquisisci preziosa esperienza professionale."
        },
        career: {
          title: "Opportunità di carriera",
          description: "Dopo la formazione, ti offriamo attraenti opportunità di assunzione e diverse possibilità di formazione continua."
        },
        culture: {
          title: "Ambiente di lavoro familiare",
          description: "Beneficia del nostro ambiente di lavoro aperto e di supporto e diventa parte del nostro team."
        }
      },
      timeline: {
        title: "Il tuo percorso formativo",
        description: "Dalle basi all'esperto - così ti sviluppi durante la tua formazione con noi.",
        year1: {
          title: "Basi & Orientamento",
          description: "Impara le basi dell'elettrotecnica, della meccanica e dei primi linguaggi di programmazione. Orientamento in azienda e conoscenza dei vari dipartimenti."
        },
        year2: {
          title: "Pratica & Approfondimento", 
          description: "Primi lavori pratici su impianti, approfondimento programmazione PLC e partecipazione a progetti più piccoli."
        },
        year3: {
          title: "Specializzazione & Progetti",
          description: "Specializzazione nella tua area scelta, collaborazione in progetti clienti e assunzione di responsabilità."
        },
        year4: {
          title: "Ruolo di esperto & Completamento",
          description: "Lavoro indipendente, mentoring di apprendisti più giovani e preparazione per la procedura di qualificazione."
        }
      },
      cta: {
        title: "Inizia la tua carriera con noi!",
        description: "Candidati ora per una posizione di formazione presso W. Althaus AG e poni le basi per un futuro di successo nella tecnologia di automazione.",
        apply: "Candidati ora",
        contact: "Mettiti in contatto"
      }
    },
    news: {
      title: 'Notizie',
      subtitle: 'Ultime notizie dall\'azienda',
      readMore: 'Leggi di più',
      watchVideo: 'Guarda il video',
      backToOverview: 'Torna alla panoramica',
      noNews: 'Attualmente nessuna notizia disponibile.',
      filter: {
        all: 'Tutte',
        company: 'Azienda',
        training: 'Formazione',
        events: 'Eventi'
      }
    },
    jobDetailLabels: {
      jobDescription: 'Descrizione della posizione',
      responsibilities: 'Le vostre mansioni',
      requirements: 'Requisiti',
      benefits: 'Cosa offriamo',
      applyNow: 'Candidati ora!',
      convinceUs: 'Convinceteci con la vostra candidatura',
      applyOnline: 'Candidatura online',
      questionsContact: 'Avete domande? Non esitate a contattarci telefonicamente o via e-mail.',
      aboutUs: 'Chi siamo',
      companyDescription: 'W. Althaus AG è un\'azienda leader nel settore dell\'automazione industriale con oltre 25 anni di esperienza. Sviluppiamo soluzioni innovative per il futuro della produzione.',
      employees: '50+ Collaboratori',
      international: 'Attivi a livello internazionale',
      isoCertified: 'Certificato ISO 14001',
      backToListings: 'Torna alle offerte di lavoro',
      featuredPosition: 'Posizione in evidenza',
      urgentlyNeeded: 'Ricerca urgente!',
      location: 'Sede',
      workload: 'Grado di occupazione',
      employment: 'Impiego',
      startDate: 'Inizio'
    },
    caseStudyLabels: {
      backToOverview: 'Torna alla panoramica',
      challengePrefix: 'Prima:',
      challenge: 'La sfida',
      solutionPrefix: 'Ora:',
      solution: 'La soluzione con W. Althaus AG',
      positiveOutcomes: 'Risultati positivi',
      servicesInProject: 'Prestazioni nel progetto',
      conclusion: 'Conclusione',
      yourProject: 'Il vostro progetto con',
      realizeTogether: 'Realizziamo insieme la vostra soluzione di automazione',
      requestProject: 'Richiedi progetto',
      moreSuccessStories: 'Altre Success Stories',
      learnMore: 'Scopri di più',
      about: 'Informazioni su',
      content: 'Contenuto',
      customerSince: 'Cliente dal',
      builtCabinets: 'Armadi costruiti',
      automationDegree: 'Grado di automazione',
      onTimeDelivery: 'Puntualità nelle consegne',
      negativeConsequences: 'Conseguenze negative',
      challengeWithout: 'La sfida senza W. Althaus AG',
      solutionWith: 'La soluzione con W. Althaus AG',
      projectFits: 'Il vostro progetto è adatto',
      scalableCabinetBuild: 'Costruzione scalabile di armadi di comando per la vostra serie.'
    },
    contact: {
      title: 'Contatto',
      subtitle: 'Contattateci. Attendiamo con piacere la vostra richiesta.',
      headquarters: 'Sede centrale',
      production: 'Sito produttivo',
      address: 'Indirizzo',
      phone: 'Telefono',
      email: 'E-Mail',
      hours: 'Orari di apertura',
      directPhone: 'Linea diretta produzione',
      directions: 'Come arrivare',
      directionsText: 'Direttamente sull\'autostrada A1, uscita Aarwangen. Parcheggio visitatori disponibile direttamente presso l\'edificio.',
      hoursText: 'Lun-Ven: 07:00 - 17:00\nSab: Su appuntamento',
      form: {
        title: 'Invia richiesta',
        subtitle: 'Vi risponderemo il prima possibile – di solito entro un giorno lavorativo.',
        sections: {
          concern: 'La vostra richiesta',
          personal: 'Dati personali',
          message: 'Il vostro messaggio',
          privacy: 'Protezione dei dati'
        },
        fields: {
          firstName: 'Nome',
          lastName: 'Cognome',
          company: 'Azienda',
          email: 'E-Mail',
          phone: 'Telefono',
          contactMethod: 'Metodo di contatto preferito',
          category: 'Qual è la vostra richiesta?',
          categoryHint: 'Selezionate la categoria appropriata:',
          subject: 'Oggetto',
          requestTo: 'Richiesta a',
          services: 'Richiesta / Servizi interessati',
          message: 'Descrivete la vostra richiesta',
          files: 'Carica file',
          privacy: 'Consenso privacy'
        },
        placeholders: {
          firstName: 'es. Mario',
          lastName: 'es. Rossi',
          company: 'es. Esempio SpA',
          email: 'es. mario.rossi@esempio.it',
          phone: 'es. +41 79 123 45 67',
          message: 'Descrivete la vostra richiesta.',
          subject: 'Indicate l\'oggetto del messaggio',
          requestTo: 'es. Sig. Rossi',
          preferredTime: 'Orario preferito'
        },
        options: {
          contactMethod: {
            email: 'E-Mail',
            phone: 'Telefono'
          },
          categories: {
            serviceInquiry: 'Richiesta sui nostri servizi',
            productIntro: 'Presentare un prodotto o servizio',
            general: 'Richiesta generale',
            support: 'Supporto per un ordine esistente'
          },
          services: {
            controlCabinet: 'Costruzione quadri elettrici',
            hardwareEngineering: 'Ingegneria hardware',
            softwareEngineering: 'Ingegneria software',
            cableAssembly: 'Assemblaggio cavi',
            terminalProduction: 'Produzione morsettiere',
            consulting: 'Consulenza',
            other: 'Altro'
          },
          preferredTime: {
            morning: 'Mattina',
            afternoon: 'Pomeriggio',
            flexible: 'Flessibile'
          }
        },
        validation: {
          firstNameRequired: 'Si prega di inserire il nome.',
          lastNameRequired: 'Si prega di inserire il cognome.',
          companyRequired: 'Si prega di inserire il nome dell\'azienda.',
          contactRequired: 'Si prega di fornire email o telefono (almeno uno è richiesto).',
          emailInvalid: 'Si prega di inserire un indirizzo email valido.',
          phoneInvalid: 'Si prega di inserire un numero di telefono valido (es. +41 79 123 45 67).',
          contactMethodRequired: 'Si prega di selezionare un metodo di contatto.',
          categoryRequired: 'Selezionate un tipo di richiesta.',
          messageRequired: 'Descrivete la vostra richiesta.',
          phoneRequiredWhenSelected: 'Inserite il vostro numero di telefono se desiderate essere contattati telefonicamente.',
          emailRequiredWhenSelected: 'Inserite il vostro indirizzo e-mail se desiderate essere contattati via e-mail.',
          servicesRequired: 'Si prega di selezionare almeno un servizio.',
          privacyRequired: 'Si prega di accettare il trattamento dei dati.'
        },
        buttons: {
          submit: 'Invia richiesta',
          submitting: 'Invio in corso...',
          newRequest: 'Invia nuova richiesta',
          callAlternative: 'O chiamateci: +41 62 919 82 10'
        },
        error: {
          title: 'Errore',
          message: 'Si è verificato un errore durante l\'invio della richiesta.'
        },
        success: {
          title: 'Richiesta inviata con successo',
          message: 'La vostra richiesta è stata inviata con successo. Vi risponderemo al più presto.',
          newsTitle: 'Novità dalla nostra azienda',
        },
        privacy: {
          text: 'Accetto il trattamento dei miei dati secondo l\'',
          link: 'Informativa sulla privacy',
          linkText: '.'
        },
        fileUpload: {
          accepted: 'PDF, PNG/JPG, ZIP • Max. 15 MB • Caricamenti multipli consentiti',
          dropzone: 'Trascina i file qui o clicca per selezionare'
        }
      }
    },
    anfahrt: {
      title: 'Come arrivare',
      subtitle: 'Visitateci ad Aarwangen - Situati direttamente sull\'autostrada A1',
      hero: {
        title: 'Benvenuti alla W. Althaus AG',
        subtitle: 'Trovateci facilmente ad Aarwangen. La nostra sede e lo Stabilimento 2 sono comodamente situati direttamente sull\'autostrada A1.'
      },
      headquarters: {
        title: 'Sede centrale',
        name: 'W. Althaus AG',
        street: 'Jurastrasse 12',
        city: '4912 Aarwangen',
        country: 'Svizzera'
      },
      werk2: {
        title: 'Stabilimento 2 - Produzione',
        name: 'W. Althaus AG - Stabilimento 2',
        street: 'Industriering',
        city: '4912 Aarwangen',
        country: 'Svizzera'
      },
      contact: {
        phone: '+41 62 919 82 82',
        email: '',
        website: 'www.althaus.swiss'
      },
      directions: {
        title: 'Direzioni in auto',
        highway: 'Autostrada A1',
        exit: 'Uscita Aarwangen',
        description: 'Prendete l\'uscita Aarwangen e seguite le indicazioni verso la zona industriale. Entrambi i siti si trovano nella zona industriale di Aarwangen.'
      },
      parking: {
        title: 'Parcheggio',
        description: 'Parcheggio gratuito per i visitatori disponibile in entrambi i siti.'
      },
      publicTransport: {
        title: 'Trasporti pubblici',
        train: 'Stazione ferroviaria di Aarwangen (10 minuti a piedi)',
        bus: 'Fermata dell\'autobus Aarwangen Dorf (5 minuti a piedi)'
      },
      hours: {
        title: 'Orari di apertura',
        weekdays: 'Lunedì - Venerdì: 07:00 - 17:00',
        saturday: 'Sabato: Su appuntamento',
        sunday: 'Domenica: Chiuso'
      }
    },
    products: {
      title: 'Prodotti',
      subtitle: 'Scoprite il nostro portfolio di soluzioni di automazione e prodotti di alta qualità per l\'industria.'
    },
    cookieConsent: {
      bannerTitle: 'Impostazioni sulla privacy',
      bannerText: 'Questo sito utilizza tecnologie di terze parti per offrire servizi, migliorarli costantemente e mostrare contenuti in linea con i vostri interessi.',
      privacyPolicy: 'Informativa sulla privacy',
      imprint: 'Note legali',
      settings: 'Impostazioni',
      acceptAll: 'Accetta tutto',
      saveSettings: 'Salva impostazioni',
      cookieSettings: 'Impostazioni cookie',
      modalTitle: 'Impostazioni sulla privacy',
      modalDescription: 'Con questo strumento puoi gestire il tuo consenso alla raccolta e al trattamento dei dati personali da parte di tecnologie di terze parti.',
      tabCategories: 'Categorie',
      tabServices: 'Servizi',
      categories: {
        essential: { name: 'Essenziali', description: 'Queste tecnologie sono necessarie per attivare le funzioni essenziali della nostra offerta di servizi.' },
        functional: { name: 'Funzionali', description: 'Queste tecnologie ci permettono di analizzare l\'utilizzo per misurare e migliorare le prestazioni del nostro sito.' },
        marketing: { name: 'Marketing', description: 'Queste tecnologie sono utilizzate dagli inserzionisti per mostrare annunci pertinenti ai vostri interessi.' }
      },
      services: {
        consentManager: { name: 'Consent Manager', description: 'Memorizza in modo sicuro le vostre preferenze sulla privacy nel browser.' },
        cloudflare: { name: 'Cloudflare', description: 'Rete di distribuzione dei contenuti per una consegna sicura e veloce del sito.' },
        googleFonts: { name: 'Google Fonts', description: 'Carica i font web per una visualizzazione coerente del sito.' },
        googleMaps: { name: 'Google Maps', description: 'Mostra mappe interattive per indicazioni stradali e informazioni sulla posizione.' },
        ostendis: { name: 'Ostendis', description: 'Fornisce gli annunci di lavoro attuali sulla pagina delle carriere.' },
        googleAnalytics: { name: 'Google Analytics', description: 'Analizza in forma anonima l\'utilizzo del sito per migliorare la nostra offerta.' },
        googleTagManager: { name: 'Google Tag Manager', description: 'Gestisce i tag di marketing e analisi del sito.' },
        googleAds: { name: 'Google Ads', description: 'Utilizzato per mostrare pubblicità pertinenti e misurare le conversioni.' }
      },
      alwaysActive: 'Sempre attivo',
      poweredBy: 'Fornito da W. Althaus AG'
    }
  }
};

// Additional page-specific translations
export const pageTranslations = {
  de: {
    crossIndustrySolutions: {
      title: 'Branchen',
      description: 'Mit über 50 Jahren Erfahrung in der industriellen Automation sind wir Spezialisten in der Entwicklung von individuellen Lösungen und der Belieferung innovativer Technik zu jedem Zeitpunkt an jeden Ort der Welt.',
      industries: {
        maschinenbau: 'Maschinen- und Anlagenbau',
        medizintechnik: 'Medizintechnik',
        energie: 'Energie & Infrastruktur',
        foodBeverage: 'Lebensmittelindustrie',
        transportation: 'Transport & Mobilität',
        erneuerbare: 'Erneuerbare Energien'
      },
      moreIndustries: '... und viele mehr'
    },
    aboutPreview: {
      title: 'Über uns',
      description: 'Wir sind ein Schweizer Familienunternehmen, das 1968 in Aarwangen im Kanton Bern gegründet wurde. Heute sind an zwei Standorten über 160 Mitarbeiterinnen und Mitarbeiter beschäftigt. Die W. Althaus AG ist ein wichtiger und richtungsweisender Arbeitgeber in der Region.',
      description2: 'Unsere Kernkompetenz liegt in der Entwicklung und Produktion von einfachsten elektrischen Steuerungen bis hin zu komplexen Automatisierungslösungen.',
      learnMore: 'Mehr erfahren',
      production: 'Produktion',
      headquarters: 'Hauptsitz',
      team: 'Team',
    },
    certificationsPartnerships: {
      title: 'Partnerschaften & Zertifizierungen',
      partnershipsLabel: 'Partnerschaften',
      certificationsLabel: 'Zertifizierungen',
      qualityManagement: 'Qualitätsmanagement',
      environmentalManagement: 'Umweltmanagement',
      sustainabilityRating: 'Sustainability Rating',
      recognizedTrainingCompany: 'Anerkannter Ausbildungsbetrieb'
    },
    footer: {
      headquarters: 'Hauptsitz',
      production: 'Produktion',
      contact: 'Kontakt',
      phone: 'Telefon',
      openingHours: {
        weekdays: 'Montag bis Donnerstag',
        friday: 'Freitag'
      }
    },
    servicesSection: {
      title: 'Unsere Dienstleistungen',
      servicesEyebrow: 'Aus dem Konzept',
      subtitle: 'Mit Automatisierung und Schaltschrankbau 4.0 digitalisieren wir Ihre Ideen für Ihren Wettbewerbsvorteil.',
      pageSubtitle: 'Mit Automatisierung und Schaltschrankbau 4.0 digitalisieren wir Ihre Ideen für Ihren Wettbewerbsvorteil. Wir begleiten unsere Kunden von der Planung über den Schaltschrankbau bis zur Entwicklung und Integration der Steuerungssoftware. So entstehen durchgängige Automatisierungslösungen, die zuverlässig funktionieren und sich flexibel in bestehende Systeme integrieren lassen.',
      heroTitle: 'Unsere Dienstleistungen',
      heroSubtitle: 'Ganzheitlich gedacht',
      ownDevelopmentsTitle: 'Unsere Eigenentwicklungen',
      ownDevelopmentsDescription: 'Mit unseren Eigenentwicklungen entwickeln wir intelligente Lösungen für moderne Engineering-, Prüf- und Fertigungsprozesse. Sie helfen dabei, Abläufe zu automatisieren, Prüfschritte zu standardisieren und Daten strukturiert nutzbar zu machen. Das Ergebnis sind zuverlässige Systeme mit hohem Praxisnutzen, die sich nahtlos in bestehende Infrastrukturen einfügen und Ihre Prozesse nachhaltig optimieren.',
      manifestEyebrow: '01 — Philosophie',
      manifestPart1: 'Ein Erfolgskonzept: Unsere ',
      manifestHighlight1: 'Automationskompetenzen',
      manifestPart2: ' und Ihre ',
      manifestHighlight2: 'Prozesskenntnisse',
      manifestPart3: '.',
      consultingTitle: 'Konzeptberatung',
      consultingLead: 'Ein Erfolgskonzept: Unsere Automationskompetenzen und Ihre Prozesskenntnisse.',
      consultingDescription: 'Wir begleiten unsere Kunden von der Planung über den Schaltschrankbau bis zur Entwicklung und Integration der Steuerungssoftware. Unsere Projektingenieure beraten Sie bereits in der Planungs- und Projektierungsphase, sind während Konstruktion und Installation vor Ort und stehen Ihnen auch nach der Inbetriebnahme im laufenden Betrieb zur Seite. Dank unserer Flexibilität entstehen durchgängige Automatisierungslösungen, die zuverlässig funktionieren, sich nahtlos in bestehende Systeme integrieren lassen und Ihre individuellen Anforderungen mit grösster Sicherheit umsetzen.',
      consultingChapterLabel: '01 — Bevor wir bauen',
      consultingHighlight: 'Unsere Automationskompetenzen und Ihre Prozesskenntnisse',
      consultingStats: [
        { value: '50+', label: 'Jahre Erfahrung in industrieller Automation' },
        { value: '360°', label: 'Begleitung von Planung bis Betrieb' },
        { value: '1:1', label: 'Persönlicher Ansprechpartner über das gesamte Projekt' },
      ],
      consultingServicesTitle: 'Unser Leistungsangebot umfasst',
      consultingServices: [
        { title: 'Analyse der Anforderungen', description: 'Wir erfassen Ihre Ziele, Rahmenbedingungen und technischen Vorgaben strukturiert.' },
        { title: 'Analyse bestehender Systeme', description: 'Wir bewerten Ihre aktuelle Infrastruktur und identifizieren Optimierungspotenziale.' },
        { title: 'Systemneutrale Beratung', description: 'Unabhängige Empfehlungen – wir wählen die für Sie passende Lösung, nicht den Hersteller.' },
        { title: 'Pflichtenheft & Konzept', description: 'Wir erarbeiten ein präzises Pflichtenheft als verlässliche Grundlage Ihres Projekts.' },
        { title: 'Projektmanagement', description: 'Klare Verantwortlichkeiten, Termine und Kommunikation – von Start bis Abnahme.' },
      ],
      services: {
        schaltschrankbau: { title: 'Schaltschrankbau', description: 'Serienreif ab Einheit 1 – geprüft, dokumentiert, skalierbar.' },
        hardware: { title: 'Hardware-Engineering', description: 'EMV-gerechtes Design, Safety und normkonforme Dokumentation.' },
        software: { title: 'Software-Engineering', description: 'Stabile Programme, saubere HMI, IIoT-ready.' }
      }
    },
    homepageContact: {
      title: 'Bereit für den nächsten Schritt?',
      button: 'Erzählen Sie uns von Ihrem Projekt'
    },
    teamPage: {
      heroTitle: 'Team',
      heroSubtitle: 'Unsere Ansprechpartner sind gerne für Sie da.',
      followUs: 'Folgen Sie uns'
    },
    careersPage: {
      hero: {
        title: 'Dein nächster Schritt',
        subtitle: 'Flexibilität & Verantwortung',
        description: 'Als regional verankerte Arbeitgeberin mit internationaler Tätigkeit bieten wir spannende Aufgaben, verlässliche Rahmenbedingungen und echte Perspektiven vom Einstieg bis zur Spezialisierung.'
      },
      intro: {
        title: 'Deine Zukunft bei Althaus',
        description: 'Automation entsteht durch Menschen, die mitdenken, anpacken und gemeinsam Lösungen entwickeln. Hinter jedem Projekt stehen engagierte Mitarbeitende, die ihr Wissen einbringen und Verantwortung übernehmen. Bei uns findest du ein Umfeld, in dem du dich weiterentwickeln, deine Ideen einbringen und gemeinsam mit uns Zukunft gestalten kannst.'
      },
      imageStatement: {
        title: '160 Mitarbeitende planen, bauen und realisieren Automation.',
        description: 'Was uns verbindet, ist die Freude an Technik und die Überzeugung, gemeinsam mehr zu erreichen. Erfahrung, technisches Know-how und der Anspruch, jeden Tag besser zu werden, prägen unseren Alltag. So entstehen Partnerschaften und Ergebnisse, auf die wir langfristig stolz sind.'
      },
      benefits: {
        title: 'Gute Gründe für Althaus',
        subtitle: 'Das erwartet dich bei uns im Arbeitsalltag.',
        items: [
          { title: 'Familiäres Arbeitsklima', description: 'Bei uns zählt jeder – ein Team, das zusammenhält und sich gegenseitig unterstützt.' },
          { title: 'Flexible Arbeitszeiten', description: 'Work-Life-Balance ist kein Schlagwort, sondern gelebte Realität bei uns.' },
          { title: 'Spannende Projekte', description: 'Abwechslungsreiche Aufgaben in der Automation – von der Idee bis zur Umsetzung.' },
          { title: 'Karriere & Entwicklung', description: 'Wir fördern deine Weiterentwicklung mit internen Schulungen und Aufstiegsmöglichkeiten.' },
          { title: 'Sichere Zukunft', description: 'Ein stabiles Unternehmen mit über 50 Jahren Erfahrung und positivem Wachstum.' },
          { title: 'Top Arbeitsplätze', description: 'Moderne Infrastruktur, neueste Technologien und eine angenehme Arbeitsumgebung.' },
          { title: '27 Tage Ferien', description: 'Mehr Zeit für Erholung, Reisen und alles, was dir wichtig ist. Mit 27 Ferientagen bleibt die Balance nicht auf der Strecke.' },
          { title: '40-Stunden Woche', description: 'Klare Strukturen für Beruf und Freizeit. Mit einer 40-Stunden Woche schaffen wir Planbarkeit und Ausgleich.' },
          { title: 'Subventionierte Mitarbeiterverpflegung', description: 'Gut essen zu fairen Konditionen. Mit subventionierten Verpflegungsangeboten ist für den Genuss im Arbeitsalltag gesorgt.' }
        ]
      },
      education: {
        title: 'Aus- und Weiterbildung',
        description: 'Mit gezielten Aus- und Weiterbildungen tragen wir zur stetigen beruflichen und persönlichen Weiterentwicklung unserer Mitarbeitenden bei. Die Bildung hat bei der W. Althaus AG aber auch sonst einen hohen Stellenwert. So investieren wir als Ausbildungsbetrieb viel in die Ausbildung von Nachwuchskräften und ermöglichen jungen Erwachsenen den Einstieg in die Berufswelt. Im Moment bilden wir 28 Lernende in den Berufen Automatiker/in, Automatikmonteur/in, KV und Logistiker/in aus.'
      },
      modernWork: {
        title: 'Arbeiten in einer modernen Umgebung',
        description: 'Von automatisierten Produktionsprozessen bis zu modernen Arbeitsplätzen im Büro. Du arbeitest mit aktueller Technik, klaren Standards und Kolleginnen und Kollegen, die gemeinsam an innovativen Lösungen arbeiten.'
      },
      cta: {
        title: 'Gestalte mit uns die Zukunft',
        description: 'Du möchtest Verantwortung übernehmen und gemeinsam mit uns Lösungen entwickeln. Hast du Lust auf Herausforderungen und Teamgeist? Dann wachse mit uns und werde Teil unseres Erfolgs.',
        button: 'Zu den offenen Stellen'
      }
    },
    aboutPage: {
      hero: {
        title: 'Regional verwurzelt,',
        subtitle: 'weltweit im Einsatz.',
        description: 'Seit 1968 verbinden wir Know-how, Engineering und Automation zu ganzheitlichen Schaltschranklösungen – präzise, durchdacht, verlässlich.'
      },
      intro: {
        leadingIn: 'Leading in Automation',
        paragraphs: [
          'Wir sind ein Schweizer Familienunternehmen, das 1968 in Aarwangen im Kanton Bern gegründet wurde. Heute arbeiten an zwei Standorten über 160 Mitarbeiterinnen und Mitarbeiter, und die W. Althaus AG gilt als wichtiger und richtungsweisender Arbeitgeber in der Region.',
          'Unsere Kernkompetenz besteht in der Entwicklung und Produktion von einfachsten elektrischen Steuerungen bis hin zu komplexen Automatisierungslösungen.',
          'Mit über 50 Jahren Erfahrung in der industriellen Automation sind wir Spezialisten in der Entwicklung von individuellen Lösungen für die Industrie. Als Full-Service-Unternehmen bieten wir mit unserem breiten Dienstleistungsangebot in Konzeptberatung, Hard- und Software-Engineering, Schaltschrankbau, Klemmensteg-Produktion, Baugruppenmontage, Montage-Support, Inbetriebnahme und Training ein umfassendes Lösungspaket an.'
        ]
      },
      stats: {
        founded: { value: '1968', label: 'Gegründet' },
        employees: { value: '160+', label: 'Mitarbeiter*innen' },
        area: { value: "6'000m²", label: 'Produktionsfläche' },
        cabinets: { value: "10'000+", label: 'Schaltschränke/Jahr' }
      },
      history: {
        title: 'Unsere Geschichte',
        subtitle: 'Vom Einmannbetrieb zum führenden Schaltschrankbauer der Schweiz – entdecken Sie unsere Meilensteine.',
        milestones: [
          { year: '1968', title: 'Gründung', description: 'Walter Althaus Sen. startet in Aarwangen mit einer Einzelfirma in die Selbstständigkeit. Aus kleinen Anfängen entsteht Schritt für Schritt ein Schweizer Familienunternehmen, das sich konsequent weiterentwickelt und kontinuierlich wächst.' },
          { year: '1970er', title: 'Erste Schaltschrankproduktion', description: 'In den 1970er Jahren beginnt die Produktion von Schaltschränken. Aus dem Bau einfacher Steuerungen entwickelt sich das Unternehmen zum Spezialisten für komplette, dokumentierte Automationslösungen. Die technische Kompetenz wird systematisch ausgebaut und bildet die Grundlage für die weitere Expansion.' },
          { year: '1980er', title: 'Ausbau der Produktion und Einstieg in ECAD', description: 'Die Produktionsfläche an der Jurastrasse wird von 400 auf 800 Quadratmeter erweitert. Damit reagiert das Unternehmen auf die steigende Nachfrage und das wachsende Projektvolumen.\n\nParallel dazu erfolgt der Einstieg in die rechnergestützte Konstruktion mit einem ECAD-Programm. Die Digitalisierung der Planung beginnt und erhöht Effizienz sowie Qualität in der Projektabwicklung.' },
          { year: '1990er', title: 'Erweiterung, Automatisierung und Generationenwechsel', description: 'Die Büroflächen werden durch den Bau eines zweiten Stockwerks vergrössert. Mit der Einführung des ersten EPLAN-Systems wird die elektrotechnische Planung weiter professionalisiert und standardisiert.\n\nErste automatisierte Prozesse werden implementiert. Litzenautomaten kommen zum Einsatz und steigern die Produktivität in der Fertigung deutlich.\n\nMitte der 1990er Jahre übernimmt Walter Althaus Jun. die Geschäftsleitung und führt das Unternehmen in die nächste Entwicklungsphase.' },
          { year: '1998', title: 'Vollautomatisches Prüfsystem', description: 'Mit dem ersten vollautomatischen Prüfsystem für Schaltschränke setzt W. Althaus AG früh auf automatisierte Qualitätssicherung. Der Meilenstein stärkt die Prozesssicherheit und sorgt für eine konstante Prüfqualität.' },
          { year: '2000er', title: 'Automatisierung und Standortverlagerung', description: 'Die Produktion wird schrittweise weiter automatisiert. Insbesondere die Blechbearbeitung wird zunehmend maschinell unterstützt und in effiziente Prozessketten integriert.\n\nDie Produktionsfläche an der Jurastrasse stösst an ihre Grenzen. Die Fertigung wird deshalb vom Dorf in das Industriegebiet von Aarwangen verlegt. Zwischen 2007 und 2011 entstehen am neuen Standort vier zusätzliche Hallen. Damit wird die infrastrukturelle Basis für weiteres Wachstum geschaffen.' },
          { year: '2005', title: 'Einstieg in 3D-Engineering', description: 'Der Start des 3D-Engineerings mit dem Aufbau einer digitalen Datenbasis markiert einen entscheidenden Schritt in Richtung vernetzter Planung und Fertigung. So entsteht die Grundlage für durchgängige Prozesse vom Engineering bis in die Produktion.' },
          { year: '2008', title: 'Erster Klemmenbestückungsautomat', description: 'Mit der Entwicklung des ersten eigenen Klemmenbestückungsautomaten treibt die W. Althaus AG die Automatisierung gezielt voran. Manuelle Arbeitsschritte werden reduziert, Abläufe beschleunigt und die Reproduzierbarkeit weiter verbessert.' },
          { year: '2010er', title: 'Investitionen in Automation und Digitalisierung', description: 'Bestehende Automationsanlagen werden modernisiert und ausgebaut. Produktionsprozesse werden digitalisiert, standardisiert und konsequent optimiert. Der Fokus liegt auf durchgängigen Datenflüssen und einer effizienten Fertigung entlang der gesamten Wertschöpfungskette.' },
          { year: '2018', title: 'Entwicklung eines neuen Verdrahtungsroboters', description: 'Mit dem Start der Entwicklung eines neuen kollaborierenden Verdrahtungsrobotersystems baut W. Althaus AG ihre Automatisierungskompetenz konsequent weiter aus. Der Meilenstein zeigt den Anspruch, innovative Robotiklösungen gezielt für die Anforderungen moderner Schaltschrankfertigung weiterzuentwickeln.' },
          { year: '2020er', title: 'Wachstum und neue Führung', description: 'Das Unternehmen wächst auf über 160 Mitarbeitende. Automation-Kompetenz, Produktionserfahrung und kontinuierliche Prozessverbesserung prägen das Selbstverständnis.\n\nAnfang der 2020er Jahre übernimmt Marco Schneider die Geschäftsführung und führt das Unternehmen strategisch weiter.' },
          { year: '2025', title: 'Rittal + Eplan Application Center Partner', description: 'Als erster Rittal + Eplan Application Center Partner in der Schweiz wird das Unternehmen offiziell ausgezeichnet. Diese Partnerschaft unterstreicht die konsequente Ausrichtung auf datengetriebene Prozesse im Steuerungs- und Schaltanlagenbau und bestätigt die technologische Führungsrolle im Bereich integrierter Engineering- und Fertigungslösungen.' }
        ]
      },
      values: {
        title: 'Unsere Werte',
        subtitle: 'Was uns antreibt und wie wir arbeiten – drei Grundsätze, die unser Handeln prägen.',
        items: [
          { title: 'Qualität', subtitle: 'Wir liefern Qualität, die bleibt', description: 'Jeder Schaltschrank, jede Lösung – präzise gefertigt und durchdacht bis ins Detail. Unser Anspruch: Null Kompromisse.' },
          { title: 'Partnerschaften', subtitle: 'Wir hören zu und denken voraus', description: 'Langfristige Beziehungen statt kurzfristiger Deals. Wir verstehen die Herausforderungen unserer Kunden und entwickeln Lösungen gemeinsam.' },
          { title: 'Innovation', subtitle: 'Jeden Tag ein Stück besser', description: 'Stillstand ist Rückschritt. Wir investieren kontinuierlich in neue Technologien, Prozesse und die Weiterentwicklung unseres Teams.' }
        ]
      },
      regionalEngagement: {
        title: 'Engagement in der Region',
        paragraphs: [
          'Als regional verwurzeltes Unternehmen ist es uns wichtig, nicht nur wirtschaftlich, sondern auch gesellschaftlich einen Beitrag zu leisten. Deshalb unterstützen wir Vereine, Projekte und Anlässe in der Region rund um Aarwangen.',
          'Unser Sponsoring richtet sich vor allem an lokale Vereine und Veranstaltungen, die mit ihrem Engagement das Dorf- und Vereinsleben stärken. Ob sportlicher Anlass, kulturelles Projekt oder gemeinschaftlicher Event, wir möchten dazu beitragen, dass solche Vorhaben möglich werden und Menschen in der Region zusammenkommen.',
          'Wir sind überzeugt, dass ein lebendiges Vereinsleben einen wichtigen Beitrag zur regionalen Identität leistet. Darum unterstützen wir ausgewählte Engagements dort, wo sie Wirkung zeigen: direkt vor Ort, bei den Menschen und Organisationen in unserer Umgebung.'
        ],
        supportedTitle: 'Vereine und Anlässe, die wir bereits unterstützen durften'
      },
    },
    sustainabilityPage: {
      hero: {
        title: 'Verantwortung für',
        subtitle: 'Umwelt, Gesellschaft & Zukunft',
        description: 'Als Schweizer Familienunternehmen handeln wir verantwortungsbewusst für unsere Umwelt, unsere Region und kommende Generationen.'
      },
      intro: {
        title: 'Nachhaltigkeit mit System',
        subtitle: '',
        titleSuffix: '',
        paragraphs: [
          'Für uns bedeutet Nachhaltigkeit, Verantwortung ganzheitlich zu denken. Gegenüber der Umwelt, der Gesellschaft und der Zukunft. Deshalb verbinden wir ökologische, wirtschaftliche und soziale Aspekte entlang des gesamten Produktlebenszyklus.',
          'Mit digitalisierten Prozessen, ECAD-Engineering und einer hochautomatisierten Fertigung reduzieren wir Ausschuss, Materialeinsatz und Durchlaufzeiten bereits ab dem ersten Stück. Unsere zertifizierten Managementsysteme nach ISO 9001 und ISO 14001 unterstützen uns dabei, Qualität und Umweltleistung kontinuierlich zu verbessern.',
          '2024 wurden wir von EcoVadis mit dem Committed-Abzeichen ausgezeichnet. Bewertet wurden die Bereiche Umwelt, Arbeits- und Menschenrechte, Ethik sowie nachhaltige Beschaffung. Besonders in den Bereichen Umwelt, Arbeits- und Menschenrechte sowie Ethik liegen wir über dem Branchendurchschnitt. Für uns ist diese Auszeichnung Bestätigung und Ansporn zugleich, unseren Weg konsequent weiterzugehen.',
          'Getreu unserem Leitspruch «Unser Handeln ist auf das Ganze fokussiert» arbeiten wir gemeinsam mit Kunden, Lieferanten und Partnern an nachhaltigen Lösungen in Schweizer Qualität.'
        ]
      },
      metrics: {
        title: 'Nachhaltigkeit in Zahlen',
        items: [
          { value: '490 kWp', label: 'Photovoltaikleistung' },
          { value: '40 %', label: 'Solarenergie' },
          
          { value: '100 %', label: 'Elektrische Firmenflotte' }
        ]
      },
      impact: {
        title: 'Nachhaltigkeit mit Wirkung',
        description: 'Wir tragen Verantwortung für die Welt von morgen - Nachhaltigkeit bedeutet für uns mehr als Umweltschutz: Wir verbinden ökologische, soziale und wirtschaftliche Aspekte zu einem ganzheitlichen Engagement und treiben nachhaltige Entwicklung voran.\n\n„Nachhaltige Entwicklung ist eine Entwicklung, die die Bedürfnisse der Gegenwart befriedigt, ohne zu riskieren, dass künftige Generationen ihre eigenen Bedürfnisse nicht befriedigen können."\n– Vereinte Nationen, Brundtland-Bericht (1987)'
      },
      achievements: {
        title: 'Unsere Nachhaltigkeitsinitiativen',
        categories: [
          {
            key: 'E',
            label: 'ENVIRONMENTAL (UMWELT)',
            items: [
              { title: 'ISO 14001 Umweltmanagement', description: 'Wir sind nach ISO 14001 zertifiziert und entwickeln unser Umweltmanagement kontinuierlich weiter. Interne Audits und klar definierte Umweltziele sichern eine nachhaltige Verbesserung.' },
              { title: 'Ressourcenschonung & Materialeffizienz', description: 'Wir nutzen Rohstoffe wie Kupfer so effizient wie möglich und folgen dem Prinzip „reduce, reuse, recycle". Dabei sorgen wir dafür, dass Abfälle nicht verloren gehen, sondern wieder in den Kreislauf zurückgeführt und als wertvolle Ressourcen weiterverwendet werden. Durch unser Retrofit-Angebot verlängern wir zudem die Lebensdauer bestehender Anlagen.' },
              { title: 'Digitaler Zwilling', description: 'Mit digitalen Zwillingen planen und simulieren wir Anlagen virtuell. So reduzieren wir Materialverbrauch, Fehlproduktionen und Nacharbeit – bereits in der Planungsphase.' },
              { title: 'Material Compliance', description: 'Wir stellen sicher, dass alle Materialien die Umweltvorgaben (REACH, RoHS) erfüllen, vermeiden Schadstoffe und geben relevante Informationen entlang der Lieferkette weiter, um die regulatorische Konformität unserer Produkte zu gewährleisten.' },
              { title: 'Eigene Solarenergie', description: 'Durch Photovoltaikanlagen an unserem Produktionsstandort (360 kWp) sowie am Hauptsitz (108 kWp) decken wir einen Teil unseres Energiebedarfs eigenständig. Gleichzeitig leisten wir einen Beitrag zur Verbesserung der Ökobilanz im Stromnetz. Insgesamt erzeugen wir dabei knapp 400 MWh Strom pro Jahr.' },
              { title: 'Energiespeicher', description: 'Ein 80 kW Batteriespeicher ermöglicht die effiziente Nutzung unserer selbst erzeugten Solarenergie und erhöht den Eigenverbrauch sowie die Autarkiegrad am Hauptsitz.' },
              { title: 'Energieeffiziente Produktionstechnologien', description: 'Wir investieren kontinuierlich in einen modernen Maschinenpark. Durch regelmässige Betriebsoptimierungen und Anlagenwartungen stellen wir einen energieeffizienten Betrieb sicher.' },
              { title: 'Intelligente Beleuchtung', description: 'Mit LED-Beleuchtung sowie Präsenz- und Tageslichtsteuerung senken wir den Energieverbrauch in unseren Gebäuden deutlich.' },
              { title: 'Elektromobilität', description: 'Unsere Fahrzeugflotte wird schrittweise auf Elektroantrieb umgestellt und leistet einen Beitrag zur Reduktion von CO₂-Emissionen.' },
              { title: 'Wärmewende / Heizsysteme', description: 'Fossile Heizsysteme wurden durch erneuerbare Lösungen ersetzt, beispielsweise durch eine Grundwasser-Wärmepumpe am Produktionsstandort. Am Hauptsitz nutzen wir Fernwärme.' },
              { title: 'Weitere Effizienzmassnahmen', description: 'Durch weitere Effizienzmassnahmen wie die Dämmung von Rohrleitungen, die Reduktion der Raumtemperatur sowie die Umstellung von CO2-Laserscheidanlagen auf moderne Fiber-Laser-Technologie werden Energieverbräuche gesenkt und CO2-Emissionen weiter reduziert.' }
            ]
          },
          {
            key: 'S',
            label: 'SOCIAL (SOZIALES)',
            items: [
              { title: 'Arbeitssicherheit & Gesundheitsschutz', description: 'Die Arbeitssicherheit und der Gesundheitsschutz sind fester Bestandteil unseres integrierten Managementsystems. Durch umfassende Aufklärung, Prävention sowie die Anbindung an die Branchenlösung Arbeitssicherheit stellen wir ein sicheres und gesundes Arbeitsumfeld sicher.' },
              { title: 'Ergonomische & attraktive Arbeitsplätze', description: 'Wir bieten regelkonforme, moderne und ergonomisch gestaltete Arbeitsplätze, die ein sicheres und angenehmes Arbeiten ermöglichen.' },
              { title: 'Gesundheitsförderung & Work-Life-Balance', description: 'Flexible Arbeitszeiten, überdurchschnittliche Ferien sowie individuell wählbare Arbeitszeitmodelle fördern die Work-Life-Balance und tragen zur Gesundheit sowie Zufriedenheit unserer Mitarbeitenden bei.' },
              { title: 'Vielfalt & Gleichstellung', description: 'Wir stehen für Chancengleichheit, Respekt und Wertschätzung aller Menschen. Vielfalt verstehen wir als Stärke und setzen uns aktiv gegen Diskriminierung ein sowie für ein inklusives Arbeitsumfeld.' },
              { title: 'Feedback- & Dialogkultur', description: 'Durch regelmässige Mitarbeiterbefragungen und offene Dialogplattformen fördern wir eine transparente Feedbackkultur. Erkenntnisse werden aktiv genutzt und fliessen in die Weiterentwicklung unserer Organisation ein.' },
              { title: 'Mitarbeiterentwicklung & Weiterbildung', description: 'Wir unterstützen gezielt die fachliche und persönliche Weiterentwicklung unserer Mitarbeitenden. Fort- und Weiterbildungen werden aktiv gefördert und individuelle Karrierewege begleitet.' },
              { title: 'Berufsbildung & Nachwuchsförderung', description: 'Als bedeutender Lehrbetrieb investieren wir in die Ausbildung junger Fachkräfte. Mit einem strukturierten Ausbildungskonzept unterstützen wir Berufseinsteiger optimal in ihrer Laufbahnplanung.' },
              { title: 'Benefits', description: 'Attraktive Zusatzleistungen wie umfassende Sozialleistungen, 13. Monatslohn, Mitarbeiterevents, teilsubventioniertes gesundes Essen, Homeoffice, Dienstaltersgeschenke, Firmenparkplätze, gratis Mineralwasser, Arbeitskleidung sowie die Benutzung von Firmenfahrzeugen tragen zu einer hohen Arbeitgeberattraktivität bei. Ergänzt wird dies durch ein fixes Spesenreglement, die Möglichkeit zur Gleitzeitauszahlung sowie Vergünstigungen wie Reka-Checks, Vorzugskonditionen und weitere Giveaways.' },
              { title: 'Regionales Engagement & Sponsoring', description: 'Wir engagieren uns aktiv in unserer Region und unterstützen kulturelle, sportliche und soziale Projekte. Damit leisten wir einen Beitrag zur Stärkung der lokalen Gemeinschaft.' },
              { title: 'Sichere Produkte', description: 'Durch klare Qualitätsanforderungen sowie umfassende Prüfungen stellen wir sicher, dass unsere Produkte sicher sind und keine Gefährdung für Mitarbeitende oder Kundinnen und Kunden darstellen – über den gesamten Lebenszyklus hinweg.' },
              { title: 'Lieferketten Sozialstandards', description: 'Wir achten auf die Einhaltung sozialer Standards entlang unserer Lieferkette. Dabei legen wir besonderen Wert auf den verantwortungsvollen Umgang mit Konfliktmineralien und fördern transparente sowie nachhaltige Beschaffungspraktiken.' }
            ]
          },
          {
            key: 'G',
            label: 'GOVERNANCE (UNTERNEHMENSFÜHRUNG)',
            items: [
              { title: 'Unternehmensführung & Struktur', description: 'Wir führen unser Familienunternehmen auf Basis einer stabilen Organisation klar, verantwortungsvoll und zukunftsorientiert. Klare Rollen und Zuständigkeiten sorgen für Orientierung und Vertrauen. Mit einer vorausschauenden Nachfolgeplanung sichern wir die langfristige Kontinuität unseres Familienunternehmens.' },
              { title: 'Ethik & Integrität', description: 'Unser Verhaltenskodex basiert auf den Zehn Prinzipien des UN Global Compact und dient als Leitfaden für ethisches, soziales und verantwortungsbewusstes Verhalten. Getreu dem Leitspruch "Unser Handeln ist auf das Ganze fokussiert" verfolgen wir die Vision einer inklusiveren und nachhaltigeren Wirtschaft die zum Wohle aller Menschen, Gemeinschaften, Märkte und der Umwelt, sowohl heute als auch in Zukunft wirkt.' },
              { title: 'Compliance', description: 'Wir handeln im Einklang mit allen gesetzlichen Vorgaben und stellen deren konsequente Einhaltung sicher. Klare interne Richtlinien und Prozesse geben Orientierung im täglichen Handeln und schaffen Verlässlichkeit.' },
              { title: 'Managementsysteme & Prozesse', description: 'Wir führen ein integriertes Managementsystem nach ISO 9001 (Qualität) und ISO 14001 (Umwelt) und stellen dessen kontinuierliche Verbesserung sicher.' },
              { title: 'Risikomanagement', description: 'Wir verfolgen einen systematischen Ansatz im Risikomanagement, um potenzielle Risiken frühzeitig zu erkennen und angemessen zu steuern. Risiken werden regelmässig identifiziert, analysiert und bewertet. Auf dieser Grundlage leiten wir bei Bedarf gezielte Massnahmen ab, um negative Auswirkungen zu vermeiden oder zu minimieren.' },
              { title: 'Transparenz & Reporting', description: 'Wir lassen unsere Nachhaltigkeitsleistung durch EcoVadis bewerten. Das Rating schafft Transparenz und hilft uns, unsere Leistungen in den Bereichen Umwelt, Soziales und Unternehmensführung kontinuierlich zu verbessern.' }
            ]
          }
        ],
        items: []
      },
      outlook: {
        title: 'Ausblick',
        headline: 'Nachhaltigkeit – Agenda 2030',
        description: 'Unser Weg zur nachhaltigen Transformation – Schritt für Schritt zu messbaren Ergebnissen und langfristiger Wirkung.',
        milestones: [
          { year: '2026', title: 'THG-Bilanzierung (Scope 1–3)', description: 'Im Jahr 2026 wird das Projekt zur Treibhausgasbilanzierung nach GHG-Protocol (Scope 1, 2 und 3) mit dem evaluierten externen Projektpartner gestartet und umgesetzt. Die unternehmensweite THG-Bilanz wird erstellt, plausibilisiert und dokumentiert.' },
          { year: '2027', title: 'Netto-Null-Pfad', description: 'Aufbauend auf der Treibhausgasbilanzierung wird im Jahr 2027 ein unternehmensspezifischer Netto-Null-Pfad definiert. Dieser beinhaltet konkrete Zieljahre, Reduktionsziele und priorisierte Massnahmen zur schrittweisen Reduktion der Treibhausgasemissionen über Scope 1–3. Der Netto-Null-Pfad wird verabschiedet und in relevante Unternehmensprozesse integriert.' },
          { year: '2028', title: 'Nachhaltigkeitsbericht (VSME)', description: 'Im Jahr 2028 wird erstmals ein strukturierter Nachhaltigkeitsbericht gemäss den VSME-Anforderungen erstellt. Der Bericht basiert auf den bestehenden Umwelt-, Klima- und Governance-Daten, bildet den Umsetzungsstand der definierten Massnahmen ab und stellt die Transparenz gegenüber relevanten Stakeholdern sicher.' },
          { year: '2029', title: 'Nachhaltigkeitsstrategie', description: 'Bis Ende 2029 wird eine unternehmensweite Nachhaltigkeitsstrategie erarbeitet, verabschiedet und kommuniziert. Diese baut auf den Ergebnissen der THG-Bilanzierung, dem definierten Netto-Null-Pfad, der Nachhaltigkeitsberichterstattung sowie auf den fünf zentralen eruierten Hebelthemen auf. Die Strategie definiert langfristige Ziele, priorisierte Handlungsfelder, Massnahmen und Verantwortlichkeiten.' }
        ]
      },
      regionalEngagement: {
        title: 'Engagement in der Region',
        paragraphs: [
          'Als regional verwurzeltes Unternehmen ist es uns wichtig, nicht nur wirtschaftlich, sondern auch gesellschaftlich einen Beitrag zu leisten. Deshalb unterstützen wir Vereine, Projekte und Anlässe in der Region rund um Aarwangen.',
          'Unser Sponsoring richtet sich vor allem an lokale Vereine und Veranstaltungen, die mit ihrem Engagement das Dorf- und Vereinsleben stärken. Ob sportlicher Anlass, kulturelles Projekt oder gemeinschaftlicher Event, wir möchten dazu beitragen, dass solche Vorhaben möglich werden und Menschen in der Region zusammenkommen.',
          'Wir sind überzeugt, dass ein lebendiges Vereinsleben einen wichtigen Beitrag zur regionalen Identität leistet. Darum unterstützen wir ausgewählte Engagements dort, wo sie Wirkung zeigen: direkt vor Ort, bei den Menschen und Organisationen in unserer Umgebung.'
        ],
        supportedTitle: 'Vereine und Anlässe, die wir bereits unterstützen durften'
      },
    },
    vocationalTrainingPage: {
      hero: {
        title: 'Deine Ausbildung bei Althaus',
        subtitle: 'Technik & Zukunft',
        description: 'Automatiker/in, Automatikmonteur/in oder Logistiker/in – wir bilden vielseitig aus und fördern dich gezielt auf deinem Weg in die Berufswelt.'
      },
      nachwuchs: {
        title: 'Nachwuchs mit Zukunft',
        subtitle: 'Seit über 50 Jahren bilden wir junge Talente aus – und sind stolz auf alle Absolvent/innen.',
        stats: {
          graduates: { value: '120+', label: 'Erfolgreiche Absolvent/innen' },
          apprenticeships: { value: '3', label: 'Lehrberufe', description: 'Automatiker/in, Automatikmonteur/in und Logistiker/in – drei Wege in die Zukunft.' },
          experience: { value: '50+', label: 'Jahre Erfahrung', description: 'in der Ausbildung junger Fachkräfte' }
        },
        cta: {
          title: 'Interessiert an einer Schnupperlehre?',
          description: 'Lerne unseren Betrieb und die Berufe kennen – melde dich jetzt an.',
          button: 'Zur Schnupperlehre'
        }
      },
      intro: {
        title: 'Wir bilden Profis aus',
        paragraphs: [
          'Wir setzen auf eine solide und aktive Berufsbildung zur Nachwuchssicherung. Unsere Berufsbildung besticht durch eine qualitativ hochstehende und abwechslungsreiche Ausbildung mit umfangreichen Schwerpunktausbildungen.',
          'Die Ausbildung und Förderung junger Berufstätiger ist für uns die wichtigste Voraussetzung für den Erhalt und die Stärkung des Produktionsstandortes Schweiz.'
        ]
      },
      openPositions: {
        title: 'Offene Lehrstellen',
        subtitle: 'Übersicht unserer Ausbildungsberufe und Verfügbarkeit'
      },
      badges: {
        available: 'Verfügbar',
        assigned: 'Vergeben'
      },
      buttons: {
        learnMore: 'Mehr erfahren'
      },
      apprenticeships: {
        automatiker: {
          title: 'Automatiker/-in EFZ',
          duration: '4 Jahre',
          description: 'Als Automatiker/-in arbeitest du an der Technik, die Maschinen, Anlagen und automatisierte Produktionssysteme steuert. Automation und Robotik prägen heute die Industrie und du bist mittendrin.',
          detailedDescription: 'Bei der W. Althaus AG lernst du, wie elektrische Steuerungen geplant, aufgebaut und getestet werden. Du arbeitest an realen Projekten und erhältst Einblick in moderne Automationslösungen für Maschinen und industrielle Anlagen.\n\nWährend deiner Ausbildung lernst du verschiedene Bereiche kennen, darunter Schaltschrankbau, Prüfabteilung, Robotik, Elektrokonstruktion, Programmierung und industrielle Automation. Im dritten Lehrjahr kannst du dich je nach Interesse und Bedarf im Bereich Software, Hardware, Elektrokonstruktion oder in der Prüf- und Testabteilung weiter vertiefen.',
          highlights: [
            'Elektrische Steuerungen und Schaltschränke aufbauen und verdrahten',
            'Elektrische Komponenten montieren, anschliessen und prüfen',
            'Schaltpläne lesen und technische Unterlagen verstehen',
            'Einblicke in industrielle Automation und Robotik erhalten',
            'Erste Erfahrungen im Programmieren und in eigenen Projekten sammeln',
            'Steuerungen testen und bei der Fehlersuche unterstützen'
          ],
          requirements: 'Sekundarschule mit guten Leistungen in Mathematik und Physik sowie Interesse an Technik und Elektronik.',
          career: 'Weiterbildung zum Techniker HF oder Studium an einer Fachhochschule im Bereich Automation oder Elektrotechnik.'
        },
        automatikmonteur: {
          title: 'Automatikmonteur/-in EFZ',
          duration: '3 Jahre',
          description: 'Als Automatikmonteur/-in arbeitest du an der Technik, die Maschinen und Anlagen mit elektrischen Steuerungen verbindet. Du baust und verdrahtest Steuerungen, die in der Industrie für automatisierte Produktionsanlagen eingesetzt werden.',
          detailedDescription: 'Bei der W. Althaus AG lernst du, wie Schaltschränke aufgebaut, verdrahtet und geprüft werden. Du arbeitest direkt in der Produktion und hilfst mit, Steuerungen für Maschinen und industrielle Anlagen Schritt für Schritt zusammenzubauen.\n\nWährend deiner Ausbildung erhältst du Einblick in verschiedene Bereiche rund um den Schaltschrankbau, unter anderem Montage, Verdrahtung und Prüfarbeiten. Dabei lernst du, wie aus einzelnen Bauteilen funktionierende Steuerungen entstehen.',
          highlights: [
            'Schaltschränke und elektrische Steuerungen aufbauen und verdrahten',
            'Elektrische Komponenten montieren, anschliessen und prüfen',
            'Schaltpläne lesen und technische Unterlagen verstehen',
            'Steuerungen testen und einfache Fehler erkennen',
            'Arbeiten im Schaltschrankbau und in der Produktion'
          ],
          requirements: 'Sekundarschule oder Realschule sowie Interesse an Technik und handwerklicher Arbeit.',
          career: 'Weiterbildung im Bereich Elektrotechnik und Automation.'
        },
        logistiker: {
          title: 'Logistiker/-in EFZ',
          duration: '3 Jahre',
          description: 'Als Logistiker/-in sorgst du dafür, dass Materialien, Bauteile und Produkte zur richtigen Zeit am richtigen Ort sind. Damit hältst du unsere Produktion am Laufen und stellst sicher, dass alle benötigten Komponenten verfügbar sind.',
          detailedDescription: 'Bei der W. Althaus AG arbeitest du mit modernen Lager- und Logistiksystemen und behältst jederzeit den Überblick über Bestände und Materialflüsse. Du nimmst Waren entgegen, lagerst sie ein, stellst Materialien für die Produktion bereit und organisierst den Versand von fertigen Produkten.\n\nWährend deiner Ausbildung durchläufst du verschiedene Bereiche im Lager, darunter Wareneingang, Lagerbewirtschaftung, Kommissionierung und Versand. Dabei lernst du Schritt für Schritt, wie ein moderner Materialfluss in einem Industrieunternehmen funktioniert.',
          highlights: [
            'Waren annehmen, kontrollieren und fachgerecht einlagern',
            'Materialien für Produktion und Montage bereitstellen',
            'Bestellungen zusammenstellen und für den Versand vorbereiten',
            'Lagerbestände mit modernen digitalen Systemen verwalten',
            'Transporte im Betrieb organisieren und koordinieren',
            'Mitarbeit in Bereichen wie Wareneingang, Lagerbewirtschaftung, Kommissionierung und Versand'
          ],
          requirements: 'Sekundarschule oder Realschule sowie organisatorisches Talent und Freude an praktischer Arbeit.',
          career: 'Weiterbildung zur Logistikfachperson oder Spezialisierung im Bereich Logistik oder Supply Chain Management.'
        }
      },
      detailedSection: {
        title: 'Unsere Ausbildungsberufe im Detail',
        whatYouLearn: 'Einblicke in deine Ausbildung',
        requirements: 'Voraussetzungen:',
        career: 'Karriere:'
      },
      quote: 'Deine Ausbildung ist der Anfang – gestalten wir gemeinsam deine Zukunft!',
      benefits: {
        title: 'Warum bei uns?',
        subtitle: 'Diese Vorteile erwarten dich in deiner Ausbildung',
        items: [
          { title: 'Familiäres Umfeld', description: 'Persönliche Betreuung und ein Team, das zusammenhält.' },
          { title: 'Praxisnahe Ausbildung', description: 'Vom ersten Tag an arbeitest du an echten Kundenprojekten.' },
          { title: 'Karrierechancen', description: 'Übernahmemöglichkeiten und Weiterbildungsförderung nach der Lehre.' },
          { title: 'Sichere Zukunft', description: 'Ein stabiles Unternehmen mit über 50 Jahren Erfahrung.' },
          { title: 'Moderne Infrastruktur', description: 'Arbeiten mit neuesten Technologien und Werkzeugen.' },
          { title: 'Erfahrene Berufsbildner', description: 'Qualifizierte Ausbildner begleiten dich auf deinem Weg.' }
        ]
      },
      path: {
        title: 'Der Weg zur Lehrstelle',
        subtitle: 'In vier Schritten zu deiner Ausbildung bei Althaus',
        steps: [
          { title: 'Informiere dich', description: 'Erkunde verschiedene Berufsfelder und ihre Anforderungen auf unserer Website und bei Beratungsdiensten.' },
          { title: 'Schnupperlehre', description: 'Bewirb dich für eine 2-tägige Schnupperlehre und lerne den Beruf und unser Unternehmen kennen.' },
          { title: 'Bewerbung', description: 'Sende uns deine vollständigen Unterlagen: Motivationsschreiben, Lebenslauf, Foto und Zeugnisse.' },
          { title: 'Lehrbeginn', description: 'Nach erfolgreicher Bewerbung startest du deine Ausbildung im August bei uns.' }
        ]
      },
      events: {
        title: 'Einblicke in unsere Berufsbildung',
        subtitle: 'Surprise Days, Sommertour, Schnuppertage und weitere Einblicke in unsere Ausbildungsberufe, Projekte und den Alltag unserer Lernenden.',
        viewAll: 'Alle Berufsbildungs-News ansehen'
      },
      form: {
        title: 'Schnupperlehre anfragen',
        subtitle: 'Lerne den Beruf und unser Unternehmen bei einer 2-tägigen Schnupperlehre kennen',
        sections: {
          personal: 'Personalien',
          school: 'Schule',
          apprenticeship: 'Schnupperlehre'
        },
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'E-Mail',
          phone: 'Telefon',
          birthDate: 'Geburtsdatum',
          shoeSize: 'Schuhgrösse',
          street: 'Strasse',
          city: 'PLZ / Ort',
          school: 'Aktuelle Schule',
          schoolYear: 'Schulklasse',
          desiredProfession: 'Wunschberuf',
          desiredApprenticeshipStart: 'Gewünschter Lehrbeginn',
          desiredDate: 'Wunschdatum im gewählten Bereich',
          preferredPeriod: 'Gewünschter Zeitraum (Mo–Fr)',
          referralSource: 'Wie bist du auf uns gestossen?',
          message: 'Bemerkungen / Motivation'
        },
        placeholders: {
          shoeSize: 'z.B. 42',
          city: 'z.B. 4912 Aarwangen',
          schoolYear: 'z.B. 8. Klasse Sek',
          selectProfession: 'Beruf auswählen',
          selectApprenticeshipStart: 'Lehrbeginn auswählen',
          selectPeriod: 'Woche auswählen',
          referralSource: 'z.B. Empfehlung, Schule, Internet, Social Media …',
          message: 'Warum interessierst du dich für diesen Beruf? Hast du spezielle Wünsche?'
        },
        professions: {
          automatiker: 'Automatiker/-in EFZ (2 Tage)',
          automatikmonteur: 'Automatikmonteur/-in EFZ (2 Tage)',
          logistiker: 'Logistiker/-in EFZ (2 Tage)'
        },
        periods: {
          fruehlingsferien: 'Frühlingsferien',
          sommerferien: 'Sommerferien',
          herbstferien: 'Herbstferien',
          sonstiges: 'Sonstiges'
        },
        attachments: {
          title: 'Beilagen für deine Bewerbung zur Schnupperlehre',
          intro: 'Bitte lade die folgenden Unterlagen vollständig hoch, damit wir deine Bewerbung prüfen können:',
          bullet1: 'Lebenslauf mit aktuellem Foto',
          bullet2: 'Kurzes Motivationsschreiben, in dem du erklärst, warum du dich für diese Schnupperlehre interessierst',
          bullet3: 'Zeugniskopien der letzten zwei Schuljahre',
          pdfHint: 'Achte darauf, dass alle Dokumente im PDF-Format sind (max. 15 MB gesamt). Alle Angaben werden selbstverständlich vertraulich behandelt.',
          cvLabel: 'Lebenslauf (PDF)',
          motivationLabel: 'Motivationsschreiben (PDF)',
          certificatesLabel: 'Zeugniskopien letzte 2 Schuljahre (PDF)',
          notesLabel: 'Frei Text / Sonstiges',
          notesPlaceholder: 'Zusätzliche Informationen, die du uns mitteilen möchtest…'
        },
        submitted: {
          title: 'Deine Bewerbung ist bei uns eingegangen',
          text: 'Vielen Dank für deine Bewerbung zur Schnupperlehre.\nWir haben deine Unterlagen erhalten und melden uns in den nächsten Tagen bei dir.',
          contactBefore: 'Bei Fragen kannst du dich jederzeit unter ',
          contactAfter: ' melden.',
          insightsTitle: 'Einblicke in unsere Berufsbildung',
          newApplication: 'Neue Bewerbung erfassen'
        },
        privacy: 'Ich akzeptiere die {link} und bin damit einverstanden, dass meine Daten zur Bearbeitung meiner Anfrage verwendet werden.',
        privacyLink: 'Datenschutzerklärung',
        submit: 'Schnupperlehre anfragen',
        toast: {
          error: 'Bitte akzeptiere die Datenschutzerklärung',
          missingDocuments: 'Bitte lade alle drei Dokumente (PDF) hoch.',
          tooLarge: 'Die Dokumente sind insgesamt zu gross (max. 15 MB).',
          notPdf: '"{name}" ist kein PDF. Bitte nur PDF-Dateien hochladen.',
          success: 'Deine Anfrage wurde gesendet! Wir melden uns bei dir.'
        }
      },
      cta: {
        title: 'Bereit für den Start?',
        description: 'Bewirb dich jetzt für eine Lehrstelle bei W. Althaus AG und werde Teil der Zukunft der Automatisierung.',
        contactTitle: 'Leiter Berufsbildung'
      }
    },
    productsPage: {
      title: 'Produkte',
      subtitle: 'Innovative Automatisierungslösungen für maximale Effizienz',
      athex: { name: 'Athex', title: 'Klemmenleistenfertigung' },
      panelscout: { name: 'Panelscout', title: 'Prüfsteuerung' }
    },
    leitbildPage: {
      hero: { title: 'Leading in Automation', subtitle: 'Qualität & Vertrauen', description: '„Leading in Automation" bedeutet für uns, hochautomatisierte und innovative Technik sowie Produkte made in Switzerland jederzeit an jeden Ort der Welt zu liefern. Dabei pflegen wir eine nachhaltige Partnerschaft mit allen Ansprechpartnern.' },
      intro: {
        title: 'Verlässlich. Innovativ.',
        highlight: 'Althaus.',
        suffix: 'Ihr Partner für industrielle Automation.',
        paragraphs: [
          'Im Mittelpunkt unserer Aktivität steht, eine durchgängige, qualitativ hochwertige und nachhaltige industrielle Automatisierung zu schaffen. Wir planen und fertigen die Produkte unter Einhaltung der geltenden Normen, Vorschriften und Richtlinien.',
          'Unsere hochmoderne Infrastruktur bildet das stabile Fundament für Qualität und Effizienz. In organisierten Produktionsumgebungen entstehen Automatisierungslösungen, die Massstäbe setzen und Innovation aktiv fördern. Hier greifen digitalisierte Prozesse, ECAD Engineering und Fertigungsautomation nahtlos ineinander, vom ersten Stück an.',
          'Genauso wichtig ist die Kommunikation und das Teamwork. In unseren modernen Besprechungsräumen werden Ideen geschärft, Entscheidungen getroffen und Projekte auf Erfolgskurs gebracht. Interdisziplinäre Teams aus Software, Hardware und Mechatronik Spezialisten planen gemeinsam, denken voraus und liefern verlässlich.',
          'Und weil Höchstleistung ein gutes Umfeld braucht, gestalten wir Arbeitsplätze der Zukunft. Ergonomisch, inspirierend und auf konzentrierte Zusammenarbeit ausgelegt. So entstehen kreative, technische Lösungen in produktiver Co Creation, schnell, flexibel und in Schweizer Qualität.'
        ]
      },
      values: {
        trust: { title: 'Vertrauen, Kontinuität und Kompetenz', description: 'Automation bedeutet für uns auch Kontinuität. Mit unseren Mitarbeitenden, unseren Kunden, Partnern und Lieferanten pflegen wir eine langfristige und vertrauensvolle Partnerschaft, die von hoher Kompetenz geprägt ist.' },
        quality: { title: 'Qualität für den Kunden', description: 'Den Erfolg unserer Firma verdanken wir im Wesentlichen den individuellen Kundenlösungen und der hohen Produktqualität, welche wir anhand des hohen Automatisierungsgrades und der optimalen Fertigungstiefe erzielen können. Während des ganzen Produktlebenszyklus unterstützen wir unsere Kunden mit auf ihre Bedürfnisse zugeschnittenen Lösungen. Wir planen und fertigen die Produkte unter Einhaltung der geltenden Normen, Vorschriften und Richtlinien.' }
      },
      cta: 'Zu unserem BigPicture'
    },
    chameleonPage: {
      heroTitle: 'Adaptiv in Automation',
      heroSubtitle: 'Weitsicht & Präzision',
      sections: [
        { title: 'Wie ein Chamäleon. Nur industriell.', subtitle: 'Wir reagieren schnell, bleiben souverän im Griff und liefern präzise Lösungen – vom ersten Konzept bis zur Inbetriebnahme.', content: '' },
        { title: 'Nahtlose Anpassung – Passgenaue Lösungen', content: 'Ein Chamäleon wechselt die Farbe, um sich nahtlos in die Umgebung einzufügen. Wir wechseln die Perspektive, um perfekt zu passen: Einzelstück, Losgrösse, Serienfertigung oder Retrofit – wir bilden Varianten präzise und modular ab. Unsere Lösungen folgen Normen, Richtlinien und Kundenstandards - ohne Kompromisse. Ergebnis: Passform statt Anpassungsaufwand.' },
        { title: 'Voller Durchblick – Planung mit Weitsicht', content: 'Das Chamäleon sieht mit beiden Augen unabhängig – es nimmt Details wahr, ohne den Gesamtkontext zu verlieren. So sehen wir Projekte. In der Konzeptphase leuchten wir die Projektlandschaft aus, priorisieren, was wichtig ist und richten alles auf ein Ziel aus: Wirkung statt Zufall. Der Startpunkt ist nicht Bauchgefühl, sondern Weitsicht und der Mut, das Wesentliche klar zu benennen.' },
        { title: 'Fokussierter Angriff – Präzise Abläufe', content: 'Wenn das Chamäleon zuschnappt, ist der Moment perfekt gewählt. Aus Überblick wird Fokus – aus Ambition wird ein klarer Ablauf. In der Umsetzung zählt jeder Schritt. Vernetzte und parallele Prozesse, vollautomatisierte und digital gesteuerte Abläufe sorgen für Tempo mit Zielgenauigkeit. Wir verkürzen Wege, vermeiden Reibung, erhöhen Wiederholgenauigkeit – schnell, aber nie leichtfertig.' },
        { title: 'Fester Halt – Qualität bis ins Detail', content: 'Greiffüsse und Schwanz geben dem Chamäleon Stabilität in jeder Lage. Unsere Stabilität entsteht in der Tiefe der Details: Flexible Fertigungstiefe, klare Kommunikationswege, nahtlose Integration, gemeinsamer Fokus und alles aus einer Hand – Flexibilität bis in die letzte Ader. So bleibt alles fest, nachvollziehbar und servicefreundlich über Jahre – Qualität, die man fühlen kann.' },
        { title: 'Perfekte Tarnung – Nahtlose Integration', content: 'Tarnung ist beim Chamäleon kein Trick, sondern eine Strategie. Bei uns bedeutet das Partnerschaft: Wir integrieren uns flexibel, präzise und verlässlich in eure Supply Chain – über den gesamten Lebenszyklus hinweg. Von der Projektierung über die Produktion bis zum After-Sales-Support. Euer Produkt steht im Rampenlicht. Wir arbeiten im Hintergrund – sichtbar nur durch die Ergebnisse.' },
        { title: 'Ständige Erneuerung – Veränderung in DNA', content: 'Das Chamäleon häutet sich, um beweglich zu bleiben, sich anzupassen und zu wachsen. Genauso entwickeln wir uns weiter: Nicht reagierend, sondern agierend als Teil unserer DNA. Seit 1968 entwickeln wir Automation, Prozesse, Standards und Routinen weiter – getragen von zwei Standorten und über 160 Mitarbeitenden. So bleibt Bewährtes stabil, während Neues schnell integriert werden kann. Veränderung ist bei uns kein Projekt, sondern gelebte Kultur.' }
      ],
      cta: { title: 'Bereit für den Farbwechsel?', subtitle: 'Lassen Sie uns Ihr Projekt in den richtigen Ton bringen.', button: 'Kontakt aufnehmen' }
    },
    documentsPage: {
      title: 'Dokumente',
      subtitle: 'Hier finden Sie alle wichtigen Dokumente, Zertifikate und Unterlagen der W. Althaus AG zum Download.',
      categories: [
        { title: 'Unternehmen', documents: [{ name: 'Logo (.png)', url: '/documents/W_Althaus_AG_Logo.png' }, { name: 'Firmendaten', url: '/documents/Firmendaten_2026.pdf' }, { name: 'Organigramm', url: '/documents/organigramm.pdf' }] },
        { title: 'Werte & Kultur', documents: [{ name: 'Leitbild (BigPicture)', url: '/documents/Althaus_Wertehaus_Bigpicture_2024.pdf' }, { name: 'Verhaltenskodex', url: '/documents/Verhaltenskodex_W._Althaus_AG.pdf' }] },
        { title: 'Einkauf- & Lieferbedingungen', documents: [{ name: 'Allgemeine Einkaufsbedingungen (Deutsch)', url: '/documents/Allgemeine_Einkaufsbedingungen.pdf' }, { name: 'General Terms and Conditions of Purchase (English)', url: '/documents/General_Terms_and_Conditions_of_Purchase.pdf' }, { name: 'Conditions générales d\'achat (Français)', url: '/documents/Conditions_generales_d_achat.pdf' }, { name: 'Allgemeine Lieferbedingungen', url: '/documents/W._Althaus_AG_Allgemeine_Lieferbedingungen.pdf' }] },
        { title: 'ISO Zertifizierungen', documents: [{ name: 'ISO 9001:2015 / ISO 14001:2015 (Deutsch)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_DE.pdf' }, { name: 'ISO 9001:2015 / ISO 14001:2015 (English)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_EN.pdf' }] },
        { title: 'Nachhaltigkeits-zertifikate', documents: [{ name: 'Freiwilliger Klimaschutz und Energieeffizienz', url: '/documents/Zertifikat_Energie-Agentur_der_Wirtschaft.pdf' }, { name: 'EcoVadis Nachhaltigkeits-Zertifikat', url: '/documents/Ecovadis_W._Althaus_AG.pdf' }] },
        { title: 'Normen & Verbände', documents: [{ name: 'UL-Certificate', url: '/documents/Certificate_of_Compliance_UL.pdf' }, { name: 'EKAS Zertifikat VSAS', url: '/documents/EKAS_Zertifikat_VSAS.pdf' }] }
      ],
      contactNote: 'Benötigen Sie weitere Unterlagen oder haben Sie Fragen zu unseren Dokumenten? Kontaktieren Sie uns gerne unter'
    },
    imprintPage: {
      title: 'Impressum',
      contact: { title: 'Kontakt' },
      register: { title: 'Handelsregistereintrag', company: 'Eingetragener Firmenname: W. Althaus AG', number: 'Nummer: CHE‑375.798.234', office: 'Handelsregisteramt des Kantons Bern' },
      vat: { title: 'Mehrwertsteuernummer', number: 'CHE-375.798.234 MWST' },
      disclaimer: { title: 'Haftungsausschluss', paragraphs: ['Die W. Althaus AG übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.', 'Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.', 'Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.'] },
      links: { title: 'Haftung für Links', text: 'Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.' },
      copyright: { title: 'Urheberrechte', text: 'Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Website gehören ausschliesslich der Firma W. Althaus AG oder den speziell genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.' }
    },
    privacyPage: {
      title: 'Datenschutz',
      sections: [
        { title: 'Geltungsbereich', content: ['Diese Datenschutzerklärung klärt Nutzer über die Art, den Umfang und Zwecke der Erhebung und Verwendung personenbezogener Daten.'] },
        { title: 'Kontaktadresse', content: ['Falls Sie weitere Informationen zum Datenschutz möchten, kontaktieren Sie unseren Datenschutzverantwortlichen via Mail.', 'Kontakt: {email}', 'Bei der Kontaktaufnahme mit dem Anbieter (zum Beispiel per Kontaktformular oder E-Mail) werden die Angaben des Nutzers zwecks Bearbeitung der Anfrage sowie für den Fall, dass Anschlussfragen entstehen, gespeichert.'] },
        { title: 'Datenschutz / Zugriffsdaten', content: ['Gestützt auf Artikel 13 der schweizerischen Bundesverfassung und die datenschutzrechtlichen Bestimmungen des Bundes (Datenschutzgesetz, DSG) hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz vor Missbrauch ihrer persönlichen Daten. Wir halten diese Bestimmungen ein. Persönliche Daten werden streng vertraulich behandelt und weder an Dritte verkauft noch weitergegeben.', 'In enger Zusammenarbeit mit unseren Hosting-Providern bemühen wir uns, die Datenbanken so gut wie möglich vor fremden Zugriffen, Verlusten, Missbrauch oder vor Fälschung zu schützen.', 'Beim Zugriff auf unsere Webseiten werden folgende Daten in Logfiles gespeichert: IP-Adresse, Datum, Uhrzeit, Browser-Anfrage und allg. übertragene Informationen zum Betriebssystem resp. Browser. Diese Nutzungsdaten bilden die Basis für statistische, anonyme Auswertungen, so dass Trends erkennbar sind, anhand derer wir unsere Angebote entsprechend verbessern können. Der Anbieter behält sich jedoch vor, die Protokolldaten nachträglich zu überprüfen, wenn aufgrund konkreter Anhaltspunkte der berechtigte Verdacht einer rechtswidrigen Nutzung besteht.'] },
        { title: 'Datenschutzerklärung für die Nutzung von Google Analytics', content: ['Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. ("Google"). Google Analytics verwendet sog. "Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch das Cookie erzeugte Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt.', 'Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenunutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen.', 'Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können.'] },
        { title: 'Umgang mit personenbezogenen Daten', content: ['Personenbezogene Daten sind Informationen, mit deren Hilfe eine Person bestimmbar ist, also Angaben, die zurück zu einer Person verfolgt werden können. Dazu gehören der Name, die Emailadresse oder die Telefonnummer.', 'Personenbezogene Daten werden von dem Anbieter nur dann erhoben, genutzt und weitergegeben, wenn dies gesetzlich erlaubt ist oder die Nutzer in die Datenerhebung einwilligen.'] },
        { title: 'Datenschutzerklärung für Online-Bewerbungen', content: ['Der Schutz Ihrer persönlichen Daten ist uns wichtig. Sie erkennen die Datenschutz-Informationen an, indem Sie bei der Anmeldung zur Online-Bewerbung den hierfür vorgesehenen elektronischen Haken setzen.', 'Wir erheben und bearbeiten personenbezogene Daten von Bewerbern zum Zwecke der Abwicklung des Bewerbungsverfahrens.'] },
        { title: 'Cookies', content: ['Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die beim Besuch dieser Website in Ihrem Computer dauerhaft oder temporär gespeichert werden. Zweck der Cookies ist insbesondere die Analyse der Nutzung dieser Website zur statistischen Auswertung sowie für kontinuierliche Verbesserungen.', 'In Ihrem Browser können Sie Cookies in den Einstellungen jederzeit ganz oder teilweise deaktivieren. Bei deaktivierten Cookies stehen Ihnen allenfalls nicht mehr alle Funktionen dieser Website zur Verfügung.'] },
        { title: 'Widerruf, Änderungen, Berichtigungen und Aktualisierungen', content: ['Der Nutzer hat das Recht, auf Antrag unentgeltlich Auskunft zu erhalten über die personenbezogenen Daten, die über ihn gespeichert wurden. Zusätzlich hat der Nutzer das Recht auf Berichtigung unrichtiger Daten, Sperrung und Löschung seiner personenbezogenen Daten, soweit dem keine gesetzliche Aufbewahrungspflicht entgegensteht.', 'Kontakt: {email}'] }
      ]
    },
    welcomeSection: {
      text: 'W. Althaus AG – Leading in Automation seit 1968.'
    },
    athexPage: {
      tagline: 'automatisiert. präzise. Althaus.',
      heroDescription: 'Mit {product} revolutionieren wir die Klemmenleistenfertigung. Unser vollautomatisiertes System produziert Klemmenleisten in höchster Präzision – schneller, fehlerfreier und wirtschaftlicher als je zuvor.',
      cards: [
        { title: 'Was ist Athex?', text: 'Athex ist unser eigenentwickeltes System zur vollautomatisierten Klemmenleistenfertigung. Von der Konfektionierung bis zur fertigen Klemmenleiste – alles in einem durchgängigen, digitalisierten Prozess. Damit reduzieren wir Durchlaufzeiten drastisch und eliminieren manuelle Fehlerquellen.' },
        { title: 'Modernste Technologie', text: 'Athex nutzt ECAD-Daten direkt aus ePlan und E3 für die automatische Bestückung. Intelligente Algorithmen optimieren die Reihenfolge, minimieren Rüstzeiten und maximieren die Auslastung. Das Ergebnis: seriennahe Qualität ab Stückzahl 1.' },
        { title: 'Ihre Vorteile', text: 'Höchste Präzision durch vollautomatisierte Fertigung. Drastisch reduzierte Durchlaufzeiten. Null manuelle Fehlerquellen. Flexible Fertigung von Einzelstücken bis zur Serie. Volle Integration in Ihren ECAD-Workflow. Rückverfolgbarkeit jeder einzelnen Klemme.' }
      ],
      functionsTitle: 'Athex Funktionen',
      functions: {
        ecad: { name: 'ECAD-Integration', description: 'Direkte Datenübernahme aus ePlan P8, ePlan Pro Panel und E3.series für nahtlose Automatisierung.' },
        automated: { name: 'Vollautomatisiert', description: 'Von der Stückliste zur fertigen Klemmenleiste ohne manuelle Eingriffe.' },
        errorFree: { name: 'Fehlerfreie Produktion', description: 'Eliminierung manueller Fehlerquellen durch durchgängige Digitalisierung.' },
        fast: { name: 'Schnelle Durchlaufzeiten', description: 'Drastisch reduzierte Fertigungszeiten durch optimierte Prozessabläufe.' },
        flexible: { name: 'Flexible Stückzahlen', description: 'Wirtschaftliche Fertigung von Einzelstücken bis zur Grossserie.' },
        traceability: { name: 'Rückverfolgbarkeit', description: 'Lückenlose Dokumentation und Nachverfolgung jeder einzelnen Komponente.' }
      },
      valueTitle: 'Ihr Mehrwert mit Athex',
      values: [
        { title: 'Geschwindigkeit', description: 'Bis zu 80% schnellere Durchlaufzeiten im Vergleich zur manuellen Fertigung.' },
        { title: 'Qualität', description: 'Konstant hohe Qualität durch vollautomatisierte, fehlerfreie Prozesse.' },
        { title: 'Flexibilität', description: 'Wirtschaftliche Fertigung ab Losgrösse 1 bis zur Grossserie.' },
        { title: 'Integration', description: 'Nahtlose Anbindung an Ihre bestehenden ECAD-Systeme.' }
      ]
    },
    panelscoutPage: {
      tagline: 'intelligent. zuverlässig. Althaus.',
      heroDescription: 'Mit {product} bringen wir intelligente Prüfsteuerung in Ihren Schaltschrankbau. Unser System prüft, dokumentiert und protokolliert – vollautomatisch und lückenlos.',
      cards: [
        { title: 'Was ist Panelscout?', text: 'Panelscout ist unser intelligentes Prüfsteuerungssystem für Schaltschränke und elektrische Anlagen. Es führt automatisierte Funktionsprüfungen durch, dokumentiert alle Messwerte und erstellt lückenlose Prüfprotokolle – für maximale Sicherheit und Qualität.' },
        { title: 'Intelligente Prüflogik', text: 'Panelscout nutzt adaptive Prüfroutinen, die sich automatisch an Ihre Schaltschrankkonzeption anpassen. Die Software erkennt Verdrahtungsfehler, prüft Isolationswiderstände und testet Funktionsabläufe – alles vollautomatisch und normgerecht.' },
        { title: 'Ihre Vorteile', text: 'Lückenlose Qualitätssicherung durch automatisierte Prüfungen. Normgerechte Dokumentation aller Messwerte. Frühzeitige Fehlererkennung vor der Auslieferung. Reduzierte Prüfzeiten bei gleichzeitig höherer Prüftiefe. Volle Rückverfolgbarkeit aller Prüfergebnisse.' }
      ],
      functionsTitle: 'Panelscout Funktionen',
      functions: {
        testing: { name: 'Automatische Prüfung', description: 'Vollautomatisierte Funktions- und Sicherheitsprüfungen nach aktuellen Normen.' },
        documentation: { name: 'Lückenlose Dokumentation', description: 'Automatische Protokollierung aller Messwerte und Prüfergebnisse.' },
        errorDetection: { name: 'Fehlererkennung', description: 'Frühzeitige Identifikation von Verdrahtungsfehlern und Defekten.' },
        compliance: { name: 'Normkonformität', description: 'Prüfungen nach IEC, EN und weiteren relevanten Industriestandards.' },
        speed: { name: 'Schnelle Prüfzeiten', description: 'Optimierte Prüfroutinen für maximale Effizienz bei höchster Qualität.' },
        traceability: { name: 'Rückverfolgbarkeit', description: 'Vollständige Nachverfolgung aller Prüfergebnisse für jedes Projekt.' }
      },
      valueTitle: 'Ihr Mehrwert mit Panelscout',
      values: [
        { title: 'Sicherheit', description: 'Lückenlose Prüfung gewährleistet höchste Betriebssicherheit Ihrer Anlagen.' },
        { title: 'Qualität', description: 'Automatisierte Prüfungen garantieren gleichbleibend hohe Qualitätsstandards.' },
        { title: 'Effizienz', description: 'Schnellere Prüfzeiten bei gleichzeitig tieferer Prüfung aller Komponenten.' },
        { title: 'Dokumentation', description: 'Normgerechte Protokolle für Zertifizierung und Gewährleistung.' }
      ]
    },
    hardwareEngineeringPage: {
      tagline: 'modular. normenkonform. Althaus.',
      heroDescription: 'Wir entwickeln intelligente Hardware-Lösungen für Ihre Automatisierung. Von der Konzeption bis zur Implementierung mit modernsten Technologien.',
      featureCards: [
        { title: 'Was Sie bei Althaus erhalten', description: 'Wir erarbeiten mit Ihnen Hardware- und Steuerungskonzepte für Anlagen und Maschinen. Mit Modularisierung und dem Digital Twin schaffen wir standardisierte, wiederverwendbare Baukästen, senken Engineeringaufwände und liefern fertigungsreife Daten für die direkte Ansteuerung unserer automatisierten Produktion.' },
        { title: 'Vom Konzept bis zur Inbetriebnahme', description: 'Wir modellieren ECAD mit ePlan P8/Pro Panel als digitalen Zwilling, modularisieren Anlagen, konstruieren Schaltschränke inkl. Layout und Verdrahtungs-Routing, erfüllen EN/UL/CSA, sichern funktionale Sicherheit, liefern Fertigungsdaten und begleiten Tests, Doku, Übergabe.' },
        { title: 'So arbeiten wir', description: 'Wir definieren in enger Zusammenarbeit Ziele, Normen und Schnittstellen, modularisieren Ihre Anlage für Wiederverwendbarkeit und entwickeln normenkonforme Schaltschrankkonzepte. Von der Risikobeurteilung über Fertigungsdaten bis zur Dokumentation und Inbetriebnahme – alles aus einer Hand.' }
      ],
      servicesTitle: 'Unser Leistungsangebot umfasst',
      services: [
        { name: 'Konzeptberatung zur Erstellung des Elektroschemas', description: 'Professionelle Beratung und Erstellung von Elektroschemas' },
        { name: 'CAD-Systeme: ePlan P8, ePlan Pro Panel', description: 'Professionelle Planung mit modernsten CAD-Tools' },
        { name: 'Anlagenmodularisierung und Automatisierung', description: 'Moderne Automatisierung für effiziente Anlagenkonzepte' },
        { name: 'Schaltschrankkonzept: Konstruktion, Layout', description: 'Präzise Konstruktion und optimales Layout-Design' },
        { name: 'Normen/Vorschriften: EN, UL, CSA', description: 'Vollständige Konformität mit internationalen Standards' },
        { name: 'Sicherheitskonzepte und Risikobeurteilung', description: 'Umfassende Sicherheitsanalysen nach höchsten Standards' }
      ],
      valueTitle: 'Ihr Mehrwert durch unsere Automatisierung',
      values: [
        { title: 'Durchgängige Datenbasis', description: 'Vom ersten Schematic bis zur Inbetriebnahme – alle Daten konsistent und wiederverwendbar.' },
        { title: 'Weniger Engineeringkosten', description: 'Dank Standards, Templates und Wiederverwendung reduzieren wir den Aufwand signifikant.' },
        { title: 'Normenkonforme Sicherheit', description: 'EN/UL/CSA ausgelegt und dokumentiert für internationale Compliance.' },
        { title: 'Modulare Skalierbarkeit', description: 'Wiederverwendbare Baukästen ermöglichen schnelle Anpassungen und Erweiterungen.' }
      ]
    },
    softwareEngineeringPage: {
      tagline: 'intelligent. intuitiv. Althaus.',
      heroDescription: 'Unsere Softwareingenieur:innen hauchen Ihren Maschinen Leben ein. Wir entwickeln intelligente Software-Lösungen für Ihre Automatisierung. Von der Konzeption bis zur Implementierung - mit modernsten Technologien.',
      featureCards: [
        { title: 'Was Sie bei Althaus erhalten', description: 'Unsere Softwareingenieure führen Sie von Planung und Konzept bis zum Pflichtenheft, entwickeln steuerungsnahe Software, intuitive HMI/SCADA und massgeschneiderte SQL-Apps. Systemneutrale Beratung und Value Engineering. Abgestimmt mit dem Hardwareengineering – für durchgängige Datenflüsse bis Fertigung und Inbetriebnahme.' },
        { title: 'Leistungsumfang - Kompetenzen & Tools', description: 'Neutrale Analyse, Architektur und Tech-Stack; priorisierte Funktionen für Taktzeit und Stabilität; transparentes Projektmanagement. Intuitive UIs mit Alarmen, Rezepturen, Audit Trail; zuverlässige PLC/Motion und Safety. Weltweite Inbetriebnahmen plus Service, Monitoring, Updates und schnelle Remote-Unterstützung.' },
        { title: 'So arbeiten wir', description: 'Von der ersten Anforderungsanalyse bis zur weltweiten Inbetriebnahme. Wir klären Ziele, Technologie-Stack und Schnittstellen, entwickeln modulare Software-Architekturen und setzen agile Methoden ein. Dokumentation, Testing und Remote-Support sichern langfristige Zuverlässigkeit Ihrer Automatisierungslösung.' }
      ],
      servicesTitle: 'Unser Leistungsangebot umfasst',
      services: [
        { name: 'PLC/Motion Programming', description: 'Steuerungsprogrammierung für alle gängigen Plattformen' },
        { name: 'HMI/SCADA Development', description: 'Intuitive Benutzeroberflächen mit Alarmen & Rezepturen' },
        { name: 'Database Applications', description: 'SQL-Server Anwendungen mit Audit Trail & Reporting' },
        { name: 'Digital Twin & Simulation', description: 'Virtuelle Inbetriebnahme & Prozessoptimierung' },
        { name: 'Safety & Compliance', description: 'Sicherheitsprogrammierung nach aktuellen Normen' },
        { name: 'Remote Service & Monitoring', description: 'Weltweiter Support und KPI-Monitoring' }
      ],
      valueTitle: 'Ihr Mehrwert durch unsere Automatisierung',
      values: [
        { title: 'Durchgängigkeit', description: 'Nahtlose Integration mit Hardware und Digital Twin für konsistente Datenflüsse.' },
        { title: 'Time-to-Commission', description: 'Strukturierte Pflichtenhefte und sauberes Projektmanagement für schnelle Inbetriebnahme.' },
        { title: 'Intuitive Bedienbarkeit', description: 'Klare HMIs und verständliche Manuals für einfache Bedienung durch Ihr Team.' },
        { title: 'Lifecycle-Support', description: 'Remote-Support und weltweite Inbetriebnahme für langfristige Zuverlässigkeit.' }
      ]
    },
    contactPage: {
      formTitle: 'Kontaktformular',
      formSubtitle: 'Haben Sie Fragen zu unseren Dienstleistungen, ein konkretes Anliegen oder möchten Sie mit uns zusammenarbeiten? Teilen Sie uns Ihr Anliegen mit, wir melden uns zeitnah bei Ihnen.',
      directContact: {
        title: 'Direkter Kontakt',
        description: 'Sie möchten uns direkt kontaktieren? Gerne stehen wir Ihnen telefonisch oder per E-Mail zur Verfügung.',
        phone: '+41 62 919 82 10',
        email: ''
      },
      departmentTitle: 'Kontakt nach Abteilung',
      departmentSubtitle: 'Wenden Sie sich direkt an die richtige Abteilung für Ihr Anliegen',
      departments: [
        { title: 'Verkauf', description: '' },
        { title: 'Einkauf', description: '' },
        { title: 'Karriere', description: '' },
        { title: 'Marketing', description: '' }
      ]
    },
    anfahrtPage: {
      heroTitle: 'So finden Sie uns.',
      heroDescription: 'Unser Bürogebäude (Hauptsitz) sowie unsere Produktion befinden sich in verkehrsgünstiger Lage, 10 Minuten von der Autobahn A1 in Aarwangen. Auch mit dem öffentlichen Verkehr sind unsere Standorte gut angebunden und problemlos erreichbar.',
      locationsTitle: 'Unsere Standorte',
      locations: [
        { title: 'Hauptsitz', country: 'Schweiz' },
        { title: 'Produktion', country: 'Schweiz' }
      ],
      openingHours: 'Öffnungszeiten',
      openingHoursWarehouse: 'Öffnungszeiten Wareneingang',
      monThu: 'Montag bis Donnerstag',
      friday: 'Freitag',
      routePlanning: 'Route planen',
      transportTitle: 'Anreisemöglichkeiten',
      transportSubtitle: 'Verschiedene Wege führen zu uns - wählen Sie die für Sie beste Option',
      carTab: 'Auto',
      publicTransportTab: 'ÖV',
      carDirections: [
        { title: 'Hauptsitz', description: 'Von der Autobahn A1 nehmen Sie die Ausfahrt Aarwangen. Folgen Sie der Beschilderung Richtung Aarwangen Dorf. Unser Hauptsitz befindet sich an der Jurastrasse 12. Parkplätze stehen direkt vor dem Gebäude zur Verfügung.' },
        { title: 'Produktion', description: 'Von der Autobahn A1 nehmen Sie die Ausfahrt Aarwangen. Folgen Sie der Beschilderung Richtung Industriegebiet. Unsere Produktionsstätte finden Sie am Industriering 2. Ausreichend Parkplätze sind vor Ort vorhanden.' }
      ],
      publicTransportDirections: [
        { title: 'Hauptsitz', description: 'Der Hauptsitz ist in nur <strong>2 Gehminuten</strong> vom Bahnhof Aarwangen Dorf zu erreichen. Nach Verlassen des Bahnhofs folgen Sie einfach der Jurastrasse.' },
        { title: 'Produktion', description: 'Die Produktion ist in <strong>10 Gehminuten</strong> von der Haltestelle Aarwangen Hard zu erreichen. Folgen Sie der Beschilderung Richtung Industriegebiet.' }
      ]
    },
    successStoriesPage: {
      heroSubtitle: 'von führenden Unternehmen',
      heroDescription: 'Entdecken Sie, wie wir unseren Kunden zu messbarem Erfolg verholfen haben',
      filterAll: 'Alle',
      projectServices: 'Leistungen im Projekt',
      readCaseStudy: 'Case Study lesen',
      employees: 'Mitarbeiter',
      quotes: {
        guedel: 'Durch die Standardisierung und den Digital Twin erhielten wir schon ab dem ersten Los seriennahe Qualität. Änderungen kurz vor Auslieferung waren ohne Terminrutsch möglich.',
        cwa: 'Dank W. Althaus AG haben wir Prozesse gestrafft: Die gelieferten Schaltschränke waren vollständig geprüft, dokumentiert und einbaufertig. Tritt eine Änderung auf, reagiert W. Althaus AG schnell und flexibel.',
        haefely: 'Mit der W. Althaus AG konnten wir unsere Prüfumgebungen schneller in Betrieb nehmen: Die Schaltschränke kamen geprüft, rückverfolgbar und einbaufertig. Bei Änderungen zeigte sich das Team jederzeit flexibel und lösungsorientiert.',
        fondarex: 'ePlan-Makros und Musterschaltschränke haben unsere Engineeringzeit halbiert – neue Maschinen gehen nun deutlich schneller in Serie.',
        bunorm: 'Die EN/UL/CSA-konforme Auslegung inkl. Risikobeurteilung hat unsere Zulassung spürbar verkürzt.',
        zehndersommer: 'Mit Digital Twin und fertigen Fertigungsdaten war der Übergang in den Schaltschrankbau reibungslos – Änderungen blieben terminstabil.',
        emmi: 'Remote-Support und klare Dokumentation hielten die Anlage stabil – Updates ohne Stillstandsdrama.',
        kadi: 'Die SQL-basierte Rezepturverwaltung mit Audit Trail schafft Transparenz – Reports auf Knopfdruck, validierungsfähig.',
        cerex: 'Das Pflichtenheft und die HMI-Flows haben die Inbetriebnahme verkürzt. Bediener fanden sich sofort zurecht, Änderungswünsche waren schnell umgesetzt.'
      },
      positions: {
        guedel: 'Head of Supply Chain Management, Güdel AG',
        cwa: 'Operativer Einkauf, CWA AG',
        haefely: 'Manager Purchasing, HAEFELY AG',
        fondarex: 'Leiter Elektrotechnik, Fondarex AG',
        bunorm: 'Geschäftsführer, Bunorm Maschinenbau AG',
        zehndersommer: 'Elektrische Innovation, Zehnder & Sommer AG',
        emmi: 'Teamleiter, Emmi Schweiz AG',
        kadi: 'Projektleiter, KADI AG',
        cerex: 'Technischer Leiter, CEREX AG'
      },
      industries: {
        guedel: 'Maschinenbau',
        cwa: 'Personentransportbau',
        haefely: 'Bau von Prüfsysteme',
        fondarex: 'Maschinenbau',
        bunorm: 'Maschinenbau',
        zehndersommer: 'Pressen-Vorschubsysteme',
        emmi: 'Lebensmittelindustrie',
        kadi: 'Lebensmittelindustrie',
        cerex: 'Maschinenbau'
      }
    },
    jobOpeningsPage: {
      title: 'Offene Stellen',
      subtitle: 'Finden Sie Ihre nächste Herausforderung bei der W. Althaus AG',
      yourTasks: 'Ihre Aufgaben:',
      learnMore: 'Mehr erfahren',
      noJobTitle: 'Keine passende Stelle gefunden?',
      noJobDescription: 'Wir freuen uns über Ihre Initiativbewerbung und prüfen gerne, ob wir eine passende Position für Sie haben.',
      sendApplication: 'Initiativbewerbung senden',
      startDate: 'Sofort oder nach Vereinbarung',
      jobs: [
        {
          title: 'Sachbearbeiter HR & Finanzen (m/w/d)',
          department: 'Administration',
          description: 'Unterstützen Sie unser Team in den Bereichen Human Resources und Finanzen. Sie übernehmen vielseitige administrative Aufgaben und tragen zur reibungslosen Organisation bei.',
          tasks: ['Unterstützung in der Personaladministration und im Rekrutierungsprozess', 'Mitarbeit in der Finanzbuchhaltung und Lohnverarbeitung', 'Administrative Aufgaben im Bereich HR und Finanzen']
        },
        {
          title: 'Automationsingenieur (m/w/d)',
          department: 'Engineering',
          description: 'Digitalisierung, Automation oder Robotik – bei uns stecken Sie mittendrin! Wir arbeiten mit modernsten Tools und Technologien. Werden Sie Teil des motivierten Teams und gestalten Sie die Zukunft in der Entwicklung entscheidend mit.',
          tasks: ['Selbständige Entwicklung, Realisierung und Inbetriebnahme von Softwareautomationslösungen', 'SPS-Software und Prozessvisualisierungen auf verschiedenen Systemen', 'Projektbegleitung und technischer Support']
        },
        {
          title: 'Automatiker, Schaltanlagenmonteur oder versierter Elektromonteur (m/w/d)',
          department: 'Produktion',
          description: 'Werden Sie Teil des motivierten Teams und gestalten Sie die Zukunft in der Produktion entscheidend mit. Sie sind verantwortlich für die gesamte Herstellung von der mechanischen Bearbeitung bis zur Verdrahtung.',
          tasks: ['Fertigung von Steuerungen und Schaltanlagen unterschiedlichster Art', 'Verantwortung für den gesamten Herstellungsprozess', 'Mechanische Bearbeitung, Aufbau und Verdrahtung des Schaltschrankes']
        }
      ]
    }
  },
  en: {
    crossIndustrySolutions: {
      title: 'Industries',
      description: 'With 50 years of experience in industrial automation, we are specialists in developing customized solutions and delivering innovative technology at any time to any place in the world.',
      industries: {
        maschinenbau: 'Machine & Plant Engineering',
        medizintechnik: 'Medical Technology',
        energie: 'Energy & Infrastructure',
        foodBeverage: 'Food Industry',
        transportation: 'Transport & Mobility',
        erneuerbare: 'Renewable Energy'
      },
      moreIndustries: '... and many more'
    },
    aboutPreview: {
      title: 'About Us',
      description: 'We are a Swiss family business founded in 1968 in Aarwangen, Canton of Bern. Today, over 160 employees work at two locations. W. Althaus AG is considered an important and pioneering employer in the region.',
      description2: 'Our core competence lies in the development and production of everything from simple electrical controls to complex automation solutions.',
      learnMore: 'Learn more',
      production: 'Production',
      headquarters: 'Headquarters',
      team: 'Team',
    },
    certificationsPartnerships: {
      title: 'Partnerships & Certifications',
      partnershipsLabel: 'Partnerships',
      certificationsLabel: 'Certifications',
      qualityManagement: 'Quality Management',
      environmentalManagement: 'Environmental Management',
      sustainabilityRating: 'Sustainability Rating',
      recognizedTrainingCompany: 'Recognised Training Company'
    },
    footer: {
      headquarters: 'Headquarters',
      production: 'Production',
      contact: 'Contact',
      phone: 'Phone',
      openingHours: {
        weekdays: 'Monday to Thursday',
        friday: 'Friday'
      }
    },
    servicesSection: {
      title: 'Our Services',
      servicesEyebrow: 'From the concept',
      subtitle: 'With automation and control cabinet construction 4.0, we digitize your ideas for your competitive advantage.',
      pageSubtitle: 'With automation and control cabinet construction 4.0, we digitize your ideas for your competitive advantage. We support our customers from planning through control cabinet construction to the development and integration of control software. This creates seamless automation solutions that work reliably and can be flexibly integrated into existing systems.',
      heroTitle: 'Our Services',
      heroSubtitle: 'Holistically designed',
      ownDevelopmentsTitle: 'Our Own Developments',
      ownDevelopmentsDescription: 'With our own developments, we create intelligent solutions for modern engineering, testing, and manufacturing processes. They help automate workflows, standardize testing steps, and make data usable in a structured way. The result is reliable systems with high practical value that seamlessly integrate into existing infrastructures and sustainably optimize your processes.',
      manifestEyebrow: '01 — Philosophy',
      manifestPart1: 'A recipe for success: Our ',
      manifestHighlight1: 'automation expertise',
      manifestPart2: ' and your ',
      manifestHighlight2: 'process knowledge',
      manifestPart3: '.',
      consultingTitle: 'Concept Consulting',
      consultingLead: 'A recipe for success: Our automation expertise and your process knowledge.',
      consultingDescription: 'We support our customers from planning through control cabinet construction to the development and integration of control software. Our project engineers advise you from the very first planning and design phase, accompany you during construction and on-site installation, and remain at your side throughout ongoing operation after commissioning. Thanks to our flexibility, we deliver end-to-end automation solutions that work reliably, integrate seamlessly into existing systems and implement your individual requirements with the highest level of reliability.',
      consultingChapterLabel: '01 — Before we build',
      consultingHighlight: 'Our automation expertise and your process knowledge',
      consultingStats: [
        { value: '50+', label: 'Years of experience in industrial automation' },
        { value: '360°', label: 'Support from planning to operation' },
        { value: '1:1', label: 'A personal contact throughout the project' },
      ],
      consultingServicesTitle: 'Our range of services includes',
      consultingServices: [
        { title: 'Requirements analysis', description: 'We capture your goals, constraints, and technical specifications in a structured way.' },
        { title: 'Analysis of existing systems', description: 'We assess your current infrastructure and identify potential for optimization.' },
        { title: 'System-neutral consulting', description: 'Independent recommendations – we choose the right solution for you, not a specific brand.' },
        { title: 'Specifications & concept', description: 'We develop a precise specification document as the reliable basis for your project.' },
        { title: 'Project management', description: 'Clear responsibilities, deadlines, and communication – from kick-off to handover.' },
      ],
      services: {
        schaltschrankbau: { title: 'Control Cabinet Construction', description: 'Production-ready from unit 1 – tested, documented, scalable.' },
        hardware: { title: 'Hardware Engineering', description: 'EMC-compliant design, safety, and standards-compliant documentation.' },
        software: { title: 'Software Engineering', description: 'Stable programs, clean HMI, IIoT-ready.' }
      }
    },
    homepageContact: {
      title: 'Ready for the next step?',
      button: 'Tell us about your project'
    },
    teamPage: {
      heroTitle: 'Team',
      heroSubtitle: 'Our contact persons are happy to help you.',
      followUs: 'Follow us'
    },
    careersPage: {
      hero: {
        title: 'Your next step',
        subtitle: 'Flexibility & Responsibility',
        description: 'As a regionally anchored employer with international activities, we offer exciting tasks, reliable conditions, and real perspectives – from entry to specialization.'
      },
      intro: {
        title: 'Your place at Althaus',
        description: 'Technology doesn\'t happen by itself. It\'s created by people who think ahead, take action and develop solutions together. For over 50 years, Althaus has stood for automation from Switzerland. Behind every project are dedicated employees who contribute their expertise and take responsibility. With us, you\'ll find an environment where you can develop, contribute your ideas and shape the future together with us.'
      },
      imageStatement: {
        title: '160 employees plan, build, and realize automation.',
        description: 'Production experience and the ambition to get better every day. We live this attitude in strong partnerships and with a clear promise: We listen, think ahead, and deliver quality that lasts.'
      },
      benefits: {
        title: 'Why work with us?',
        subtitle: 'This is what makes us an attractive employer',
        items: [
          { title: 'Family work atmosphere', description: 'Everyone counts with us – a team that sticks together and supports each other.' },
          { title: 'Flexible working hours', description: 'Work-life balance is not just a buzzword, but lived reality with us.' },
          { title: 'Exciting projects', description: 'Varied tasks in automation – from idea to implementation.' },
          { title: 'Career & Development', description: 'We support your development with internal training and advancement opportunities.' },
          { title: 'Secure future', description: 'A stable company with over 50 years of experience and positive growth.' },
          { title: 'Top workplaces', description: 'Modern infrastructure, latest technologies, and a pleasant work environment.' },
          { title: '27 vacation days', description: 'More time for relaxation, travel, and everything that matters to you. With 27 vacation days, work-life balance stays on track.' },
          { title: '40-hour week', description: 'Clear structures for work and leisure. With a 40-hour week, we create predictability and balance.' },
          { title: 'Subsidized employee meals', description: 'Great food at fair prices. With subsidized meal options, enjoyment is part of everyday work life.' }
        ]
      },
      education: {
        title: 'Education & Training',
        description: 'Through targeted education and training programs, we contribute to the continuous professional and personal development of our employees. Education holds a high priority at W. Althaus AG in general. As a training company, we invest heavily in developing young talent and enabling young adults to enter the professional world. We currently train 28 apprentices in the professions of automation technician, automation assembler, commercial employee, and logistics specialist.'
      },
      modernWork: {
        title: 'Working in a state-of-the-art environment',
        description: 'From automated control cabinet construction to modern workplaces. You work with current technology, clear standards, and a team that lives innovation.'
      },
      cta: {
        title: 'Become part of our team',
        description: 'Looking for a challenge and team spirit? Grow with us and share in our success.',
        button: 'View open positions'
      }
    },
    aboutPage: {
      hero: {
        title: 'Regionally rooted,',
        subtitle: 'globally deployed.',
        description: 'Since 1968, we have been combining know-how, engineering, and automation into holistic control cabinet solutions – precise, well-thought-out, reliable.'
      },
      intro: {
        leadingIn: 'Leading in Automation',
        paragraphs: [
          'We are a Swiss family business that was founded in 1968 in Aarwangen in the canton of Bern. Today, over 160 employees work at two locations, and W. Althaus AG is considered an important and pioneering employer in the region.',
          'Our core competency lies in the development and production of the simplest electrical controls to complex automation solutions.',
          'With 50 years of experience in industrial automation, we are specialists in developing customized solutions for industry. As a full-service company, we offer a comprehensive solution package with our broad service offering in concept consulting, hardware software engineering, control cabinet construction, terminal strip production, assembly group assembly, assembly support, commissioning, and training.'
        ]
      },
      stats: {
        founded: { value: '1968', label: 'Founded' },
        employees: { value: '160+', label: 'Employees' },
        area: { value: "6,000m²", label: 'Production area' },
        cabinets: { value: "10,000+", label: 'Cabinets/year' }
      },
      history: {
        title: 'Our History',
        subtitle: 'From a one-man operation to Switzerland\'s leading control cabinet builder – discover our milestones.',
        milestones: [
          { year: '1968', title: 'Foundation', description: 'Walter Althaus Sr. starts as a sole proprietor in Aarwangen. From humble beginnings, a Swiss family business emerges step by step, consistently evolving and continuously growing.' },
          { year: '1970s', title: 'First control cabinet production', description: 'In the 1970s, control cabinet production begins. From building simple controls, the company develops into a specialist for complete, documented automation solutions. Technical expertise is systematically expanded, laying the foundation for further expansion.' },
          { year: '1980s', title: 'Production expansion & ECAD entry', description: 'The production area on Jurastrasse is expanded from 400 to 800 square meters, responding to increasing demand and growing project volumes.\n\nAt the same time, the company enters computer-aided design with an ECAD program. The digitization of planning begins, increasing efficiency and quality in project execution.' },
          { year: '1990s', title: 'Expansion, automation & generational change', description: 'Office space is expanded with the construction of a second floor. The introduction of the first EPLAN system further professionalizes and standardizes electrical engineering planning.\n\nFirst automated processes are implemented. Wire processing machines are deployed, significantly increasing production productivity.\n\nIn the mid-1990s, Walter Althaus Jr. takes over management and leads the company into the next development phase.' },
          { year: '1998', title: 'Fully automated testing system', description: 'With the first fully automated testing system for control cabinets, W. Althaus AG early on embraces automated quality assurance. This milestone strengthens process reliability and ensures consistent testing quality.' },
          { year: '2000s', title: 'Automation & site relocation', description: 'Production is gradually further automated. Sheet metal processing in particular is increasingly machine-supported and integrated into efficient process chains.\n\nThe production area on Jurastrasse reaches its limits. Manufacturing is therefore relocated from the village to the industrial area of Aarwangen. Between 2007 and 2011, four additional halls are built at the new location, creating the infrastructure for further growth.' },
          { year: '2005', title: 'Entry into 3D engineering', description: 'The launch of 3D engineering with the development of a digital data foundation marks a decisive step toward connected planning and manufacturing. This creates the basis for seamless processes from engineering to production.' },
          { year: '2008', title: 'First terminal assembly machine', description: 'With the development of the first proprietary terminal assembly machine, W. Althaus AG purposefully advances automation. Manual work steps are reduced, processes accelerated, and reproducibility further improved.' },
          { year: '2010s', title: 'Investments in automation & digitization', description: 'Existing automation systems are modernized and expanded. Production processes are digitized, standardized, and consistently optimized. The focus is on seamless data flows and efficient manufacturing along the entire value chain.' },
          { year: '2018', title: 'Development of a new wiring robot', description: 'With the start of developing a new collaborative wiring robot system, W. Althaus AG consistently expands its automation expertise. This milestone demonstrates the ambition to purposefully develop innovative robotics solutions for the requirements of modern control cabinet manufacturing.' },
          { year: '2020s', title: 'Growth & new leadership', description: 'The company grows to over 160 employees. Automation expertise, production experience, and continuous process improvement define the company\'s identity.\n\nIn the early 2020s, Marco Schneider takes over as CEO and continues to lead the company strategically.' },
          { year: '2025', title: 'Rittal + Eplan Application Center Partner', description: 'As the first Rittal + Eplan Application Center Partner in Switzerland, the company receives official recognition. This partnership underscores the consistent focus on data-driven processes in control and switchgear construction and confirms the technological leadership in integrated engineering and manufacturing solutions.' }
        ]
      },
      values: {
        title: 'Our Values',
        subtitle: 'What drives us and how we work – three principles that shape our actions.',
        items: [
          { title: 'Quality', subtitle: 'We deliver quality that lasts', description: 'Every control cabinet, every solution – precisely manufactured and thought through to the last detail. Our standard: Zero compromises.' },
          { title: 'Partnership', subtitle: 'We listen and think ahead', description: 'Long-term relationships instead of short-term deals. We understand our customers\' challenges and develop solutions together.' },
          { title: 'Innovation', subtitle: 'Getting better every day', description: 'Standing still means falling behind. We continuously invest in new technologies, processes, and the development of our team.' }
        ]
      },
      regionalEngagement: {
        title: 'Regional Engagement',
        paragraphs: [
          'As a company deeply rooted in the region, it is important to us to contribute not only economically but also socially. That is why we support associations, projects and events in the region around Aarwangen.',
          'Our sponsorship is primarily aimed at local clubs and events that strengthen village and community life through their commitment. Whether it is a sporting event, a cultural project or a community gathering, we want to help make such initiatives possible and bring people in the region together.',
          'We are convinced that a vibrant club scene makes an important contribution to regional identity. That is why we support selected causes where they have an impact: directly on the ground, with the people and organisations in our surroundings.'
        ],
        supportedTitle: 'Clubs and events we have had the pleasure of supporting'
      },
    },
    sustainabilityPage: {
      hero: {
        title: 'Responsibility for',
        subtitle: 'Environment, Society & Future',
        description: 'As a Swiss family business, we act responsibly – for our environment, our region, and future generations.'
      },
      intro: {
        title: 'Responsible. Future-oriented.',
        subtitle: 'Althaus',
        titleSuffix: '– Sustainability with system.',
        paragraphs: [
          'For us, sustainability means more than environmental protection. We think ecologically, economically, and socially – holistically along the entire product lifecycle. Through digitized processes, ECAD engineering, and highly automated production, we reduce waste, material usage, and lead times – from the first piece onwards.',
          'In 2024, we were awarded the Committed badge by EcoVadis – a confirmation of our continuous commitment. The areas of environment, labor & human rights, ethics, and sustainable procurement were evaluated. In environment, labor & human rights, and ethics, we are above the industry average. Additionally, we secure quality and environmental performance with our management systems according to ISO 9001 and ISO 14001 and continuously improve both.',
          'We consistently meet all legal requirements including material compliance and go further according to the principle reduce, reuse, recycle. We use resource-intensive copper particularly efficiently. With operational optimizations and regular system maintenance, we increase energy efficiency, our pool of electric vehicles reduces fuel demand, and PV systems on our roofs strengthen the carbon footprint in the power grid. Together with our customers, suppliers, and partners, we identify additional potential for more sustainable solutions in Swiss quality.'
        ]
      },
      metrics: {
        title: 'Numbers and Goals',
        items: [
          { value: '95%', label: 'Automation level' },
          
          { value: '40%', label: 'Solar energy' },
          { value: '2030', label: 'Carbon neutral' }
        ]
      },
      impact: {
        title: 'Sustainability with impact',
        description: 'We combine ecological, social, and economic responsibility with measurable results. Certified according to ISO 9001/14001 and confirmed by EcoVadis (Committed 2024) – efficient, transparent, future-oriented.'
      },
      achievements: {
        title: 'Our sustainability initiatives',
        categories: [],
        items: [
          { title: 'ISO 14001 Certification', subtitle: 'Certified environmental management system', description: 'Introduction and certification of our environmental management system according to ISO 14001 for continuous improvement of our environmental performance.' },
          { title: 'Own Solar Energy', subtitle: 'Photovoltaic systems at two locations', description: 'With photovoltaic systems at the production site (380 kWp) and headquarters (110 kWp), we generate part of our energy needs ourselves.' },
          { title: 'Energy Storage', subtitle: 'Battery storage at headquarters', description: 'An 80 kW battery storage system enables more efficient use of our self-generated solar energy.' },
          { title: 'Energy-Efficient Production', subtitle: 'Modern manufacturing technologies', description: 'The switch from CO2 laser cutting systems to modern fiber lasers reduces energy consumption while increasing production efficiency.' },
          { title: 'Intelligent Lighting', subtitle: 'LED with presence and daylight control', description: 'By switching to LED lighting with automatic presence and daylight control, we significantly reduce energy consumption in our buildings.' },
          { title: 'Electromobility', subtitle: 'Gradual conversion of the vehicle fleet', description: 'Part of our company vehicles are already electrically powered. The electrification of our fleet is being continuously expanded.' },
          { title: 'Sustainability as a Continuous Process', subtitle: 'Step by step to more efficiency', description: 'We continuously work to reduce our energy consumption and emissions. New technologies and optimizations are continuously evaluated and implemented.' }
        ]
      },
      outlook: {
        title: 'Outlook',
        headline: 'Sustainability – Agenda 2030',
        description: 'Our path to sustainable transformation – step by step towards measurable results and long-term impact.',
        milestones: [
          { year: '2026', title: 'GHG Accounting (Scope 1–3)', description: 'In 2026, the greenhouse gas accounting project according to the GHG Protocol (Scope 1, 2 and 3) will be launched and implemented with the evaluated external project partner. The company-wide GHG balance will be created, validated and documented.' },
          { year: '2027', title: 'Net-Zero Pathway', description: 'Building on the greenhouse gas accounting, a company-specific net-zero pathway will be defined in 2027. This includes concrete target years, reduction targets and prioritized measures for the gradual reduction of greenhouse gas emissions across Scope 1–3. The net-zero pathway will be adopted and integrated into relevant business processes.' },
          { year: '2028', title: 'Sustainability Report (VSME)', description: 'In 2028, a structured sustainability report will be created for the first time in accordance with VSME requirements. The report is based on existing environmental, climate and governance data, reflects the implementation status of the defined measures and ensures transparency towards relevant stakeholders.' },
          { year: '2029', title: 'Sustainability Strategy', description: 'By the end of 2029, a company-wide sustainability strategy will be developed, adopted and communicated. This builds on the results of the GHG accounting, the defined net-zero pathway, the sustainability reporting and the five central lever topics identified. The strategy defines long-term goals, prioritized fields of action, measures and responsibilities.' }
        ]
      }
    },
    vocationalTrainingPage: {
      hero: {
        title: 'Your training at Althaus',
        subtitle: 'Technology & Future',
        description: 'Automation technician, automation assembly technician, or logistics specialist – we train diversely and support you specifically on your way into the professional world.'
      },
      nachwuchs: {
        title: 'Young talent with a future',
        subtitle: 'For over 50 years, we have been training young talents – and are proud of every graduate.',
        stats: {
          graduates: { value: '120+', label: 'Successful graduates' },
          apprenticeships: { value: '3', label: 'Apprenticeships', description: 'Automation technician, automation assembly technician, and logistics specialist – three paths into the future.' },
          experience: { value: '50+', label: 'Years of experience', description: 'in training young professionals' }
        },
        cta: {
          title: 'Interested in a trial apprenticeship?',
          description: 'Get to know our company and the professions – register now.',
          button: 'To trial apprenticeship'
        }
      },
      intro: {
        title: 'We train professionals',
        paragraphs: [
          'We rely on solid and active vocational training to secure young talent. Our vocational training stands out through high-quality and varied training with extensive focus training.',
          'Training and supporting young professionals is for us the most important prerequisite for maintaining and strengthening Switzerland as a production location.'
        ]
      },
      openPositions: {
        title: 'Open Apprenticeships',
        subtitle: 'Overview of our training professions and availability'
      },
      badges: {
        available: 'Available',
        assigned: 'Assigned'
      },
      buttons: {
        learnMore: 'Learn more'
      },
      apprenticeships: {
        automatiker: {
          title: 'Automation Technician EFZ',
          duration: '4 years',
          description: 'As an automation technician, you work on the technology that controls machines, systems and automated production systems. Automation and robotics shape today\'s industry and you are right in the middle of it.',
          detailedDescription: 'At W. Althaus AG, you learn how electrical controls are planned, built and tested. You work on real projects and gain insight into modern automation solutions for machines and industrial systems.\n\nDuring your training, you get to know various areas, including control cabinet construction, testing department, robotics, electrical design, programming and industrial automation. In the third year of your apprenticeship, you can specialise further in software, hardware, electrical design or the testing department, depending on your interests and needs.',
          highlights: [
            'Build and wire electrical controls and control cabinets',
            'Assemble, connect and test electrical components',
            'Read circuit diagrams and understand technical documentation',
            'Gain insights into industrial automation and robotics',
            'Gain first experience in programming and your own projects',
            'Test controls and support troubleshooting'
          ],
          requirements: 'Secondary school with good performance in mathematics and physics and interest in technology and electronics.',
          career: 'Further training as HF technician or studies at a university of applied sciences in automation or electrical engineering.'
        },
        automatikmonteur: {
          title: 'Automation Assembly Technician EFZ',
          duration: '3 years',
          description: 'As an automation assembly technician, you work on the technology that connects machines and systems with electrical controls. You build and wire controls used in industry for automated production systems.',
          detailedDescription: 'At W. Althaus AG, you learn how control cabinets are built, wired and tested. You work directly in production and help assemble controls for machines and industrial systems step by step.\n\nDuring your training, you gain insight into various areas of control cabinet construction, including assembly, wiring and testing. You learn how individual components become functioning controls.',
          highlights: [
            'Build and wire control cabinets and electrical controls',
            'Assemble, connect and test electrical components',
            'Read circuit diagrams and understand technical documentation',
            'Test controls and identify simple faults',
            'Work in control cabinet construction and production'
          ],
          requirements: 'Secondary or secondary modern school and interest in technology and manual work.',
          career: 'Further training in electrical engineering and automation.'
        },
        logistiker: {
          title: 'Logistics Specialist EFZ',
          duration: '3 years',
          description: 'As a logistics specialist, you ensure that materials, components and products are in the right place at the right time. This keeps our production running and ensures all required components are available.',
          detailedDescription: 'At W. Althaus AG, you work with modern warehouse and logistics systems and always keep track of inventory and material flows. You receive goods, store them, prepare materials for production and organise the dispatch of finished products.\n\nDuring your training, you go through various areas in the warehouse, including goods receiving, inventory management, picking and shipping. Step by step, you learn how modern material flow works in an industrial company.',
          highlights: [
            'Receive, inspect and properly store goods',
            'Prepare materials for production and assembly',
            'Compile orders and prepare them for dispatch',
            'Manage inventory with modern digital systems',
            'Organise and coordinate transport within the company',
            'Work in areas such as goods receiving, inventory management, picking and shipping'
          ],
          requirements: 'Secondary or secondary modern school, organisational talent and enjoyment of practical work.',
          career: 'Further training as logistics specialist or specialisation in logistics or supply chain management.'
        }
      },
      detailedSection: {
        title: 'Our training professions in detail',
        whatYouLearn: 'What you will learn:',
        requirements: 'Requirements:',
        career: 'Career:'
      },
      quote: 'Your training is the beginning – let\'s shape your future together!',
      benefits: {
        title: 'Why us?',
        subtitle: 'These benefits await you in your training',
        items: [
          { title: 'Family environment', description: 'Personal support and a team that sticks together.' },
          { title: 'Practical training', description: 'From day one, you work on real customer projects.' },
          { title: 'Career opportunities', description: 'Takeover opportunities and support for further education after the apprenticeship.' },
          { title: 'Secure future', description: 'A stable company with over 50 years of experience.' },
          { title: 'Modern infrastructure', description: 'Work with the latest technologies and tools.' },
          { title: 'Experienced trainers', description: 'Qualified trainers accompany you on your way.' }
        ]
      },
      path: {
        title: 'The path to an apprenticeship',
        subtitle: 'In four steps to your training at Althaus',
        steps: [
          { title: 'Get informed', description: 'Explore various professional fields and their requirements on our website and with counseling services.' },
          { title: 'Trial apprenticeship', description: 'Apply for a 2-day trial apprenticeship and get to know the profession and our company.' },
          { title: 'Application', description: 'Send us your complete documents: cover letter, CV, photo, and certificates.' },
          { title: 'Start of apprenticeship', description: 'After successful application, you start your training with us in August.' }
        ]
      },
      events: {
        title: 'Our Events',
        subtitle: 'Trial days, information events, and more',
        viewAll: 'View all vocational training news'
      },
      form: {
        title: 'Request trial apprenticeship',
        subtitle: 'Get to know the profession and our company during a 2-day trial apprenticeship',
        sections: {
          personal: 'Personal details',
          school: 'School',
          apprenticeship: 'Trial apprenticeship'
        },
        fields: {
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          phone: 'Phone',
          birthDate: 'Date of birth',
          shoeSize: 'Shoe size',
          street: 'Street',
          city: 'Postal code / City',
          school: 'Current school',
          schoolYear: 'School class',
          desiredProfession: 'Desired profession',
          desiredApprenticeshipStart: 'Desired apprenticeship start',
          desiredDate: 'Preferred date within the selected range',
          preferredPeriod: 'Preferred week (Mon–Fri)',
          referralSource: 'How did you hear about us?',
          message: 'Comments / Motivation'
        },
        placeholders: {
          shoeSize: 'e.g. 42',
          city: 'e.g. 4912 Aarwangen',
          schoolYear: 'e.g. 8th grade secondary',
          selectProfession: 'Select profession',
          selectApprenticeshipStart: 'Select start date',
          selectPeriod: 'Select week',
          referralSource: 'e.g. recommendation, school, internet, social media…',
          message: 'Why are you interested in this profession? Do you have special requests?'
        },
        professions: {
          automatiker: 'Automation Technician EFZ (2 days)',
          automatikmonteur: 'Automation Assembly Technician EFZ (2 days)',
          logistiker: 'Logistics Specialist EFZ (2 days)'
        },
        periods: {
          fruehlingsferien: 'Spring holidays',
          sommerferien: 'Summer holidays',
          herbstferien: 'Autumn holidays',
          sonstiges: 'Other'
        },
        attachments: {
          title: 'Attachments for your trial apprenticeship application',
          intro: 'Please upload the following documents so we can review your application:',
          bullet1: 'CV with a recent photo',
          bullet2: 'Short motivation letter explaining why you are interested in this trial apprenticeship',
          bullet3: 'Copies of your school reports from the last two years',
          pdfHint: 'Please make sure all documents are in PDF format (max. 15 MB in total). All information will of course be treated confidentially.',
          cvLabel: 'CV (PDF)',
          motivationLabel: 'Motivation letter (PDF)',
          certificatesLabel: 'School reports of the last 2 years (PDF)',
          notesLabel: 'Free text / Other',
          notesPlaceholder: 'Additional information you would like to share…'
        },
        submitted: {
          title: 'Your application has been received',
          text: 'Thank you for your trial apprenticeship application.\nWe have received your documents and will get back to you in the next few days.',
          contactBefore: 'If you have any questions, feel free to contact us at ',
          contactAfter: '.',
          insightsTitle: 'Insights into our vocational training',
          newApplication: 'Submit another application'
        },
        privacy: 'I accept the {link} and agree that my data will be used to process my request.',
        privacyLink: 'Privacy Policy',
        submit: 'Request trial apprenticeship',
        toast: {
          error: 'Please accept the privacy policy',
          missingDocuments: 'Please upload all three documents (PDF).',
          tooLarge: 'The documents together are too large (max. 15 MB).',
          notPdf: '"{name}" is not a PDF. Please upload PDF files only.',
          success: 'Your request has been sent! We will get back to you.'
        }
      },
      cta: {
        title: 'Ready to start?',
        description: 'Apply now for an apprenticeship at W. Althaus AG and become part of the future of automation.',
        contactTitle: 'Head of Vocational Training'
      }
    },
    productsPage: {
      title: 'Products',
      subtitle: 'Innovative automation solutions for maximum efficiency',
      athex: { name: 'Athex', title: 'Terminal strip manufacturing' },
      panelscout: { name: 'Panelscout', title: 'Test control' }
    },
    leitbildPage: {
      hero: { title: 'Leading in Automation', subtitle: 'Quality & Trust', description: '"Leading in Automation" means to us: delivering highly automated and innovative technology and products "made in Switzerland" to any place in the world at any time. In doing so, we cultivate a sustainable partnership with all our stakeholders.' },
      intro: {
        title: 'Reliable. Innovative.',
        highlight: 'Althaus',
        suffix: '– Your partner for industrial automation.',
        paragraphs: [
          'At the heart of our activity is creating seamless, high-quality, and sustainable industrial automation. We plan and manufacture products in compliance with applicable standards, regulations, and guidelines.',
          'Our state-of-the-art infrastructure forms the stable foundation for quality and efficiency. In organized production environments, automation solutions are created that set standards and actively promote innovation. Here, digitized processes, ECAD engineering, and manufacturing automation seamlessly interlock – from the very first piece.',
          'Equally important: Communication & teamwork. In our modern meeting rooms, ideas are sharpened, decisions are made, and projects are set on a course for success. Interdisciplinary teams of software, hardware, and mechatronics specialists plan together, think ahead, and deliver reliably.',
          'And because peak performance needs a good environment, we design workplaces of the future: Ergonomic, inspiring, and designed for focused collaboration. This is how creative, technical solutions emerge in productive co-creation – fast, flexible, and in Swiss quality.'
        ]
      },
      values: {
        trust: { title: 'Trust, Continuity, and Competence', description: 'Automation also means continuity for us. With our employees, customers, partners, and suppliers, we maintain a long-term and trustful partnership characterized by high competence.' },
        quality: { title: 'Quality for the Customer', description: 'We owe the success of our company essentially to individual customer solutions and high product quality, which we achieve through our high degree of automation and optimal manufacturing depth. Throughout the entire product lifecycle, we support our customers with solutions tailored to their needs. We plan and manufacture products in compliance with applicable standards, regulations, and guidelines.' }
      },
      cta: 'View our BigPicture'
    },
    chameleonPage: {
      heroTitle: 'Adaptive in Automation',
      heroSubtitle: 'Foresight & Precision',
      sections: [
        { title: 'Like a chameleon. Only industrial.', subtitle: 'We react quickly, stay in control, and deliver precise solutions – from the first concept to commissioning.', content: '' },
        { title: 'Seamless Adaptation – Tailored Solutions', content: 'A chameleon changes color to blend seamlessly into its environment. We change perspective to fit perfectly: single piece, batch size, series production, or retrofit – we map variants precisely and modularly. Our solutions follow standards, guidelines, and customer specifications – without compromise. Result: Perfect fit instead of adaptation effort.' },
        { title: 'Full Overview – Planning with Foresight', content: 'The chameleon sees with both eyes independently – perceiving details without losing the overall context. That\'s how we see projects. In the concept phase, we illuminate the project landscape, prioritize what matters, and align everything toward one goal: Impact instead of chance. The starting point is not gut feeling, but foresight and the courage to clearly name what\'s essential.' },
        { title: 'Focused Strike – Precise Processes', content: 'When the chameleon strikes, the moment is perfectly chosen. Overview becomes focus – ambition becomes a clear process. In implementation, every step counts. Networked and parallel processes, fully automated and digitally controlled workflows ensure speed with precision. We shorten paths, avoid friction, increase repeatability – fast, but never reckless.' },
        { title: 'Firm Grip – Quality Down to the Detail', content: 'Gripping feet and tail give the chameleon stability in any position. Our stability comes from the depth of details: Flexible manufacturing depth, clear communication channels, seamless integration, shared focus, and everything from one source – flexibility down to the last wire. This keeps everything solid, traceable, and service-friendly for years – quality you can feel.' },
        { title: 'Perfect Camouflage – Seamless Integration', content: 'Camouflage for the chameleon is not a trick, but a strategy. For us, it means partnership: We integrate flexibly, precisely, and reliably into your supply chain – throughout the entire lifecycle. From project planning through production to after-sales support. Your product takes center stage. We work in the background – visible only through the results.' },
        { title: 'Constant Renewal – Change in DNA', content: 'The chameleon sheds its skin to stay agile, adapt, and grow. We evolve the same way: Not reacting, but acting as part of our DNA. Since 1968, we have been advancing automation, processes, standards, and routines – supported by two locations and over 160 employees. This keeps proven methods stable while new ones can be quickly integrated. Change for us is not a project, but a lived culture.' }
      ],
      cta: { title: 'Ready for a color change?', subtitle: 'Let us bring your project to the right tone.', button: 'Get in touch' }
    },
    documentsPage: {
      title: 'Documents',
      subtitle: 'Here you will find all important documents, certificates, and materials from W. Althaus AG for download.',
      categories: [
        { title: 'Company', documents: [{ name: 'Logo (.png)', url: '/documents/W_Althaus_AG_Logo.png' }, { name: 'Company data', url: '/documents/Firmendaten_2026.pdf' }, { name: 'Organization Chart', url: '/documents/organigramm.pdf' }] },
        { title: 'Values & Culture', documents: [{ name: 'Mission Statement (BigPicture)', url: '/documents/Althaus_Wertehaus_Bigpicture_2024.pdf' }, { name: 'Code of Conduct', url: '/documents/Verhaltenskodex_W._Althaus_AG.pdf' }] },
        { title: 'Purchasing & Delivery Conditions', documents: [{ name: 'General Purchasing Conditions (Deutsch)', url: '/documents/Allgemeine_Einkaufsbedingungen.pdf' }, { name: 'General Purchasing Conditions (English)', url: '/documents/General_Terms_and_Conditions_of_Purchase.pdf' }, { name: 'General Purchasing Conditions (Français)', url: '/documents/Conditions_generales_d_achat.pdf' }, { name: 'General Delivery Conditions', url: '/documents/W._Althaus_AG_Allgemeine_Lieferbedingungen.pdf' }] },
        { title: 'ISO Certifications', documents: [{ name: 'ISO 9001:2015 / ISO 14001:2015 (German)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_DE.pdf' }, { name: 'ISO 9001:2015 / ISO 14001:2015 (English)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_EN.pdf' }] },
        { title: 'Sustainability Certificates', documents: [{ name: 'Voluntary Climate Protection and Energy Efficiency', url: '/documents/Zertifikat_Energie-Agentur_der_Wirtschaft.pdf' }, { name: 'EcoVadis Sustainability Certificate', url: '/documents/Ecovadis_W._Althaus_AG.pdf' }] },
        { title: 'Standards & Associations', documents: [{ name: 'UL-Certificate', url: '/documents/Certificate_of_Compliance_UL.pdf' }, { name: 'EKAS Certificate VSAS', url: '/documents/EKAS_Zertifikat_VSAS.pdf' }] }
      ],
      contactNote: 'Do you need additional documents or have questions about our materials? Feel free to contact us at'
    },
    imprintPage: {
      title: 'Imprint',
      contact: { title: 'Contact' },
      register: { title: 'Commercial Register Entry', company: 'Registered company name: W. Althaus AG', number: 'Number: CHE‑375.798.234', office: 'Commercial Register Office of the Canton of Bern' },
      vat: { title: 'VAT Number', number: 'CHE-375.798.234 VAT' },
      disclaimer: { title: 'Disclaimer', paragraphs: ['W. Althaus AG assumes no liability for the accuracy, correctness, timeliness, reliability, or completeness of the information.', 'Liability claims against the author for damages of a material or immaterial nature arising from access to, use of, or non-use of the published information, through misuse of the connection, or due to technical malfunctions are excluded.', 'All offers are non-binding. The author expressly reserves the right to change, supplement, or delete parts of the pages or the entire offer without separate announcement, or to temporarily or permanently cease publication.'] },
      links: { title: 'Liability for Links', text: 'References and links to third-party websites are outside our area of responsibility. Any responsibility for such websites is rejected. Access to and use of such websites is at the user\'s own risk.' },
      copyright: { title: 'Copyright', text: 'The copyright and all other rights to content, images, photos, or other files on the website belong exclusively to W. Althaus AG or the specifically named rights holders. Written consent of the copyright holders must be obtained in advance for the reproduction of any elements.' }
    },
    privacyPage: {
      title: 'Privacy Policy',
      sections: [
        { title: 'Scope', content: ['This privacy policy informs users about the nature, scope, and purposes of the collection and use of personal data.'] },
        { title: 'Contact Address', content: ['If you would like more information about data protection, please contact our data protection officer via email.', 'Contact: {email}', 'When contacting the provider (e.g., via contact form or email), the user\'s details are stored for the purpose of processing the request and in case follow-up questions arise.'] },
        { title: 'Data Protection / Access Data', content: ['Based on Article 13 of the Swiss Federal Constitution and the data protection provisions of the federal government (Data Protection Act, DSG), every person is entitled to protection of their privacy and protection against misuse of their personal data. We comply with these provisions. Personal data is treated strictly confidentially and is neither sold nor passed on to third parties.', 'In close cooperation with our hosting providers, we strive to protect the databases as well as possible against unauthorized access, loss, misuse, or falsification.', 'When accessing our websites, the following data is stored in log files: IP address, date, time, browser request, and general information about the operating system or browser. This usage data forms the basis for statistical, anonymous evaluations so that trends can be identified and we can improve our offerings accordingly.'] },
        { title: 'Privacy Policy for the Use of Google Analytics', content: ['This website uses Google Analytics, a web analytics service provided by Google Inc. ("Google"). Google Analytics uses "cookies," text files that are stored on your computer and enable analysis of your use of the website.', 'Google will use this information to evaluate your use of the website, to compile reports on website activities for website operators, and to provide other services related to website and internet usage.', 'You can prevent the installation of cookies by setting your browser software accordingly; however, we point out that in this case you may not be able to use all functions of this website to their full extent.'] },
        { title: 'Handling of Personal Data', content: ['Personal data is information that can be used to identify a person, i.e., information that can be traced back to a person. This includes name, email address, or telephone number.', 'Personal data is only collected, used, and passed on by the provider if this is permitted by law or if users consent to data collection.'] },
        { title: 'Privacy Policy for Online Applications', content: ['The protection of your personal data is important to us. You acknowledge the privacy information by checking the designated checkbox when registering for the online application.', 'We collect and process personal data from applicants for the purpose of processing the application procedure.'] },
        { title: 'Cookies', content: ['This website uses cookies. Cookies are small text files that are permanently or temporarily stored on your computer when you visit this website. The purpose of cookies is in particular the analysis of the use of this website for statistical evaluation and for continuous improvements.', 'You can deactivate cookies in your browser settings at any time, in whole or in part. With deactivated cookies, not all functions of this website may be available to you.'] },
        { title: 'Revocation, Changes, Corrections, and Updates', content: ['The user has the right to request free information about the personal data stored about them. In addition, the user has the right to correct inaccurate data, block and delete their personal data, provided there is no legal obligation to retain it.', 'Contact: {email}'] }
      ]
    },
    welcomeSection: {
      text: 'W. Althaus AG – Leading in Automation since 1968.'
    },
    athexPage: {
      tagline: 'automated. precise. Althaus.',
      heroDescription: 'With {product}, we are revolutionizing terminal strip manufacturing. Our fully automated system produces terminal strips with the highest precision – faster, more error-free, and more economical than ever before.',
      cards: [
        { title: 'What is Athex?', text: 'Athex is our proprietary system for fully automated terminal strip manufacturing. From assembly to the finished terminal strip – everything in one continuous, digitized process. This drastically reduces lead times and eliminates manual error sources.' },
        { title: 'State-of-the-Art Technology', text: 'Athex uses ECAD data directly from ePlan and E3 for automatic assembly. Intelligent algorithms optimize the sequence, minimize setup times, and maximize utilization. The result: series-quality from batch size 1.' },
        { title: 'Your Benefits', text: 'Highest precision through fully automated manufacturing. Drastically reduced lead times. Zero manual error sources. Flexible manufacturing from single pieces to series. Full integration into your ECAD workflow. Traceability of every single terminal.' }
      ],
      functionsTitle: 'Athex Functions',
      functions: {
        ecad: { name: 'ECAD Integration', description: 'Direct data transfer from ePlan P8, ePlan Pro Panel, and E3.series for seamless automation.' },
        automated: { name: 'Fully Automated', description: 'From the bill of materials to the finished terminal strip without manual intervention.' },
        errorFree: { name: 'Error-Free Production', description: 'Elimination of manual error sources through end-to-end digitization.' },
        fast: { name: 'Fast Lead Times', description: 'Drastically reduced manufacturing times through optimized process sequences.' },
        flexible: { name: 'Flexible Quantities', description: 'Economical manufacturing from single pieces to large series.' },
        traceability: { name: 'Traceability', description: 'Complete documentation and tracking of every single component.' }
      },
      valueTitle: 'Your Value with Athex',
      values: [
        { title: 'Speed', description: 'Up to 80% faster lead times compared to manual manufacturing.' },
        { title: 'Quality', description: 'Consistently high quality through fully automated, error-free processes.' },
        { title: 'Flexibility', description: 'Economical manufacturing from batch size 1 to large series.' },
        { title: 'Integration', description: 'Seamless connection to your existing ECAD systems.' }
      ]
    },
    panelscoutPage: {
      tagline: 'intelligent. reliable. Althaus.',
      heroDescription: 'With {product}, we bring intelligent test control to your control cabinet construction. Our system tests, documents, and logs – fully automatically and without gaps.',
      cards: [
        { title: 'What is Panelscout?', text: 'Panelscout is our intelligent test control system for control cabinets and electrical systems. It performs automated functional tests, documents all measured values, and creates complete test protocols – for maximum safety and quality.' },
        { title: 'Intelligent Test Logic', text: 'Panelscout uses adaptive test routines that automatically adapt to your control cabinet design. The software detects wiring errors, tests insulation resistance, and checks functional sequences – all fully automated and standards-compliant.' },
        { title: 'Your Benefits', text: 'Complete quality assurance through automated testing. Standards-compliant documentation of all measured values. Early error detection before delivery. Reduced test times with simultaneously greater test depth. Full traceability of all test results.' }
      ],
      functionsTitle: 'Panelscout Functions',
      functions: {
        testing: { name: 'Automatic Testing', description: 'Fully automated functional and safety tests according to current standards.' },
        documentation: { name: 'Complete Documentation', description: 'Automatic logging of all measured values and test results.' },
        errorDetection: { name: 'Error Detection', description: 'Early identification of wiring errors and defects.' },
        compliance: { name: 'Standards Compliance', description: 'Testing according to IEC, EN, and other relevant industry standards.' },
        speed: { name: 'Fast Test Times', description: 'Optimized test routines for maximum efficiency with highest quality.' },
        traceability: { name: 'Traceability', description: 'Complete tracking of all test results for every project.' }
      },
      valueTitle: 'Your Value with Panelscout',
      values: [
        { title: 'Safety', description: 'Comprehensive testing ensures the highest operational safety of your systems.' },
        { title: 'Quality', description: 'Automated testing guarantees consistently high quality standards.' },
        { title: 'Efficiency', description: 'Faster test times with simultaneously deeper testing of all components.' },
        { title: 'Documentation', description: 'Standards-compliant protocols for certification and warranty.' }
      ]
    },
    hardwareEngineeringPage: {
      tagline: 'modular. standards-compliant. Althaus.',
      heroDescription: 'We develop intelligent hardware solutions for your automation. From concept to implementation with cutting-edge technologies.',
      featureCards: [
        { title: 'What you get at Althaus', description: 'We develop hardware and control concepts for your systems and machines. Through modularization and Digital Twin, we create standardized, reusable building blocks, reduce engineering effort, and deliver production-ready data for direct control of our automated production.' },
        { title: 'From concept to commissioning', description: 'We model ECAD with ePlan P8/Pro Panel as a digital twin, modularize systems, design control cabinets including layout and wiring routing, meet EN/UL/CSA standards, ensure functional safety, deliver manufacturing data, and support testing, documentation, and handover.' },
        { title: 'How we work', description: 'We define goals, standards, and interfaces in close collaboration, modularize your system for reusability, and develop standards-compliant control cabinet concepts. From risk assessment through manufacturing data to documentation and commissioning – everything from a single source.' }
      ],
      servicesTitle: 'Our service portfolio includes',
      services: [
        { name: 'Concept consulting for electrical schematics', description: 'Professional consulting and creation of electrical schematics' },
        { name: 'CAD systems: ePlan P8, ePlan Pro Panel', description: 'Professional planning with state-of-the-art CAD tools' },
        { name: 'System modularization and automation', description: 'Modern automation for efficient system concepts' },
        { name: 'Control cabinet concept: design, layout', description: 'Precise design and optimal layout engineering' },
        { name: 'Standards/regulations: EN, UL, CSA', description: 'Full compliance with international standards' },
        { name: 'Safety concepts and risk assessment', description: 'Comprehensive safety analyses to the highest standards' }
      ],
      valueTitle: 'Your added value through Hardware Engineering',
      values: [
        { title: 'Consistent data basis', description: 'From the first schematic to commissioning – all data consistent and reusable.' },
        { title: 'Lower engineering costs', description: 'Thanks to standards, templates, and reuse, we significantly reduce effort.' },
        { title: 'Standards-compliant safety', description: 'Designed and documented for EN/UL/CSA international compliance.' },
        { title: 'Modular scalability', description: 'Reusable building blocks enable fast adaptations and extensions.' }
      ]
    },
    softwareEngineeringPage: {
      tagline: 'intelligent. intuitive. Althaus.',
      heroDescription: 'Our software engineers bring your machines to life. We develop intelligent software solutions for your automation. From concept to implementation – with cutting-edge technologies.',
      featureCards: [
        { title: 'What you get at Althaus', description: 'Our software engineers guide you from planning and concept to specifications, develop control-related software, intuitive HMI/SCADA, and custom SQL apps. System-neutral consulting and value engineering. Aligned with hardware engineering – for seamless data flows through to production and commissioning.' },
        { title: 'Scope of services - Competencies & Tools', description: 'Neutral analysis, architecture, and tech stack; prioritized functions for cycle time and stability; transparent project management. Intuitive UIs with alarms, recipes, audit trail; reliable PLC/Motion and safety. Worldwide commissioning plus service, monitoring, updates, and fast remote support.' },
        { title: 'How we work', description: 'From the first requirements analysis to worldwide commissioning. We clarify goals, technology stack, and interfaces, develop modular software architectures, and apply agile methods. Documentation, testing, and remote support ensure long-term reliability of your automation solution.' }
      ],
      servicesTitle: 'Our service portfolio includes',
      services: [
        { name: 'PLC/Motion Programming', description: 'Control programming for all common platforms' },
        { name: 'HMI/SCADA Development', description: 'Intuitive user interfaces with alarms & recipes' },
        { name: 'Database Applications', description: 'SQL Server applications with audit trail & reporting' },
        { name: 'Digital Twin & Simulation', description: 'Virtual commissioning & process optimization' },
        { name: 'Safety & Compliance', description: 'Safety programming according to current standards' },
        { name: 'Remote Service & Monitoring', description: 'Worldwide support and KPI monitoring' }
      ],
      valueTitle: 'Your added value through Software Engineering',
      values: [
        { title: 'Seamless integration', description: 'Seamless integration with hardware and Digital Twin for consistent data flows.' },
        { title: 'Time-to-Commission', description: 'Structured specifications and clean project management for fast commissioning.' },
        { title: 'Intuitive usability', description: 'Clear HMIs and comprehensive manuals for easy operation by your team.' },
        { title: 'Lifecycle support', description: 'Remote support and worldwide commissioning for long-term reliability.' }
      ]
    },
    contactPage: {
      formTitle: 'Contact Form',
      formSubtitle: 'Do you have questions about our services, a specific concern, or would you like to work with us? Share your request with us, and we will get back to you promptly.',
      directContact: {
        title: 'Direct Contact',
        description: 'Would you like to contact us directly? We are happy to assist you by phone or email.',
        phone: '+41 62 919 82 10',
        email: ''
      },
      departmentTitle: 'Contact by Department',
      departmentSubtitle: 'Contact the right department directly for your inquiry',
      departments: [
        { title: 'Sales', description: '' },
        { title: 'Purchasing', description: '' },
        { title: 'Careers', description: '' },
        { title: 'Marketing', description: '' }
      ]
    },
    anfahrtPage: {
      heroTitle: 'How to find us.',
      heroDescription: 'Our office building (headquarters) and our production facility are conveniently located, 10 minutes from the A1 motorway in Aarwangen. Our locations are also well connected and easily accessible by public transport.',
      locationsTitle: 'Our Locations',
      locations: [
        { title: 'Headquarters', country: 'Switzerland' },
        { title: 'Production', country: 'Switzerland' }
      ],
      openingHours: 'Opening Hours',
      openingHoursWarehouse: 'Goods Receiving Opening Hours',
      monThu: 'Monday to Thursday',
      friday: 'Friday',
      routePlanning: 'Plan Route',
      transportTitle: 'Getting Here',
      transportSubtitle: 'Various ways lead to us – choose the best option for you',
      carTab: 'Car',
      publicTransportTab: 'Public Transport',
      carDirections: [
        { title: 'Headquarters', description: 'From the A1 motorway, take the Aarwangen exit. Follow the signs towards Aarwangen village. Our headquarters is located at Jurastrasse 12. Parking is available directly in front of the building.' },
        { title: 'Production', description: 'From the A1 motorway, take the Aarwangen exit. Follow the signs towards the industrial area. You will find our production facility at Industriering 2. Ample parking is available on site.' }
      ],
      publicTransportDirections: [
        { title: 'Headquarters', description: 'The headquarters is just a <strong>2-minute walk</strong> from Aarwangen Dorf station. After leaving the station, simply follow Jurastrasse.' },
        { title: 'Production', description: 'The production facility is a <strong>10-minute walk</strong> from the Aarwangen Hard stop. Follow the signs towards the industrial area.' }
      ]
    },
    successStoriesPage: {
      heroSubtitle: 'from leading companies',
      heroDescription: 'Discover how we have helped our customers achieve measurable success',
      filterAll: 'All',
      projectServices: 'Project Services',
      readCaseStudy: 'Read Case Study',
      employees: 'Employees',
      quotes: {
        guedel: 'Through standardization and the Digital Twin, we received near-series quality from the very first batch. Changes shortly before delivery were possible without schedule delays.',
        cwa: 'Thanks to W. Althaus AG, we streamlined processes: The delivered control cabinets were fully tested, documented, and ready to install. When changes occur, W. Althaus AG responds quickly and flexibly.',
        haefely: 'With W. Althaus AG, we were able to commission our test environments faster: The control cabinets arrived tested, traceable, and ready to install. The team always showed flexibility and solution orientation when changes were needed.',
        fondarex: 'ePlan macros and template control cabinets cut our engineering time in half – new machines now go into series production much faster.',
        bunorm: 'The EN/UL/CSA-compliant design including risk assessment noticeably shortened our approval process.',
        zehndersommer: 'With Digital Twin and ready manufacturing data, the transition to control cabinet construction was seamless – changes remained on schedule.',
        emmi: 'Remote support and clear documentation kept the system stable – updates without downtime drama.',
        kadi: 'The SQL-based recipe management with audit trail creates transparency – reports at the push of a button, validation-ready.',
        cerex: 'The specifications and HMI flows shortened commissioning. Operators found their way immediately, change requests were implemented quickly.'
      },
      positions: {
        guedel: 'Head of Supply Chain Management, Güdel AG',
        cwa: 'Operational Purchasing, CWA AG',
        haefely: 'Manager Purchasing, HAEFELY AG',
        fondarex: 'Head of Electrical Engineering, Fondarex AG',
        bunorm: 'Managing Director, Bunorm Maschinenbau AG',
        zehndersommer: 'Electrical Innovation, Zehnder & Sommer AG',
        emmi: 'Team Leader, Emmi Schweiz AG',
        kadi: 'Project Manager, KADI AG',
        cerex: 'Technical Director, CEREX AG'
      },
      industries: {
        guedel: 'Mechanical Engineering',
        cwa: 'Passenger Transport Construction',
        haefely: 'Test Systems Manufacturing',
        fondarex: 'Mechanical Engineering',
        bunorm: 'Mechanical Engineering',
        zehndersommer: 'Press Feed Systems',
        emmi: 'Food Industry',
        kadi: 'Food Industry',
        cerex: 'Mechanical Engineering'
      }
    },
    jobOpeningsPage: {
      title: 'Job Openings',
      subtitle: 'Find your next challenge at W. Althaus AG',
      yourTasks: 'Your tasks:',
      learnMore: 'Learn more',
      noJobTitle: 'No suitable position found?',
      noJobDescription: 'We welcome your unsolicited application and will be happy to check whether we have a suitable position for you.',
      sendApplication: 'Send unsolicited application',
      startDate: 'Immediately or by arrangement',
      jobs: [
        {
          title: 'HR & Finance Administrator (m/f/d)',
          department: 'Administration',
          description: 'Support our team in Human Resources and Finance. You will take on versatile administrative tasks and contribute to smooth organizational operations.',
          tasks: ['Support in HR administration and recruitment processes', 'Assistance in financial accounting and payroll processing', 'Administrative tasks in HR and Finance']
        },
        {
          title: 'Automation Engineer (m/f/d)',
          department: 'Engineering',
          description: 'Digitalization, automation or robotics – with us, you are right in the middle of it! We work with state-of-the-art tools and technologies. Join our motivated team and play a decisive role in shaping the future of development.',
          tasks: ['Independent development, implementation and commissioning of software automation solutions', 'PLC software and process visualizations on various systems', 'Project support and technical support']
        },
        {
          title: 'Automation Technician or Experienced Electrical Installer (m/f/d)',
          department: 'Production',
          description: 'Join our motivated team and play a decisive role in shaping the future of production. You are responsible for the entire manufacturing process from mechanical processing to wiring.',
          tasks: ['Manufacturing of control systems and switchgear of all kinds', 'Responsibility for the entire manufacturing process', 'Mechanical processing, assembly, and wiring of control cabinets']
        }
      ]
    }
  },
  fr: {
    crossIndustrySolutions: {
      title: 'Secteurs',
      description: 'Avec 50 ans d\'expérience dans l\'automatisation industrielle, nous sommes spécialistes dans le développement de solutions personnalisées et la fourniture de technologies innovantes à tout moment et en tout lieu dans le monde.',
      industries: {
        maschinenbau: 'Construction de machines et d\'installations',
        medizintechnik: 'Technologie médicale',
        energie: 'Énergie & Infrastructure',
        foodBeverage: 'Industrie alimentaire',
        transportation: 'Transport & Mobilité',
        erneuerbare: 'Énergies renouvelables'
      },
      moreIndustries: '... et bien d\'autres'
    },
    aboutPreview: {
      title: 'À propos',
      description: 'Nous sommes une entreprise familiale suisse fondée en 1968 à Aarwangen, dans le canton de Berne. Aujourd\'hui, plus de 160 collaboratrices et collaborateurs travaillent sur deux sites. W. Althaus AG est considérée comme un employeur important et visionnaire dans la région.',
      description2: 'Notre compétence clé réside dans le développement et la production de commandes électriques les plus simples jusqu\'aux solutions d\'automatisation les plus complexes.',
      learnMore: 'En savoir plus',
      production: 'Production',
      headquarters: 'Siège social',
      team: 'Équipe',
    },
    certificationsPartnerships: {
      title: 'Partenariats & Certifications',
      partnershipsLabel: 'Partenariats',
      certificationsLabel: 'Certifications',
      qualityManagement: 'Management de la qualité',
      environmentalManagement: 'Management environnemental',
      sustainabilityRating: 'Évaluation de durabilité',
      recognizedTrainingCompany: 'Entreprise formatrice reconnue'
    },
    footer: {
      headquarters: 'Siège social',
      production: 'Production',
      contact: 'Contact',
      phone: 'Téléphone',
      openingHours: {
        weekdays: 'Lundi au jeudi',
        friday: 'Vendredi'
      }
    },
    servicesSection: {
      title: 'Nos Services',
      servicesEyebrow: 'Du concept',
      subtitle: 'Avec l\'automatisation et la construction d\'armoires électriques 4.0, nous digitalisons vos idées pour votre avantage concurrentiel.',
      pageSubtitle: 'Avec l\'automatisation et la construction d\'armoires électriques 4.0, nous digitalisons vos idées pour votre avantage concurrentiel. Nous accompagnons nos clients de la planification à la construction d\'armoires électriques jusqu\'au développement et à l\'intégration du logiciel de commande. Ainsi naissent des solutions d\'automatisation complètes qui fonctionnent de manière fiable et s\'intègrent de manière flexible dans les systèmes existants.',
      heroTitle: 'Nos Services',
      heroSubtitle: 'Pensé de manière globale',
      ownDevelopmentsTitle: 'Nos propres développements',
      ownDevelopmentsDescription: 'Avec nos propres développements, nous créons des solutions intelligentes pour les processus modernes d\'ingénierie, de test et de fabrication. Ils aident à automatiser les flux de travail, à standardiser les étapes de test et à rendre les données exploitables de manière structurée. Le résultat : des systèmes fiables à forte valeur pratique qui s\'intègrent parfaitement dans les infrastructures existantes et optimisent durablement vos processus.',
      manifestEyebrow: '01 — Philosophie',
      manifestPart1: 'Une recette du succès : nos ',
      manifestHighlight1: 'compétences en automatisation',
      manifestPart2: ' et votre ',
      manifestHighlight2: 'connaissance des processus',
      manifestPart3: '.',
      consultingTitle: 'Conseil en conception',
      consultingLead: 'Une recette du succès : nos compétences en automatisation et votre connaissance des processus.',
      consultingDescription: 'Nous accompagnons nos clients de la planification à la construction d\'armoires électriques, jusqu\'au développement et à l\'intégration du logiciel de commande. Nos ingénieurs de projet vous conseillent dès la phase de planification et de conception, sont présents sur site pendant la construction et l\'installation et restent à vos côtés après la mise en service, durant l\'exploitation. Grâce à notre flexibilité, nous créons des solutions d\'automatisation cohérentes, fiables, qui s\'intègrent parfaitement dans les systèmes existants et répondent à vos exigences individuelles avec la plus grande fiabilité.',
      consultingChapterLabel: '01 — Avant de construire',
      consultingHighlight: 'Nos compétences en automatisation et votre connaissance des processus',
      consultingStats: [
        { value: '50+', label: 'Années d\'expérience en automatisation industrielle' },
        { value: '360°', label: 'Accompagnement de la planification à l\'exploitation' },
        { value: '1:1', label: 'Un interlocuteur dédié tout au long du projet' },
      ],
      consultingServicesTitle: 'Notre offre de prestations comprend',
      consultingServices: [
        { title: 'Analyse des besoins', description: 'Nous recensons vos objectifs, contraintes et exigences techniques de manière structurée.' },
        { title: 'Analyse des systèmes existants', description: 'Nous évaluons votre infrastructure actuelle et identifions les potentiels d\'optimisation.' },
        { title: 'Conseil neutre', description: 'Recommandations indépendantes – nous choisissons la solution adaptée, pas une marque.' },
        { title: 'Cahier des charges & concept', description: 'Nous élaborons un cahier des charges précis comme base fiable de votre projet.' },
        { title: 'Gestion de projet', description: 'Responsabilités, délais et communication clairs – du démarrage à la réception.' },
      ],
      services: {
        schaltschrankbau: { title: 'Construction d\'armoires électriques', description: 'Prêt pour la série dès l\'unité 1 – testé, documenté, évolutif.' },
        hardware: { title: 'Ingénierie matérielle', description: 'Conception conforme CEM, sécurité et documentation conforme aux normes.' },
        software: { title: 'Ingénierie logicielle', description: 'Programmes stables, HMI propre, prêt pour l\'IIoT.' }
      }
    },
    homepageContact: {
      title: 'Prêt pour la prochaine étape?',
      button: 'Parlez-nous de votre projet'
    },
    teamPage: {
      heroTitle: 'Équipe',
      heroSubtitle: 'Nos interlocuteurs sont à votre disposition.',
      followUs: 'Suivez-nous'
    },
    careersPage: {
      hero: {
        title: 'Votre prochaine étape',
        subtitle: 'Flexibilité & Responsabilité',
        description: 'En tant qu\'employeur ancré régionalement avec des activités internationales, nous offrons des tâches passionnantes, des conditions fiables et de vraies perspectives – de l\'entrée à la spécialisation.'
      },
      intro: {
        title: 'Votre place chez Althaus',
        description: 'La technique ne naît pas toute seule. Elle est créée par des personnes qui réfléchissent, agissent et développent des solutions ensemble. Depuis plus de 50 ans, Althaus est synonyme d\'automatisation made in Switzerland. Derrière chaque projet se trouvent des collaborateurs engagés qui apportent leur savoir-faire et assument des responsabilités. Chez nous, vous trouverez un environnement où vous pourrez vous développer, apporter vos idées et façonner l\'avenir avec nous.'
      },
      imageStatement: {
        title: '160 employés planifient, construisent et réalisent l\'automatisation.',
        description: 'Expérience de production et l\'ambition de s\'améliorer chaque jour. Nous vivons cette attitude dans des partenariats solides et avec une promesse claire: Nous écoutons, pensons à l\'avance et livrons une qualité qui dure.'
      },
      benefits: {
        title: 'Pourquoi travailler avec nous?',
        subtitle: 'C\'est ce qui fait de nous un employeur attractif',
        items: [
          { title: 'Atmosphère de travail familiale', description: 'Chacun compte chez nous – une équipe qui se serre les coudes et se soutient mutuellement.' },
          { title: 'Horaires de travail flexibles', description: 'L\'équilibre travail-vie n\'est pas qu\'un slogan, mais une réalité vécue chez nous.' },
          { title: 'Projets passionnants', description: 'Tâches variées dans l\'automatisation – de l\'idée à la mise en œuvre.' },
          { title: 'Carrière & Développement', description: 'Nous soutenons votre développement avec des formations internes et des opportunités d\'avancement.' },
          { title: 'Avenir sûr', description: 'Une entreprise stable avec plus de 50 ans d\'expérience et une croissance positive.' },
          { title: 'Postes de travail de qualité', description: 'Infrastructure moderne, technologies les plus récentes et environnement de travail agréable.' },
          { title: '27 jours de vacances', description: 'Plus de temps pour le repos, les voyages et tout ce qui vous tient à cœur. Avec 27 jours de vacances, l\'équilibre reste assuré.' },
          { title: 'Semaine de 40 heures', description: 'Des structures claires pour le travail et les loisirs. Avec une semaine de 40 heures, nous créons prévisibilité et équilibre.' },
          { title: 'Restauration subventionnée', description: 'Bien manger à des conditions avantageuses. Avec des offres de restauration subventionnées, le plaisir fait partie du quotidien professionnel.' }
        ]
      },
      education: {
        title: 'Formation et perfectionnement',
        description: 'Par des formations et des perfectionnements ciblés, nous contribuons au développement professionnel et personnel continu de nos collaborateurs. La formation a également une grande importance chez W. Althaus AG. En tant qu\'entreprise formatrice, nous investissons beaucoup dans la formation de la relève et permettons aux jeunes adultes d\'entrer dans le monde professionnel. Nous formons actuellement 28 apprentis dans les métiers d\'automaticien, de monteur en automatisation, d\'employé de commerce et de logisticien.'
      },
      modernWork: {
        title: 'Travailler dans un environnement ultramoderne',
        description: 'De la construction automatisée d\'armoires électriques aux postes de travail modernes. Vous travaillez avec une technologie actuelle, des normes claires et une équipe qui vit l\'innovation.'
      },
      cta: {
        title: 'Faites partie de notre équipe',
        description: 'Envie de défis et d\'esprit d\'équipe? Grandissez avec nous et partagez notre succès.',
        button: 'Voir les postes ouverts'
      }
    },
    aboutPage: {
      hero: {
        title: 'Enraciné régionalement,',
        subtitle: 'déployé mondialement.',
        description: 'Depuis 1968, nous combinons savoir-faire, ingénierie et automatisation en solutions d\'armoires électriques globales – précises, réfléchies, fiables.'
      },
      intro: {
        leadingIn: 'Leading in Automation',
        paragraphs: [
          'Nous sommes une entreprise familiale suisse fondée en 1968 à Aarwangen dans le canton de Berne. Aujourd\'hui, plus de 160 employés travaillent sur deux sites, et W. Althaus AG est considérée comme un employeur important et pionnier dans la région.',
          'Notre compétence principale réside dans le développement et la production des commandes électriques les plus simples aux solutions d\'automatisation complexes.',
          'Avec 50 ans d\'expérience dans l\'automatisation industrielle, nous sommes spécialistes dans le développement de solutions personnalisées pour l\'industrie. En tant qu\'entreprise de service complet, nous offrons un package de solutions complet avec notre large offre de services en conseil conceptuel, ingénierie hardware et software, construction d\'armoires électriques, production de borniers, assemblage de groupes, support d\'assemblage, mise en service et formation.'
        ]
      },
      stats: {
        founded: { value: '1968', label: 'Fondée' },
        employees: { value: '160+', label: 'Employés' },
        area: { value: "6'000m²", label: 'Surface de production' },
        cabinets: { value: "10'000+", label: 'Armoires/an' }
      },
      history: {
        title: 'Notre Histoire',
        subtitle: 'D\'une entreprise individuelle au principal constructeur d\'armoires électriques de Suisse – découvrez nos jalons.',
        milestones: [
          { year: '1968', title: 'Fondation', description: 'Walter Althaus père démarre en tant qu\'entrepreneur individuel à Aarwangen. À partir de modestes débuts, une entreprise familiale suisse se développe progressivement, évoluant constamment et en croissance continue.' },
          { year: '1970s', title: 'Première production d\'armoires électriques', description: 'Dans les années 1970, la production d\'armoires électriques commence. De la construction de commandes simples, l\'entreprise se développe en spécialiste des solutions d\'automatisation complètes et documentées. L\'expertise technique est systématiquement développée, posant les bases de l\'expansion future.' },
          { year: '1980s', title: 'Extension de la production et entrée dans l\'ECAD', description: 'La surface de production sur la Jurastrasse est étendue de 400 à 800 mètres carrés, répondant à la demande croissante et au volume de projets en augmentation.\n\nParallèlement, l\'entreprise entre dans la conception assistée par ordinateur avec un programme ECAD. La numérisation de la planification commence, augmentant l\'efficacité et la qualité dans l\'exécution des projets.' },
          { year: '1990s', title: 'Extension, automatisation et changement de génération', description: 'Les surfaces de bureaux sont agrandies par la construction d\'un deuxième étage. L\'introduction du premier système EPLAN professionnalise et standardise davantage la planification électrotechnique.\n\nLes premiers processus automatisés sont mis en œuvre. Des machines de traitement de câbles sont déployées, augmentant considérablement la productivité.\n\nAu milieu des années 1990, Walter Althaus fils reprend la direction et conduit l\'entreprise vers la phase de développement suivante.' },
          { year: '1998', title: 'Système de test entièrement automatisé', description: 'Avec le premier système de test entièrement automatisé pour armoires électriques, W. Althaus AG mise très tôt sur l\'assurance qualité automatisée. Ce jalon renforce la fiabilité des processus et garantit une qualité de test constante.' },
          { year: '2000s', title: 'Automatisation et relocalisation', description: 'La production est progressivement davantage automatisée. Le traitement de la tôle en particulier est de plus en plus soutenu par des machines et intégré dans des chaînes de processus efficaces.\n\nLa surface de production sur la Jurastrasse atteint ses limites. La fabrication est donc relocalisée du village vers la zone industrielle d\'Aarwangen. Entre 2007 et 2011, quatre halls supplémentaires sont construites sur le nouveau site, créant l\'infrastructure pour une croissance future.' },
          { year: '2005', title: 'Entrée dans l\'ingénierie 3D', description: 'Le lancement de l\'ingénierie 3D avec la mise en place d\'une base de données numérique marque une étape décisive vers une planification et une fabrication connectées. Cela crée la base de processus continus, de l\'ingénierie à la production.' },
          { year: '2008', title: 'Premier automate d\'équipement de bornes', description: 'Avec le développement du premier automate d\'équipement de bornes propre, W. Althaus AG fait progresser l\'automatisation de manière ciblée. Les étapes de travail manuelles sont réduites, les processus accélérés et la reproductibilité encore améliorée.' },
          { year: '2010s', title: 'Investissements dans l\'automatisation et la numérisation', description: 'Les installations d\'automatisation existantes sont modernisées et étendues. Les processus de production sont numérisés, standardisés et systématiquement optimisés. L\'accent est mis sur des flux de données continus et une fabrication efficace tout au long de la chaîne de valeur.' },
          { year: '2018', title: 'Développement d\'un nouveau robot de câblage', description: 'Avec le début du développement d\'un nouveau système de robot de câblage collaboratif, W. Althaus AG développe systématiquement ses compétences en automatisation. Ce jalon démontre l\'ambition de développer des solutions robotiques innovantes adaptées aux exigences de la fabrication moderne d\'armoires électriques.' },
          { year: '2020s', title: 'Croissance et nouvelle direction', description: 'L\'entreprise passe à plus de 160 employés. La compétence en automatisation, l\'expérience de production et l\'amélioration continue des processus définissent l\'identité de l\'entreprise.\n\nAu début des années 2020, Marco Schneider prend la direction et continue à diriger l\'entreprise de manière stratégique.' },
          { year: '2025', title: 'Partenaire Rittal + Eplan Application Center', description: 'En tant que premier partenaire Rittal + Eplan Application Center en Suisse, l\'entreprise reçoit une reconnaissance officielle. Ce partenariat souligne l\'orientation constante vers des processus basés sur les données dans la construction de commandes et d\'appareillages et confirme le leadership technologique dans les solutions intégrées d\'ingénierie et de fabrication.' }
        ]
      },
      values: {
        title: 'Nos Valeurs',
        subtitle: 'Ce qui nous motive et comment nous travaillons – trois principes qui façonnent nos actions.',
        items: [
          { title: 'Qualité', subtitle: 'Nous livrons une qualité qui dure', description: 'Chaque armoire électrique, chaque solution – fabriquée avec précision et réfléchie dans les moindres détails. Notre standard: Zéro compromis.' },
          { title: 'Partenariat', subtitle: 'Nous écoutons et pensons à l\'avance', description: 'Relations à long terme plutôt que transactions à court terme. Nous comprenons les défis de nos clients et développons des solutions ensemble.' },
          { title: 'Innovation', subtitle: 'S\'améliorer chaque jour', description: 'L\'immobilisme, c\'est reculer. Nous investissons continuellement dans de nouvelles technologies, processus et le développement de notre équipe.' }
        ]
      },
      regionalEngagement: {
        title: 'Engagement régional',
        paragraphs: [
          'En tant qu\'entreprise profondément ancrée dans la région, il nous tient à cœur de contribuer non seulement sur le plan économique, mais aussi sur le plan social. C\'est pourquoi nous soutenons des associations, des projets et des événements dans la région d\'Aarwangen.',
          'Notre parrainage s\'adresse principalement aux associations et aux manifestations locales qui renforcent la vie communale et associative par leur engagement. Qu\'il s\'agisse d\'événements sportifs, de projets culturels ou de rencontres communautaires, nous souhaitons contribuer à ce que de telles initiatives soient possibles et que les gens de la région se retrouvent.',
          'Nous sommes convaincus qu\'une vie associative dynamique contribue de manière importante à l\'identité régionale. C\'est pourquoi nous soutenons des engagements sélectionnés là où ils ont un impact : directement sur place, auprès des personnes et des organisations de notre entourage.'
        ],
        supportedTitle: 'Associations et manifestations que nous avons eu le plaisir de soutenir'
      },
    },
    sustainabilityPage: {
      hero: {
        title: 'Responsabilité pour',
        subtitle: 'l\'Environnement, la Société & l\'Avenir',
        description: 'En tant qu\'entreprise familiale suisse, nous agissons de manière responsable – pour notre environnement, notre région et les générations futures.'
      },
      intro: {
        title: 'Responsable. Tourné vers l\'avenir.',
        subtitle: 'Althaus',
        titleSuffix: '– Durabilité avec système.',
        paragraphs: [
          'Pour nous, la durabilité signifie plus que la protection de l\'environnement. Nous pensons écologiquement, économiquement et socialement – de manière holistique tout au long du cycle de vie du produit. Grâce aux processus numérisés, à l\'ingénierie ECAD et à la production hautement automatisée, nous réduisons les déchets, l\'utilisation des matériaux et les délais – dès la première pièce.',
          'En 2024, nous avons reçu le badge Committed d\'EcoVadis – une confirmation de notre engagement continu. Les domaines de l\'environnement, des droits du travail et de l\'homme, de l\'éthique et des achats durables ont été évalués. En environnement, droits du travail et de l\'homme, et éthique, nous sommes au-dessus de la moyenne du secteur. De plus, nous assurons la qualité et la performance environnementale avec nos systèmes de management selon ISO 9001 et ISO 14001 et améliorons les deux en continu.',
          'Nous respectons systématiquement toutes les exigences légales, y compris la conformité des matériaux, et allons plus loin selon le principe réduire, réutiliser, recycler. Nous utilisons le cuivre à forte intensité de ressources de manière particulièrement efficace. Avec des optimisations opérationnelles et une maintenance régulière des installations, nous augmentons l\'efficacité énergétique, notre parc de véhicules électriques réduit la demande de carburant, et les installations photovoltaïques sur nos toits renforcent le bilan carbone du réseau électrique. Avec nos clients, fournisseurs et partenaires, nous identifions des potentiels supplémentaires pour des solutions plus durables en qualité suisse.'
        ]
      },
      metrics: {
        title: 'Chiffres et Objectifs',
        items: [
          { value: '95%', label: 'Degré d\'automatisation' },
          
          { value: '40%', label: 'Énergie solaire' },
          { value: '2030', label: 'Neutre en carbone' }
        ]
      },
      impact: {
        title: 'Durabilité avec impact',
        description: 'Nous combinons responsabilité écologique, sociale et économique avec des résultats mesurables. Certifié selon ISO 9001/14001 et confirmé par EcoVadis (Committed 2024) – efficace, transparent, tourné vers l\'avenir.'
      },
      achievements: {
        title: 'Nos initiatives en matière de durabilité',
        categories: [],
        items: [
          { title: 'Certification ISO 14001', subtitle: 'Système de management environnemental certifié', description: 'Introduction et certification de notre système de management environnemental selon ISO 14001 pour l\'amélioration continue de notre performance environnementale.' },
          { title: 'Énergie solaire propre', subtitle: 'Installations photovoltaïques sur deux sites', description: 'Avec des installations photovoltaïques sur le site de production (380 kWp) et au siège (110 kWp), nous produisons une partie de nos besoins énergétiques nous-mêmes.' },
          { title: 'Stockage d\'énergie', subtitle: 'Batterie de stockage au siège', description: 'Un système de stockage par batterie de 80 kW permet une utilisation plus efficace de notre énergie solaire autoproduite.' },
          { title: 'Production écoénergétique', subtitle: 'Technologies de fabrication modernes', description: 'Le passage des systèmes de découpe laser CO2 aux lasers fibre modernes réduit la consommation d\'énergie tout en augmentant l\'efficacité de production.' },
          { title: 'Éclairage intelligent', subtitle: 'LED avec détection de présence et de lumière du jour', description: 'En passant à l\'éclairage LED avec contrôle automatique de présence et de lumière du jour, nous réduisons considérablement la consommation d\'énergie dans nos bâtiments.' },
          { title: 'Électromobilité', subtitle: 'Conversion progressive de la flotte de véhicules', description: 'Une partie de nos véhicules d\'entreprise fonctionne déjà à l\'électricité. L\'électrification de notre flotte est continuellement étendue.' },
          
          { title: 'La durabilité comme processus continu', subtitle: 'Pas à pas vers plus d\'efficacité', description: 'Nous travaillons en permanence à réduire notre consommation d\'énergie et nos émissions. Les nouvelles technologies et optimisations sont continuellement évaluées et mises en œuvre.' }
        ]
      },
      outlook: {
        title: 'Perspectives',
        headline: 'Durabilité – Agenda 2030',
        description: 'Notre chemin vers la transformation durable – pas à pas vers des résultats mesurables et un impact à long terme.',
        milestones: [
          { year: '2026', title: 'Bilan GES (Scope 1–3)', description: 'En 2026, le projet de bilan des gaz à effet de serre selon le protocole GHG (Scope 1, 2 et 3) sera lancé et mis en œuvre avec le partenaire de projet externe évalué. Le bilan GES de l\'entreprise sera créé, plausibilisé et documenté.' },
          { year: '2027', title: 'Trajectoire Net-Zero', description: 'Sur la base du bilan des gaz à effet de serre, une trajectoire net-zero spécifique à l\'entreprise sera définie en 2027. Celle-ci comprend des années cibles concrètes, des objectifs de réduction et des mesures prioritaires pour la réduction progressive des émissions de gaz à effet de serre sur Scope 1–3. La trajectoire net-zero sera adoptée et intégrée dans les processus d\'entreprise pertinents.' },
          { year: '2028', title: 'Rapport de Durabilité (VSME)', description: 'En 2028, un rapport de durabilité structuré sera créé pour la première fois conformément aux exigences VSME. Le rapport repose sur les données environnementales, climatiques et de gouvernance existantes, reflète l\'état de mise en œuvre des mesures définies et assure la transparence envers les parties prenantes pertinentes.' },
          { year: '2029', title: 'Stratégie de Durabilité', description: 'D\'ici la fin de 2029, une stratégie de durabilité à l\'échelle de l\'entreprise sera élaborée, adoptée et communiquée. Elle s\'appuie sur les résultats du bilan GES, de la trajectoire net-zero définie, du reporting de durabilité ainsi que sur les cinq thèmes de leviers centraux identifiés. La stratégie définit des objectifs à long terme, des domaines d\'action prioritaires, des mesures et des responsabilités.' }
        ]
      }
    },
    vocationalTrainingPage: {
      hero: {
        title: 'Ta formation chez Althaus',
        subtitle: 'Technologie & Avenir',
        description: 'Technicien en automatisation, monteur en automatisation ou spécialiste en logistique – nous formons de manière diversifiée et te soutenons spécifiquement sur ton chemin vers le monde professionnel.'
      },
      nachwuchs: {
        title: 'Jeunes talents avec un avenir',
        subtitle: 'Depuis plus de 50 ans, nous formons de jeunes talents – et sommes fiers de chaque diplômé.',
        stats: {
          graduates: { value: '120+', label: 'Diplômés réussis' },
          apprenticeships: { value: '3', label: 'Apprentissages', description: 'Technicien en automatisation, monteur en automatisation et spécialiste en logistique – trois voies vers l\'avenir.' },
          experience: { value: '50+', label: 'Années d\'expérience', description: 'dans la formation de jeunes professionnels' }
        },
        cta: {
          title: 'Intéressé par un stage découverte?',
          description: 'Découvre notre entreprise et les métiers – inscris-toi maintenant.',
          button: 'Vers le stage découverte'
        }
      },
      intro: {
        title: 'Nous formons des professionnels',
        paragraphs: [
          'Nous misons sur une formation professionnelle solide et active pour assurer la relève. Notre formation professionnelle se distingue par une formation de haute qualité et variée avec des formations approfondies étendues.',
          'La formation et le soutien des jeunes professionnels sont pour nous la condition préalable la plus importante pour maintenir et renforcer la Suisse comme site de production.'
        ]
      },
      openPositions: {
        title: 'Places d\'apprentissage ouvertes',
        subtitle: 'Aperçu de nos métiers de formation et disponibilité'
      },
      badges: {
        available: 'Disponible',
        assigned: 'Attribué'
      },
      buttons: {
        learnMore: 'En savoir plus'
      },
      apprenticeships: {
        automatiker: {
          title: 'Technicien en automatisation CFC',
          duration: '4 ans',
          description: 'En tant que technicien/ne en automatisation, tu travailles sur la technologie qui commande les machines, les installations et les systèmes de production automatisés. L\'automatisation et la robotique façonnent l\'industrie d\'aujourd\'hui et tu es au cœur de l\'action.',
          detailedDescription: 'Chez W. Althaus AG, tu apprends comment les commandes électriques sont planifiées, construites et testées. Tu travailles sur des projets réels et obtiens un aperçu des solutions d\'automatisation modernes pour les machines et les installations industrielles.\n\nPendant ta formation, tu découvres différents domaines, dont la construction d\'armoires électriques, le département de test, la robotique, la conception électrique, la programmation et l\'automatisation industrielle. En troisième année, tu peux te spécialiser davantage en logiciel, matériel, conception électrique ou dans le département de test, selon tes intérêts et les besoins.',
          highlights: [
            'Construire et câbler des commandes électriques et armoires électriques',
            'Monter, raccorder et tester des composants électriques',
            'Lire des schémas et comprendre la documentation technique',
            'Obtenir des aperçus de l\'automatisation industrielle et de la robotique',
            'Acquérir de premières expériences en programmation et dans ses propres projets',
            'Tester des commandes et soutenir la recherche de pannes'
          ],
          requirements: 'École secondaire avec de bonnes performances en mathématiques et physique ainsi qu\'un intérêt pour la technique et l\'électronique.',
          career: 'Formation continue comme technicien ES ou études en haute école spécialisée dans le domaine de l\'automatisation ou de l\'électrotechnique.'
        },
        automatikmonteur: {
          title: 'Monteur en automatisation CFC',
          duration: '3 ans',
          description: 'En tant que monteur/se en automatisation, tu travailles sur la technologie qui relie les machines et les installations aux commandes électriques. Tu construis et câbles des commandes utilisées dans l\'industrie pour les installations de production automatisées.',
          detailedDescription: 'Chez W. Althaus AG, tu apprends comment les armoires électriques sont construites, câblées et testées. Tu travailles directement dans la production et aides à assembler pas à pas des commandes pour machines et installations industrielles.\n\nPendant ta formation, tu découvres différents domaines de la construction d\'armoires électriques, notamment le montage, le câblage et les travaux de test. Tu apprends comment des composants individuels deviennent des commandes fonctionnelles.',
          highlights: [
            'Construire et câbler des armoires électriques et des commandes électriques',
            'Monter, raccorder et tester des composants électriques',
            'Lire des schémas et comprendre la documentation technique',
            'Tester des commandes et identifier des erreurs simples',
            'Travailler dans la construction d\'armoires électriques et la production'
          ],
          requirements: 'École secondaire ou école secondaire générale ainsi qu\'un intérêt pour la technique et le travail manuel.',
          career: 'Formation continue dans le domaine de l\'électrotechnique et de l\'automatisation.'
        },
        logistiker: {
          title: 'Spécialiste en logistique CFC',
          duration: '3 ans',
          description: 'En tant que spécialiste en logistique, tu veilles à ce que les matériaux, composants et produits soient au bon endroit au bon moment. Tu maintiens ainsi notre production en marche et t\'assures que tous les composants nécessaires sont disponibles.',
          detailedDescription: 'Chez W. Althaus AG, tu travailles avec des systèmes modernes d\'entreposage et de logistique et gardes à tout moment une vue d\'ensemble des stocks et des flux de matériaux. Tu réceptionnes les marchandises, les stockes, prépares les matériaux pour la production et organises l\'expédition des produits finis.\n\nPendant ta formation, tu passes par différents domaines de l\'entrepôt, dont la réception des marchandises, la gestion des stocks, la préparation de commandes et l\'expédition. Tu apprends pas à pas comment fonctionne un flux de matériaux moderne dans une entreprise industrielle.',
          highlights: [
            'Réceptionner, contrôler et stocker correctement les marchandises',
            'Préparer les matériaux pour la production et le montage',
            'Composer les commandes et les préparer pour l\'expédition',
            'Gérer les stocks avec des systèmes numériques modernes',
            'Organiser et coordonner les transports dans l\'entreprise',
            'Collaborer dans des domaines tels que réception, gestion des stocks, préparation de commandes et expédition'
          ],
          requirements: 'École secondaire ou école secondaire générale, talent organisationnel et plaisir du travail pratique.',
          career: 'Formation continue comme spécialiste en logistique ou spécialisation dans le domaine de la logistique ou du supply chain management.'
        }
      },
      detailedSection: {
        title: 'Nos métiers de formation en détail',
        whatYouLearn: 'Ce que tu apprendras:',
        requirements: 'Conditions:',
        career: 'Carrière:'
      },
      quote: 'Ta formation est le début – façonnons ensemble ton avenir!',
      benefits: {
        title: 'Pourquoi chez nous?',
        subtitle: 'Ces avantages t\'attendent dans ta formation',
        items: [
          { title: 'Environnement familial', description: 'Accompagnement personnel et une équipe qui se serre les coudes.' },
          { title: 'Formation pratique', description: 'Dès le premier jour, tu travailles sur de vrais projets clients.' },
          { title: 'Opportunités de carrière', description: 'Possibilités de reprise et soutien à la formation continue après l\'apprentissage.' },
          { title: 'Avenir sûr', description: 'Une entreprise stable avec plus de 50 ans d\'expérience.' },
          { title: 'Infrastructure moderne', description: 'Travailler avec les technologies et outils les plus récents.' },
          { title: 'Formateurs expérimentés', description: 'Des formateurs qualifiés t\'accompagnent sur ton chemin.' }
        ]
      },
      path: {
        title: 'Le chemin vers l\'apprentissage',
        subtitle: 'En quatre étapes vers ta formation chez Althaus',
        steps: [
          { title: 'Informe-toi', description: 'Explore différents domaines professionnels et leurs exigences sur notre site web et auprès des services de conseil.' },
          { title: 'Stage découverte', description: 'Postule pour un stage découverte de 2 jours et découvre le métier et notre entreprise.' },
          { title: 'Candidature', description: 'Envoie-nous tes documents complets: lettre de motivation, CV, photo et certificats.' },
          { title: 'Début de l\'apprentissage', description: 'Après une candidature réussie, tu commences ta formation chez nous en août.' }
        ]
      },
      events: {
        title: 'Nos Événements',
        subtitle: 'Journées découverte, événements d\'information et plus',
        viewAll: 'Voir toutes les actualités de la formation professionnelle'
      },
      form: {
        title: 'Demander un stage découverte',
        subtitle: 'Découvre le métier et notre entreprise lors d\'un stage découverte de 2 jours',
        sections: {
          personal: 'Informations personnelles',
          school: 'École',
          apprenticeship: 'Stage découverte'
        },
        fields: {
          firstName: 'Prénom',
          lastName: 'Nom',
          email: 'E-mail',
          phone: 'Téléphone',
          birthDate: 'Date de naissance',
          shoeSize: 'Pointure',
          street: 'Rue',
          city: 'Code postal / Ville',
          school: 'École actuelle',
          schoolYear: 'Classe scolaire',
          desiredProfession: 'Métier souhaité',
          desiredApprenticeshipStart: 'Début d\'apprentissage souhaité',
          desiredDate: 'Date souhaitée dans la période sélectionnée',
          preferredPeriod: 'Semaine souhaitée (lun–ven)',
          referralSource: 'Comment as-tu entendu parler de nous?',
          message: 'Remarques / Motivation'
        },
        placeholders: {
          shoeSize: 'p. ex. 42',
          city: 'p. ex. 4912 Aarwangen',
          schoolYear: 'p. ex. 8ème année secondaire',
          selectProfession: 'Sélectionner le métier',
          selectApprenticeshipStart: 'Sélectionner le début',
          selectPeriod: 'Sélectionner la semaine',
          referralSource: 'p. ex. recommandation, école, internet, réseaux sociaux…',
          message: 'Pourquoi es-tu intéressé par ce métier? As-tu des souhaits particuliers?'
        },
        professions: {
          automatiker: 'Technicien en automatisation CFC (2 jours)',
          automatikmonteur: 'Monteur en automatisation CFC (2 jours)',
          logistiker: 'Spécialiste en logistique CFC (2 jours)'
        },
        periods: {
          fruehlingsferien: 'Vacances de printemps',
          sommerferien: 'Vacances d\'été',
          herbstferien: 'Vacances d\'automne',
          sonstiges: 'Autre'
        },
        attachments: {
          title: 'Documents à joindre à ta candidature pour le stage découverte',
          intro: 'Merci de télécharger les documents suivants afin que nous puissions examiner ta candidature :',
          bullet1: 'CV avec une photo récente',
          bullet2: 'Courte lettre de motivation expliquant pourquoi ce stage découverte t\'intéresse',
          bullet3: 'Copies des bulletins scolaires des deux dernières années',
          pdfHint: 'Veille à ce que tous les documents soient au format PDF (15 Mo maximum au total). Toutes les informations restent bien entendu confidentielles.',
          cvLabel: 'CV (PDF)',
          motivationLabel: 'Lettre de motivation (PDF)',
          certificatesLabel: 'Bulletins des 2 dernières années (PDF)',
          notesLabel: 'Texte libre / Autre',
          notesPlaceholder: 'Informations complémentaires que tu souhaites nous communiquer…'
        },
        submitted: {
          title: 'Ta candidature nous est bien parvenue',
          text: 'Merci pour ta candidature au stage découverte.\nNous avons bien reçu tes documents et te recontacterons dans les prochains jours.',
          contactBefore: 'Pour toute question, tu peux nous contacter à ',
          contactAfter: '.',
          insightsTitle: 'Un aperçu de notre formation professionnelle',
          newApplication: 'Saisir une nouvelle candidature'
        },
        privacy: 'J\'accepte la {link} et accepte que mes données soient utilisées pour traiter ma demande.',
        privacyLink: 'Politique de confidentialité',
        submit: 'Demander un stage découverte',
        toast: {
          error: 'Veuillez accepter la politique de confidentialité',
          missingDocuments: 'Merci de télécharger les trois documents (PDF).',
          tooLarge: 'Les documents sont trop volumineux au total (15 Mo max.).',
          notPdf: '"{name}" n\'est pas un PDF. Merci de ne télécharger que des fichiers PDF.',
          success: 'Ta demande a été envoyée! Nous te recontacterons.'
        }
      },
      cta: {
        title: 'Prêt à commencer?',
        description: 'Postule maintenant pour un apprentissage chez W. Althaus AG et deviens partie intégrante de l\'avenir de l\'automatisation.',
        contactTitle: 'Responsable de la formation professionnelle'
      }
    },
    productsPage: {
      title: 'Produits',
      subtitle: 'Solutions d\'automatisation innovantes pour une efficacité maximale',
      athex: { name: 'Athex', title: 'Fabrication de barrettes de bornes' },
      panelscout: { name: 'Panelscout', title: 'Contrôle de test' }
    },
    leitbildPage: {
      hero: { title: 'Leading in Automation', subtitle: 'Qualité & Confiance', description: '« Leading in Automation » signifie pour nous : livrer à tout moment et en tout lieu des technologies et produits hautement automatisés et innovants « made in Switzerland ». Ce faisant, nous cultivons un partenariat durable avec tous nos interlocuteurs.' },
      intro: {
        title: 'Fiable. Innovant.',
        highlight: 'Althaus',
        suffix: '– Votre partenaire pour l\'automatisation industrielle.',
        paragraphs: [
          'Au cœur de notre activité se trouve la création d\'une automatisation industrielle continue, de haute qualité et durable. Nous planifions et fabriquons les produits en conformité avec les normes, réglementations et directives en vigueur.',
          'Notre infrastructure ultramoderne constitue le fondement stable de la qualité et de l\'efficacité. Dans des environnements de production organisés naissent des solutions d\'automatisation qui établissent des standards et favorisent activement l\'innovation.',
          'Tout aussi important: la communication et le travail d\'équipe. Dans nos salles de réunion modernes, les idées sont affinées, les décisions prises et les projets mis sur la voie du succès.',
          'Et parce que la haute performance nécessite un bon environnement, nous concevons les espaces de travail du futur: ergonomiques, inspirants et conçus pour une collaboration concentrée.'
        ]
      },
      values: {
        trust: { title: 'Confiance, Continuité et Compétence', description: 'L\'automatisation signifie aussi continuité pour nous. Avec nos employés, clients, partenaires et fournisseurs, nous entretenons un partenariat à long terme et de confiance, caractérisé par une haute compétence.' },
        quality: { title: 'Qualité pour le Client', description: 'Nous devons le succès de notre entreprise essentiellement aux solutions client individuelles et à la haute qualité des produits. Tout au long du cycle de vie du produit, nous soutenons nos clients avec des solutions adaptées à leurs besoins.' }
      },
      cta: 'Voir notre BigPicture'
    },
    chameleonPage: {
      heroTitle: 'Adaptatif en Automatisation',
      heroSubtitle: 'Vision & Précision',
      sections: [
        { title: 'Comme un caméléon. Mais industriel.', subtitle: 'Nous réagissons vite, gardons le contrôle et livrons des solutions précises.', content: '' },
        { title: 'Adaptation sans faille – Solutions sur mesure', content: 'Un caméléon change de couleur pour s\'intégrer parfaitement à son environnement. Nous changeons de perspective pour nous adapter parfaitement: pièce unique, lot, production en série ou retrofit.' },
        { title: 'Vue d\'ensemble – Planification avec vision', content: 'Le caméléon voit avec ses deux yeux indépendamment. C\'est ainsi que nous voyons les projets. Dans la phase de conception, nous éclairons le paysage du projet.' },
        { title: 'Frappe ciblée – Processus précis', content: 'Quand le caméléon frappe, le moment est parfaitement choisi. Des processus connectés et parallèles assurent vitesse et précision.' },
        { title: 'Prise ferme – Qualité dans les détails', content: 'Les pieds préhensiles donnent au caméléon de la stabilité. Notre stabilité naît de la profondeur des détails.' },
        { title: 'Camouflage parfait – Intégration sans faille', content: 'Le camouflage n\'est pas un truc, mais une stratégie. Pour nous, cela signifie partenariat.' },
        { title: 'Renouvellement constant – Le changement dans l\'ADN', content: 'Le caméléon mue pour rester agile. Nous évoluons de la même manière: pas en réagissant, mais en agissant, dans notre ADN.' }
      ],
      cta: { title: 'Prêt pour un changement de couleur?', subtitle: 'Donnons le bon ton à votre projet.', button: 'Nous contacter' }
    },
    documentsPage: {
      title: 'Documents',
      subtitle: 'Vous trouverez ici tous les documents, certificats et supports importants de W. Althaus AG en téléchargement.',
      categories: [
        { title: 'Entreprise', documents: [{ name: 'Logo (.png)', url: '/documents/W_Althaus_AG_Logo.png' }, { name: 'Données d\'entreprise', url: '/documents/Firmendaten_2026.pdf' }, { name: 'Organigramme', url: '/documents/organigramm.pdf' }] },
        { title: 'Valeurs & Culture', documents: [{ name: 'Mission (BigPicture)', url: '/documents/Althaus_Wertehaus_Bigpicture_2024.pdf' }, { name: 'Code de conduite', url: '/documents/Verhaltenskodex_W._Althaus_AG.pdf' }] },
        { title: 'Conditions d\'achat & de livraison', documents: [{ name: 'Conditions générales d\'achat (Deutsch)', url: '/documents/Allgemeine_Einkaufsbedingungen.pdf' }, { name: 'Conditions générales d\'achat (English)', url: '/documents/General_Terms_and_Conditions_of_Purchase.pdf' }, { name: 'Conditions générales d\'achat (Français)', url: '/documents/Conditions_generales_d_achat.pdf' }, { name: 'Conditions générales de livraison', url: '/documents/W._Althaus_AG_Allgemeine_Lieferbedingungen.pdf' }] },
        { title: 'Certifications ISO', documents: [{ name: 'ISO 9001:2015 / ISO 14001:2015 (Allemand)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_DE.pdf' }, { name: 'ISO 9001:2015 / ISO 14001:2015 (Anglais)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_EN.pdf' }] },
        { title: 'Certificats de durabilité', documents: [{ name: 'Protection climatique volontaire et efficacité énergétique', url: '/documents/Zertifikat_Energie-Agentur_der_Wirtschaft.pdf' }, { name: 'Certificat de durabilité EcoVadis', url: '/documents/Ecovadis_W._Althaus_AG.pdf' }] },
        { title: 'Normes & Associations', documents: [{ name: 'Certificat UL', url: '/documents/Certificate_of_Compliance_UL.pdf' }, { name: 'Certificat EKAS VSAS', url: '/documents/EKAS_Zertifikat_VSAS.pdf' }] }
      ],
      contactNote: 'Vous avez besoin de documents supplémentaires ou avez des questions? Contactez-nous à'
    },
    imprintPage: {
      title: 'Mentions légales',
      contact: { title: 'Contact' },
      register: { title: 'Inscription au registre du commerce', company: 'Raison sociale: W. Althaus AG', number: 'Numéro: CHE‑375.798.234', office: 'Office du registre du commerce du canton de Berne' },
      vat: { title: 'Numéro TVA', number: 'CHE-375.798.234 TVA' },
      disclaimer: { title: 'Clause de non-responsabilité', paragraphs: ['W. Althaus AG n\'assume aucune responsabilité quant à l\'exactitude, la précision, l\'actualité, la fiabilité et l\'exhaustivité des informations.', 'Les réclamations en responsabilité sont exclues.', 'Toutes les offres sont sans engagement.'] },
      links: { title: 'Responsabilité pour les liens', text: 'Les références et liens vers des sites tiers sont en dehors de notre domaine de responsabilité.' },
      copyright: { title: 'Droits d\'auteur', text: 'Les droits d\'auteur et tous les autres droits sur les contenus, images, photos ou autres fichiers du site appartiennent exclusivement à W. Althaus AG.' }
    },
    privacyPage: {
      title: 'Protection des données',
      sections: [
        { title: 'Champ d\'application', content: ['Cette déclaration de protection des données informe les utilisateurs sur la nature, l\'étendue et les finalités de la collecte et de l\'utilisation des données personnelles.'] },
        { title: 'Adresse de contact', content: ['Pour plus d\'informations sur la protection des données, veuillez contacter notre responsable de la protection des données par e-mail.', 'Contact: {email}'] },
        { title: 'Protection des données / Données d\'accès', content: ['Conformément à l\'article 13 de la Constitution fédérale suisse, toute personne a droit à la protection de sa vie privée. Nous respectons ces dispositions.'] },
        { title: 'Google Analytics', content: ['Ce site utilise Google Analytics, un service d\'analyse web fourni par Google Inc.'] },
        { title: 'Traitement des données personnelles', content: ['Les données personnelles ne sont collectées que si la loi le permet ou si les utilisateurs y consentent.'] },
        { title: 'Candidatures en ligne', content: ['La protection de vos données personnelles nous tient à cœur.'] },
        { title: 'Cookies', content: ['Ce site utilise des cookies pour l\'analyse et l\'amélioration continue.'] },
        { title: 'Révocation, Modifications et Mises à jour', content: ['L\'utilisateur a le droit d\'obtenir gratuitement des informations sur ses données personnelles stockées.', 'Contact: {email}'] }
      ]
    },
    welcomeSection: {
      text: 'W. Althaus AG – Leading in Automation depuis 1968.'
    },
    athexPage: {
      tagline: 'automatisé. précis. Althaus.',
      heroDescription: 'Avec {product}, nous révolutionnons la fabrication de barrettes de bornes.',
      cards: [
        { title: 'Qu\'est-ce qu\'Athex?', text: 'Athex est notre système propriétaire de fabrication entièrement automatisée de barrettes de bornes.' },
        { title: 'Technologie de pointe', text: 'Athex utilise les données ECAD directement depuis ePlan et E3 pour l\'assemblage automatique.' },
        { title: 'Vos avantages', text: 'Précision maximale grâce à la fabrication entièrement automatisée.' }
      ],
      functionsTitle: 'Fonctions Athex',
      functions: {
        ecad: { name: 'Intégration ECAD', description: 'Transfert direct des données depuis ePlan P8, ePlan Pro Panel et E3.series.' },
        automated: { name: 'Entièrement automatisé', description: 'De la nomenclature à la barrette finie sans intervention manuelle.' },
        errorFree: { name: 'Production sans erreur', description: 'Élimination des sources d\'erreur manuelles.' },
        fast: { name: 'Délais rapides', description: 'Temps de fabrication drastiquement réduits.' },
        flexible: { name: 'Quantités flexibles', description: 'Fabrication économique de pièces unitaires aux grandes séries.' },
        traceability: { name: 'Traçabilité', description: 'Documentation et suivi complets.' }
      },
      valueTitle: 'Votre valeur ajoutée avec Athex',
      values: [
        { title: 'Vitesse', description: 'Jusqu\'à 80% de délais plus rapides.' },
        { title: 'Qualité', description: 'Qualité constamment élevée.' },
        { title: 'Flexibilité', description: 'Fabrication économique dès la pièce 1.' },
        { title: 'Intégration', description: 'Connexion transparente à vos systèmes ECAD.' }
      ]
    },
    panelscoutPage: {
      tagline: 'intelligent. fiable. Althaus.',
      heroDescription: 'Avec {product}, nous apportons un contrôle de test intelligent à votre construction d\'armoires.',
      cards: [
        { title: 'Qu\'est-ce que Panelscout?', text: 'Panelscout est notre système de contrôle de test intelligent pour les armoires électriques.' },
        { title: 'Logique de test intelligente', text: 'Panelscout utilise des routines de test adaptatives.' },
        { title: 'Vos avantages', text: 'Assurance qualité complète grâce aux tests automatisés.' }
      ],
      functionsTitle: 'Fonctions Panelscout',
      functions: {
        testing: { name: 'Test automatique', description: 'Tests fonctionnels et de sécurité entièrement automatisés.' },
        documentation: { name: 'Documentation complète', description: 'Protocole automatique de toutes les valeurs mesurées.' },
        errorDetection: { name: 'Détection d\'erreurs', description: 'Identification précoce des erreurs de câblage.' },
        compliance: { name: 'Conformité aux normes', description: 'Tests selon IEC, EN et normes industrielles.' },
        speed: { name: 'Temps de test rapides', description: 'Routines de test optimisées.' },
        traceability: { name: 'Traçabilité', description: 'Suivi complet de tous les résultats de test.' }
      },
      valueTitle: 'Votre valeur ajoutée avec Panelscout',
      values: [
        { title: 'Sécurité', description: 'Tests complets pour la sécurité maximale.' },
        { title: 'Qualité', description: 'Standards de qualité constamment élevés.' },
        { title: 'Efficacité', description: 'Tests plus rapides avec une profondeur accrue.' },
        { title: 'Documentation', description: 'Protocoles conformes aux normes.' }
      ]
    },
    hardwareEngineeringPage: {
      tagline: 'modulaire. conforme. Althaus.',
      heroDescription: 'Nous développons des solutions matérielles intelligentes pour votre automatisation. De la conception à la mise en œuvre avec les technologies les plus modernes.',
      featureCards: [
        { title: 'Ce que vous obtenez chez Althaus', description: 'Nous élaborons avec vous des concepts de matériel et de commande pour installations et machines. Grâce à la modularisation et au Digital Twin, nous créons des kits standardisés et réutilisables, réduisons les efforts d\'ingénierie et fournissons des données prêtes pour la production.' },
        { title: 'Du concept à la mise en service', description: 'Nous modélisons l\'ECAD avec ePlan P8/Pro Panel comme jumeau numérique, modularisons les installations, concevons les armoires électriques incluant l\'agencement et le routage du câblage, respectons EN/UL/CSA, assurons la sécurité fonctionnelle, fournissons les données de fabrication et accompagnons les tests, la documentation et la mise en service.' },
        { title: 'Notre méthode de travail', description: 'Nous définissons en étroite collaboration les objectifs, normes et interfaces, modularisons votre installation pour la réutilisabilité et développons des concepts d\'armoires conformes aux normes. De l\'évaluation des risques aux données de fabrication, en passant par la documentation et la mise en service – tout d\'une seule source.' }
      ],
      servicesTitle: 'Notre offre de services comprend',
      services: [
        { name: 'Conseil conceptuel pour la création de schémas électriques', description: 'Conseil professionnel et création de schémas électriques' },
        { name: 'Systèmes CAO : ePlan P8, ePlan Pro Panel', description: 'Planification professionnelle avec les outils CAO les plus modernes' },
        { name: 'Modularisation et automatisation des installations', description: 'Automatisation moderne pour des concepts d\'installations efficaces' },
        { name: 'Concept d\'armoire : construction, agencement', description: 'Construction précise et conception d\'agencement optimale' },
        { name: 'Normes/réglementations : EN, UL, CSA', description: 'Conformité totale aux normes internationales' },
        { name: 'Concepts de sécurité et évaluation des risques', description: 'Analyses de sécurité complètes selon les normes les plus élevées' }
      ],
      valueTitle: 'Votre valeur ajoutée grâce au Hardware Engineering',
      values: [
        { title: 'Base de données cohérente', description: 'Du premier schéma à la mise en service – toutes les données cohérentes et réutilisables.' },
        { title: 'Moins de coûts d\'ingénierie', description: 'Grâce aux standards, modèles et réutilisation, nous réduisons significativement l\'effort.' },
        { title: 'Sécurité conforme aux normes', description: 'Conçu et documenté selon EN/UL/CSA pour la conformité internationale.' },
        { title: 'Évolutivité modulaire', description: 'Des kits réutilisables permettent des adaptations et extensions rapides.' }
      ]
    },
    softwareEngineeringPage: {
      tagline: 'intelligent. intuitif. Althaus.',
      heroDescription: 'Nos ingénieurs logiciels donnent vie à vos machines. Nous développons des solutions logicielles intelligentes pour votre automatisation. De la conception à la mise en œuvre – avec les technologies les plus modernes.',
      featureCards: [
        { title: 'Ce que vous obtenez chez Althaus', description: 'Nos ingénieurs logiciels vous accompagnent de la planification et du concept au cahier des charges, développent des logiciels proches du contrôle, des HMI/SCADA intuitifs et des applications SQL sur mesure. Conseil neutre et value engineering. En coordination avec l\'ingénierie matérielle – pour des flux de données continus jusqu\'à la production et la mise en service.' },
        { title: 'Étendue des services - Compétences & outils', description: 'Analyse neutre, architecture et stack technique ; fonctions priorisées pour le temps de cycle et la stabilité ; gestion de projet transparente. IU intuitives avec alarmes, recettes, piste d\'audit ; PLC/Motion et Safety fiables. Mises en service mondiales plus service, monitoring, mises à jour et assistance à distance rapide.' },
        { title: 'Notre méthode de travail', description: 'De la première analyse des besoins à la mise en service mondiale. Nous clarifions les objectifs, le stack technologique et les interfaces, développons des architectures logicielles modulaires et appliquons des méthodes agiles. Documentation, tests et support à distance assurent la fiabilité à long terme de votre solution d\'automatisation.' }
      ],
      servicesTitle: 'Notre offre de services comprend',
      services: [
        { name: 'Programmation PLC/Motion', description: 'Programmation de commande pour toutes les plateformes courantes' },
        { name: 'Développement HMI/SCADA', description: 'Interfaces utilisateur intuitives avec alarmes et recettes' },
        { name: 'Applications de base de données', description: 'Applications SQL Server avec piste d\'audit et reporting' },
        { name: 'Digital Twin & Simulation', description: 'Mise en service virtuelle et optimisation des processus' },
        { name: 'Sécurité & Conformité', description: 'Programmation de sécurité selon les normes actuelles' },
        { name: 'Service à distance & Monitoring', description: 'Support mondial et monitoring KPI' }
      ],
      valueTitle: 'Votre valeur ajoutée grâce au Software Engineering',
      values: [
        { title: 'Continuité', description: 'Intégration transparente avec le matériel et le Digital Twin pour des flux de données cohérents.' },
        { title: 'Délai de mise en service', description: 'Cahiers des charges structurés et gestion de projet propre pour une mise en service rapide.' },
        { title: 'Facilité d\'utilisation', description: 'HMI clairs et manuels compréhensibles pour une utilisation facile par votre équipe.' },
        { title: 'Support cycle de vie', description: 'Support à distance et mise en service mondiale pour une fiabilité à long terme.' }
      ]
    },
    contactPage: {
      formTitle: 'Formulaire de contact',
      formSubtitle: 'Vous avez des questions sur nos services, une demande concrète ou souhaitez collaborer avec nous ? Faites-nous part de votre demande, nous vous répondrons dans les plus brefs délais.',
      directContact: {
        title: 'Contact direct',
        description: 'Vous souhaitez nous contacter directement ? Nous sommes à votre disposition par téléphone ou par e-mail.',
        phone: '+41 62 919 82 10',
        email: ''
      },
      departmentTitle: 'Contact par département',
      departmentSubtitle: 'Contactez directement le bon département pour votre demande',
      departments: [
        { title: 'Ventes', description: '' },
        { title: 'Achats', description: '' },
        { title: 'Carrière', description: '' },
        { title: 'Marketing', description: '' }
      ]
    },
    anfahrtPage: {
      heroTitle: 'Comment nous trouver.',
      heroDescription: 'Notre bâtiment de bureaux (siège social) ainsi que notre production sont idéalement situés, à 10 minutes de l\'autoroute A1 à Aarwangen. Nos sites sont également bien desservis par les transports publics et facilement accessibles.',
      locationsTitle: 'Nos sites',
      locations: [
        { title: 'Siège social', country: 'Suisse' },
        { title: 'Production', country: 'Suisse' }
      ],
      openingHours: 'Heures d\'ouverture',
      openingHoursWarehouse: 'Heures d\'ouverture réception des marchandises',
      monThu: 'Lundi au jeudi',
      friday: 'Vendredi',
      routePlanning: 'Planifier l\'itinéraire',
      transportTitle: 'Accès',
      transportSubtitle: 'Différentes options s\'offrent à vous – choisissez celle qui vous convient le mieux',
      carTab: 'Voiture',
      publicTransportTab: 'Transports publics',
      carDirections: [
        { title: 'Siège social', description: 'Depuis l\'autoroute A1, prenez la sortie Aarwangen. Suivez la signalisation en direction du village d\'Aarwangen. Notre siège social se trouve à la Jurastrasse 12. Des places de stationnement sont disponibles directement devant le bâtiment.' },
        { title: 'Production', description: 'Depuis l\'autoroute A1, prenez la sortie Aarwangen. Suivez la signalisation en direction de la zone industrielle. Notre site de production se trouve à l\'Industriering 2. Un parking suffisant est disponible sur place.' }
      ],
      publicTransportDirections: [
        { title: 'Siège social', description: 'Le siège social est à seulement <strong>2 minutes à pied</strong> de la gare d\'Aarwangen Dorf. En sortant de la gare, suivez simplement la Jurastrasse.' },
        { title: 'Production', description: 'La production est à <strong>10 minutes à pied</strong> de l\'arrêt Aarwangen Hard. Suivez la signalisation en direction de la zone industrielle.' }
      ]
    },
    successStoriesPage: {
      heroSubtitle: 'd\'entreprises leaders',
      heroDescription: 'Découvrez comment nous avons aidé nos clients à atteindre un succès mesurable',
      filterAll: 'Tous',
      projectServices: 'Services du projet',
      readCaseStudy: 'Lire le cas client',
      employees: 'Collaborateurs',
      quotes: {
        guedel: 'Grâce à la standardisation et au Digital Twin, nous avons obtenu une qualité proche de la série dès le premier lot. Les modifications peu avant la livraison étaient possibles sans retard de calendrier.',
        cwa: 'Grâce à W. Althaus AG, nous avons rationalisé les processus : les armoires livrées étaient entièrement testées, documentées et prêtes à l\'installation. En cas de modification, W. Althaus AG réagit rapidement et avec flexibilité.',
        haefely: 'Avec W. Althaus AG, nous avons pu mettre en service nos environnements de test plus rapidement : les armoires sont arrivées testées, traçables et prêtes à l\'installation. L\'équipe a toujours fait preuve de flexibilité et d\'orientation solution.',
        fondarex: 'Les macros ePlan et les armoires modèles ont réduit de moitié notre temps d\'ingénierie – les nouvelles machines entrent désormais en série beaucoup plus rapidement.',
        bunorm: 'La conception conforme EN/UL/CSA incluant l\'évaluation des risques a sensiblement raccourci notre homologation.',
        zehndersommer: 'Avec le Digital Twin et les données de fabrication prêtes, la transition vers la construction d\'armoires s\'est faite sans heurts – les modifications sont restées dans les délais.',
        emmi: 'Le support à distance et la documentation claire ont maintenu l\'installation stable – mises à jour sans drame d\'arrêt.',
        kadi: 'La gestion des recettes basée sur SQL avec piste d\'audit crée de la transparence – rapports en un clic, prêts pour la validation.',
        cerex: 'Le cahier des charges et les flux HMI ont raccourci la mise en service. Les opérateurs se sont immédiatement orientés, les demandes de modification ont été rapidement mises en œuvre.'
      },
      positions: {
        guedel: 'Head of Supply Chain Management, Güdel AG',
        cwa: 'Achats opérationnels, CWA AG',
        haefely: 'Manager Purchasing, HAEFELY AG',
        fondarex: 'Responsable électrotechnique, Fondarex AG',
        bunorm: 'Directeur général, Bunorm Maschinenbau AG',
        zehndersommer: 'Innovation électrique, Zehnder & Sommer AG',
        emmi: 'Chef d\'équipe, Emmi Schweiz AG',
        kadi: 'Chef de projet, KADI AG',
        cerex: 'Directeur technique, CEREX AG'
      },
      industries: {
        guedel: 'Construction mécanique',
        cwa: 'Construction de véhicules de transport',
        haefely: 'Construction de systèmes de test',
        fondarex: 'Construction mécanique',
        bunorm: 'Construction mécanique',
        zehndersommer: 'Systèmes d\'avance de presse',
        emmi: 'Industrie alimentaire',
        kadi: 'Industrie alimentaire',
        cerex: 'Construction mécanique'
      }
    },
    jobOpeningsPage: {
      title: 'Postes vacants',
      subtitle: 'Trouvez votre prochain défi chez W. Althaus AG',
      yourTasks: 'Vos tâches :',
      learnMore: 'En savoir plus',
      noJobTitle: 'Aucun poste correspondant trouvé ?',
      noJobDescription: 'Nous nous réjouissons de recevoir votre candidature spontanée et vérifierons volontiers si nous avons un poste adapté pour vous.',
      sendApplication: 'Envoyer une candidature spontanée',
      startDate: 'Immédiatement ou selon accord',
      jobs: [
        {
          title: 'Collaborateur RH & Finances (h/f/d)',
          department: 'Administration',
          description: 'Soutenez notre équipe dans les domaines des ressources humaines et des finances. Vous prenez en charge des tâches administratives variées.',
          tasks: ['Soutien dans l\'administration RH et le processus de recrutement', 'Collaboration à la comptabilité et au traitement des salaires', 'Tâches administratives dans les domaines RH et finances']
        },
        {
          title: 'Ingénieur en automatisation (h/f/d)',
          department: 'Ingénierie',
          description: 'Digitalisation, automatisation ou robotique – chez nous, vous êtes au cœur de l\'action ! Rejoignez notre équipe motivée et façonnez l\'avenir du développement.',
          tasks: ['Développement, réalisation et mise en service de solutions d\'automatisation logicielles', 'Logiciels API et visualisations de processus sur différents systèmes', 'Accompagnement de projets et support technique']
        },
        {
          title: 'Automaticien, monteur d\'installations ou électricien expérimenté (h/f/d)',
          department: 'Production',
          description: 'Rejoignez notre équipe motivée et façonnez l\'avenir de la production. Vous êtes responsable de l\'ensemble de la fabrication.',
          tasks: ['Fabrication de commandes et d\'installations de commutation de tous types', 'Responsabilité de l\'ensemble du processus de fabrication', 'Usinage mécanique, montage et câblage de l\'armoire électrique']
        }
      ]
    }
  },
  it: {
    crossIndustrySolutions: {
      title: 'Settori',
      description: 'Con 50 anni di esperienza nell\'automazione industriale, siamo specialisti nello sviluppo di soluzioni personalizzate e nella fornitura di tecnologia innovativa in qualsiasi momento e in qualsiasi parte del mondo.',
      industries: {
        maschinenbau: 'Costruzione di macchine e impianti',
        medizintechnik: 'Tecnologia medica',
        energie: 'Energia & Infrastruttura',
        foodBeverage: 'Industria alimentare',
        transportation: 'Trasporti & Mobilità',
        erneuerbare: 'Energie rinnovabili'
      },
      moreIndustries: '... e molti altri'
    },
    aboutPreview: {
      title: 'Chi siamo',
      description: 'Siamo un\'azienda familiare svizzera fondata nel 1968 ad Aarwangen, nel Canton Berna. Oggi, oltre 160 collaboratrici e collaboratori lavorano in due sedi. La W. Althaus AG è considerata un datore di lavoro importante e all\'avanguardia nella regione.',
      description2: 'La nostra competenza chiave risiede nello sviluppo e nella produzione di comandi elettrici semplici fino a soluzioni di automazione complesse.',
      learnMore: 'Scopri di più',
      production: 'Produzione',
      headquarters: 'Sede centrale',
      team: 'Team',
    },
    certificationsPartnerships: {
      title: 'Partnership & Certificazioni',
      partnershipsLabel: 'Partnership',
      certificationsLabel: 'Certificazioni',
      qualityManagement: 'Gestione della qualità',
      environmentalManagement: 'Gestione ambientale',
      sustainabilityRating: 'Valutazione di sostenibilità',
      recognizedTrainingCompany: 'Azienda di formazione riconosciuta'
    },
    footer: {
      headquarters: 'Sede centrale',
      production: 'Produzione',
      contact: 'Contatto',
      phone: 'Telefono',
      openingHours: {
        weekdays: 'Lunedì a giovedì',
        friday: 'Venerdì'
      }
    },
    servicesSection: {
      title: 'I Nostri Servizi',
      servicesEyebrow: 'Dal concetto',
      subtitle: 'Con l\'automazione e la costruzione di quadri elettrici 4.0, digitalizziamo le vostre idee per il vostro vantaggio competitivo.',
      pageSubtitle: 'Con l\'automazione e la costruzione di quadri elettrici 4.0, digitalizziamo le vostre idee per il vostro vantaggio competitivo. Accompagniamo i nostri clienti dalla pianificazione alla costruzione di quadri elettrici fino allo sviluppo e all\'integrazione del software di controllo. Nascono così soluzioni di automazione complete che funzionano in modo affidabile e si integrano in modo flessibile nei sistemi esistenti.',
      heroTitle: 'I Nostri Servizi',
      heroSubtitle: 'Pensato in modo olistico',
      ownDevelopmentsTitle: 'I Nostri Sviluppi',
      ownDevelopmentsDescription: 'Con i nostri sviluppi propri, creiamo soluzioni intelligenti per i moderni processi di ingegneria, collaudo e produzione. Aiutano ad automatizzare i flussi di lavoro, a standardizzare le fasi di collaudo e a rendere i dati utilizzabili in modo strutturato. Il risultato sono sistemi affidabili con un elevato valore pratico che si integrano perfettamente nelle infrastrutture esistenti e ottimizzano i vostri processi in modo sostenibile.',
      manifestEyebrow: '01 — Filosofia',
      manifestPart1: 'Una ricetta di successo: le nostre ',
      manifestHighlight1: 'competenze in automazione',
      manifestPart2: ' e la vostra ',
      manifestHighlight2: 'conoscenza dei processi',
      manifestPart3: '.',
      consultingTitle: 'Consulenza concettuale',
      consultingLead: 'Una ricetta di successo: le nostre competenze in automazione e la vostra conoscenza dei processi.',
      consultingDescription: 'Accompagniamo i nostri clienti dalla pianificazione alla costruzione dei quadri elettrici, fino allo sviluppo e all\'integrazione del software di controllo. I nostri ingegneri di progetto vi consigliano già nella fase di pianificazione e progettazione, sono presenti in loco durante la costruzione e l\'installazione e restano al vostro fianco anche dopo la messa in servizio, durante l\'esercizio. Grazie alla nostra flessibilità nascono soluzioni di automazione end-to-end affidabili, che si integrano perfettamente nei sistemi esistenti e realizzano le vostre esigenze individuali con la massima affidabilità.',
      consultingChapterLabel: '01 — Prima di costruire',
      consultingHighlight: 'Le nostre competenze in automazione e la vostra conoscenza dei processi',
      consultingStats: [
        { value: '50+', label: 'Anni di esperienza nell\'automazione industriale' },
        { value: '360°', label: 'Accompagnamento dalla pianificazione all\'esercizio' },
        { value: '1:1', label: 'Un referente personale per l\'intero progetto' },
      ],
      consultingServicesTitle: 'La nostra offerta di servizi comprende',
      consultingServices: [
        { title: 'Analisi dei requisiti', description: 'Rileviamo in modo strutturato i vostri obiettivi, vincoli e specifiche tecniche.' },
        { title: 'Analisi dei sistemi esistenti', description: 'Valutiamo la vostra infrastruttura attuale e individuiamo i potenziali di ottimizzazione.' },
        { title: 'Consulenza neutrale', description: 'Raccomandazioni indipendenti – scegliamo la soluzione giusta per voi, non un marchio.' },
        { title: 'Capitolato & concetto', description: 'Elaboriamo un capitolato preciso come base affidabile per il vostro progetto.' },
        { title: 'Gestione del progetto', description: 'Responsabilità, scadenze e comunicazione chiare – dall\'avvio al collaudo.' },
      ],
      services: {
        schaltschrankbau: { title: 'Costruzione quadri elettrici', description: 'Pronto per la serie dall\'unità 1 – testato, documentato, scalabile.' },
        hardware: { title: 'Ingegneria hardware', description: 'Design conforme EMC, sicurezza e documentazione conforme alle norme.' },
        software: { title: 'Ingegneria software', description: 'Programmi stabili, HMI pulita, pronto per IIoT.' }
      }
    },
    homepageContact: {
      title: 'Pronti per il prossimo passo?',
      button: 'Parlateci del vostro progetto'
    },
    teamPage: {
      heroTitle: 'Team',
      heroSubtitle: 'I nostri referenti sono a vostra disposizione.',
      followUs: 'Seguiteci'
    },
    careersPage: {
      hero: {
        title: 'Il tuo prossimo passo',
        subtitle: 'Flessibilità & Responsabilità',
        description: 'Come datore di lavoro radicato nella regione con attività internazionali, offriamo compiti entusiasmanti, condizioni affidabili e vere prospettive – dall\'ingresso alla specializzazione.'
      },
      intro: {
        title: 'Il tuo posto da Althaus',
        description: 'La tecnica non nasce da sola. Nasce da persone che pensano, agiscono e sviluppano soluzioni insieme. Da oltre 50 anni Althaus è sinonimo di automazione dalla Svizzera. Dietro ogni progetto ci sono collaboratori impegnati che mettono a disposizione le proprie competenze e si assumono responsabilità. Da noi trovi un ambiente in cui puoi svilupparti, portare le tue idee e plasmare insieme a noi il futuro.'
      },
      imageStatement: {
        title: '160 dipendenti pianificano, costruiscono e realizzano automazione.',
        description: 'Esperienza produttiva e l\'ambizione di migliorare ogni giorno. Viviamo questo atteggiamento in partnership solide e con una promessa chiara: ascoltiamo, pensiamo avanti e consegniamo qualità che dura.'
      },
      benefits: {
        title: 'Perché lavorare con noi?',
        subtitle: 'Questo è ciò che ci rende un datore di lavoro attraente',
        items: [
          { title: 'Atmosfera lavorativa familiare', description: 'Ognuno conta da noi – un team che sta insieme e si sostiene a vicenda.' },
          { title: 'Orari di lavoro flessibili', description: 'L\'equilibrio lavoro-vita non è solo uno slogan, ma una realtà vissuta da noi.' },
          { title: 'Progetti entusiasmanti', description: 'Compiti vari nell\'automazione – dall\'idea alla realizzazione.' },
          { title: 'Carriera & Sviluppo', description: 'Supportiamo il tuo sviluppo con formazioni interne e opportunità di avanzamento.' },
          { title: 'Futuro sicuro', description: 'Un\'azienda stabile con oltre 50 anni di esperienza e crescita positiva.' },
          { title: 'Posti di lavoro di qualità', description: 'Infrastruttura moderna, tecnologie più recenti e ambiente di lavoro piacevole.' },
          { title: '27 giorni di vacanza', description: 'Più tempo per il riposo, i viaggi e tutto ciò che ti sta a cuore. Con 27 giorni di vacanza, l\'equilibrio resta garantito.' },
          { title: 'Settimana di 40 ore', description: 'Strutture chiare per lavoro e tempo libero. Con una settimana di 40 ore, creiamo prevedibilità ed equilibrio.' },
          { title: 'Ristorazione sovvenzionata', description: 'Mangiare bene a condizioni vantaggiose. Con offerte di ristorazione sovvenzionate, il piacere fa parte della vita lavorativa quotidiana.' }
        ]
      },
      education: {
        title: 'Formazione e perfezionamento',
        description: 'Con formazioni e perfezionamenti mirati, contribuiamo allo sviluppo professionale e personale continuo dei nostri collaboratori. La formazione ha un alto valore anche in generale presso la W. Althaus AG. Come azienda formatrice, investiamo molto nella formazione delle nuove leve e consentiamo ai giovani adulti di entrare nel mondo professionale. Attualmente formiamo 28 apprendisti nelle professioni di tecnico dell\'automazione, montatore di automazione, impiegato di commercio e logistico.'
      },
      modernWork: {
        title: 'Lavorare in un ambiente all\'avanguardia',
        description: 'Dalla costruzione automatizzata di quadri elettrici ai posti di lavoro moderni. Lavori con tecnologia attuale, standard chiari e un team che vive l\'innovazione.'
      },
      cta: {
        title: 'Entra a far parte del nostro team',
        description: 'Cerchi sfide e spirito di squadra? Cresci con noi e condividi il nostro successo.',
        button: 'Vedi le posizioni aperte'
      }
    },
    aboutPage: {
      hero: {
        title: 'Radicati nella regione,',
        subtitle: 'impiegati nel mondo.',
        description: 'Dal 1968 combiniamo know-how, ingegneria e automazione in soluzioni complete per quadri elettrici – precise, ben pensate, affidabili.'
      },
      intro: {
        leadingIn: 'Leading in Automation',
        paragraphs: [
          'Siamo un\'azienda familiare svizzera fondata nel 1968 ad Aarwangen nel cantone di Berna. Oggi, oltre 160 dipendenti lavorano in due sedi, e la W. Althaus AG è considerata un datore di lavoro importante e pionieristico nella regione.',
          'La nostra competenza principale risiede nello sviluppo e nella produzione dai controlli elettrici più semplici alle soluzioni di automazione complesse.',
          'Con 50 anni di esperienza nell\'automazione industriale, siamo specialisti nello sviluppo di soluzioni personalizzate per l\'industria. Come azienda di servizi completi, offriamo un pacchetto di soluzioni completo con la nostra ampia offerta di servizi in consulenza concettuale, ingegneria hardware e software, costruzione quadri elettrici, produzione morsettiere, assemblaggio gruppi, supporto assemblaggio, messa in servizio e formazione.'
        ]
      },
      stats: {
        founded: { value: '1968', label: 'Fondata' },
        employees: { value: '160+', label: 'Dipendenti' },
        area: { value: "6'000m²", label: 'Area produttiva' },
        cabinets: { value: "10'000+", label: 'Quadri/anno' }
      },
      history: {
        title: 'La Nostra Storia',
        subtitle: 'Da un\'azienda individuale al principale costruttore di quadri elettrici in Svizzera – scoprite le nostre pietre miliari.',
        milestones: [
          { year: '1968', title: 'Fondazione', description: 'Walter Althaus senior avvia la propria attività come impresa individuale ad Aarwangen. Da modesti inizi nasce passo dopo passo un\'azienda familiare svizzera che si evolve costantemente e cresce in modo continuo.' },
          { year: '1970s', title: 'Prima produzione di quadri elettrici', description: 'Negli anni \'70 inizia la produzione di quadri elettrici. Dalla costruzione di semplici controlli, l\'azienda si sviluppa in specialista per soluzioni di automazione complete e documentate. La competenza tecnica viene sistematicamente ampliata, gettando le basi per l\'ulteriore espansione.' },
          { year: '1980s', title: 'Ampliamento della produzione e ingresso nell\'ECAD', description: 'La superficie produttiva sulla Jurastrasse viene ampliata da 400 a 800 metri quadrati, in risposta alla crescente domanda e al volume di progetti in aumento.\n\nParallelamente, l\'azienda entra nella progettazione assistita da computer con un programma ECAD. La digitalizzazione della pianificazione inizia, aumentando efficienza e qualità nell\'esecuzione dei progetti.' },
          { year: '1990s', title: 'Espansione, automazione e cambio generazionale', description: 'Gli spazi ufficio vengono ampliati con la costruzione di un secondo piano. L\'introduzione del primo sistema EPLAN professionalizza e standardizza ulteriormente la pianificazione elettrotecnica.\n\nVengono implementati i primi processi automatizzati. Le macchine per la lavorazione dei cavi vengono impiegate, aumentando significativamente la produttività.\n\nA metà degli anni \'90, Walter Althaus junior assume la direzione e guida l\'azienda nella fase di sviluppo successiva.' },
          { year: '1998', title: 'Sistema di test completamente automatizzato', description: 'Con il primo sistema di test completamente automatizzato per quadri elettrici, W. Althaus AG punta precocemente sulla garanzia di qualità automatizzata. Questa pietra miliare rafforza l\'affidabilità dei processi e garantisce una qualità di test costante.' },
          { year: '2000s', title: 'Automazione e trasferimento del sito', description: 'La produzione viene gradualmente ulteriormente automatizzata. La lavorazione della lamiera in particolare è sempre più supportata da macchine e integrata in catene di processo efficienti.\n\nLa superficie produttiva sulla Jurastrasse raggiunge i suoi limiti. La produzione viene quindi trasferita dal paese alla zona industriale di Aarwangen. Tra il 2007 e il 2011, vengono costruiti quattro capannoni aggiuntivi nel nuovo sito, creando l\'infrastruttura per un\'ulteriore crescita.' },
          { year: '2005', title: 'Ingresso nell\'ingegneria 3D', description: 'L\'avvio dell\'ingegneria 3D con la creazione di una base dati digitale segna un passo decisivo verso la pianificazione e la produzione connesse. Si crea così la base per processi continui dall\'ingegneria alla produzione.' },
          { year: '2008', title: 'Primo automa di assemblaggio morsetti', description: 'Con lo sviluppo del primo automa di assemblaggio morsetti proprietario, W. Althaus AG promuove miratamente l\'automazione. Le fasi di lavoro manuali vengono ridotte, i processi accelerati e la riproducibilità ulteriormente migliorata.' },
          { year: '2010s', title: 'Investimenti in automazione e digitalizzazione', description: 'Gli impianti di automazione esistenti vengono modernizzati e ampliati. I processi produttivi vengono digitalizzati, standardizzati e sistematicamente ottimizzati. L\'attenzione è rivolta a flussi di dati continui e una produzione efficiente lungo l\'intera catena del valore.' },
          { year: '2018', title: 'Sviluppo di un nuovo robot di cablaggio', description: 'Con l\'avvio dello sviluppo di un nuovo sistema di robot di cablaggio collaborativo, W. Althaus AG amplia sistematicamente le proprie competenze in automazione. Questa pietra miliare dimostra l\'ambizione di sviluppare soluzioni robotiche innovative mirate alle esigenze della moderna produzione di quadri elettrici.' },
          { year: '2020s', title: 'Crescita e nuova direzione', description: 'L\'azienda cresce a oltre 160 dipendenti. La competenza in automazione, l\'esperienza produttiva e il miglioramento continuo dei processi definiscono l\'identità aziendale.\n\nAll\'inizio degli anni 2020, Marco Schneider assume la carica di CEO e continua a guidare l\'azienda in modo strategico.' },
          { year: '2025', title: 'Partner Rittal + Eplan Application Center', description: 'Come primo partner Rittal + Eplan Application Center in Svizzera, l\'azienda riceve un riconoscimento ufficiale. Questa partnership sottolinea l\'orientamento costante verso processi basati sui dati nella costruzione di comandi e quadri e conferma la leadership tecnologica nelle soluzioni integrate di ingegneria e produzione.' }
        ]
      },
      values: {
        title: 'I Nostri Valori',
        subtitle: 'Cosa ci motiva e come lavoriamo – tre principi che plasmano le nostre azioni.',
        items: [
          { title: 'Qualità', subtitle: 'Consegniamo qualità che dura', description: 'Ogni quadro elettrico, ogni soluzione – fabbricata con precisione e pensata nei minimi dettagli. Il nostro standard: zero compromessi.' },
          { title: 'Partnership', subtitle: 'Ascoltiamo e pensiamo avanti', description: 'Relazioni a lungo termine invece di affari a breve termine. Comprendiamo le sfide dei nostri clienti e sviluppiamo soluzioni insieme.' },
          { title: 'Innovazione', subtitle: 'Migliorare ogni giorno', description: 'Stare fermi significa andare indietro. Investiamo continuamente in nuove tecnologie, processi e nello sviluppo del nostro team.' }
        ]
      },
      regionalEngagement: {
        title: 'Impegno nella regione',
        paragraphs: [
          'Come azienda profondamente radicata nella regione, per noi è importante contribuire non solo dal punto di vista economico, ma anche sociale. Per questo motivo sosteniamo associazioni, progetti ed eventi nella regione di Aarwangen.',
          'La nostra sponsorizzazione è rivolta principalmente ad associazioni ed eventi locali che rafforzano la vita del paese e associativa con il loro impegno. Che si tratti di eventi sportivi, progetti culturali o incontri comunitari, vogliamo contribuire affinché tali iniziative siano possibili e le persone della regione si ritrovino.',
          'Siamo convinti che una vita associativa vivace contribuisca in modo importante all\'identità regionale. Per questo sosteniamo impegni selezionati laddove hanno un impatto: direttamente sul posto, con le persone e le organizzazioni del nostro territorio.'
        ],
        supportedTitle: 'Associazioni ed eventi che abbiamo avuto il piacere di sostenere'
      }
    },
    sustainabilityPage: {
      hero: {
        title: 'Responsabilità per',
        subtitle: 'Ambiente, Società & Futuro',
        description: 'Come azienda familiare svizzera, agiamo responsabilmente – per il nostro ambiente, la nostra regione e le generazioni future.'
      },
      intro: {
        title: 'Responsabile. Orientato al futuro.',
        subtitle: 'Althaus',
        titleSuffix: '– Sostenibilità con sistema.',
        paragraphs: [
          'Per noi, sostenibilità significa più che protezione ambientale. Pensiamo ecologicamente, economicamente e socialmente – in modo olistico lungo l\'intero ciclo di vita del prodotto. Attraverso processi digitalizzati, ingegneria ECAD e produzione altamente automatizzata, riduciamo gli scarti, l\'uso dei materiali e i tempi di consegna – dal primo pezzo in poi.',
          'Nel 2024 siamo stati premiati con il badge Committed da EcoVadis – una conferma del nostro impegno continuo. Sono stati valutati i settori ambiente, diritti del lavoro e umani, etica e approvvigionamento sostenibile. In ambiente, diritti del lavoro e umani ed etica, siamo sopra la media del settore. Inoltre, garantiamo qualità e prestazioni ambientali con i nostri sistemi di gestione secondo ISO 9001 e ISO 14001 e miglioriamo entrambi continuamente.',
          'Rispettiamo costantemente tutti i requisiti legali, inclusa la conformità dei materiali, e andiamo oltre secondo il principio ridurre, riutilizzare, riciclare. Utilizziamo il rame ad alta intensità di risorse in modo particolarmente efficiente. Con ottimizzazioni operative e manutenzione regolare degli impianti, aumentiamo l\'efficienza energetica, il nostro parco di veicoli elettrici riduce la domanda di carburante e gli impianti fotovoltaici sui nostri tetti rafforzano l\'impronta di carbonio nella rete elettrica. Insieme ai nostri clienti, fornitori e partner, identifichiamo ulteriori potenziali per soluzioni più sostenibili in qualità svizzera.'
        ]
      },
      metrics: {
        title: 'Numeri e Obiettivi',
        items: [
          { value: '95%', label: 'Grado di automazione' },
          
          { value: '40%', label: 'Energia solare' },
          { value: '2030', label: 'Neutrale in carbonio' }
        ]
      },
      impact: {
        title: 'Sostenibilità con impatto',
        description: 'Combiniamo responsabilità ecologica, sociale ed economica con risultati misurabili. Certificati secondo ISO 9001/14001 e confermati da EcoVadis (Committed 2024) – efficienti, trasparenti, orientati al futuro.'
      },
      achievements: {
        title: 'Le nostre iniziative di sostenibilità',
        categories: [],
        items: [
          { title: 'Certificazione ISO 14001', subtitle: 'Sistema di gestione ambientale certificato', description: 'Introduzione e certificazione del nostro sistema di gestione ambientale secondo ISO 14001 per il miglioramento continuo delle nostre prestazioni ambientali.' },
          { title: 'Energia solare propria', subtitle: 'Impianti fotovoltaici in due sedi', description: 'Con impianti fotovoltaici presso il sito produttivo (380 kWp) e la sede centrale (110 kWp), generiamo parte del nostro fabbisogno energetico autonomamente.' },
          { title: 'Accumulo di energia', subtitle: 'Batteria di accumulo presso la sede', description: 'Un sistema di accumulo a batteria da 80 kW consente un utilizzo più efficiente della nostra energia solare autoprodotta.' },
          { title: 'Produzione efficiente dal punto di vista energetico', subtitle: 'Tecnologie produttive moderne', description: 'Il passaggio dai sistemi di taglio laser CO2 ai moderni laser a fibra riduce il consumo energetico aumentando al contempo l\'efficienza produttiva.' },
          { title: 'Illuminazione intelligente', subtitle: 'LED con sensori di presenza e luce diurna', description: 'Passando all\'illuminazione LED con controllo automatico di presenza e luce diurna, riduciamo significativamente il consumo energetico nei nostri edifici.' },
          { title: 'Elettromobilità', subtitle: 'Conversione graduale della flotta veicoli', description: 'Parte dei nostri veicoli aziendali è già alimentata elettricamente. L\'elettrificazione della nostra flotta viene continuamente ampliata.' },
          
          { title: 'Sostenibilità come processo continuo', subtitle: 'Passo dopo passo verso una maggiore efficienza', description: 'Lavoriamo costantemente per ridurre il nostro consumo energetico e le nostre emissioni. Nuove tecnologie e ottimizzazioni vengono continuamente valutate e implementate.' }
        ]
      },
      outlook: {
        title: 'Prospettive',
        headline: 'Sostenibilità – Agenda 2030',
        description: 'Il nostro percorso verso la trasformazione sostenibile – passo dopo passo verso risultati misurabili e un impatto a lungo termine.',
        milestones: [
          { year: '2026', title: 'Bilancio GHG (Scope 1–3)', description: 'Nel 2026 verrà avviato e implementato il progetto di bilancio dei gas a effetto serra secondo il protocollo GHG (Scope 1, 2 e 3) con il partner di progetto esterno valutato. Il bilancio GHG aziendale verrà creato, plausibilizzato e documentato.' },
          { year: '2027', title: 'Percorso Net-Zero', description: 'Sulla base del bilancio dei gas a effetto serra, nel 2027 verrà definito un percorso net-zero specifico per l\'azienda. Questo include anni target concreti, obiettivi di riduzione e misure prioritarie per la riduzione graduale delle emissioni di gas a effetto serra su Scope 1–3. Il percorso net-zero verrà adottato e integrato nei processi aziendali rilevanti.' },
          { year: '2028', title: 'Report di Sostenibilità (VSME)', description: 'Nel 2028 verrà creato per la prima volta un report di sostenibilità strutturato conformemente ai requisiti VSME. Il report si basa sui dati ambientali, climatici e di governance esistenti, riflette lo stato di attuazione delle misure definite e garantisce la trasparenza nei confronti degli stakeholder rilevanti.' },
          { year: '2029', title: 'Strategia di Sostenibilità', description: 'Entro la fine del 2029 verrà sviluppata, adottata e comunicata una strategia di sostenibilità a livello aziendale. Questa si basa sui risultati del bilancio GHG, del percorso net-zero definito, del reporting di sostenibilità e sui cinque temi leva centrali identificati. La strategia definisce obiettivi a lungo termine, campi d\'azione prioritari, misure e responsabilità.' }
        ]
      }
    },
    vocationalTrainingPage: {
      hero: {
        title: 'La tua formazione da Althaus',
        subtitle: 'Tecnologia & Futuro',
        description: 'Tecnico dell\'automazione, montatore di automazione o specialista in logistica – formiamo in modo diversificato e ti supportiamo specificamente nel tuo percorso verso il mondo professionale.'
      },
      nachwuchs: {
        title: 'Giovani talenti con un futuro',
        subtitle: 'Da oltre 50 anni formiamo giovani talenti – e siamo orgogliosi di ogni diplomato.',
        stats: {
          graduates: { value: '120+', label: 'Diplomati di successo' },
          apprenticeships: { value: '3', label: 'Apprendistati', description: 'Tecnico dell\'automazione, montatore di automazione e specialista in logistica – tre strade verso il futuro.' },
          experience: { value: '50+', label: 'Anni di esperienza', description: 'nella formazione di giovani professionisti' }
        },
        cta: {
          title: 'Interessato a uno stage di prova?',
          description: 'Conosci la nostra azienda e le professioni – iscriviti ora.',
          button: 'Allo stage di prova'
        }
      },
      intro: {
        title: 'Formiamo professionisti',
        paragraphs: [
          'Puntiamo su una formazione professionale solida e attiva per garantire i giovani talenti. La nostra formazione professionale si distingue per una formazione di alta qualità e varia con formazioni approfondite estese.',
          'La formazione e il supporto dei giovani professionisti sono per noi il prerequisito più importante per mantenere e rafforzare la Svizzera come sede produttiva.'
        ]
      },
      openPositions: {
        title: 'Posti di apprendistato aperti',
        subtitle: 'Panoramica delle nostre professioni formative e disponibilità'
      },
      badges: {
        available: 'Disponibile',
        assigned: 'Assegnato'
      },
      buttons: {
        learnMore: 'Scopri di più'
      },
      apprenticeships: {
        automatiker: {
          title: 'Tecnico dell\'automazione AFC',
          duration: '4 anni',
          description: 'Come tecnico/a dell\'automazione, lavori sulla tecnologia che controlla macchine, impianti e sistemi di produzione automatizzati. L\'automazione e la robotica plasmano l\'industria di oggi e tu sei nel mezzo dell\'azione.',
          detailedDescription: 'Presso W. Althaus AG, impari come i comandi elettrici vengono pianificati, costruiti e testati. Lavori su progetti reali e ottieni approfondimenti sulle moderne soluzioni di automazione per macchine e impianti industriali.\n\nDurante la tua formazione, conosci vari settori, tra cui la costruzione di armadi elettrici, il reparto test, la robotica, la progettazione elettrica, la programmazione e l\'automazione industriale. Nel terzo anno di apprendistato, puoi approfondire ulteriormente software, hardware, progettazione elettrica o nel reparto test, a seconda dei tuoi interessi e delle esigenze.',
          highlights: [
            'Costruire e cablare comandi elettrici e armadi elettrici',
            'Montare, collegare e testare componenti elettrici',
            'Leggere schemi e comprendere la documentazione tecnica',
            'Ottenere approfondimenti sull\'automazione industriale e la robotica',
            'Acquisire prime esperienze nella programmazione e in progetti propri',
            'Testare comandi e supportare la ricerca guasti'
          ],
          requirements: 'Scuola secondaria con buone prestazioni in matematica e fisica e interesse per la tecnica e l\'elettronica.',
          career: 'Formazione continua come tecnico SSS o studi presso una scuola universitaria professionale nel campo dell\'automazione o dell\'elettrotecnica.'
        },
        automatikmonteur: {
          title: 'Montatore di automazione AFC',
          duration: '3 anni',
          description: 'Come montatore/trice di automazione, lavori sulla tecnologia che collega macchine e impianti con comandi elettrici. Costruisci e cabli comandi utilizzati nell\'industria per impianti di produzione automatizzati.',
          detailedDescription: 'Presso W. Althaus AG, impari come gli armadi elettrici vengono costruiti, cablati e testati. Lavori direttamente nella produzione e aiuti ad assemblare passo dopo passo comandi per macchine e impianti industriali.\n\nDurante la tua formazione, ottieni approfondimenti in vari settori della costruzione di armadi elettrici, tra cui montaggio, cablaggio e lavori di test. Impari come singoli componenti diventano comandi funzionanti.',
          highlights: [
            'Costruire e cablare armadi elettrici e comandi elettrici',
            'Montare, collegare e testare componenti elettrici',
            'Leggere schemi e comprendere la documentazione tecnica',
            'Testare comandi e riconoscere errori semplici',
            'Lavorare nella costruzione di armadi elettrici e nella produzione'
          ],
          requirements: 'Scuola secondaria o scuola secondaria generale e interesse per la tecnica e il lavoro manuale.',
          career: 'Formazione continua nel campo dell\'elettrotecnica e dell\'automazione.'
        },
        logistiker: {
          title: 'Specialista in logistica AFC',
          duration: '3 anni',
          description: 'Come specialista in logistica, ti assicuri che materiali, componenti e prodotti siano nel posto giusto al momento giusto. Così mantieni la nostra produzione in funzione e garantisci che tutti i componenti necessari siano disponibili.',
          detailedDescription: 'Presso W. Althaus AG, lavori con moderni sistemi di magazzino e logistica e mantieni sempre una panoramica delle scorte e dei flussi di materiale. Ricevi merci, le immagazzini, prepari materiali per la produzione e organizzi la spedizione dei prodotti finiti.\n\nDurante la tua formazione, attraversi vari settori del magazzino, tra cui ricezione merci, gestione del magazzino, picking e spedizione. Passo dopo passo impari come funziona un moderno flusso di materiali in un\'azienda industriale.',
          highlights: [
            'Ricevere, controllare e immagazzinare correttamente le merci',
            'Preparare materiali per la produzione e il montaggio',
            'Comporre ordini e prepararli per la spedizione',
            'Gestire le scorte con moderni sistemi digitali',
            'Organizzare e coordinare i trasporti in azienda',
            'Collaborare in settori come ricezione merci, gestione magazzino, picking e spedizione'
          ],
          requirements: 'Scuola secondaria o scuola secondaria generale, talento organizzativo e piacere per il lavoro pratico.',
          career: 'Formazione continua come specialista in logistica o specializzazione nel campo della logistica o del supply chain management.'
        }
      },
      detailedSection: {
        title: 'Le nostre professioni formative in dettaglio',
        whatYouLearn: 'Cosa imparerai:',
        requirements: 'Requisiti:',
        career: 'Carriera:'
      },
      quote: 'La tua formazione è l\'inizio – plasmiamo insieme il tuo futuro!',
      benefits: {
        title: 'Perché da noi?',
        subtitle: 'Questi vantaggi ti aspettano nella tua formazione',
        items: [
          { title: 'Ambiente familiare', description: 'Supporto personale e un team che sta insieme.' },
          { title: 'Formazione pratica', description: 'Dal primo giorno, lavori su veri progetti dei clienti.' },
          { title: 'Opportunità di carriera', description: 'Possibilità di assunzione e supporto per la formazione continua dopo l\'apprendistato.' },
          { title: 'Futuro sicuro', description: 'Un\'azienda stabile con oltre 50 anni di esperienza.' },
          { title: 'Infrastruttura moderna', description: 'Lavorare con le tecnologie e gli strumenti più recenti.' },
          { title: 'Formatori esperti', description: 'Formatori qualificati ti accompagnano nel tuo percorso.' }
        ]
      },
      path: {
        title: 'Il percorso verso l\'apprendistato',
        subtitle: 'In quattro passi verso la tua formazione da Althaus',
        steps: [
          { title: 'Informati', description: 'Esplora vari campi professionali e i loro requisiti sul nostro sito web e presso i servizi di consulenza.' },
          { title: 'Stage di prova', description: 'Candidati per uno stage di prova di 2 giorni e conosci la professione e la nostra azienda.' },
          { title: 'Candidatura', description: 'Inviaci i tuoi documenti completi: lettera di motivazione, CV, foto e certificati.' },
          { title: 'Inizio dell\'apprendistato', description: 'Dopo una candidatura di successo, inizi la tua formazione da noi in agosto.' }
        ]
      },
      events: {
        title: 'I Nostri Eventi',
        subtitle: 'Giornate di prova, eventi informativi e altro',
        viewAll: 'Vedi tutte le notizie sulla formazione professionale'
      },
      form: {
        title: 'Richiedi stage di prova',
        subtitle: 'Conosci la professione e la nostra azienda durante uno stage di prova di 2 giorni',
        sections: {
          personal: 'Dati personali',
          school: 'Scuola',
          apprenticeship: 'Stage di prova'
        },
        fields: {
          firstName: 'Nome',
          lastName: 'Cognome',
          email: 'E-mail',
          phone: 'Telefono',
          birthDate: 'Data di nascita',
          shoeSize: 'Numero di scarpa',
          street: 'Via',
          city: 'CAP / Città',
          school: 'Scuola attuale',
          schoolYear: 'Classe scolastica',
          desiredProfession: 'Professione desiderata',
          desiredApprenticeshipStart: 'Inizio apprendistato desiderato',
          desiredDate: 'Data desiderata nel periodo selezionato',
          preferredPeriod: 'Settimana preferita (lun–ven)',
          referralSource: 'Come ci hai conosciuti?',
          message: 'Osservazioni / Motivazione'
        },
        placeholders: {
          shoeSize: 'es. 42',
          city: 'es. 4912 Aarwangen',
          schoolYear: 'es. 8ª classe secondaria',
          selectProfession: 'Seleziona professione',
          selectApprenticeshipStart: 'Seleziona inizio',
          selectPeriod: 'Seleziona settimana',
          referralSource: 'es. raccomandazione, scuola, internet, social media…',
          message: 'Perché sei interessato a questa professione? Hai richieste particolari?'
        },
        professions: {
          automatiker: 'Tecnico dell\'automazione AFC (2 giorni)',
          automatikmonteur: 'Montatore di automazione AFC (2 giorni)',
          logistiker: 'Specialista in logistica AFC (2 giorni)'
        },
        periods: {
          fruehlingsferien: 'Vacanze di primavera',
          sommerferien: 'Vacanze estive',
          herbstferien: 'Vacanze autunnali',
          sonstiges: 'Altro'
        },
        attachments: {
          title: 'Allegati per la tua candidatura allo stage di prova',
          intro: 'Carica i seguenti documenti in modo completo affinché possiamo valutare la tua candidatura:',
          bullet1: 'CV con una foto recente',
          bullet2: 'Breve lettera di motivazione in cui spieghi perché sei interessato a questo stage di prova',
          bullet3: 'Copie delle pagelle degli ultimi due anni scolastici',
          pdfHint: 'Assicurati che tutti i documenti siano in formato PDF (max. 15 MB in totale). Tutte le informazioni saranno naturalmente trattate in modo riservato.',
          cvLabel: 'CV (PDF)',
          motivationLabel: 'Lettera di motivazione (PDF)',
          certificatesLabel: 'Pagelle degli ultimi 2 anni scolastici (PDF)',
          notesLabel: 'Testo libero / Altro',
          notesPlaceholder: 'Ulteriori informazioni che vorresti comunicarci…'
        },
        submitted: {
          title: 'Abbiamo ricevuto la tua candidatura',
          text: 'Grazie per la tua candidatura allo stage di prova.\nAbbiamo ricevuto i tuoi documenti e ti ricontatteremo nei prossimi giorni.',
          contactBefore: 'Per qualsiasi domanda, puoi contattarci in qualsiasi momento all\'indirizzo ',
          contactAfter: '.',
          insightsTitle: 'Uno sguardo alla nostra formazione professionale',
          newApplication: 'Inserisci una nuova candidatura'
        },
        privacy: 'Accetto l\'{link} e acconsento che i miei dati vengano utilizzati per elaborare la mia richiesta.',
        privacyLink: 'Informativa sulla privacy',
        submit: 'Richiedi stage di prova',
        toast: {
          error: 'Si prega di accettare l\'informativa sulla privacy',
          missingDocuments: 'Carica tutti e tre i documenti (PDF).',
          tooLarge: 'I documenti sono complessivamente troppo grandi (max. 15 MB).',
          notPdf: '"{name}" non è un PDF. Carica solo file PDF.',
          success: 'La tua richiesta è stata inviata! Ti ricontatteremo.'
        }
      },
      cta: {
        title: 'Pronto a iniziare?',
        description: 'Candidati ora per un apprendistato presso W. Althaus AG e diventa parte del futuro dell\'automazione.',
        contactTitle: 'Responsabile della formazione professionale'
      }
    },
    productsPage: {
      title: 'Prodotti',
      subtitle: 'Soluzioni di automazione innovative per la massima efficienza',
      athex: { name: 'Athex', title: 'Produzione di morsettiere' },
      panelscout: { name: 'Panelscout', title: 'Controllo di test' }
    },
    leitbildPage: {
      hero: { title: 'Leading in Automation', subtitle: 'Qualità & Fiducia', description: '"Leading in Automation" significa per noi: fornire in qualsiasi momento e in qualsiasi luogo del mondo tecnologie e prodotti altamente automatizzati e innovativi "made in Switzerland". In questo contesto, coltiviamo una partnership sostenibile con tutti i nostri interlocutori.' },
      intro: {
        title: 'Affidabile. Innovativo.',
        highlight: 'Althaus',
        suffix: '– Il vostro partner per l\'automazione industriale.',
        paragraphs: [
          'Al centro della nostra attività c\'è la creazione di un\'automazione industriale continua, di alta qualità e sostenibile.',
          'La nostra infrastruttura all\'avanguardia costituisce il fondamento stabile per qualità ed efficienza.',
          'Altrettanto importante: comunicazione e lavoro di squadra.',
          'E poiché le prestazioni eccellenti richiedono un buon ambiente, progettiamo i luoghi di lavoro del futuro.'
        ]
      },
      values: {
        trust: { title: 'Fiducia, Continuità e Competenza', description: 'L\'automazione significa per noi anche continuità. Con i nostri dipendenti, clienti, partner e fornitori manteniamo una partnership a lungo termine e di fiducia.' },
        quality: { title: 'Qualità per il Cliente', description: 'Dobbiamo il successo della nostra azienda essenzialmente alle soluzioni personalizzate per i clienti e all\'alta qualità dei prodotti.' }
      },
      cta: 'Visualizza il nostro BigPicture'
    },
    chameleonPage: {
      heroTitle: 'Adattivo nell\'Automazione',
      heroSubtitle: 'Lungimiranza & Precisione',
      sections: [
        { title: 'Come un camaleonte. Solo industriale.', subtitle: 'Reagiamo velocemente, manteniamo il controllo e forniamo soluzioni precise.', content: '' },
        { title: 'Adattamento perfetto – Soluzioni su misura', content: 'Un camaleonte cambia colore per integrarsi perfettamente nel suo ambiente. Noi cambiamo prospettiva per adattarci perfettamente.' },
        { title: 'Visione completa – Pianificazione con lungimiranza', content: 'Il camaleonte vede con entrambi gli occhi indipendentemente. Così vediamo i progetti.' },
        { title: 'Attacco mirato – Processi precisi', content: 'Quando il camaleonte colpisce, il momento è scelto perfettamente.' },
        { title: 'Presa salda – Qualità nei dettagli', content: 'I piedi prensili danno al camaleonte stabilità. La nostra stabilità nasce dalla profondità dei dettagli.' },
        { title: 'Mimetismo perfetto – Integrazione senza soluzione di continuità', content: 'Il mimetismo non è un trucco, ma una strategia. Per noi significa partnership.' },
        { title: 'Rinnovamento costante – Il cambiamento nel DNA', content: 'Il camaleonte muta per restare agile. Ci evolviamo allo stesso modo.' }
      ],
      cta: { title: 'Pronti per un cambio di colore?', subtitle: 'Diamo il tono giusto al vostro progetto.', button: 'Contattateci' }
    },
    documentsPage: {
      title: 'Documenti',
      subtitle: 'Qui trovate tutti i documenti, certificati e materiali importanti di W. Althaus AG da scaricare.',
      categories: [
        { title: 'Azienda', documents: [{ name: 'Logo (.png)', url: '/documents/W_Althaus_AG_Logo.png' }, { name: 'Dati aziendali', url: '/documents/Firmendaten_2026.pdf' }, { name: 'Organigramma', url: '/documents/organigramm.pdf' }] },
        { title: 'Valori & Cultura', documents: [{ name: 'Missione (BigPicture)', url: '/documents/Althaus_Wertehaus_Bigpicture_2024.pdf' }, { name: 'Codice di condotta', url: '/documents/Verhaltenskodex_W._Althaus_AG.pdf' }] },
        { title: 'Condizioni d\'acquisto & consegna', documents: [{ name: 'Condizioni generali d\'acquisto (Deutsch)', url: '/documents/Allgemeine_Einkaufsbedingungen.pdf' }, { name: 'Condizioni generali d\'acquisto (English)', url: '/documents/General_Terms_and_Conditions_of_Purchase.pdf' }, { name: 'Condizioni generali d\'acquisto (Français)', url: '/documents/Conditions_generales_d_achat.pdf' }, { name: 'Condizioni generali di consegna', url: '/documents/W._Althaus_AG_Allgemeine_Lieferbedingungen.pdf' }] },
        { title: 'Certificazioni ISO', documents: [{ name: 'ISO 9001:2015 / ISO 14001:2015 (Tedesco)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_DE.pdf' }, { name: 'ISO 9001:2015 / ISO 14001:2015 (Inglese)', url: '/documents/SQS_Zertifikat_ISO_9001_14001_2015_EN.pdf' }] },
        { title: 'Certificati di sostenibilità', documents: [{ name: 'Protezione climatica volontaria', url: '/documents/Zertifikat_Energie-Agentur_der_Wirtschaft.pdf' }, { name: 'Certificato di sostenibilità EcoVadis', url: '/documents/Ecovadis_W._Althaus_AG.pdf' }] },
        { title: 'Norme & Associazioni', documents: [{ name: 'Certificato UL', url: '/documents/Certificate_of_Compliance_UL.pdf' }, { name: 'Certificato EKAS VSAS', url: '/documents/EKAS_Zertifikat_VSAS.pdf' }] }
      ],
      contactNote: 'Avete bisogno di ulteriori documenti o avete domande? Contattateci a'
    },
    imprintPage: {
      title: 'Impressum',
      contact: { title: 'Contatto' },
      register: { title: 'Iscrizione al registro di commercio', company: 'Ragione sociale: W. Althaus AG', number: 'Numero: CHE‑375.798.234', office: 'Ufficio del registro di commercio del Cantone di Berna' },
      vat: { title: 'Numero IVA', number: 'CHE-375.798.234 IVA' },
      disclaimer: { title: 'Esclusione di responsabilità', paragraphs: ['W. Althaus AG non assume alcuna responsabilità per la correttezza, l\'accuratezza, l\'attualità, l\'affidabilità e la completezza delle informazioni.', 'Le richieste di risarcimento sono escluse.', 'Tutte le offerte sono senza impegno.'] },
      links: { title: 'Responsabilità per i link', text: 'I riferimenti e i link a siti di terzi sono al di fuori della nostra area di responsabilità.' },
      copyright: { title: 'Diritti d\'autore', text: 'I diritti d\'autore e tutti gli altri diritti sui contenuti, immagini, foto o altri file del sito appartengono esclusivamente a W. Althaus AG.' }
    },
    privacyPage: {
      title: 'Protezione dei dati',
      sections: [
        { title: 'Ambito di applicazione', content: ['Questa dichiarazione sulla protezione dei dati informa gli utenti sulla natura, l\'ambito e le finalità della raccolta e dell\'utilizzo dei dati personali.'] },
        { title: 'Indirizzo di contatto', content: ['Per ulteriori informazioni sulla protezione dei dati, contattate il nostro responsabile della protezione dei dati via e-mail.', 'Contatto: {email}'] },
        { title: 'Protezione dei dati / Dati di accesso', content: ['In base all\'articolo 13 della Costituzione federale svizzera, ogni persona ha diritto alla protezione della propria sfera privata.'] },
        { title: 'Google Analytics', content: ['Questo sito utilizza Google Analytics, un servizio di analisi web fornito da Google Inc.'] },
        { title: 'Trattamento dei dati personali', content: ['I dati personali vengono raccolti solo se consentito dalla legge o con il consenso degli utenti.'] },
        { title: 'Candidature online', content: ['La protezione dei vostri dati personali è importante per noi.'] },
        { title: 'Cookie', content: ['Questo sito utilizza cookie per l\'analisi e il miglioramento continuo.'] },
        { title: 'Revoca, Modifiche e Aggiornamenti', content: ['L\'utente ha il diritto di ottenere gratuitamente informazioni sui propri dati personali memorizzati.', 'Contatto: {email}'] }
      ]
    },
    welcomeSection: {
      text: 'W. Althaus AG – Leading in Automation dal 1968.'
    },
    athexPage: {
      tagline: 'automatizzato. preciso. Althaus.',
      heroDescription: 'Con {product}, rivoluzioniamo la produzione di morsettiere.',
      cards: [
        { title: 'Cos\'è Athex?', text: 'Athex è il nostro sistema proprietario per la produzione completamente automatizzata di morsettiere.' },
        { title: 'Tecnologia all\'avanguardia', text: 'Athex utilizza i dati ECAD direttamente da ePlan ed E3.' },
        { title: 'I vostri vantaggi', text: 'Massima precisione grazie alla produzione completamente automatizzata.' }
      ],
      functionsTitle: 'Funzioni Athex',
      functions: {
        ecad: { name: 'Integrazione ECAD', description: 'Trasferimento diretto dei dati da ePlan P8, ePlan Pro Panel ed E3.series.' },
        automated: { name: 'Completamente automatizzato', description: 'Dalla distinta base alla morsettiera finita senza intervento manuale.' },
        errorFree: { name: 'Produzione senza errori', description: 'Eliminazione delle fonti di errore manuali.' },
        fast: { name: 'Tempi rapidi', description: 'Tempi di produzione drasticamente ridotti.' },
        flexible: { name: 'Quantità flessibili', description: 'Produzione economica dal pezzo singolo alla grande serie.' },
        traceability: { name: 'Tracciabilità', description: 'Documentazione e tracciamento completi.' }
      },
      valueTitle: 'Il vostro valore aggiunto con Athex',
      values: [
        { title: 'Velocità', description: 'Fino all\'80% di tempi più rapidi.' },
        { title: 'Qualità', description: 'Qualità costantemente elevata.' },
        { title: 'Flessibilità', description: 'Produzione economica dal lotto 1.' },
        { title: 'Integrazione', description: 'Connessione trasparente ai vostri sistemi ECAD.' }
      ]
    },
    panelscoutPage: {
      tagline: 'intelligente. affidabile. Althaus.',
      heroDescription: 'Con {product}, portiamo un controllo di test intelligente nella vostra costruzione di quadri.',
      cards: [
        { title: 'Cos\'è Panelscout?', text: 'Panelscout è il nostro sistema di controllo di test intelligente per quadri elettrici.' },
        { title: 'Logica di test intelligente', text: 'Panelscout utilizza routine di test adattive.' },
        { title: 'I vostri vantaggi', text: 'Garanzia di qualità completa attraverso test automatizzati.' }
      ],
      functionsTitle: 'Funzioni Panelscout',
      functions: {
        testing: { name: 'Test automatico', description: 'Test funzionali e di sicurezza completamente automatizzati.' },
        documentation: { name: 'Documentazione completa', description: 'Protocollo automatico di tutti i valori misurati.' },
        errorDetection: { name: 'Rilevamento errori', description: 'Identificazione precoce degli errori di cablaggio.' },
        compliance: { name: 'Conformità alle norme', description: 'Test secondo IEC, EN e norme industriali.' },
        speed: { name: 'Tempi di test rapidi', description: 'Routine di test ottimizzate.' },
        traceability: { name: 'Tracciabilità', description: 'Tracciamento completo di tutti i risultati dei test.' }
      },
      valueTitle: 'Il vostro valore aggiunto con Panelscout',
      values: [
        { title: 'Sicurezza', description: 'Test completi per la massima sicurezza operativa.' },
        { title: 'Qualità', description: 'Standard di qualità costantemente elevati.' },
        { title: 'Efficienza', description: 'Test più rapidi con maggiore profondità.' },
        { title: 'Documentazione', description: 'Protocolli conformi alle norme.' }
      ]
    },
    hardwareEngineeringPage: {
      tagline: 'modulare. conforme. Althaus.',
      heroDescription: 'Sviluppiamo soluzioni hardware intelligenti per la vostra automazione. Dalla progettazione all\'implementazione con le tecnologie più moderne.',
      featureCards: [
        { title: 'Cosa ottenete da Althaus', description: 'Elaboriamo con voi concetti di hardware e di controllo per impianti e macchine. Con la modularizzazione e il Digital Twin creiamo kit standardizzati e riutilizzabili, riduciamo gli sforzi di ingegneria e forniamo dati pronti per la produzione.' },
        { title: 'Dal concetto alla messa in servizio', description: 'Modelliamo ECAD con ePlan P8/Pro Panel come gemello digitale, modularizziamo gli impianti, progettiamo quadri elettrici inclusi layout e routing del cablaggio, rispettiamo EN/UL/CSA, garantiamo la sicurezza funzionale, forniamo dati di produzione e accompagniamo test, documentazione e consegna.' },
        { title: 'Come lavoriamo', description: 'Definiamo in stretta collaborazione obiettivi, norme e interfacce, modularizziamo il vostro impianto per la riutilizzabilità e sviluppiamo concetti di quadri conformi alle norme. Dalla valutazione dei rischi ai dati di produzione, passando per la documentazione e la messa in servizio – tutto da un\'unica fonte.' }
      ],
      servicesTitle: 'La nostra offerta di servizi comprende',
      services: [
        { name: 'Consulenza concettuale per schemi elettrici', description: 'Consulenza professionale e creazione di schemi elettrici' },
        { name: 'Sistemi CAD: ePlan P8, ePlan Pro Panel', description: 'Pianificazione professionale con gli strumenti CAD più moderni' },
        { name: 'Modularizzazione e automazione degli impianti', description: 'Automazione moderna per concetti di impianti efficienti' },
        { name: 'Concetto di quadro: costruzione, layout', description: 'Costruzione precisa e progettazione ottimale del layout' },
        { name: 'Norme/regolamenti: EN, UL, CSA', description: 'Conformità totale agli standard internazionali' },
        { name: 'Concetti di sicurezza e valutazione dei rischi', description: 'Analisi di sicurezza complete secondo i massimi standard' }
      ],
      valueTitle: 'Il vostro valore aggiunto attraverso l\'Hardware Engineering',
      values: [
        { title: 'Base dati coerente', description: 'Dal primo schema alla messa in servizio – tutti i dati coerenti e riutilizzabili.' },
        { title: 'Meno costi di ingegneria', description: 'Grazie a standard, modelli e riutilizzo, riduciamo significativamente lo sforzo.' },
        { title: 'Sicurezza conforme alle norme', description: 'Progettato e documentato secondo EN/UL/CSA per la conformità internazionale.' },
        { title: 'Scalabilità modulare', description: 'Kit riutilizzabili consentono adattamenti ed estensioni rapidi.' }
      ]
    },
    softwareEngineeringPage: {
      tagline: 'intelligente. intuitivo. Althaus.',
      heroDescription: 'I nostri ingegneri software danno vita alle vostre macchine. Sviluppiamo soluzioni software intelligenti per la vostra automazione. Dalla progettazione all\'implementazione – con le tecnologie più moderne.',
      featureCards: [
        { title: 'Cosa ottenete da Althaus', description: 'I nostri ingegneri software vi guidano dalla pianificazione e dal concetto al capitolato, sviluppano software vicino al controllo, HMI/SCADA intuitivi e app SQL personalizzate. Consulenza neutrale e value engineering. In coordinamento con l\'ingegneria hardware – per flussi di dati continui fino alla produzione e alla messa in servizio.' },
        { title: 'Ambito dei servizi - Competenze e strumenti', description: 'Analisi neutrale, architettura e stack tecnologico; funzioni prioritarie per tempo di ciclo e stabilità; gestione trasparente dei progetti. UI intuitive con allarmi, ricette, audit trail; PLC/Motion e Safety affidabili. Messa in servizio mondiale più servizio, monitoring, aggiornamenti e supporto remoto rapido.' },
        { title: 'Come lavoriamo', description: 'Dalla prima analisi dei requisiti alla messa in servizio mondiale. Chiariamo obiettivi, stack tecnologico e interfacce, sviluppiamo architetture software modulari e applichiamo metodi agili. Documentazione, testing e supporto remoto assicurano l\'affidabilità a lungo termine della vostra soluzione di automazione.' }
      ],
      servicesTitle: 'La nostra offerta di servizi comprende',
      services: [
        { name: 'Programmazione PLC/Motion', description: 'Programmazione di controllo per tutte le piattaforme comuni' },
        { name: 'Sviluppo HMI/SCADA', description: 'Interfacce utente intuitive con allarmi e ricette' },
        { name: 'Applicazioni database', description: 'Applicazioni SQL Server con audit trail e reporting' },
        { name: 'Digital Twin & Simulazione', description: 'Messa in servizio virtuale e ottimizzazione dei processi' },
        { name: 'Sicurezza & Conformità', description: 'Programmazione di sicurezza secondo le norme attuali' },
        { name: 'Servizio remoto & Monitoring', description: 'Supporto mondiale e monitoring KPI' }
      ],
      valueTitle: 'Il vostro valore aggiunto attraverso il Software Engineering',
      values: [
        { title: 'Continuità', description: 'Integrazione trasparente con hardware e Digital Twin per flussi di dati coerenti.' },
        { title: 'Time-to-Commission', description: 'Capitolati strutturati e gestione di progetto pulita per una rapida messa in servizio.' },
        { title: 'Facilità d\'uso', description: 'HMI chiari e manuali comprensibili per un utilizzo semplice da parte del vostro team.' },
        { title: 'Supporto ciclo di vita', description: 'Supporto remoto e messa in servizio mondiale per un\'affidabilità a lungo termine.' }
      ]
    },
    contactPage: {
      formTitle: 'Modulo di contatto',
      formSubtitle: 'Avete domande sui nostri servizi, una richiesta specifica o desiderate collaborare con noi? Comunicateci la vostra richiesta, vi risponderemo tempestivamente.',
      directContact: {
        title: 'Contatto diretto',
        description: 'Desiderate contattarci direttamente? Siamo a vostra disposizione telefonicamente o via e-mail.',
        phone: '+41 62 919 82 10',
        email: ''
      },
      departmentTitle: 'Contatto per reparto',
      departmentSubtitle: 'Contattate direttamente il reparto giusto per la vostra richiesta',
      departments: [
        { title: 'Vendite', description: '' },
        { title: 'Acquisti', description: '' },
        { title: 'Carriera', description: '' },
        { title: 'Marketing', description: '' }
      ]
    },
    anfahrtPage: {
      heroTitle: 'Come trovarci.',
      heroDescription: 'Il nostro edificio per uffici (sede centrale) e la nostra produzione si trovano in una posizione comoda, a 10 minuti dall\'autostrada A1 ad Aarwangen. I nostri siti sono anche ben collegati e facilmente raggiungibili con i trasporti pubblici.',
      locationsTitle: 'Le nostre sedi',
      locations: [
        { title: 'Sede centrale', country: 'Svizzera' },
        { title: 'Produzione', country: 'Svizzera' }
      ],
      openingHours: 'Orari di apertura',
      openingHoursWarehouse: 'Orari di apertura ricevimento merci',
      monThu: 'Da lunedì a giovedì',
      friday: 'Venerdì',
      routePlanning: 'Pianifica percorso',
      transportTitle: 'Come raggiungerci',
      transportSubtitle: 'Diverse opzioni vi portano da noi – scegliete quella più adatta a voi',
      carTab: 'Auto',
      publicTransportTab: 'Trasporti pubblici',
      carDirections: [
        { title: 'Sede centrale', description: 'Dall\'autostrada A1, prendete l\'uscita Aarwangen. Seguite la segnaletica in direzione del villaggio di Aarwangen. La nostra sede si trova in Jurastrasse 12. Parcheggi disponibili direttamente davanti all\'edificio.' },
        { title: 'Produzione', description: 'Dall\'autostrada A1, prendete l\'uscita Aarwangen. Seguite la segnaletica in direzione della zona industriale. Il nostro stabilimento di produzione si trova in Industriering 2. Ampio parcheggio disponibile in loco.' }
      ],
      publicTransportDirections: [
        { title: 'Sede centrale', description: 'La sede centrale è a soli <strong>2 minuti a piedi</strong> dalla stazione di Aarwangen Dorf. Uscendo dalla stazione, seguite semplicemente la Jurastrasse.' },
        { title: 'Produzione', description: 'La produzione è a <strong>10 minuti a piedi</strong> dalla fermata Aarwangen Hard. Seguite la segnaletica in direzione della zona industriale.' }
      ]
    },
    successStoriesPage: {
      heroSubtitle: 'di aziende leader',
      heroDescription: 'Scoprite come abbiamo aiutato i nostri clienti a raggiungere un successo misurabile',
      filterAll: 'Tutti',
      projectServices: 'Servizi nel progetto',
      readCaseStudy: 'Leggi caso studio',
      employees: 'Collaboratori',
      quotes: {
        guedel: 'Grazie alla standardizzazione e al Digital Twin, abbiamo ottenuto una qualità vicina alla serie fin dal primo lotto. Le modifiche poco prima della consegna erano possibili senza ritardi.',
        cwa: 'Grazie a W. Althaus AG, abbiamo snellito i processi: i quadri consegnati erano completamente testati, documentati e pronti per l\'installazione.',
        haefely: 'Con W. Althaus AG, abbiamo potuto mettere in servizio i nostri ambienti di test più rapidamente: i quadri sono arrivati testati, tracciabili e pronti per l\'installazione.',
        fondarex: 'Le macro ePlan e i quadri modello hanno dimezzato il nostro tempo di ingegneria.',
        bunorm: 'La progettazione conforme EN/UL/CSA inclusa la valutazione dei rischi ha sensibilmente abbreviato la nostra omologazione.',
        zehndersommer: 'Con il Digital Twin e i dati di produzione pronti, la transizione alla costruzione di quadri è stata fluida.',
        emmi: 'Il supporto remoto e la documentazione chiara hanno mantenuto l\'impianto stabile.',
        kadi: 'La gestione delle ricette basata su SQL con audit trail crea trasparenza – report con un clic.',
        cerex: 'Il capitolato e i flussi HMI hanno abbreviato la messa in servizio.'
      },
      positions: {
        guedel: 'Head of Supply Chain Management, Güdel AG',
        cwa: 'Acquisti operativi, CWA AG',
        haefely: 'Manager Purchasing, HAEFELY AG',
        fondarex: 'Responsabile elettrotecnica, Fondarex AG',
        bunorm: 'Direttore generale, Bunorm Maschinenbau AG',
        zehndersommer: 'Innovazione elettrica, Zehnder & Sommer AG',
        emmi: 'Caposquadra, Emmi Schweiz AG',
        kadi: 'Capo progetto, KADI AG',
        cerex: 'Direttore tecnico, CEREX AG'
      },
      industries: {
        guedel: 'Costruzione meccanica',
        cwa: 'Costruzione veicoli di trasporto',
        haefely: 'Costruzione sistemi di test',
        fondarex: 'Costruzione meccanica',
        bunorm: 'Costruzione meccanica',
        zehndersommer: 'Sistemi di avanzamento presse',
        emmi: 'Industria alimentare',
        kadi: 'Industria alimentare',
        cerex: 'Costruzione meccanica'
      }
    },
    jobOpeningsPage: {
      title: 'Posizioni aperte',
      subtitle: 'Trovate la vostra prossima sfida presso W. Althaus AG',
      yourTasks: 'Le vostre mansioni:',
      learnMore: 'Scopri di più',
      noJobTitle: 'Nessuna posizione adatta trovata?',
      noJobDescription: 'Siamo lieti di ricevere la vostra candidatura spontanea e verificheremo volentieri se abbiamo una posizione adatta per voi.',
      sendApplication: 'Invia candidatura spontanea',
      startDate: 'Subito o da concordare',
      jobs: [
        {
          title: 'Collaboratore HR & Finanze (m/f/d)',
          department: 'Amministrazione',
          description: 'Supportate il nostro team nelle risorse umane e nelle finanze. Vi occupate di compiti amministrativi versatili.',
          tasks: ['Supporto nell\'amministrazione HR e nel processo di reclutamento', 'Collaborazione nella contabilità e nell\'elaborazione dei salari', 'Compiti amministrativi nei settori HR e finanze']
        },
        {
          title: 'Ingegnere dell\'automazione (m/f/d)',
          department: 'Ingegneria',
          description: 'Digitalizzazione, automazione o robotica – da noi siete al centro dell\'azione! Unitevi al nostro team motivato e contribuite a plasmare il futuro dello sviluppo.',
          tasks: ['Sviluppo, realizzazione e messa in servizio di soluzioni di automazione software', 'Software PLC e visualizzazioni di processo su vari sistemi', 'Accompagnamento progetti e supporto tecnico']
        },
        {
          title: 'Tecnico dell\'automazione o elettricista esperto (m/f/d)',
          department: 'Produzione',
          description: 'Unitevi al nostro team motivato e contribuite a plasmare il futuro della produzione.',
          tasks: ['Produzione di sistemi di controllo e quadri di commutazione di ogni tipo', 'Responsabilità dell\'intero processo di produzione', 'Lavorazione meccanica, montaggio e cablaggio del quadro elettrico']
        }
      ]
    }
  }
};

export function getTranslation(locale: Locale) {
  return translations[locale] || translations.de;
}

export function getPageTranslation(locale: Locale) {
  return pageTranslations[locale] || pageTranslations.de;
}